
 let locations = [{
		"addressName": [{
			"ename": "ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "ГАРАЖНЫЙ МАССИВ №1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Курчатов"
			}, {
				"ename": "УЛИЦА 10 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 10 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 10-й Кирпичный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 10 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 10 Проезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 10 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 11 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 11 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 11 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 11Проезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 11 Степная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 11 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 12 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 12 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 12 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 12 Околоток, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 12 Проезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 12 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 13 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 13 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 13 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 13 Проезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 13 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 14 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 14 Загородная 1 заезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 14 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 14 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "МИКРОРАЙОН 14 Микрорайон, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 14 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 15 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 15 Жилой Район 2 Микрорайон, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 15 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 15 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "МИКРОРАЙОН 15 Микрорайон, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 15 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 16 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 16 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 16 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 16 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 17 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 17 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 17 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 17 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 18 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 18 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 18 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 18 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 19 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 19 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 19 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Автодромная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Амбулаторная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Горный заезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Декабря, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 ЖАСЫЛ ОРМАН, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Жибек Жолы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Жоламановка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Загородный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Загородняя, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Заезд Ипподромный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 заезд Кабанбай Батыра, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 заезд Каржаубайулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Заезд Пархоменко, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Каржаубайулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Кирпичный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Лесотарная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Лодочная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Матяша, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "МИКРОРАЙОН 1 Микрорайон, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Набережный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Околоток, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Омская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Орманды, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 пос.Бобровка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 пос.Западный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Пристанской, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1Проезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Самал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Северный заезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Созидательная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Степная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Центральная пос. Бобровка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 1 Чимкентский заезд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Щорса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 1 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ №2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Курчатов"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ №2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "КВАРТАЛ 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 20 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 20 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 20 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 21 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 21 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "УЛИЦА 22 Водная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}, {
				"ename": "ПЕРЕУЛОК 22 Юность, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Семей"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "КВАРТАЛ 003, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 051, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 078, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 092, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 095, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "КВАРТАЛ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 15 Разъезд Подхоз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "МИКРОРАЙОН 16, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 17, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 17, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 18, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 18, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 21, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 2 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 2 Горная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "ПРОЕЗД 2-Й ДСУ 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА 31, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 3 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "КВАРТАЛ 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 4 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "КВАРТАЛ 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 5 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 5 Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "КВАРТАЛ 5 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 7 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "МИКРОРАЙОН 7 Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 8 Микрорайон, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "МИКРОРАЙОН VIP коттеджный городок № 9 Нура-Ишим, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА Абилкайыр Хана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА А.Блока, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Абрикосовая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "ПРОСПЕКТ Абылай хана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Абылай хана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Авангард, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Авиатор, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автобаза Облпотребсоюза, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ ГАРАЖНЫЙ КООПЕРАТИВ Автомобилист, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ ГАРАЖНЫЙ КООПЕРАТИВ Автомобилист-1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Степногорск"
			}, {
				"ename": "УЛИЦА Автомобилистов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автотранспортник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "ПРОЕЗД А. Грибоедова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Ағыбай батыр (Корчагина), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА А. Затаевича, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Азаттык, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Айгуль, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Айдын, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}, {
				"ename": "УЛИЦА Айтеке Би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА Айтмагамбет Есмагамбетулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Косшы"
			}, {
				"ename": "УЛИЦА Академика В.И.Вернадского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кокшетау"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Актюбинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шалкар, РАЙОН Шалкарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 099, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЛИЦА 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шалкар, РАЙОН Шалкарский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 10, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ №10, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЛИЦА 101 Стрелковой Бригады, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ №10-Г, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "МИКРОРАЙОН 11, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 11, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 12, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "МИКРОРАЙОН 12, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "МИКРОРАЙОН 12 Б, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "МИКРОРАЙОН 12 Вг, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 13, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 14, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 141, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 143, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 15, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 154, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 155, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 155, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 155, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 16, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 163, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 164, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 164, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 164, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 165, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 17, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 170, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 176, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 176, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 177, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 178, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 18, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 180, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 181, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 181, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 182, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 182, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 182, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 183, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 19, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЛИЦА 1 Май, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шалкар, РАЙОН Шалкарский"
			}, {
				"ename": "ЖИЛОЙ МАССИВ 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 20, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 205, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 207, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 207, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 208, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 209, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 21, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 212, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 212, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 213, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 213, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 22, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 23, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 23А, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЛИЦА 23 Квартал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Хромтау, РАЙОН Хромтауский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 24, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 25, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ 25-лет Целины, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 26, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 27, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 28, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №3, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №30 Авиатор-3, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "УЛИЦА 30 лет Казахстана, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ 30 лет Казахстана, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 31, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ПРОСПЕКТ 312 Стрелковой дивизии, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 32, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 33, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "РАЗЪЕЗД 39, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ №4, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "РАЗЪЕЗД 41, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд Курсантское шоссе, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд ПМС-2, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд РСХТ, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд станция Альджан, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд ул.Элеваторная, РАЙОН В ГОРОДЕ Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 43, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "УЛИЦА 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шалкар, РАЙОН Шалкарский"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга, РАЙОН Алгинский"
			}, {
				"ename": "МИКРОРАЙОН №5 Батыс-2, РАЙОН В ГОРОДЕ Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Алматинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 035, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 042, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 043, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 12А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 12Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 158, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 18, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 234, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 244, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 247, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 247, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 254, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 257, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 259, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 263, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ №272, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ №274, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА А.Д.Койчуманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Ақжол, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Алмагуль, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Алматинская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Алтын-Алма, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Ардагер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Ардагер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Арна, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Асем-Тас, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Бірлесу, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Ветеринарлық бекеті, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Восточный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Вохр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ гаражный кооператив Строитель, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Гульдер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПРОСПЕКТ Д.А.Кунаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "АЛЛЕЯ Демалыс, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Достық, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПРОСПЕКТ Жамбыла, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Железнодорожная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Жулдыз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПЕРЕУЛОК Заводской, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Зайсан, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Зареченская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО ЗАРЯ ВОСТОКА, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Заря Капшагай простое садоводческое товарищество, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Заря простое садоводческое товарищество, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Ивушка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Индустриальная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ Казахстан, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДОВ Капшагай Алтын-Алма, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Капшагайская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Карлыгаш, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Комсомольская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Левый берег река Или, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Мостостроителей, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Оранжерейная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ простое гаражное товарищество Бытовик-2Н, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ простое гаражное товарищество Оранжерея, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ простое гаражное товарищество Робот, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ простое гаражное товарищество Спутник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ простое гаражное товарищество Толкын, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Рауан, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Речников, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Садоводческое общество ГЦИ-Демалыс, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ садоводческое общество Строитель, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПЕРЕУЛОК Садовый, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Сакена Сейфуллина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Самал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Санаторий металлург, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Связист-1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Связист простое гаражное товарищество, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Северное побережье Капшагайского водохранилища, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "МИКРОРАЙОН Спутник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ТРАССА трасса Алматы-Оскемен, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Центральная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "УЛИЦА Шенгельдинская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Электрик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Қонаев"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Алматы",
			"addressName": [{
				"ename": "МИКРОРАЙОН 1, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 1, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "МИКРОРАЙОН 10, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "МИКРОРАЙОН 10а, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "МИКРОРАЙОН 11, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 11 кирпичнозаводская, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "МИКРОРАЙОН 12, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "МИКРОРАЙОН 13, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "УЛИЦА 13 воен.городок, РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "ПЕРЕУЛОК 13 переулок, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "МИКРОРАЙОН 14, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "ПЕРЕУЛОК 14 переулок, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "ПЕРЕУЛОК 15 переулок, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 1-ая Бригадная, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 1 кирпичнозаводская, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 1 Лисянского, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 1 Нестерова, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "МИКРОРАЙОН 2, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 2, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "ПЕРЕУЛОК 20 линия, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 20 линия, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 22 Линия, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 24 июня, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 26, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 28, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 2-ая Каримбаева, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 2 Братская, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "УЛИЦА 2 Вишневского, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 2 Гончарная, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "УЛИЦА 2 Кастекская, РАЙОН В ГОРОДЕ Алмалинский"
			}, {
				"ename": "УЛИЦА 2 кирпичнозаводская, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 2 Кисловодская, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "УЛИЦА 2 курчатова, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 2 линия, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 2 Многоводная, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 3, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "МИКРОРАЙОН 3, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 3 вишневского, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 3 кирпичнозаводская, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА 4, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "МИКРОРАЙОН 4, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 5, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "МИКРОРАЙОН 5, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 5 кирпичнозаводская, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "МИКРОРАЙОН 6, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 6, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО 6-е Домоуправление, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 6 кирпичнозаводская, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "МИКРОРАЙОН 7, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА 7, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "РАЗЪЕЗД 71, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "МИКРОРАЙОН 8, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "МИКРОРАЙОН 8 (Аэропорт), РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "УЛИЦА 8-й Гвардейской дивизии, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "МИКРОРАЙОН 9, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "МИКРОРАЙОН 9 (Аэропорт), РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО №9 Домоуправление, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 9 кирпичнозаводская, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА 9 января, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "МИКРОРАЙОН Абай, РАЙОН В ГОРОДЕ Наурызбайский"
			}, {
				"ename": "УЛИЦА Абаканская, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "ПРОСПЕКТ Абая, РАЙОН В ГОРОДЕ Алмалинский"
			}, {
				"ename": "ПРОСПЕКТ Абая, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "ПРОСПЕКТ Абая, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "ПРОСПЕКТ Абая, РАЙОН В ГОРОДЕ Ауэзовский"
			}, {
				"ename": "УЛИЦА Абдирова, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "УЛИЦА Абдуллиных, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА Абиш Кекилбайулы, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА Абхазская, РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "ПРОСПЕКТ Абылай хана, РАЙОН В ГОРОДЕ Алмалинский"
			}, {
				"ename": "ПРОСПЕКТ Абылай хана, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Авиатор, РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "УЛИЦА Авиационная, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Аврз, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Аврора, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Автодом, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ ГАРАЖНЫЙ КООПЕРАТИВ Автолюбителей, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автомобилист, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Авторембаза, РАЙОН В ГОРОДЕ Наурызбайский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО агропромбанк \\\\\\\"Арман\\\\\\\", РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА Ажибай батыра, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА Азербаева, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА Азизбекова, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "УЛИЦА Азовская, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "УЛИЦА Айбасова, РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "УЛИЦА Айвазовского, РАЙОН В ГОРОДЕ Алмалинский"
			}, {
				"ename": "УЛИЦА Айвазовского, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "МИКРОРАЙОН Айгерим-1, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "МИКРОРАЙОН Айгерим-2, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "МИКРОРАЙОН Айгерим микрорайон, РАЙОН В ГОРОДЕ Алатауский"
			}, {
				"ename": "УЛИЦА Айгөлек, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА Айдын, РАЙОН В ГОРОДЕ Медеуский"
			}, {
				"ename": "УЛИЦА Айманова, РАЙОН В ГОРОДЕ Алмалинский"
			}, {
				"ename": "УЛИЦА Айманова, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА Аймауытова Ж, РАЙОН В ГОРОДЕ Турксибский"
			}, {
				"ename": "МИКРОРАЙОН Айнабулак, РАЙОН В ГОРОДЕ Жетысуский"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Айнабулак, РАЙОН В ГОРОДЕ Бостандыкский"
			}, {
				"ename": "УЛИЦА Айтеке би, РАЙОН В ГОРОДЕ Алмалинский"
			}, {
				"ename": "УЛИЦА Айтеке би, РАЙОН В ГОРОДЕ Медеуский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Астана (Нур-Султан)",
			"addressName": [{
				"ename": "УЛИЦА 101, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА 101, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА 12-3, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 12-31, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 12-39, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 126, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ 13 АО Целинтрансстрой, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "УЛИЦА 189, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА 191, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА 196, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА 197, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПРОЕЗД 20, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 20-1, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 20-2, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 215, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА 216, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "ПЕРЕУЛОК 217, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПЕРЕУЛОК 218, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПЕРЕУЛОК 219, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПЕРЕУЛОК 220, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПЕРЕУЛОК 221, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 22-1, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "ПЕРЕУЛОК 222, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 22-2, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "ПЕРЕУЛОК 223, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 22-3, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "ПЕРЕУЛОК 224, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 22-4, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "ПЕРЕУЛОК 225, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 22-5, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "УЛИЦА 23-16, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА 23-2, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА 25, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Тулеубаева, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "ПЕРЕУЛОК 2 Степана Разина, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 3, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПРОЕЗД 34, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА 39, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПЕРЕУЛОК 3-ий Радищева (Радищева 3-й), РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "ПРОЕЗД 41, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "ПРОЕЗД 49, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 51, РАЙОН В ГОРОДЕ Нұра"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО №51 ПМК Союзцелингаз, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "ПРОЕЗД 59, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "ПРОЕЗД 68, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "ПРОЕЗД 69, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "ПРОЕЗД 70, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "ПРОЕЗД 77, РАЙОН В ГОРОДЕ Есиль"
			}, {
				"ename": "УЛИЦА 85, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА 8 Марта, РАЙОН В ГОРОДЕ Сарыарка"
			}, {
				"ename": "УЛИЦА 92, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПРОЕЗД 93, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "МАССИВ VIP-Городок, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 1, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 102, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 103, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 105, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 108, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 123, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 128, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 129, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 130, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 139, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 184, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 185, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 187, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 188, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 189, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 190, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 191, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 194, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 195, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 197, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА А 2, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 205, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 206, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 207, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 218, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 219, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 220, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 221, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 227, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 27, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 273, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 28, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 29, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 292, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 30, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 304, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА А 31, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 32, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 333, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 334, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 348, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 35, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 350, РАЙОН В ГОРОДЕ Байконыр"
			}, {
				"ename": "УЛИЦА А 351, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 353, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 354, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А 355, РАЙОН В ГОРОДЕ Алматы"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Атырауская",
			"addressName": [{
				"ename": "ГАРАЖНЫЙ МАССИВ №12 Мектеп, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "РЯД № 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "РАЗЪЕЗД 496, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "РЯД № 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МАССИВ 8 Наурыз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Абай алаңы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Авангард, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Авангард -2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Авангард -2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Авангард-3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Авангард-4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Авиатор, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Автобаза, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Автомобилист, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Автопарк, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Автотэп, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ағатай Батыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Адмирал Лев Владимирский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Адырыс, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОСПЕКТ Азаттық, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Азаттық, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Айша Бибі, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Академик Бинеш Жарбосынов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Акжайык, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Ақжайық, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПЕРЕУЛОК Ақжал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ақжол, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Аққыстау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Ақсұңқар, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ақтамберді Жырау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Ақтау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Ақ Шағала, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ақшағыл, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ақын Сара, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ақын Шернияз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Алатау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Алатау (Сырдария), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Алаш, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Алғабас, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Александр Афанасьев, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Александр Грибоедов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Александр Затаевич, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Александр Пушкин, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Александр Стаханов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Алиева- Курмангазы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Алмагүл, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Алмалы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МАССИВ Алмалы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Алпамыс Батыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Алтай, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Алтынкөл, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Альпияр Жұмағазиев, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Амангелді, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Амөз Аумағындағы Өндіріс аймағы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Анпз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Антон Чехов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО АНУ-2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Арал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Арал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Ардагер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Ардагер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Арзамасская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Арын, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Асау Барақ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Аскар Бисекенов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Астрахань, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ТРАССА Астрахань, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Атамұра (Алиев Курмангазы), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Атырау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Атырау-2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ТРАССА Атырау-Доссор, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ТРАССА Атырау-Уральск, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Ахмет Жұбанов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Ащысай, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Байкент, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Байланысшылар, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Байтақ (Водников), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Бақсай, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Бақтыгерей Құлманов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Балқаш, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Балықшы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПЕРЕУЛОК Баянауыл (Улкенкульская), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Баянды (Қаршыға Ахмедьяров), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОСПЕКТ Бейбарыс, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Бәйдібек (Ахмет Байтұрсынов), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Бейімбет Майлин, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Бекбай Бимағанов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОЕЗД Бердібек Соқпақбаев (Талғат Бигельдинов), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Береке, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Береке, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Береке, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Берқайыр Аманшин, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Бестоғай (Блочная), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "МИКРОРАЙОН Бірлік, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Бөгенбай Батыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}, {
				"ename": "УЛИЦА Боран Нысанбаев, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Восточно-Казахстанская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ  005, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 051, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 052, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 053, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 057, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ЖИЛОЙ МАССИВ 16, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ЖИЛОЙ МАССИВ № 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Автогаражная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Алейская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Арычная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Коммунальная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Мельничная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Набережная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Нагорная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЛИЦА 1-ая Невская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 1-ая Свинцовая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЛИЦА 1-ая Северная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №1 Г. УСТЬ-КАМЕНОГОРСК, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 1 км от с.Ново-Ахмирово, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Б.Хмельницкого, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Казахстанский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Коммунальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Кривоноса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Одесский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Паровозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Полтавский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ № 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ЖИЛОЙ РАЙОН 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "МИКРОРАЙОН 24, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 26 Б.КОМИССАРОВ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ЖИЛОЙ РАЙОН 28, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Автогаражная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Арычная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Выставочная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Заречная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Иртышская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Коммунальная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Невская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 2-ая Северная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-Казахстанский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ТЕРРИТОРИЯ 2 км от с. Меновное, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 2 км от с. Ново-Ахмирово, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 2 км от с. Ново-Явленка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 2 км от с. Самсоновка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Б.Хмельницкого, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Гурьевский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Коммунальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Кривоноса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Одесский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Паровозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Полтавский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 30-й Гвардейской Дивизии, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "КВАРТАЛ 3 Жилой Район, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ПЕРЕУЛОК 3-ий Б.Хмельницкого, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 3-ий Кривоноса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 3-ий Широкий, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Паровозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 3 км от с.Ново-Ахмирово, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 3 км от с. Ново-Троицкое, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 3 км от с. Самсоновка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 3-Стахановская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЛИЦА 3-я Автогаражная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 3-я Алейская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 3-я Невская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 3-я Северная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 4-ый Паровозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 5-го Декабря, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 5 км от с. Самсоновка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 5-ый Паровозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ № 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК 6-й Паровозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 6 км от с. Самсоновка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 7 км от с. Ново-Явленка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 7 км от с. Самсоновка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ГАРАЖНО-СТРОИТЕЛЬНЫЙ КООПЕРАТИВ №8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ 8 км от с. Ново-Троицкое, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 8-Марта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "КВАРТАЛ 91, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "КВАРТАЛ 93, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "КВАРТАЛ 94, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "КВАРТАЛ 95, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ТЕРРИТОРИЯ 9 км от с. Самсоновка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА 9-МАЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ПРОСПЕКТ Абай (Островского), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЛИЦА А. Байбатчина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ТЕРРИТОРИЯ Абайский Леспромхоз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ПРОСПЕКТ Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ПЕРЕУЛОК Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА А. Бокейханова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ГАРАЖНО-СТРОИТЕЛЬНЫЙ КООПЕРАТИВ Авангард, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УРОЧИЩЕ Авдеев ключ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "УЛИЦА Авиационная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Риддер"
			}, {
				"ename": "ПЕРЕУЛОК Авиационный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА Авиценны, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "УЛИЦА Авроры, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ АВТО-71, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Усть-Каменогорск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Жамбылская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 043 Квартал, РАЙОН Таласский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 079, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 083, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 088, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 093 Квартал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Абилахата Еспаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Агадила Сухамбаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Айтеке Би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Акмолда Батыра, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Антона Чехова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Артема, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Байзак батыра, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Барбюса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Бауыржан Момышулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Бейбитшилик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Болтирик Шешен, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Валерия Чкалова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Владимира Маяковского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ЖИЛОЙ МАССИВ 1 Водник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 генерала Рахимова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПРОЕЗД 1 генерала Рахимова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Динмухамеда Конаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Екейбая Кашаганова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Есей би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Железнодорожный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ТУПИК №1 Жибек Жолы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПРОЕЗД 1 Жилкооперация, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Жилкооперация, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Жолшы Сыздыкова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Жумадил Акылбекова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Жусип Баласагуна, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Западный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Заречный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Зеленый, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Зои Космодемьянской, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Кадыргали Жалаири, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Кажымукана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Казыбек Би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Каллаур Акима, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Капал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЛИЦА 1 Карасу, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Кошеней, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Красина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Кустанайский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ТУПИК 1 Кустанайский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Лукманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПРОЕЗД 1 Лукманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Магазы Масанчи, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Моисея Урицкого, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Мухамед Хайдар Дулати, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "УЛИЦА 1 Наурыз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Октября, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Песчанный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "МАССИВ 1 Родничок, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Сейлхана Аккозиева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Сенкибая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Сергея Лазо, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Смоленский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Сорокина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Степана Разина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Степной, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПРОЕЗД 1 Степной, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Строительный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Султанбаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Сырыма Датова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Тиленши Аппаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Тургынбека Жанкоразова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Уездный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Узбекский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Улбике Акына, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Ушбулакский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Фзо, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Хмелевского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Целиноградский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Центральный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Шаумяна, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Шокана Уалиханова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Ыбырайыма Сулейменова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Элеваторный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 1 Яблочный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 8 Марта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Абдильди Тажибаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Абдирахмана Айтиева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Абдуллы Розыбакиева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Абилахата Еспаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Автомобильный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Агадила Сухамбаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Акмолда Батыра, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПРОЕЗД 2 Алимхана Комратова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Антона Чехова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Артема, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Байзак батыра, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Барбюса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Бауыржан Момышулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Бейбитшилик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}, {
				"ename": "ПЕРЕУЛОК 2 Болтирик Шешен, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Тараз"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Жетісу",
			"addressName": [{
				"ename": "ОТДЕЛЕНИЕ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ОТДЕЛЕНИЕ 2 Бөлімше, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА 8 Наурыз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "МИКРОРАЙОН 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Абай, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА А.Байтуганова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Байтурсынова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Абубакира Тыныбаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Абылай хана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Абылай хана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Абылхана Кастеева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Автомобилист, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА А.Гайдара, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Герцена, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Грибоедова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДОВ Агропромышленник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Даирова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Жангельдина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Затаевича, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Избасарова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Исмаилова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Айдар Би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "ДОРОГА Айнабулак, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Акбастау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Кивилева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Ак кайын, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Аксуская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Акын Сара, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Алатау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Алем, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Алмаағаш, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДОВ Алмалы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Алмалы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Алматинская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Алтын Дан, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Алтын Орда, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Аль Фараби, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Амангельды Иманов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Аманжолов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Матросова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Невского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Пушкина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Радищева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Ардагер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Арман, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ДОРОГА Арнайы Қалашық жолы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА А.Фадеева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Ахмета Байтурсынова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА А.Шахворостова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДОВ Ащыбұлақ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Байкена Ашимова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Байконыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Байшешек, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Бақтыбай, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Б.Акылбекова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Балпык би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Балпык би, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Балхашская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ПЕРЕУЛОК Батыс, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Бауыржана Момыш Улы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Б.Берентаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Береговая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Береке, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Бикен Римовой, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Биржан Сал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "МИКРОРАЙОН Бирлик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Боктерли, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "МИКРОРАЙОН Болашак, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Болтірік Шешен, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Булакты, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Бухар Жырау, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Бытовик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА В.Белинского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА В.Блюхера, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Веселая Поляна, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА В.Иванилова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА В.Маяковского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "МИКРОРАЙОН ВОЕННЫЙ ГОРОДОК \\\"ЖУЛДЫЗ\\\", ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "МИКРОРАЙОН ВОЕННЫЙ ГОРОДОК \\\"УЛАН\\\", ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Восточная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "МИКРОРАЙОН Восточный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Восточный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА В.Панфилова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА В.Терешковой, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА В.Чкалова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Гагарин, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "МИКРОРАЙОН Гарышкер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Гарышкерлер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Гаухар Ана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Геолог, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Г.Котовского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Г.Ли, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Говд, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Г.Орманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ KООПЕРАТИВ САДОВОДЧЕСКОЕ ОБЩЕСТВО Горняк, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Текели"
			}, {
				"ename": "УЛИЦА Г.Сланова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}, {
				"ename": "УЛИЦА Дабыр Байгутовой, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Талдыкорган"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 17-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 1Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ТУПИК 1-Завокзальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПЕРЕУЛОК 1-Строительный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ТУПИК 2-Завокзальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 2-ой, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПЕРЕУЛОК 2-Строительный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 3-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 3-Завокзальный Тупик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПЕРЕУЛОК 3-Строительный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 4-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ТУПИК 4-Завокзальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПЕРЕУЛОК 4-Строительный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 5-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 5 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 6-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 7-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 7 ой км Сарат тр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 8-ая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 8 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 8 Марта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА 9-АЯ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Балашова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПРОСПЕКТ Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Абиш Кекилбаев (Комсомольская), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Абубакир Кердери, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПРОСПЕКТ Абулхаир Хана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПРОСПЕКТ Абулхайыр Хана 6/1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Авиатор, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Авто, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автодорожник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автодорожник-1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Автодорожник-2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Автоколонна 2555, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автомобилист, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист-2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Автомобилист 2555, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Автомобильная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА АГНКС-1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Аграрник, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Гребнева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Агрофирма Болашак, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Агрохимик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Әйтиев, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "МИКРОРАЙОН Азаулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Азаулы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Иманов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Академика Асана Тайманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА академик Сухан Камалов (Вольная), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Карев, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Ақбұлақ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Ақжар, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "МИКРОРАЙОН Ақжүніс, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Аққу, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Аккум, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Ақмола, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Ковалева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Коровина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Акотау (2-ой Километр), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Ақтөбе, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Кусайынова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алаш, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алғабас, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алдияр Рахметов (Ореховая), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алексей Черекаев, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алкей Маргулан, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Алма, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПЕРЕУЛОК Алмазовский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алмалы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алматы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Алтынкөл, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Амангелди Каримуллин (Пойменная), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Анатолий Скоробогатов, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Пушкин, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Арал, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Ардагер, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Арман, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Арматурщик, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "МИКРОРАЙОН Астана, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Стрижаченко, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Тихоненко, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Уразбаевой, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Чехова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Чурилина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Ашхабад (Ашхабадская), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА А.Щурихин, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Аэропорт, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Багбан, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Базарбай Жұманиязов (Светлая), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Байқоңыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Балбырауын, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "УЛИЦА Балластная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Банковец, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Банковец-2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Банковец-3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}, {
				"ename": "ПЕРЕУЛОК Баскачкинский, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Уральск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Карагандинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "КВАРТАЛ 003, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Приозерск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "КВАРТАЛ 005, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Приозерск"
			}, {
				"ename": "КВАРТАЛ 006, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Приозерск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "КВАРТАЛ 007, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Приозерск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 012, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 046, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 049, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 053, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сарань"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 057, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 086, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Шахтинск"
			}, {
				"ename": "КВАРТАЛ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "ЛИНИЯ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ №1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "МИКРОРАЙОН 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "МИКРОРАЙОН 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "КВАРТАЛ 100, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 101, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 103, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 103, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 104, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 104, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 105, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 105, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 106, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 107, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 107, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "МИКРОРАЙОН 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "МИКРОРАЙОН 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "КВАРТАЛ 110, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 110, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 111, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 111, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 112, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 112, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 113, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 114, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 115, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 116, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 117, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 118, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 119, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "МИКРОРАЙОН 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧАСТОК 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 121, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 122, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 123, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 124, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 124А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 125, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 125, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 125А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 126, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 127, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 127, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 129, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 12А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "КВАРТАЛ 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "МИКРОРАЙОН № 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "КВАРТАЛ 130, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 132, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 134, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 136, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 136А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 137 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Приозерск"
			}, {
				"ename": "РАЗЪЕЗД 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "КВАРТАЛ 142А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 144, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 146, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Темиртау"
			}, {
				"ename": "КВАРТАЛ 14А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}, {
				"ename": "КВАРТАЛ 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "УЛИЦА 11 Солнечная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 13А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ПРОЕЗД 1 40 лет Октября, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "МИКРОРАЙОН 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 16, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ПРОЕЗД 1 Герцена, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Жуковского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1 Костанайская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Лермонтова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "УЛИЦА 1 Мая, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1 Речная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1 Рудненская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Солнечный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Спартака, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Станционный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Химиков, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1 Цветочная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Цветочный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 1 Чапаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1 Челябинская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 1-я Западная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 24, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 24, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 24А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 29, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ПРОЕЗД 2 Герцена, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2 Костанайская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 2 Лермонтова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "УЛИЦА 2 Речная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2 Рудненская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2 Совхозная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 2 Спартака, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 2 Станционный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 2 Химиков, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 2 Цветочный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2 Центральная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 2 Чапаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2 Челябинская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 2-я Западная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "УЛИЦА 30 лет Целины, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 3 Герцена, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 3-й 40 лет Октября, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 3 Костанайская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 3 Лермонтова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 3 Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ПРОЕЗД 3 Спартака, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 3 Станционная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 3 Станционный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 3 Цветочная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 3 Цветочный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 3 Центральная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ПРОЕЗД 3 Чапаева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 3 Челябинская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО № 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "УЛИЦА 40 лет Октября, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "УЛИЦА 40 лет Октября, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Рудный"
			}, {
				"ename": "УЛИЦА 40 лет Победы, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Костанай"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО 4А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Лисаковск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Кызылординская",
			"addressName": [{
				"ename": "ПЛОЩАДКА 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "ПЛОЩАДКА 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 103, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 106, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 110, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 110А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 111-1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 111-2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 112, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 112А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 112Д, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 113, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 113Г, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 114А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 114Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 115Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 116, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 118, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 132, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 15А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 15Г, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 17, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 175, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 17К, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 17-К, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 17МЖГ, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 17П, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 18, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 19А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "УЛИЦА №1 көше, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "ПЕРЕУЛОК 1 Мамыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "УЛИЦА 1 Мамыр, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "ПЛОЩАДКА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 200, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 201, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 202, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 21, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 21А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 21Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 21В, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 21Г, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 250, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 250А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 251, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 254, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 255, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 255-254,110А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 257, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 257А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 257Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 2А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 2Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 2Ж, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 2т, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "КВАРТАЛ 2 Укрупненный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "СТАНЦИЯ 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 31, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 32, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 37, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 3А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 3Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 3Ж, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 3Р, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "КВАРТАЛ 3 Укрупненный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "ПЛОЩАДКА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 42, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 43, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 44, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 45, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "КВАРТАЛ 4 Укрупненный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "СТАНЦИЯ 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 504-3К, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "МИКРОРАЙОН 5 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЕРЕУЛОК 60, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "МИКРОРАЙОН 6А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 71, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 72, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 75, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "МИКРОРАЙОН 7А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "УРОЧИЩЕ 800 Бас, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "ПЛОЩАДКА 81, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 82, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 84, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "УЛИЦА 8 Марта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЕРЕУЛОК 8 Наурыз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "УЛИЦА 8 Наурыз, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кызылорда"
			}, {
				"ename": "ПЛОЩАДКА 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 90, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}, {
				"ename": "ПЛОЩАДКА 9/1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Мангистауская",
			"addressName": [{
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен"
			}, {
				"ename": "МИКРОРАЙОН 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 11 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 12 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 14 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 15 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 16, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 17, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 18, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 18А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 19А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 1 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 1 Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 1 В, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен"
			}, {
				"ename": "МИКРОРАЙОН 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 20А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 21, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 24, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ДОРОГА 245км автодороги Актау Каламкас, РАЙОН Тупкараганский"
			}, {
				"ename": "МИКРОРАЙОН 25, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ДОРОГА 256 км автодороги Актау Каламкас, РАЙОН Тупкараганский"
			}, {
				"ename": "МИКРОРАЙОН 26, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 27, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 28, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 28 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 29, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 29 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МАССИВ №2 Шахта, РАЙОН Тупкараганский"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 30, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 31, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 31А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 31Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 32, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 32а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 32 Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 32-В, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН №33, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН №34, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 34А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 35, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 36, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 37, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 38, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 39, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 3 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 3 Б, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен"
			}, {
				"ename": "МИКРОРАЙОН 40, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 41, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 42, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 43, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ДОРОГА 43 км автотрассы Актау форт Шевченко, РАЙОН Тупкараганский"
			}, {
				"ename": "МИКРОРАЙОН 44, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 45, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 46, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 47, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 48, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 49, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 49А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 4 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен"
			}, {
				"ename": "МИКРОРАЙОН 50, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 51, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ДОРОГА 52 км по трассе Актау форт Шевченко, РАЙОН Тупкараганский"
			}, {
				"ename": "МИКРОРАЙОН 5 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен"
			}, {
				"ename": "МИКРОРАЙОН 6 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 7 А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 8 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "МИКРОРАЙОН 9 а, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау"
			}, {
				"ename": "ЗИМОВКА Агаштыбауыр, РАЙОН Тупкараганский"
			}, {
				"ename": "МАССИВ Айтуар, РАЙОН Тупкараганский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Павлодарская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ЛИНИЯ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ПРОЕЗД 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "УЛИЦА 10 Жанааульская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 10 Линейный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 10-Пятилетка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 10 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ЛИНИЯ 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 11 Линейный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 11 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 11 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "УЛИЦА 1 (22 микрорайон), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 12 Линейный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 12 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 12 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 13 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 13 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 148, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЛИЦА 14 Годовщина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 14 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 153, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 157, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 15 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 16 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН № 17, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 171, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 172, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 17 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 18 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 1А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "УЛИЦА 1 Жанааульская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПЕРЕУЛОК 1 Зеленый, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 1 Линейный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 1 Открытый, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЛИЦА 1У, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ПРОЕЗД 1 Школьный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 1 Юго-Западный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 1 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "УЛИЦА 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ЛИНИЯ 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "МИКРОРАЙОН 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "КВАРТАЛ 207, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "КВАРТАЛ 208, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 20 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 21, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 21 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЛИЦА 2 (22 микрорайон), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 22 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 230, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 232, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 233, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 234, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 235, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 236, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 237, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ПРОЕЗД 23 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 24, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 24 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 252, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ПРОЕЗД 25 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 26, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 26 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 27, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 27 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 28 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЛИЦА 29 Ноября, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 29 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 2А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "УЛИЦА 2 Жанааульская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 2 Линейный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Зеленый, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 2 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 2 Юго-Западный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 2 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ЛИНИЯ 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "УЛИЦА 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 30 ЛЕТ КАЗАХСТАНА, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 30 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "МИКРОРАЙОН 31, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 31 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "УЛИЦА 3 (22 микрорайон), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 32 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 3А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "УЛИЦА 3 Жанааульская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 3 (Лесозавод), ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}, {
				"ename": "ПРОЕЗД 3 Линейный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 3 Северный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 3 Юго-Западный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ПРОЕЗД 3 Южный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Экибастуз"
			}, {
				"ename": "ЛИНИЯ 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "УЛИЦА 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу"
			}, {
				"ename": "ПРОЕЗД 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Павлодар"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Северо-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 131 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 137 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 137 км Выемка, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 142 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Амангельды, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Г.Я. Михеева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Дзержинского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Жастык, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Заовражный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Заречный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й имени О.Кошевого, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й имени Перминовых, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й имени Ярослава Гашека, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й им. Щорса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Карьерный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 1-й Колхозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Колхозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 1-й Кузнечный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 1-й Куйбышевской рощи, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Мира, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Н.А.Семашко, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й П.Лазутина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й С. Разина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Степной, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Суворова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Универсальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Урожайный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 1-й Школьный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Школьный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-й Шмидта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 1-ый имени Ильи Залманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 1-я Заречная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 1-я Кирпичная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 1-я Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 1-я Сенная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2617 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2618 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2620 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2629 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2632 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Амангельды, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Г.Я. Михеева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Дзержинского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Жастык, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й имени Перминовых, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й им. Степана Разина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й им. Щорса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Индустриальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й карьерный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Колхозный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Колхозный Косогор, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Кузнечный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Куйбышевского Лесничества, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Куйбышевского Лесничества, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Куйбышевской рощи, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Куйбышевской рощи, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Маяковского, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Мира, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Н.А.Семашко, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й О.Кошевого, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й П.Лазутина, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Сенной, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Суворова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Универсальный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Урожайный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Школьный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Школьный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-й Шмидта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 2-ой имени Ильи Залманова, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Водосточная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Заречная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Индустриальная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Кирпичная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Кузнечная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Новаторная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Первомайская, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 2-я Сенная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 314-й Стрелковой дивизии, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Г.Я. Михеева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Жастык, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й им. Щорса, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Карьерный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Кирпичный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Кузнечный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Куйбышевского лесничества, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Куйбышевской рощи, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Куйбышевской рощи, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Мира, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 3-й Шмидта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 3-я Кирпичная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 3-я Кузнечная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 3-я Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 3-я Сенная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 4-й Г.Я.Михеева, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 4-й Кирпичный, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "ПРОЕЗД 4-й Шмидта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 4-я Кирпичная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 4-я Линия, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}, {
				"ename": "УЛИЦА 4-я Сенная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Петропавловск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Туркестанская",
			"addressName": [{
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 001, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 001, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 002, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 002, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 003, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 004, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 004, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 005, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 005, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 006, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 006, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 007, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 007, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 008, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 008, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 009, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 009, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 010, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 010, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 011, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 011, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 012, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 012, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 013, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 013, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 014, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 014, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 015, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 015, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 016, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 016, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 017, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 018, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 019, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 019, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 020, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 021, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 022, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 023, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 024, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 025, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 026, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 027, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 027, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 028, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 028, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 029, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 029, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 030, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кентау"
			}, {
				"ename": "КВАРТАЛ 030, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 030, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 031, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 031, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 032, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 032, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 033, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 033, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 034, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 034, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 035, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 035, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 036, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 036, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 037, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 037, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 038, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 038, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 039, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 039, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 040, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 040, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 041, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 042, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 043, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 043, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 044, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 044, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 045, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 045, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 046, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 046, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 047, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 048, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 050, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 055, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 057, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 064, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 068, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 072, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 075, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 077, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс"
			}, {
				"ename": "КВАРТАЛ 093, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 099, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кентау"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 107, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "УЛИЦА 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Туркестан"
			}, {
				"ename": "КВАРТАЛ 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кентау"
			}, {
				"ename": "МИКРОРАЙОН 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Кентау"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ОБЛАСТЬ Ұлытау",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 10, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 11, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "КВАРТАЛ 12, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 13, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 14, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 15, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 15А, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 15В, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 16, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 17, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 18, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 19, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "ПЕРЕУЛОК 1-я Инженерная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 2, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 20, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 21, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 21, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 22, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 23, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "КВАРТАЛ 24, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "КВАРТАЛ 25, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Каражал"
			}, {
				"ename": "КВАРТАЛ 27, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 28, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 29, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "ПЕРЕУЛОК 2-я Инженерная, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 32, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "РАЗЪЕЗД 323, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "РАЗЪЕЗД 359 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "РАЗЪЕЗД 366 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "УЧАСТОК №368, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "РАЗЪЕЗД 370 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "РАЗЪЕЗД 385 Км, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "РАЗЪЕЗД 411, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 5, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 55, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 59, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 5-й, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 60, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 61, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 61, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 62, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 62, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 63, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 63, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 64, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 64, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 65, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 65, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "РАЗЪЕЗД 66, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 66, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 66, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 67, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 67, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 68, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 69, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 71, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 71, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 72, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 73, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 74, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 74, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 79, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "МИКРОРАЙОН 8, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 81, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 84, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "УЛИЦА 8 Марта, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Сатпаев"
			}, {
				"ename": "КВАРТАЛ 9, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 91, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 92, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 93, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 94, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}, {
				"ename": "КВАРТАЛ 95, ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Шымкент",
			"addressName": [{
				"ename": "КВАРТАЛ 001, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 001, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 001, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 002, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 003, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 004, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 005, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 006, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 007, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 008, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 009, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 010, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 011, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 012, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 013, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 014, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 015, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 016, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 017, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 018, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 019, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 019, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 020, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 021, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 022, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 024, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 025, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 026, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 027, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 028, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 029, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 030, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 031, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 032, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 032, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 033, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 034, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 035, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 035, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 037, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 038, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 039, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 040, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 041, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 042, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 043, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 044, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 045, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 046, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 047, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 048, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 049, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 050, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 051, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 052, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 053, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 054, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 055, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 056, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 057, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 058, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 059, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 060, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 062, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 072, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 073, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 073, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 075, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 077, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 078, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 079, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 079, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 080, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 081, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 082, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 082, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 083, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 084, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 086, РАЙОН В ГОРОДЕ Каратау"
			}, {
				"ename": "КВАРТАЛ 092, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 094, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 095, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "КВАРТАЛ 096, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "ДОРОГА №1, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 100, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 101, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 102, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 103, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 104, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 105, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 106, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 107, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 108, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 109, РАЙОН В ГОРОДЕ Аль-Фарабийский"
			}, {
				"ename": "МИКРОРАЙОН 11, РАЙОН В ГОРОДЕ Енбекшинский"
			}, {
				"ename": "КВАРТАЛ 110, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 112, РАЙОН В ГОРОДЕ Тұран"
			}, {
				"ename": "КВАРТАЛ 113, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 114, РАЙОН В ГОРОДЕ Абайский"
			}, {
				"ename": "КВАРТАЛ 115, РАЙОН В ГОРОДЕ Абайский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Абайский, ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, СЕЛО Караул, СЕЛЬСКИЙ ОКРУГ Караульский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Медеу, СЕЛЬСКИЙ ОКРУГ Медеуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011 (УЧЕТНЫЙ КВАРТАЛ 011), СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 012 (УЧЕТНЫЙ КВАРТАЛ 012), СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014 (УЧЕТНЫЙ КВАРТАЛ 014), СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Караул, СЕЛЬСКИЙ ОКРУГ Караульский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА 11 Гектар, СЕЛО Медеу, СЕЛЬСКИЙ ОКРУГ Медеуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 12, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Караул, СЕЛЬСКИЙ ОКРУГ Караульский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Абдеш, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА АБДИ-2, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Абдилда, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Абді, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Абек, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "ЗИМОВКА Аблайша, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Адасхан, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Адил-1, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "ЗИМОВКА Азамат, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Азберген, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Азимбай-1, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Азимбай-2, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Азимжан, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Ай, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Айбар, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Айгерим-2, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "УЛИЦА Айгерима, СЕЛО Караул, СЕЛЬСКИЙ ОКРУГ Караульский"
			}, {
				"ename": "ЗИМОВКА Айгыр-1, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Айгыр-2, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Айдапкел, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Айдапкел 1, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Айманбет, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Аймедет, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Аймыш, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "УЛИЦА Айпара, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Айтказы, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Айтказы-1, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Айтказы-2, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Айтуган 1, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Айтуган 2, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Акбаз, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Акбастау, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "ЗИМОВКА Акбастау-2, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "ЗИМОВКА Акбиик, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Акбиык, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "ЗИМОВКА Акбота, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Аккияк, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Аккозы, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Аккора, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "ЗИМОВКА Ак Кора, СЕЛО Медеу, СЕЛЬСКИЙ ОКРУГ Медеуский"
			}, {
				"ename": "ЗИМОВКА Ак Кора, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Аккудук, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Акмагамбет, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Акмола, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Акнур, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Акпар-2, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Актанберди, СЕЛО Караул, СЕЛЬСКИЙ ОКРУГ Караульский"
			}, {
				"ename": "УЛИЦА Актанберди, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "ЗИМОВКА Актас, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "ЗИМОВКА Актас-1, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Актас-2, СЕЛО Токтамыс, СЕЛЬСКИЙ ОКРУГ Токтамысский"
			}, {
				"ename": "ЗИМОВКА Актобе, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актобе-2, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актобе-3, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актогай, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актогай-1, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актогай-2, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актогай-3, СЕЛО Кенгирбай би, СЕЛЬСКИЙ ОКРУГ Кенгирбайбийский"
			}, {
				"ename": "ЗИМОВКА Актумсык, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "ЗИМОВКА Акшеке, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Акшокы, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Акшокы, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Акшокы-1, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Акыжан, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Акыжан-2, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Акылбай, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "УЛИЦА Акылбая, СЕЛО Караул, СЕЛЬСКИЙ ОКРУГ Караульский"
			}, {
				"ename": "ЗИМОВКА Акымжан, СЕЛО Журекадыр, СЕЛЬСКИЙ ОКРУГ Кундыздинский"
			}, {
				"ename": "ЗИМОВКА Алабие, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Алабие-1, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Алдияр Аппак, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Али, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Али-Баба, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Алимбет, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Алмас, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}, {
				"ename": "ЗИМОВКА Алтындыбулак, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "ЗИМОВКА Алтындыбулак-2, СЕЛО Архат, СЕЛЬСКИЙ ОКРУГ Архатский"
			}, {
				"ename": "ЗИМОВКА Алшынбай, СЕЛО Саржал, СЕЛЬСКИЙ ОКРУГ Саржалский"
			}, {
				"ename": "ЗИМОВКА Аман-Серик, СЕЛО Каскабулак, СЕЛЬСКИЙ ОКРУГ Каскабулакский"
			}, {
				"ename": "ЗИМОВКА Амантай, СЕЛО Кокбай, СЕЛЬСКИЙ ОКРУГ Кокбайский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Абайский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Шымкент",
			"addressName": [{
				"ename": "КВАРТАЛ 059"
			}, {
				"ename": "КВАРТАЛ 060"
			}, {
				"ename": "КВАРТАЛ 062"
			}, {
				"ename": "КВАРТАЛ 072"
			}, {
				"ename": "КВАРТАЛ 077"
			}, {
				"ename": "КВАРТАЛ 096"
			}, {
				"ename": "КВАРТАЛ 100"
			}, {
				"ename": "КВАРТАЛ 101"
			}, {
				"ename": "КВАРТАЛ 102"
			}, {
				"ename": "КВАРТАЛ 103"
			}, {
				"ename": "КВАРТАЛ 104"
			}, {
				"ename": "КВАРТАЛ 105"
			}, {
				"ename": "КВАРТАЛ 106"
			}, {
				"ename": "КВАРТАЛ 107"
			}, {
				"ename": "КВАРТАЛ 108"
			}, {
				"ename": "КВАРТАЛ 110"
			}, {
				"ename": "КВАРТАЛ 113"
			}, {
				"ename": "КВАРТАЛ 114"
			}, {
				"ename": "КВАРТАЛ 115"
			}, {
				"ename": "КВАРТАЛ 116"
			}, {
				"ename": "КВАРТАЛ 118"
			}, {
				"ename": "КВАРТАЛ 120"
			}, {
				"ename": "КВАРТАЛ 121"
			}, {
				"ename": "КВАРТАЛ 123"
			}, {
				"ename": "КВАРТАЛ 124"
			}, {
				"ename": "КВАРТАЛ 125"
			}, {
				"ename": "КВАРТАЛ 126"
			}, {
				"ename": "КВАРТАЛ 127"
			}, {
				"ename": "КВАРТАЛ 128"
			}, {
				"ename": "КВАРТАЛ 129"
			}, {
				"ename": "КВАРТАЛ 130"
			}, {
				"ename": "КВАРТАЛ 131"
			}, {
				"ename": "КВАРТАЛ 132"
			}, {
				"ename": "КВАРТАЛ 133"
			}, {
				"ename": "КВАРТАЛ 134"
			}, {
				"ename": "КВАРТАЛ 135"
			}, {
				"ename": "КВАРТАЛ 136"
			}, {
				"ename": "КВАРТАЛ 137"
			}, {
				"ename": "КВАРТАЛ 138"
			}, {
				"ename": "КВАРТАЛ 139"
			}, {
				"ename": "КВАРТАЛ 140"
			}, {
				"ename": "КВАРТАЛ 141"
			}, {
				"ename": "КВАРТАЛ 142"
			}, {
				"ename": "КВАРТАЛ 143"
			}, {
				"ename": "КВАРТАЛ 144"
			}, {
				"ename": "КВАРТАЛ 146"
			}, {
				"ename": "КВАРТАЛ 147"
			}, {
				"ename": "КВАРТАЛ 148"
			}, {
				"ename": "КВАРТАЛ 150"
			}, {
				"ename": "КВАРТАЛ 151"
			}, {
				"ename": "КВАРТАЛ 153"
			}, {
				"ename": "КВАРТАЛ 158"
			}, {
				"ename": "КВАРТАЛ 159"
			}, {
				"ename": "КВАРТАЛ 160"
			}, {
				"ename": "КВАРТАЛ 161"
			}, {
				"ename": "КВАРТАЛ 162"
			}, {
				"ename": "КВАРТАЛ 164"
			}, {
				"ename": "КВАРТАЛ 166"
			}, {
				"ename": "КВАРТАЛ 167"
			}, {
				"ename": "КВАРТАЛ 168"
			}, {
				"ename": "КВАРТАЛ 169"
			}, {
				"ename": "КВАРТАЛ 170"
			}, {
				"ename": "КВАРТАЛ 172"
			}, {
				"ename": "КВАРТАЛ 187"
			}, {
				"ename": "КВАРТАЛ 189"
			}, {
				"ename": "КВАРТАЛ 197"
			}, {
				"ename": "КВАРТАЛ 199"
			}, {
				"ename": "УЛИЦА 1 Бадам"
			}, {
				"ename": "ТУПИК 1-й Конститутции"
			}, {
				"ename": "ТУПИК 1-ши Гагарина"
			}, {
				"ename": "КВАРТАЛ 200"
			}, {
				"ename": "КВАРТАЛ 201"
			}, {
				"ename": "КВАРТАЛ 205"
			}, {
				"ename": "КВАРТАЛ 206"
			}, {
				"ename": "КВАРТАЛ 207"
			}, {
				"ename": "КВАРТАЛ 209"
			}, {
				"ename": "КВАРТАЛ 212"
			}, {
				"ename": "КВАРТАЛ 213"
			}, {
				"ename": "КВАРТАЛ 214"
			}, {
				"ename": "КВАРТАЛ 215"
			}, {
				"ename": "КВАРТАЛ 216"
			}, {
				"ename": "КВАРТАЛ №279"
			}, {
				"ename": "КВАРТАЛ №283"
			}, {
				"ename": "КВАРТАЛ №284"
			}, {
				"ename": "КВАРТАЛ №285"
			}, {
				"ename": "КВАРТАЛ №287"
			}, {
				"ename": "КВАРТАЛ №288"
			}, {
				"ename": "КВАРТАЛ №289"
			}, {
				"ename": "КВАРТАЛ 291"
			}, {
				"ename": "КВАРТАЛ №292"
			}, {
				"ename": "КВАРТАЛ №293"
			}, {
				"ename": "КВАРТАЛ №294"
			}, {
				"ename": "КВАРТАЛ 295"
			}, {
				"ename": "КВАРТАЛ №296"
			}, {
				"ename": "КВАРТАЛ №297"
			}, {
				"ename": "ТУПИК 2-й Гагарина"
			}, {
				"ename": "ТУПИК 2-й Конституции"
			}, {
				"ename": "ПРОЕЗД 2-й Коргасыншылар"
			}, {
				"ename": "УЛИЦА 2-ой Гульбах"
			}, {
				"ename": "УЛИЦА 30 лет Октября"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Абайский, ОБЛАСТЬ Карагандинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, ПОСЕЛОК Карабас"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 035, ПОСЕЛОК Топар"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 036, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 036, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, ПОСЕЛОК Южный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 054, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 054, ПОСЕЛОК Южный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 055, ПОСЕЛОК Южный"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 057, ПОСЕЛОК Южный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 058, ПОСЕЛОК Южный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 060, ПОСЕЛОК Южный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 060, ПОСЕЛОК Топар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 063, ПОСЕЛОК Топар"
			}, {
				"ename": "КВАРТАЛ 1, ПОСЕЛОК Южный"
			}, {
				"ename": "КВАРТАЛ 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 1, ПОСЕЛОК Топар"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЛИЦА 10 лет независимости РК, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 11, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 12, ПОСЕЛОК Топар"
			}, {
				"ename": "КВАРТАЛ 13, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 14, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "ЛИНИЯ 14, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 15, ПОСЕЛОК Топар"
			}, {
				"ename": "КВАРТАЛ 15, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 17 (017), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ 1-го квартала (Гаражный массив 1-го квартала), ПОСЕЛОК Топар"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ 1 Квартал, ПОСЕЛОК Топар"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Строительный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "ПЕРЕУЛОК 1-ый Школьный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 2, ПОСЕЛОК Топар"
			}, {
				"ename": "КВАРТАЛ 2, ПОСЕЛОК Южный"
			}, {
				"ename": "КВАРТАЛ 20, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 23, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 25, ПОСЕЛОК Топар"
			}, {
				"ename": "КВАРТАЛ 26, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 27, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 29А, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "ПЕРЕУЛОК 2-ой Школьный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 30, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 30А, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 31, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 32, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 33, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 34, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 35, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЛИЦА 35 объект, ПОСЕЛОК Карабас"
			}, {
				"ename": "КВАРТАЛ 37, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КАДАСТРОВЫЙ КВАРТАЛ 37, ПОСЕЛОК Топар"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Строительный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 40, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 40, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "ПЕРЕУЛОК 4-ый Строительный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 5, ПОСЕЛОК Топар"
			}, {
				"ename": "РЯД 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Абай"
			}, {
				"ename": "КВАРТАЛ 6, ПОСЕЛОК Южный"
			}, {
				"ename": "КВАРТАЛ 7, ПОСЕЛОК Топар"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Айтекебийский, ОБЛАСТЬ Актюбинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, ОТДЕЛЕНИЕ Улгайсын, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Ушкатты, СЕЛЬСКИЙ ОКРУГ Ушкаттинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Аралтобе, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Жабасак, СЕЛЬСКИЙ ОКРУГ Жабасакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Талдысай, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Айке, СЕЛЬСКИЙ ОКРУГ Айкенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Милысай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 01, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Белкопа, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Аралтобе, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧАСТОК 02, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Актасты, СЕЛЬСКИЙ ОКРУГ Актастынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Милысай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, ОТДЕЛЕНИЕ Улгайсын, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 02, СЕЛО Айке, СЕЛЬСКИЙ ОКРУГ Айкенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Айке, СЕЛЬСКИЙ ОКРУГ Айкенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 03, СЕЛО Аралтобе, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 04, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 04, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 04, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 04, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 04, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 04, СЕЛО Айке, СЕЛЬСКИЙ ОКРУГ Айкенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 06, СЕЛО Талдык, СЕЛЬСКИЙ ОКРУГ Кайрактинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 06, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 06, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 06, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 09, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 09, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 09, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Белкопа, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "ЗИМОВКА 1, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Жароткель, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Талдысай, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Актасты, СЕЛЬСКИЙ ОКРУГ Актастынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "ТУПИК 1, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1, СЕЛО Айке, СЕЛЬСКИЙ ОКРУГ Айкенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 10, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 10, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 11, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 12, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 13, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 14, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 15, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЛИЦА №1 көше, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 1 Отделение, СЕЛО Сарат, СЕЛЬСКИЙ ОКРУГ Саратский"
			}, {
				"ename": "УЧАСТОК 1-Участок, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 2, СЕЛО Талдысай, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 2, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 2, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "ФЕРМА 2 Бөлімше, СЕЛО Талдысай, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 3, СЕЛО Милысай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧАСТОК 33, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЛИЦА №4 көше, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЛИЦА 50 лет Казахстан, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 6, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 7, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 7, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 7, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 8, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 8, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 8, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 83, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 9, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 9, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Сарат, СЕЛЬСКИЙ ОКРУГ Саратский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Темирбек Жургенов"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ушкатты, СЕЛЬСКИЙ ОКРУГ Ушкаттинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Сулуколь, СЕЛЬСКИЙ ОКРУГ Сулукольский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кумкудык, СЕЛЬСКИЙ ОКРУГ Кумкудыкский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Аралтогай, СЕЛЬСКИЙ ОКРУГ Аралтогайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Карабутак, СЕЛЬСКИЙ ОКРУГ Карабутакский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Айыртауский, ОБЛАСТЬ Северо-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 1 Мая, СЕЛО Имантау, СЕЛЬСКИЙ ОКРУГ Имантауский"
			}, {
				"ename": "УЛИЦА 1МАЯ, СЕЛО Агынтай Батыр, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА 30летПобеды, СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Абай (Советская), СЕЛО Антоновка, СЕЛЬСКИЙ ОКРУГ Антоновский"
			}, {
				"ename": "УЛИЦА Абай (Советская), СЕЛО Айыртау, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Абай (Ленина), СЕЛО Кирилловка, СЕЛЬСКИЙ ОКРУГ Украинский"
			}, {
				"ename": "УЛИЦА Абай (Ленина), СЕЛО Лобаново, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Абай (Ворошилова), СЕЛО Имантау, СЕЛЬСКИЙ ОКРУГ Имантауский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Светлое, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кумтоккен, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Каменный-Брод, СЕЛЬСКИЙ ОКРУГ Украинский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Автогородок, СЕЛО Антоновка, СЕЛЬСКИЙ ОКРУГ Антоновский"
			}, {
				"ename": "УЛИЦА Акана Сере, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Акан-Сере, СЕЛО Укили Ыбырай, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Акан-Сере, СЕЛО Кумтоккен, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Ақан Сері (К.Маркса), СЕЛО Имантау, СЕЛЬСКИЙ ОКРУГ Имантауский"
			}, {
				"ename": "УЛИЦА Ақан Сері (Ленина), СЕЛО Антоновка, СЕЛЬСКИЙ ОКРУГ Антоновский"
			}, {
				"ename": "УЛИЦА Ақан Сері (Урицкого), СЕЛО Лобаново, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Акколь, СЕЛО Альжан, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Алматинская, СЕЛО Целинное, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Алматинская, СЕЛО Светлое, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Аманжол, СЕЛО Каратал, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА А.М. Михедько (Советская), СЕЛО Константиновка, СЕЛЬСКИЙ ОКРУГ Константиновский"
			}, {
				"ename": "УЛИЦА Антоновская, СЕЛО Комаровка, СЕЛЬСКИЙ ОКРУГ Антоновский"
			}, {
				"ename": "УЛИЦА Ардагерлер, СЕЛО Ботай, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Асеева, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Атп, СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Атыгай, СЕЛО Сырымбет, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Ауельбекова, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Байжуман, СЕЛО Бирлестык, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "МИКРОРАЙОН Байтерек, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Шалкар, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Б.Аманжолова, СЕЛО Кумтоккен, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Бауыржана, СЕЛО Качиловка, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Бәйкен Әшімов (Кирова), СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Бәйкен Әшімов (Достык), СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Белорусская, СЕЛО Береславка, СЕЛЬСКИЙ ОКРУГ Гусаковский"
			}, {
				"ename": "УЛИЦА Белорусская, СЕЛО Казанка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Белорусская, СЕЛО Гусаковка, СЕЛЬСКИЙ ОКРУГ Гусаковский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Галицино, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА берег оз, Айыртаучик, СЕЛО Лобаново, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Берег оз.Шалкар, СЕЛО Шалкар, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "ОТДЕЛЕНИЕ Березка, СЕЛО Имантау, СЕЛЬСКИЙ ОКРУГ Имантауский"
			}, {
				"ename": "УЛИЦА Березовая, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Березовая, СЕЛО Новоукраинка, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Бірлік (С. Разина), СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Богачева, СЕЛО Воскресеновка, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Богенбая, СЕЛО Егиндыагаш, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Боканова, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Казанка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Куспек, СЕЛЬСКИЙ ОКРУГ Константиновский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Быковского, СЕЛО Новоукраинка, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Василий Антонов (Буденный), СЕЛО Лобаново, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Кoрсаковка, СЕЛЬСКИЙ ОКРУГ Гусаковский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Всеволодовка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Береславка, СЕЛЬСКИЙ ОКРУГ Гусаковский"
			}, {
				"ename": "УЛИЦА Возле Тока, СЕЛО Орловка, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Ворошилова, СЕЛО Целинное, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Светлое, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Сырымбет, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Новосветловка, СЕЛЬСКИЙ ОКРУГ Гусаковский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Горем-22, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Горная, СЕЛО Агынтай Батыр, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Имантау, СЕЛЬСКИЙ ОКРУГ Имантауский"
			}, {
				"ename": "УЛИЦА Губарькова, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Дамбаская, СЕЛО Светлое, СЕЛЬСКИЙ ОКРУГ Камсактинский"
			}, {
				"ename": "УЛИЦА Дачная, СЕЛО Куспек, СЕЛЬСКИЙ ОКРУГ Константиновский"
			}, {
				"ename": "УЛИЦА Дачная, СЕЛО Целинное, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Дачная, СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Д.Бедного, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Дмитриева, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Даукара, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Альжан, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Карасай Батыр, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Достық (Калинина), СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Достық (Совхозная), СЕЛО Сырымбет, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Достық (Пугачева), СЕЛО Имантау, СЕЛЬСКИЙ ОКРУГ Имантауский"
			}, {
				"ename": "УЛИЦА Достық (Куйбышева), СЕЛО Константиновка, СЕЛЬСКИЙ ОКРУГ Константиновский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА ДСУ 75, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Дэу, СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Ементаева, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Ералы Мұқашев (Ворошилова), СЕЛО Арыкбалык, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Еркін Әуелбеков (Ворошилов), СЕЛО Лобаново, СЕЛЬСКИЙ ОКРУГ Лобановский"
			}, {
				"ename": "УЛИЦА Есей, СЕЛО Каратал, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Жамбыла, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Жапек-Батыра, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Карасай Батыр, СЕЛЬСКИЙ ОКРУГ Арыкбалыкский"
			}, {
				"ename": "УЛИЦА Жасыл, СЕЛО Сулыколь, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Жасыл, СЕЛО Айыртауское, СЕЛЬСКИЙ ОКРУГ Елецкий"
			}, {
				"ename": "УЛИЦА Жасыл, СЕЛО Шолакозек, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Ждс, СЕЛО Саумалколь, СЕЛЬСКИЙ ОКРУГ Володарский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Акжаикский, ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "ПЕРЕУЛОК 10, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ПЕРЕУЛОК 11, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 11, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 12, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 13, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 16, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЧАСТОК 1км автомобильной дороги Чапаево-Жангала, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЧАСТОК 1кмЧапаево-Жангала, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Алгабас, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Есенсай, СЕЛЬСКИЙ ОКРУГ Есенсайский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Бударино, СЕЛЬСКИЙ ОКРУГ Бударинский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Самал, СЕЛЬСКИЙ ОКРУГ Бударинский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Атамекен, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Кенсуат, СЕЛЬСКИЙ ОКРУГ Есенсайский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Базартобе, СЕЛЬСКИЙ ОКРУГ Базартобинский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Жубана Молдагалиева, СЕЛЬСКИЙ ОКРУГ Курайлысайский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Сайкудук, СЕЛЬСКИЙ ОКРУГ Курайлысайский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Жанама, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Конеккеткен, СЕЛЬСКИЙ ОКРУГ Конеккеткенский"
			}, {
				"ename": "ПЕРЕУЛОК 2, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ПЕРЕУЛОК 20, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 20, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ПЕРЕУЛОК 21, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 21, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ПЕРЕУЛОК 22, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 22, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ПЕРЕУЛОК 23, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ДОРОГА 264-Километр, СЕЛО Тайпак, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "ДОРОГА 272 км Уральск-Атырау, СЕЛО Тайпак, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "ТРАССА 273 километр трассы \\\\\\\"Атырау-Уральск\\\\\\\", СЕЛО Атамекен, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА 28, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 2 У, СЕЛО Конеккеткен, СЕЛЬСКИЙ ОКРУГ Конеккеткенский"
			}, {
				"ename": "ПЕРЕУЛОК 3, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 30, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 31, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 32, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 33, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 34, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 36, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 37, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ТРАССА 371 километр трассы Атырау-Уральск, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ТРАССА 372 километр трассы Атырау-Уральск, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ТРАССА 376 километр трассы \\\\\\\"Атырау-Уральск\\\\\\\", СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ТРАССА 390 км трассы \\\\\\\"Атырау-Уральск\\\\\\\", СЕЛО Жанабулак, СЕЛЬСКИЙ ОКРУГ Жанабулакский"
			}, {
				"ename": "УЛИЦА 4, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 40, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 41, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 42, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ЗИМОВКА 46 Лиман, СЕЛО Атамекен, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "ТРАССА 47 километр автотрассы Чапаев-Казталовка, СЕЛО Битик, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "ПЕРЕУЛОК 49, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ЗИМОВКА 49-Лиман, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА 5, СЕЛО Конеккеткен, СЕЛЬСКИЙ ОКРУГ Конеккеткенский"
			}, {
				"ename": "УЛИЦА 5, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 52, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 53, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 54, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 6, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 7, СЕЛО Конеккеткен, СЕЛЬСКИЙ ОКРУГ Конеккеткенский"
			}, {
				"ename": "ЗИМОВКА 73-километр, СЕЛО Коловертное, СЕЛЬСКИЙ ОКРУГ Бударинский"
			}, {
				"ename": "ПЕРЕУЛОК 8, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА 9, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ПЕРЕУЛОК 9, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА А.Айтиев, СЕЛО Лбищенское, СЕЛЬСКИЙ ОКРУГ Акжолский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Базаршолан, СЕЛЬСКИЙ ОКРУГ Базаршоланский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Сайкудук, СЕЛЬСКИЙ ОКРУГ Курайлысайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Мергенево, СЕЛЬСКИЙ ОКРУГ Мергеневский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Тайпак, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Жанама, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Сарман, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА А.Баяшев, СЕЛО Базаршолан, СЕЛЬСКИЙ ОКРУГ Базаршоланский"
			}, {
				"ename": "УЛИЦА Абдир Кашкенов, СЕЛО Тайпак, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "УЛИЦА Абдулов, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "ЗИМОВКА Абилсай, СЕЛО Жанабулак, СЕЛЬСКИЙ ОКРУГ Жанабулакский"
			}, {
				"ename": "УЛИЦА А.Бисенов, СЕЛО Шабдаржап, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "УЛИЦА Абулхаир Хан, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "УЛИЦА Абу Сембаев, СЕЛО Жанама, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА Абылай Хан, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "ЗИМОВКА Авангард, СЕЛО Коловертное, СЕЛЬСКИЙ ОКРУГ Бударинский"
			}, {
				"ename": "ЗИМОВКА Аврам, СЕЛО Тайпак, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "УЛИЦА Автобаза, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ТРАССА Автодорога  \\\\\\\"Уральск-Атырау\\\\\\\" 199 км, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "ТРАССА Автодорога  \\\\\\\"Уральск-Атырау\\\\\\\" 371 км, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ЗИМОВКА Агапия, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Адил, СЕЛО Есенсай, СЕЛЬСКИЙ ОКРУГ Есенсайский"
			}, {
				"ename": "ЗИМОВКА Адил, СЕЛО Карагай, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА Азаттык, СЕЛО Тайпак, СЕЛЬСКИЙ ОКРУГ Тайпакский"
			}, {
				"ename": "УЛИЦА Азаттық, СЕЛО Кабыршакты, СЕЛЬСКИЙ ОКРУГ Кабыршактынский"
			}, {
				"ename": "ЗИМОВКА Азовсков, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА А.Иманов, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА А.Иманов, СЕЛО Карауылтобе, СЕЛЬСКИЙ ОКРУГ Карауылтобинский"
			}, {
				"ename": "ЗИМОВКА Айбатыр, СЕЛО Бударино, СЕЛЬСКИЙ ОКРУГ Бударинский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Аймырза, СЕЛО Конеккеткен, СЕЛЬСКИЙ ОКРУГ Конеккеткенский"
			}, {
				"ename": "УЛИЦА Айтеке Би, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}, {
				"ename": "ЗИМОВКА Айтжан, СЕЛО Сайкудук, СЕЛЬСКИЙ ОКРУГ Курайлысайский"
			}, {
				"ename": "УЛИЦА Айтиев, СЕЛО Чапаев, СЕЛЬСКИЙ ОКРУГ Чапаевский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Акжарский, ОБЛАСТЬ Северо-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 10 лет Казахстана, СЕЛО Восходское, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА 20 лет Целины, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА 25 лет Целины, СЕЛО Аксары, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА 30 лет Победы, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА 30 лет Целины, СЕЛО Казанское, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА 40 лет Каз ССР, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА 40 лет Октября, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Казанское, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА C.Сейфуллина, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "ТРАССА А-13 Кокшетау-Кишкенеколь-Бидайыкский-граница РФ, СЕЛО Дауит, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Абай (Октябрьская), СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ащиколь, СЕЛЬСКИЙ ОКРУГ Акжаркынский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Айсаринское, СЕЛЬСКИЙ ОКРУГ Айсаринский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кіші Қараой, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Кулыкольский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кулыколь, СЕЛЬСКИЙ ОКРУГ Кулыкольский"
			}, {
				"ename": "ПЕРЕУЛОК Абая, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Аблайхана, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Аблайхана, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Аблайхана, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Аблай хана, СЕЛО Восходское, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Аблай хана, СЕЛО Аксай, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Абылай Хан (Советская), СЕЛО Кулыколь, СЕЛЬСКИЙ ОКРУГ Кулыкольский"
			}, {
				"ename": "УЛИЦА Абылай Хан (Комсомольская), СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Абылай Хан (Горького), СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Байтус, СЕЛЬСКИЙ ОКРУГ Кенащинский"
			}, {
				"ename": "УЛИЦА Абылай Хана, СЕЛО Ащиколь, СЕЛЬСКИЙ ОКРУГ Акжаркынский"
			}, {
				"ename": "УЛИЦА Автомобильная, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Автомобильная, СЕЛО Дауит, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА А.Иманова, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Акана Сери, СЕЛО Бостандык, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Акан Сери, СЕЛО Айсаринское, СЕЛЬСКИЙ ОКРУГ Айсаринский"
			}, {
				"ename": "УЛИЦА Акан Сери, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Ақан сері (Советская), СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Ақан Сері, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Аккаин, СЕЛО Тугуржап, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Алкатерек, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Алматинская, СЕЛО Кызылту, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Алтынсарин, СЕЛО Айсаринское, СЕЛЬСКИЙ ОКРУГ Айсаринский"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Аль-Фараби, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Восходское, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Аксары, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Бостандык, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Ауезов, СЕЛО Айсаринское, СЕЛЬСКИЙ ОКРУГ Айсаринский"
			}, {
				"ename": "УЛИЦА Ауыл, СЕЛО Айсаринское, СЕЛЬСКИЙ ОКРУГ Айсаринский"
			}, {
				"ename": "УЛИЦА Ахметуали, СЕЛО Байтус, СЕЛЬСКИЙ ОКРУГ Кенащинский"
			}, {
				"ename": "УЛИЦА А.Чеховa, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Бауржан Момышулы, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы (Шевченко), СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Белорусская, СЕЛО Акжаркын, СЕЛЬСКИЙ ОКРУГ Акжаркынский"
			}, {
				"ename": "УЛИЦА Биржан Сал, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Биржан Сал, СЕЛО Айсаринское, СЕЛЬСКИЙ ОКРУГ Айсаринский"
			}, {
				"ename": "УЛИЦА Биржан-Сала, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Бостандыкcкая, СЕЛО Аксары, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА Бостандыкская, СЕЛО Бостандык, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Булак, СЕЛО Тугуржап, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Валиханова, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Валиханова, СЕЛО Кіші Қараой, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Ветеринарная, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Вокзальная, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Ворошилова, СЕЛО Дауит, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Кулыкольский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Аксай, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Кулыколь, СЕЛЬСКИЙ ОКРУГ Кулыкольский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Кызылту, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Восходское, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Кенащы, СЕЛЬСКИЙ ОКРУГ Кенащинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Кіші Қараой, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Газиза Кусаинова, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Гайлис, СЕЛО Кенащы, СЕЛЬСКИЙ ОКРУГ Кенащинский"
			}, {
				"ename": "УЛИЦА Гаражная, СЕЛО Ульгили, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Гвардейская, СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Ленинградское, СЕЛЬСКИЙ ОКРУГ Ленинградский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Динмухамед Кунаева, СЕЛО Восходское, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Донецкая, СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Алкатерек, СЕЛЬСКИЙ ОКРУГ Алкатерекский"
			}, {
				"ename": "УЛИЦА Дружба, СЕЛО Бостандык, СЕЛЬСКИЙ ОКРУГ Кишикаройский"
			}, {
				"ename": "УЛИЦА Дружба, СЕЛО Восходское, СЕЛЬСКИЙ ОКРУГ Восходский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Кенащы, СЕЛЬСКИЙ ОКРУГ Кенащинский"
			}, {
				"ename": "УЛИЦА Едіге Батыр (Мичурина), СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова (М.Ломоносова), СЕЛО Талшык, СЕЛЬСКИЙ ОКРУГ Талшыкский"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова (Ленина), СЕЛО Горьковское, СЕЛЬСКИЙ ОКРУГ Үлкен Қараой"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аккайынский, ОБЛАСТЬ Северо-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 1 Мая, СЕЛО Ивановка, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "УЛИЦА 1 Улица, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "УЛИЦА 25 лет Целины, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА 25 лет Целины, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА 2 Улица, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "ПРОЕЗД 3, СЕЛО Токуши, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА 3 Улица, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА 40 лет Целины, СЕЛО Черкасское, СЕЛЬСКИЙ ОКРУГ Черкасский"
			}, {
				"ename": "УЛИЦА 4 Улица, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Ивановка, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Власовка, СЕЛЬСКИЙ ОКРУГ Власовский"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Абай (Ленина), СЕЛО Власовка, СЕЛЬСКИЙ ОКРУГ Власовский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Киялы, СЕЛЬСКИЙ ОКРУГ Киялинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Рублевка, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Аралагаш, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Трудовое, СЕЛЬСКИЙ ОКРУГ Григорьевский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Черкасское, СЕЛЬСКИЙ ОКРУГ Черкасский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Аблай Хана, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Аккайын, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Ақкөл (Проезд 4), СЕЛО Камышлово, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Алексея Щербакова (Кирова), СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Рублевка, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Анатолия Захарова, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "ТРАССА Астана-Петропавловск, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Астықты, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Асфальтная, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА А. Сыздыкова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Барыкуль, СЕЛО Барыколь, СЕЛЬСКИЙ ОКРУГ Киялинский"
			}, {
				"ename": "УЛИЦА Батыр Баян, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Безымянная, СЕЛО Аралагаш, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Новостроительная), СЕЛО Аралагаш, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Проезд 3), СЕЛО Камышлово, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "ПРОЕЗД Бәйтерек (1), СЕЛО Токуши, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Березовая, СЕЛО Борки, СЕЛЬСКИЙ ОКРУГ Полтавский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Южное, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "ПРОЕЗД Бірлік (2), СЕЛО Токуши, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Бірлік (70 лет Октября), СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "РАЗЪЕЗД Бозарал (4 разъезд), СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "ПЕРЕУЛОК Больничный Городок, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Вадима Буторина, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Василия Мордвинова (Первая), СЕЛО Тюменка, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Борки, СЕЛЬСКИЙ ОКРУГ Полтавский"
			}, {
				"ename": "УЛИЦА Виталия Лизуна (Ленина), СЕЛО Безлесное, СЕЛЬСКИЙ ОКРУГ Власовский"
			}, {
				"ename": "УЛИЦА Владимира Макаренко, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Токуши, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Южное, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Рублевка, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Власовка, СЕЛЬСКИЙ ОКРУГ Власовский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Киялы, СЕЛЬСКИЙ ОКРУГ Киялинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Григорьевка, СЕЛЬСКИЙ ОКРУГ Григорьевский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Гайдара, СЕЛО Токуши, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Гастелло, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Г.Мусрепова, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Киялы, СЕЛЬСКИЙ ОКРУГ Киялинский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Токуши, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Дайындык, СЕЛО Дайындык, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Степное, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Дінмұхаммед Қонаев, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Киялы, СЕЛЬСКИЙ ОКРУГ Киялинский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Трудовое, СЕЛЬСКИЙ ОКРУГ Григорьевский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "ПЕРЕУЛОК Дорожный, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Дайындык, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Шагалалы, СЕЛЬСКИЙ ОКРУГ Шагалалы"
			}, {
				"ename": "УЛИЦА Достық (Вторая), СЕЛО Тюменка, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Достық (Эристонская), СЕЛО Власовка, СЕЛЬСКИЙ ОКРУГ Власовский"
			}, {
				"ename": "УЛИЦА Евней Бөкетов (Буденного), СЕЛО Ивановка, СЕЛЬСКИЙ ОКРУГ Ивановский"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова (Пионерская), СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Еңбек (Проезд 5), СЕЛО Камышлово, СЕЛЬСКИЙ ОКРУГ Токушинский"
			}, {
				"ename": "УЛИЦА Еңбек, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Жамбыл Жабаев, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "РАЗЪЕЗД Жанажол, СЕЛО Черкасское, СЕЛЬСКИЙ ОКРУГ Черкасский"
			}, {
				"ename": "РАЗЪЕЗД Жаңажол (5 Разъезд), СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "РАЗЪЕЗД Жаңа Тұрмыс (Разъезд 1), СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Жансүгір батыр, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Жәлел Қизатов, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Желтоқсан, СЕЛО Ленинское, СЕЛЬСКИЙ ОКРУГ Лесной"
			}, {
				"ename": "УЛИЦА Ж.Жабаева, СЕЛО Аралагаш, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Ж. Жабаева, СЕЛО Рублевка, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Ж. Жабаева, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Аралагашский"
			}, {
				"ename": "УЛИЦА Животноводческая, СЕЛО Власовка, СЕЛЬСКИЙ ОКРУГ Власовский"
			}, {
				"ename": "УЛИЦА Жумабаева, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}, {
				"ename": "УЛИЦА Заводская, СЕЛО Смирново, СЕЛЬСКИЙ ОКРУГ Смирновский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аккольский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "КВАРТАЛ 011, СЕЛО Азат"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ШОССЕ 172 км. Акколь-Минское племенное хозяйство, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА 1 Шегебая Узакбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "РАЗЪЕЗД 29, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА 2 Шегебая Узакбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "РАЗЪЕЗД 30, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА 3 Шегебая Узакбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА 4 Шегебая Узакбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Абай (Привокзальная), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Абылай хана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Адильбека Майкотова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Азат, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Акжол, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Акниет, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Алаш, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Аманат (Абая Кунанбаева), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Арай, СЕЛО Азат"
			}, {
				"ename": "ПЕРЕУЛОК Армандастар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "МИКРОРАЙОН Астана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ТРАССА Астана-Петропавловск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ТРАССА Астана-Петропавловск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ТРАССА Астана-Петропавловск 94 км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Атамекен (Горная), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Балуан Шолак, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Баубека Булкышева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Бейимбета Майлина (Бейимбета Майлина, Бейімбет Майлин), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Береке, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Богенбая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Божен, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Болашак, СЕЛО Азат"
			}, {
				"ename": "ЗАИМКА Бужум, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Булавского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Гагарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Гани Муратбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Гоголя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ПЕРЕУЛОК Горный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Горького, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ПЕРЕУЛОК Госнитиевский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Домбай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Домбыралы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Достар, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Достык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Әл-Фараби (Мира), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Енбек, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Жагалау (Береговая), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жайыка Бектурова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жана Ел, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Жастар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жасыл, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Желтоксан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жеруйык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Жибек жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ПЕРЕУЛОК Заводской, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Иващука, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Ильяса Жансугурова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Интернациональная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Исакова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Исатая Тайманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Кайыма Мухамедханова (К.Мухаметханова, 1 Кайыма Мухамедханова), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Каныша Сатпаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Кара-Найза, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Каукен Кенжетаева (Каукена Кенжетаева), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Кирдищева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Ключевая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Коктал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Коктем, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Кулагер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Куляш Байсеитовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Курылыс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Лесная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Линейная 390км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Луганская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Маншук Маметовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Моншакты, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Мухтара Ауезова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Онтустик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "ПЕРЕУЛОК Опытно-заводской, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Орлеу, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Орталык, СЕЛО Азат"
			}, {
				"ename": "УЛИЦА Островского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Панфилова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Парковая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}, {
				"ename": "УЛИЦА Пушкина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Акколь"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аққулы, ОБЛАСТЬ Павлодарская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 11, СЕЛО Малыбай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА 1 Мамыр, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА 40 лет Казахстана, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шоктал, СЕЛЬСКИЙ ОКРУГ Шакинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Майкарагай, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шабар, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ямышево, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Имени Абылхаира Баймульдина, СЕЛЬСКИЙ ОКРУГ Баймульдинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Мергалым, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Малыбай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Абугали Сальменова, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Абылкайыра Баймолдина, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Аипа Кусаинова, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Айгожы Сакиянова, СЕЛО Ямышево, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Айдархана Жумабекова, СЕЛО Шабар, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Айдархана Искакова, СЕЛО Тлектес, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Майкарагай, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Такир, СЕЛЬСКИЙ ОКРУГ Баймульдинский"
			}, {
				"ename": "УЛИЦА Амин Умурзаков, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Аргынбаева, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Асаубая Ахметова, СЕЛО Кызылкогам, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Астана (Степная), СЕЛО Имени Абылхаира Баймульдина, СЕЛЬСКИЙ ОКРУГ Баймульдинский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Малыбай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Атамекен, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Байзакова, СЕЛО Шоктал, СЕЛЬСКИЙ ОКРУГ Шакинский"
			}, {
				"ename": "УЛИЦА Баймагамбетова (Баймагамбетова), СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Баймолдинова, СЕЛО Малыбай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Баймульдина, СЕЛО Имени Абылхаира Баймульдина, СЕЛЬСКИЙ ОКРУГ Баймульдинский"
			}, {
				"ename": "УЛИЦА Балгабая Оспанова, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Башира Аубакирова, СЕЛО Тлектес, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Тосагаш, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Малыбай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Бәйтерек, СЕЛО Малыбай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Казантай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Тосагаш, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Жанатан, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Болашак, СЕЛО Тосагаш, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Всеволода Иванова (Всеволод Иванова), СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Всеволода Иванова (Всеволод Иванова), СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "ПЕРЕУЛОК Гагарина, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Шака, СЕЛЬСКИЙ ОКРУГ Шакинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Имени Абылхаира Баймульдина, СЕЛЬСКИЙ ОКРУГ Баймульдинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Джанхотов Сальмурза, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Жабаглы, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Достық, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Елизаветы Головушкиной, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Енбекши, СЕЛО Казантай, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Еңбекшілер, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Жабаева, СЕЛО Майкарагай, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Жағалау, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Жамбыл, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Жамбыла, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Жанааульская (Жанаульская), СЕЛО Мергалым, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Жангелдина, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Жангельды, СЕЛО Майкарагай, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Жанпеиса Сыздыкова, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Ямышево, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Желтоқсан, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Желтоқсан, СЕЛО Айтей, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Жолжиек (Дорожная), СЕЛО Имени Абылхаира Баймульдина, СЕЛЬСКИЙ ОКРУГ Баймульдинский"
			}, {
				"ename": "УЛИЦА Жумабека Жангожина, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Заводская, СЕЛО Шака, СЕЛЬСКИЙ ОКРУГ Шакинский"
			}, {
				"ename": "УЛИЦА Ибрая Алтынсарина, СЕЛО Шарбакты, СЕЛЬСКИЙ ОКРУГ Шарбактинский"
			}, {
				"ename": "УЛИЦА Ивана Синицина, СЕЛО Ямышево, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Идрисханова, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Исы Байзакова, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Исы Байзакова, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Исы Байзакова, СЕЛО Майкарагай, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Кабдыжапар Есимова, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Кабдылказы Айткалиева, СЕЛО Шоктал, СЕЛЬСКИЙ ОКРУГ Шакинский"
			}, {
				"ename": "УЛИЦА Кабыкен Сыздыкбаев, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Кадырбаева, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Казбек Жапаров, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Каирбаева, СЕЛО Мергалым, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Каиркена Динкина, СЕЛО Кызылкогам, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Кайрат, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЛИЦА Кайырбая Абетова, СЕЛО Аққулы, СЕЛЬСКИЙ ОКРУГ Аққулы"
			}, {
				"ename": "УЛИЦА Калел Темиржанов, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}, {
				"ename": "УЛИЦА Калиева, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Калы Дуйсенова (Калы Дюсенова), СЕЛО Кызылкогам, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Канаша Камзина, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Каныша Сатпаева, СЕЛО Казы, СЕЛЬСКИЙ ОКРУГ Малыбайский"
			}, {
				"ename": "УЛИЦА Каныша Сатпаева, СЕЛО Майкарагай, СЕЛЬСКИЙ ОКРУГ Майкарагайский"
			}, {
				"ename": "УЛИЦА Каныша Сатпаева, СЕЛО Ямышево, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Капсаттара Смаилова, СЕЛО Ямышево, СЕЛЬСКИЙ ОКРУГ Ямышевский"
			}, {
				"ename": "УЛИЦА Каримжан Апсаликова, СЕЛО Қарақала, СЕЛЬСКИЙ ОКРУГ Қарақала"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аксу, ОБЛАСТЬ Павлодарская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045"
			}, {
				"ename": "ЛИНИЯ 1"
			}, {
				"ename": "УЛИЦА 1У"
			}, {
				"ename": "ЛИНИЯ 2"
			}, {
				"ename": "УЛИЦА 2"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 237"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 252"
			}, {
				"ename": "УЛИЦА 3"
			}, {
				"ename": "ЛИНИЯ 3"
			}, {
				"ename": "ЛИНИЯ 4"
			}, {
				"ename": "УЛИЦА 4"
			}, {
				"ename": "УЛИЦА 5"
			}, {
				"ename": "УЛИЦА 8 Марта"
			}, {
				"ename": "УЛИЦА Абая"
			}, {
				"ename": "УЛИЦА Абая поселок Аксу"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Автомобилист-Аксу"
			}, {
				"ename": "УЛИЦА Аксу"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Аксу"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой"
			}, {
				"ename": "УЛИЦА Амангельды"
			}, {
				"ename": "УЛИЦА Астана"
			}, {
				"ename": "УЛИЦА Ауэзова поселок Аксу"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынов"
			}, {
				"ename": "УЛИЦА Бауыржана Момышұлы"
			}, {
				"ename": "УЛИЦА Береговая"
			}, {
				"ename": "УЛИЦА Березовая"
			}, {
				"ename": "УЛИЦА Больничная"
			}, {
				"ename": "УЛИЦА Весенняя"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ Ветеран-Аксу"
			}, {
				"ename": "УЛИЦА Вокзальная"
			}, {
				"ename": "УЛИЦА Гагарина"
			}, {
				"ename": "УЛИЦА Гайдара"
			}, {
				"ename": "УЛИЦА Гайдара поселок Аксу"
			}, {
				"ename": "УЛИЦА Горького"
			}, {
				"ename": "УЛИЦА Дачная"
			}, {
				"ename": "УЛИЦА Донентаева"
			}, {
				"ename": "УЛИЦА Дружбы"
			}, {
				"ename": "УЛИЦА Әлихан Бөкейханов"
			}, {
				"ename": "УЛИЦА Ермухан Бекмаханов"
			}, {
				"ename": "УЛИЦА Жамбыла"
			}, {
				"ename": "УЛИЦА Железнодорожная"
			}, {
				"ename": "УЛИЦА Желтоксан"
			}, {
				"ename": "УЛИЦА Желтоксан (Беловка)"
			}, {
				"ename": "УЛИЦА Западная"
			}, {
				"ename": "УЛИЦА Зеленая"
			}, {
				"ename": "УЛИЦА Ивана Суптеля"
			}, {
				"ename": "УЛИЦА имени Алиева Али Омара"
			}, {
				"ename": "УЛИЦА имени Владимира Новика"
			}, {
				"ename": "УЛИЦА имени Ильяса Оспанова"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Индивидуальный предприниматель Идрисова"
			}, {
				"ename": "УЛИЦА Интернациональная"
			}, {
				"ename": "УЛИЦА Иртышская"
			}, {
				"ename": "ПРОЕЗД І"
			}, {
				"ename": "ПРОЕЗД ІІ"
			}, {
				"ename": "ПРОЕЗД ІІІ"
			}, {
				"ename": "УЛИЦА Қажымұқан Мұңайтпасов"
			}, {
				"ename": "УЛИЦА Казахстанская"
			}, {
				"ename": "УЛИЦА Калинина"
			}, {
				"ename": "УЛИЦА Камзина"
			}, {
				"ename": "УЛИЦА Қаныш Сәтбаев"
			}, {
				"ename": "УЛИЦА Карагандинская"
			}, {
				"ename": "УЛИЦА Карла Маркса"
			}, {
				"ename": "УЛИЦА Каукен Кенжетаев"
			}, {
				"ename": "УЛИЦА Квартал Новый"
			}, {
				"ename": "УЛИЦА Комсомола"
			}, {
				"ename": "УЛИЦА Комсомольская"
			}, {
				"ename": "УЛИЦА Конечная"
			}, {
				"ename": "УЛИЦА Космонавтов"
			}, {
				"ename": "УЛИЦА Ленина"
			}, {
				"ename": "УЛИЦА Лермонтова"
			}, {
				"ename": "УЛИЦА Линия"
			}, {
				"ename": "УЛИЦА Луговая"
			}, {
				"ename": "УЛИЦА Луговая поселок Аксу"
			}, {
				"ename": "УЛИЦА Лютикова"
			}, {
				"ename": "УЛИЦА Майская"
			}, {
				"ename": "УЛИЦА Майская (Черемушки)"
			}, {
				"ename": "УЛИЦА Малайсары Батыра"
			}, {
				"ename": "УЛИЦА Маншук Маметовой"
			}, {
				"ename": "УЛИЦА Металлистов"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ Металлург"
			}, {
				"ename": "УЛИЦА Металлургов"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Механизатор"
			}, {
				"ename": "УЛИЦА М.О. Ауэзова"
			}, {
				"ename": "УЛИЦА Набережная"
			}, {
				"ename": "УЛИЦА Набережная поселок Аксу"
			}, {
				"ename": "УЛИЦА Народная"
			}, {
				"ename": "УЛИЦА Нефтебаза"
			}, {
				"ename": "УЛИЦА Николая Бердникова"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Общество гаражей Ферросплавщик"
			}, {
				"ename": "УЛИЦА Октябрьская"
			}, {
				"ename": "УЛИЦА Парковая"
			}, {
				"ename": "УЛИЦА Пионерская"
			}, {
				"ename": "УЛИЦА Победы"
			}, {
				"ename": "УЛИЦА Полевая"
			}, {
				"ename": "УЛИЦА Проезд І поселок Аксу"
			}, {
				"ename": "УЛИЦА Промышленная"
			}, {
				"ename": "УЛИЦА Промышленная поселок Аксу"
			}, {
				"ename": "УЛИЦА Пушкина"
			}, {
				"ename": "УЛИЦА Рождественская"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Садоводство Энергетик поселок Аксу"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Ақсуат, ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "КВАРТАЛ 1, СЕЛО Каргыба, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "КВАРТАЛ 1, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 10, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 10, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 11, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 12, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 1 Квартал, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "КВАРТАЛ 1 Квартал, СЕЛО Мурсалим, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 2, СЕЛО Каргыба, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "КВАРТАЛ 2, СЕЛО Кокбастау, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "КВАРТАЛ 2, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 2, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 3, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 3, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 3, СЕЛО Каргыба, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "КВАРТАЛ 4, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 4, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 5, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 5, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 6, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 6, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЧАСТОК 60 Летняя, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "КВАРТАЛ 7, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 7, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 8, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КВАРТАЛ 8, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 9, СЕЛО Жантикей, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "КВАРТАЛ 9, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЛИЦА А.Аюпова, СЕЛО Ойшилик, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЛИЦА А.Байкыдырова, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "УЛИЦА А.Байтурсынова, СЕЛО Коктубек, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "УЧАСТОК Абат, СЕЛО Уштобе, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЧАСТОК Абат, СЕЛО Кызыл кесик, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "УЧАСТОК Абдилда, СЕЛО Кызыл кесик, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЧАСТОК Абдыраман, СЕЛО Ойшилик, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЛИЦА А.Бейсеуова, СЕЛО Томар, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Кызбай, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЛИЦА Абылая, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "УЧАСТОК Абылхайыр, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЧАСТОК Адилхан, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЛИЦА А.Жубанова, СЕЛО Тана мырза, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Аидабол, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЧАСТОК Айган, СЕЛО Ойшилик, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Айгуль, СЕЛО Аккала, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Айдос, СЕЛО Сериктес, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Айдос, СЕЛО Базарка, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЛИЦА Айманова, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "УЧАСТОК Айнабастау, СЕЛО Айнабастау, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Акбадеш, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "УЧАСТОК Акбаз, СЕЛО Есим, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Акбаз, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "ЗИМОВКА Акбаз, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "ЗИМОВКА Акбас, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЧАСТОК Акерке, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЧАСТОК Акжайлау, СЕЛО Кызыл кесик, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "ЗИМОВКА Акжайлау, СЕЛО Уштобе, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЧАСТОК Акжал, СЕЛО Акжал, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Акжол, СЕЛО Кожагельды, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "УЧАСТОК Акжол, СЕЛО Киндикты, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}, {
				"ename": "УЧАСТОК Аккезен, СЕЛО Уштобе, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Кызыл кесик, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Уштобе, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЧАСТОК Аккудык, СЕЛО Сатпаев, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "УЧАСТОК Аккудык, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "УЧАСТОК Акой, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЧАСТОК Акой, СЕЛО Коктубек, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "УЧАСТОК Ак Ой, СЕЛО Сатпаев, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "ЗИМОВКА Актас, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "УЧАСТОК Актогай, СЕЛО Киндикты, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}, {
				"ename": "ЗИМОВКА Ақшағыл, СЕЛО Кокжол, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "ЗИМОВКА Акши, СЕЛО Томар, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Акши, СЕЛО Ойшилик, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "ЗИМОВКА Ақши, СЕЛО Киндикты, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}, {
				"ename": "УЧАСТОК Акшоки, СЕЛО Кызыл кесик, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЧАСТОК Алабас, СЕЛО Ойшилик, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЛИЦА Алгабас, СЕЛО Алгабас, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}, {
				"ename": "УЧАСТОК Али, СЕЛО Есим, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "ЗИМОВКА Алиби, СЕЛО Кокбастау, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЧАСТОК Алтыбай, СЕЛО Кумголь, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЧАСТОК Алтыбай, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "МИКРОРАЙОН Алтыншы, СЕЛО Киндикты, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}, {
				"ename": "ЗИМОВКА Алшын, СЕЛО Уштобе, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЧАСТОК Амангелді, СЕЛО Кызбай, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЛИЦА Амангелді Түндікбаев, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "УЛИЦА Аманкелди, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "УЛИЦА А.Маргулана, СЕЛО Кызылжулдыз, СЕЛЬСКИЙ ОКРУГ Кумгольский"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, СЕЛО Аксуат, СЕЛЬСКИЙ ОКРУГ Аксуатский"
			}, {
				"ename": "ЗИМОВКА Анжан, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "ЗИМОВКА Апар, СЕЛО Томар, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "УЧАСТОК Апар, СЕЛО Томар, СЕЛЬСКИЙ ОКРУГ Ойшиликский"
			}, {
				"ename": "ЗИМОВКА Араб, СЕЛО Кызыл кесик, СЕЛЬСКИЙ ОКРУГ Кызыл кесикский"
			}, {
				"ename": "УЛИЦА Арап Батыр, СЕЛО Кожагельды, СЕЛЬСКИЙ ОКРУГ Ыргызбайский"
			}, {
				"ename": "УЛИЦА Армандастар, СЕЛО Армандастар, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}, {
				"ename": "УЧАСТОК Аршалы, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "УЧАСТОК Ахмади, СЕЛО Кокжыра, СЕЛЬСКИЙ ОКРУГ Кокжиринский"
			}, {
				"ename": "ЗИМОВКА Ахмади, СЕЛО Екпин, СЕЛЬСКИЙ ОКРУГ Екпинский"
			}, {
				"ename": "УЧАСТОК Ашудасты, СЕЛО Киндикты, СЕЛЬСКИЙ ОКРУГ Киндиктинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аксуский, ОБЛАСТЬ Жетісу",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Ойтоган, СЕЛЬСКИЙ ОКРУГ Ойтоганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, СЕЛО Ойтоган, СЕЛЬСКИЙ ОКРУГ Ойтоганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Ойтоган, СЕЛЬСКИЙ ОКРУГ Ойтоганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Ойтоган, СЕЛЬСКИЙ ОКРУГ Ойтоганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, СЕЛО Барлыбек Сырттанов, СЕЛЬСКИЙ ОКРУГ Барлыбека Сырттанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, СЕЛО Барлыбек Сырттанов, СЕЛЬСКИЙ ОКРУГ Барлыбека Сырттанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Барлыбек Сырттанов, СЕЛЬСКИЙ ОКРУГ Барлыбека Сырттанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Суыксай, СЕЛЬСКИЙ ОКРУГ Суыксайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Барлыбек Сырттанов, СЕЛЬСКИЙ ОКРУГ Барлыбека Сырттанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Барлыбек Сырттанов, СЕЛЬСКИЙ ОКРУГ Барлыбека Сырттанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Барлыбек Сырттанов, СЕЛЬСКИЙ ОКРУГ Барлыбека Сырттанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 012, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Карашиликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Карашиликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Карашиликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Карашиликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Карашиликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, СЕЛО Карашилик, СЕЛЬСКИЙ ОКРУГ Карашиликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Жаналык, СЕЛЬСКИЙ ОКРУГ Жаналыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Жаналык, СЕЛЬСКИЙ ОКРУГ Жаналыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Жаналык, СЕЛЬСКИЙ ОКРУГ Жаналыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, СЕЛО Каракоз, СЕЛЬСКИЙ ОКРУГ Каракозский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, СЕЛО Каракоз, СЕЛЬСКИЙ ОКРУГ Каракозский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Каракоз, СЕЛЬСКИЙ ОКРУГ Каракозский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 035, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 035, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 036, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 037, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 037, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Каракоз, СЕЛЬСКИЙ ОКРУГ Каракозский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Кенжыра, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, СЕЛО Кенжыра, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 046, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 046, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 049, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 053, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 054, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 055, СЕЛО Жансугуров, СЕЛЬСКИЙ ОКРУГ Жансугуровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 066, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 067, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 068, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 069, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 070, СЕЛО Матай, СЕЛЬСКИЙ ОКРУГ Матайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 076, СЕЛО Егинсу, СЕЛЬСКИЙ ОКРУГ Егинсуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 077, СЕЛО Егинсу, СЕЛЬСКИЙ ОКРУГ Егинсуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 079, СЕЛО Егинсу, СЕЛЬСКИЙ ОКРУГ Егинсуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 080, СЕЛО Егинсу, СЕЛЬСКИЙ ОКРУГ Егинсуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 081, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 082, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 083, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 084, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 085, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 086, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 087, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 089, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 090, СЕЛО Молалы, СЕЛЬСКИЙ ОКРУГ Молалынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 092, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 093, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 095, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 096, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 097, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 098, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 099, СЕЛО Кошкентал, СЕЛЬСКИЙ ОКРУГ Кошкенталский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 100, СЕЛО Кошкентал, СЕЛЬСКИЙ ОКРУГ Кошкенталский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 101, СЕЛО Кошкентал, СЕЛЬСКИЙ ОКРУГ Кошкенталский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 102, СЕЛО Кошкентал, СЕЛЬСКИЙ ОКРУГ Кошкенталский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 102, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 105, СЕЛО Капал, СЕЛЬСКИЙ ОКРУГ Капалский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 106, СЕЛО Арасан, СЕЛЬСКИЙ ОКРУГ Арасанский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 108, СЕЛО Арасан, СЕЛЬСКИЙ ОКРУГ Арасанский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 110, СЕЛО Арасан, СЕЛЬСКИЙ ОКРУГ Арасанский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 111, СЕЛО Арасан, СЕЛЬСКИЙ ОКРУГ Арасанский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 112, СЕЛО Арасан, СЕЛЬСКИЙ ОКРУГ Арасанский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 113, СЕЛО Суыксай, СЕЛЬСКИЙ ОКРУГ Суыксайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 115, СЕЛО Суыксай, СЕЛЬСКИЙ ОКРУГ Суыксайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 116, СЕЛО Суыксай, СЕЛЬСКИЙ ОКРУГ Суыксайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 117, СЕЛО Суыксай, СЕЛЬСКИЙ ОКРУГ Суыксайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 117, СЕЛО Есеболатова, СЕЛЬСКИЙ ОКРУГ Есеболатовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 118, СЕЛО Кызылагаш, СЕЛЬСКИЙ ОКРУГ Кызылагашский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актау, ОБЛАСТЬ Мангистауская",
			"addressName": [{
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1"
			}, {
				"ename": "МИКРОРАЙОН 1"
			}, {
				"ename": "МИКРОРАЙОН 10"
			}, {
				"ename": "МИКРОРАЙОН 11"
			}, {
				"ename": "МИКРОРАЙОН 11 а"
			}, {
				"ename": "МИКРОРАЙОН 12"
			}, {
				"ename": "МИКРОРАЙОН 12 а"
			}, {
				"ename": "МИКРОРАЙОН 13"
			}, {
				"ename": "МИКРОРАЙОН 14"
			}, {
				"ename": "МИКРОРАЙОН 14 а"
			}, {
				"ename": "МИКРОРАЙОН 15"
			}, {
				"ename": "МИКРОРАЙОН 15 а"
			}, {
				"ename": "МИКРОРАЙОН 16"
			}, {
				"ename": "МИКРОРАЙОН 17"
			}, {
				"ename": "МИКРОРАЙОН 18"
			}, {
				"ename": "МИКРОРАЙОН 18А"
			}, {
				"ename": "МИКРОРАЙОН 19"
			}, {
				"ename": "МИКРОРАЙОН 19А"
			}, {
				"ename": "МИКРОРАЙОН 1 А"
			}, {
				"ename": "МИКРОРАЙОН 1 Б"
			}, {
				"ename": "МИКРОРАЙОН 1 В"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2"
			}, {
				"ename": "МИКРОРАЙОН 2"
			}, {
				"ename": "МИКРОРАЙОН 20"
			}, {
				"ename": "МИКРОРАЙОН 20А"
			}, {
				"ename": "МИКРОРАЙОН 21"
			}, {
				"ename": "МИКРОРАЙОН 22"
			}, {
				"ename": "МИКРОРАЙОН 23"
			}, {
				"ename": "МИКРОРАЙОН 24"
			}, {
				"ename": "МИКРОРАЙОН 25"
			}, {
				"ename": "МИКРОРАЙОН 26"
			}, {
				"ename": "МИКРОРАЙОН 27"
			}, {
				"ename": "МИКРОРАЙОН 28"
			}, {
				"ename": "МИКРОРАЙОН 28 А"
			}, {
				"ename": "МИКРОРАЙОН 29"
			}, {
				"ename": "МИКРОРАЙОН 29 А"
			}, {
				"ename": "МИКРОРАЙОН 3"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3"
			}, {
				"ename": "МИКРОРАЙОН 30"
			}, {
				"ename": "МИКРОРАЙОН 31"
			}, {
				"ename": "МИКРОРАЙОН 31А"
			}, {
				"ename": "МИКРОРАЙОН 31Б"
			}, {
				"ename": "МИКРОРАЙОН 32"
			}, {
				"ename": "МИКРОРАЙОН 32а"
			}, {
				"ename": "МИКРОРАЙОН 32 Б"
			}, {
				"ename": "МИКРОРАЙОН 32-В"
			}, {
				"ename": "МИКРОРАЙОН №33"
			}, {
				"ename": "МИКРОРАЙОН №34"
			}, {
				"ename": "МИКРОРАЙОН 34А"
			}, {
				"ename": "МИКРОРАЙОН 35"
			}, {
				"ename": "МИКРОРАЙОН 36"
			}, {
				"ename": "МИКРОРАЙОН 37"
			}, {
				"ename": "МИКРОРАЙОН 38"
			}, {
				"ename": "МИКРОРАЙОН 39"
			}, {
				"ename": "МИКРОРАЙОН 3 А"
			}, {
				"ename": "МИКРОРАЙОН 3 Б"
			}, {
				"ename": "МИКРОРАЙОН 4"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4"
			}, {
				"ename": "МИКРОРАЙОН 40"
			}, {
				"ename": "МИКРОРАЙОН 41"
			}, {
				"ename": "МИКРОРАЙОН 42"
			}, {
				"ename": "МИКРОРАЙОН 43"
			}, {
				"ename": "МИКРОРАЙОН 44"
			}, {
				"ename": "МИКРОРАЙОН 45"
			}, {
				"ename": "МИКРОРАЙОН 46"
			}, {
				"ename": "МИКРОРАЙОН 47"
			}, {
				"ename": "МИКРОРАЙОН 48"
			}, {
				"ename": "МИКРОРАЙОН 49"
			}, {
				"ename": "МИКРОРАЙОН 49А"
			}, {
				"ename": "МИКРОРАЙОН 4 А"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 5"
			}, {
				"ename": "МИКРОРАЙОН 5"
			}, {
				"ename": "МИКРОРАЙОН 50"
			}, {
				"ename": "МИКРОРАЙОН 51"
			}, {
				"ename": "МИКРОРАЙОН 5 А"
			}, {
				"ename": "МИКРОРАЙОН 6"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 6"
			}, {
				"ename": "МИКРОРАЙОН 6 А"
			}, {
				"ename": "МИКРОРАЙОН 7"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 7"
			}, {
				"ename": "МИКРОРАЙОН 7 А"
			}, {
				"ename": "МИКРОРАЙОН 8"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 8"
			}, {
				"ename": "МИКРОРАЙОН 8 а"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 9"
			}, {
				"ename": "МИКРОРАЙОН 9"
			}, {
				"ename": "МИКРОРАЙОН 9 а"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Ару Ана"
			}, {
				"ename": "ПЛОЩАДЬ Астана"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Коктем"
			}, {
				"ename": "ПРОСПЕКТ Президента"
			}, {
				"ename": "МИКРОРАЙОН Приморский 1"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Самал"
			}, {
				"ename": "МИКРОРАЙОН Самал 1"
			}, {
				"ename": "МИКРОРАЙОН Самал 2"
			}, {
				"ename": "МАССИВ Северо-Запад"
			}, {
				"ename": "БАЗА ОТДЫХА Теплый пляж"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Толкын"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Толкын 2"
			}, {
				"ename": "МИКРОРАЙОН Шыгыс 1"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Актобе, ОБЛАСТЬ Актюбинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 099, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ №10, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЛИЦА 101 Стрелковой Бригады, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ №10-Г, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "МИКРОРАЙОН 11, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "МИКРОРАЙОН 12, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "МИКРОРАЙОН 12 Б, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "МИКРОРАЙОН 12 Вг, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 141, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 143, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 154, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 155, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 155, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 155, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 163, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 164, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 164, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 164, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 165, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 170, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 176, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 176, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 177, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 178, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 180, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 181, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 181, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 182, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 182, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 182, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 183, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 205, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 207, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 207, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 208, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 209, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 212, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 212, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 213, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 213, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ 25-лет Целины, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №3, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №30 Авиатор-3, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЛИЦА 30 лет Казахстана, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ 30 лет Казахстана, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПРОСПЕКТ 312 Стрелковой дивизии, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 39, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ №4, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 41, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд Курсантское шоссе, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд ПМС-2, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд РСХТ, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд станция Альджан, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "РАЗЪЕЗД 41 Разъезд ул.Элеваторная, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "МИКРОРАЙОН №5 Батыс-2, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №5 Луч, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ №5 управление Западно-Казахстанской железной дороги, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №7 Саздинский, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЛИЦА 8 Марта, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ №8 Саздинский, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ №9 Зеленый, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА А.Акимжанова, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПРОСПЕКТ Абая, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЛИЦА Абая, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПРОСПЕКТ Абилкайыр Хана, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Абрикос, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА Абубакира Кердери, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "КВАРТАЛ Авиагородок, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "КВАРТАЛ Авиатор, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Авиатор-1, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Авиатор-1, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Авиатор-1, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Авиатор-2, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "КВАРТАЛ Авиатор-2, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Авиатор-2, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Авиатор-4, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Авиатор-5, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА Авиационная, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Авпэс, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автобаза-2, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автобаза Связи, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автобусник, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автогараж АЗФ, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автолюбитель, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ Автолюбитель-2004, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автомобилист, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автомобилист, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автомобилист-1 АТП-1 (114), РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автомобилист-2 Актюбинское Лесничество, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автомобилист Автокомбината-1, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Автомобилист АТП ПГО, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Авторемонтник-1, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "ПЕРЕУЛОК Автотранспортный, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ Агропромтранс, РАЙОН В ГОРОДЕ Алматы"
			}, {
				"ename": "УЛИЦА Ажибай Бия, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "УЛИЦА Аз Наурыз, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Азф, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ АЗФ 1, РАЙОН В ГОРОДЕ Астана"
			}, {
				"ename": "САДОВОДЧЕСКИЙ КОЛЛЕКТИВ АЗФ(1), РАЙОН В ГОРОДЕ Алматы"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Актогайский, ОБЛАСТЬ Павлодарская",
			"addressName": [{
				"ename": "УЛИЦА 1 Мая, СЕЛО Приреченское, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Карабузау, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Баскамыс, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА 30 лет Целины, СЕЛО Баскамыс, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Баскамыс, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Барлыбай, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жалаулы, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Приреченское, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Караоба, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ауельбек, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Ақ Жайық (Заготзерно), СЕЛО Жолболды, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Акку, СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Алматинская, СЕЛО Приреченское, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Ардагер, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Аслана Магулова, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "ПЕРЕУЛОК Астана, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Атамекен (Озерная), СЕЛО Жолболды, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "УЛИЦА Ахмета Байтурсынова, СЕЛО Ақжол, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Балбыр, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Жанааул, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Мира), СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Береговая Красная Поляна, СЕЛО Караоба, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Береке (Мира), СЕЛО Разумовка, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "ПЕРЕУЛОК Береке, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Береке, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Береке (Целинная Кырыкуй), СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Бірлік (Садовая), СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Бірлік (Степная), СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "ПЕРЕУЛОК Бірлік, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "ПЕРЕУЛОК Бірлік, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Богенбая, СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Болашақ (Строительная), СЕЛО Жолболды, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "УЛИЦА Болашақ (8 Марта), СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Караоба, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "ПЕРЕУЛОК Ганауэра, СЕЛО Приреченское, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Ганауэра, СЕЛО Приреченское, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Ғарышкер (Космонавтов), СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Ақжол, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "ПЕРЕУЛОК Детсад, СЕЛО Жолболды, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "УЛИЦА Достық (Степная), СЕЛО Жалаулы, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Достық (Центральная), СЕЛО Жолболды, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "УЛИЦА Достық (Советская), СЕЛО Шолаксор, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Достық, СЕЛО Жанааул, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Достық (Ленинградская), СЕЛО Барлыбай, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Достық (Комсомольская), СЕЛО Ақжол, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Достық, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Думатова, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Егемен, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Әйтеке Би (Ленина), СЕЛО Жолболды, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "УЛИЦА Ертис, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Ертіс, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Ертіс, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Ертіс, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Ертіс, СЕЛО Абжан, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Ертіс, СЕЛО Жанабет, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Ескі Ауыл, СЕЛО Шуга, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "УЛИЦА Естая, СЕЛО Жалаулы, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "ПЕРЕУЛОК Естая, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Естая, СЕЛО Баскамыс, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "ПЕРЕУЛОК Естая, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Естая Беркимбаева, СЕЛО Ақжол, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Жағалау, СЕЛО Жанатап, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Жағалау, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Жағалау, СЕЛО Естая, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Жаңа Ауыл, СЕЛО Шуга, СЕЛЬСКИЙ ОКРУГ Жолболдинский"
			}, {
				"ename": "ПЕРЕУЛОК Жармухамбета Тленшина, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "ПЕРЕУЛОК Жастар, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Отес, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Жоламан, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Жастар (Садовая), СЕЛО Балтасап, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Жас Ұлан (Комсомольская), СЕЛО Барлыбай, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Желтоқсан, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Желтоқсан, СЕЛО Исантерек, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Жеңіс (Победы), СЕЛО Балтасап, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Жеңіс (Победы), СЕЛО Жалаулы, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Жеңіс, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Жеңіс, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "ПЕРЕУЛОК Зеленный, СЕЛО Харьковка, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "ПЕРЕУЛОК Исы Байзакова, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Исы Байзакова, СЕЛО Жалаулы, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Кабылбека Алина, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Кажымурата Ибадильдина, СЕЛО Баскамыс, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}, {
				"ename": "УЛИЦА Қазақстан, СЕЛО Муткенова, СЕЛЬСКИЙ ОКРУГ Муткеновский"
			}, {
				"ename": "УЛИЦА Казахстанская, СЕЛО Караоба, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Камзина, СЕЛО Жалаулы, СЕЛЬСКИЙ ОКРУГ Жалаулинский"
			}, {
				"ename": "УЛИЦА Кожамжар, СЕЛО Кожамжар, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "ПЕРЕУЛОК Коммунальный, СЕЛО Актогай, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Коммунистическая, СЕЛО Караоба, СЕЛЬСКИЙ ОКРУГ Караобинский"
			}, {
				"ename": "УЛИЦА Космическая, СЕЛО Приреченское, СЕЛЬСКИЙ ОКРУГ Актогайский"
			}, {
				"ename": "УЛИЦА Күбән, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Кожамжарский"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Баскамыс, СЕЛЬСКИЙ ОКРУГ Ақжол"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Актогайский, ОБЛАСТЬ Карагандинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 022, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 023, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 024, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 025, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 027, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 028, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 029, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 029, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 030, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 031, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 032, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 033, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 039, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 048, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 069, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 072, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 076, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ 1, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 118, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 120, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 121, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 125, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 126, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 126, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 127, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 127, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 128, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 129, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 131, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 132, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 1320, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 135, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 136, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 137, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 137, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ТУПИК 140 139 129, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 144, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 151, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 160, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 162, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 164, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 185, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 186, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 187, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 189, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 191, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЛИЦА 1 Микрорайон, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 203, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 207, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 208, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 209, ПОСЕЛОК Шашубай"
			}, {
				"ename": "УЧАСТОК 211, ПОСЕЛОК Шашубай"
			}, {
				"ename": "ДАЧНЫЙ МАССИВ 26а, 2/д, 10/1а, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА 2-ыкшам аудан, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 342, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК №357, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК №358, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК №359, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК №361, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 376, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 390, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА 3-ыкшам аудан, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 486, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 49, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 497, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ШОССЕ 500.6 км автодороги Алматы-Екатеринбург, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ШОССЕ 501км автодороги Алматы-Екатеринбург, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 502, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ШОССЕ 503 км автодороги Алматы-Екатеринбург, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 517, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 522, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 604, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 605, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 607, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 608, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 609, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 610, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 611, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 625, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 653, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 693, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЧАСТОК 741, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА Абай, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, ПОСЕЛОК Шашубай"
			}, {
				"ename": "ШОССЕ Автотрасса г.Балхаш - п.Шашубай АЗС, ПОСЕЛОК Шашубай"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "МИКРОРАЙОН Алтын Молтек ауданы, ПОСЕЛОК Шашубай"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Асан, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ШОССЕ Астана-Караганда-Балкаш-Алматы1955-2005км, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА Байтерек, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА Балхаш, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "ЗИМОВКА Бамовская, ПОСЕЛОК Сарышаган"
			}, {
				"ename": "УЛИЦА Бейбитшилик, ПОСЕЛОК Сарышаган"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Алакольский, ОБЛАСТЬ Жетісу",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛЬСКИЙ ОКРУГ Енбекшинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, СЕЛЬСКИЙ ОКРУГ Енбекшинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 132, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 148, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА 8 Март, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Абай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Абылай Хан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА А.Иванов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА А.Исмаилов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Алакөл, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Амангелді, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ахмет Байтұрсынұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ахмет Жұбанұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Бейбітшілік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Бексұлтан Төре, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Бірлік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Б.Майлин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Б.Момышұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Бөгенбай Батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Болашақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Б.Ыдырышев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА В.Кашлаков, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "ЖИЛОЙ МАССИВ военный городок 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА военный городок 12, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА военный городок 13, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "ЖИЛОЙ МАССИВ военный городок 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "ЖИЛОЙ МАССИВ военный городок 8, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА В.Рязанов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА В.Тощенко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ғабит Мүсірепұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Г.Безродных, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ғ.Орманов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Д.Қонаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Д.Нүрпейісова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Достық, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ә.Әлімжанұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Әл-Фараби, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ә.Тиірменов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Жалбы Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Жастар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Желтоқсан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Жеңіс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Жетісу, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ж.Жабаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Жібек Жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА И.Панфилов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА І.Жансүгіров, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қабанбай Батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қажымұқан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қазақстан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қасабай батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қ.Бектұров, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА К.Жексембаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА К.Қасымжанов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қ.Сәтпаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Құрманғазы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Қ.Шуақов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Мағжан Жұмабайұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Мамырбек Болысбайұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА М.Дулатов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА М.Дулепов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА М.Мәметова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Мұхтар Әуезов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА О.Жандосов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Омарұлы Рысбек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Рақым Омаров, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "ДАЧНЫЙ МАССИВ Садово-огородническое товарищество Садовод, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Садық Құсайын, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Самал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА С.Мұқанов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА С.Сейфуллин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Стебляков, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Сыпатай Батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Тәуелсіздік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Т.Қарайғанов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Т.Нұрмұхамбетов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Төле би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Т.Рысқұлов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧАСТОК Ушаралский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ш.Айманов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Шәкәрім, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ш.Қалдаяқов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ш.Уәлиханов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ы.Алтынсарин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ы.Әлібаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ынтымақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЛИЦА Ю.Гагарин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ушарал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Аркарлы, СЕЛЬСКИЙ ОКРУГ Аркарлинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, СЕЛО Аркарлы, СЕЛЬСКИЙ ОКРУГ Аркарлинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Аркарлы, СЕЛЬСКИЙ ОКРУГ Аркарлинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Жанама, СЕЛЬСКИЙ ОКРУГ Жанаминский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Аркарлы, СЕЛЬСКИЙ ОКРУГ Аркарлинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Алатауский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Алматы",
			"addressName": [{
				"ename": "МИКРОРАЙОН 13"
			}, {
				"ename": "МИКРОРАЙОН 14"
			}, {
				"ename": "УЛИЦА 2 Братская"
			}, {
				"ename": "УЛИЦА 2 Кисловодская"
			}, {
				"ename": "РАЗЪЕЗД 71"
			}, {
				"ename": "УЛИЦА 9 января"
			}, {
				"ename": "УЛИЦА Азизбекова"
			}, {
				"ename": "МИКРОРАЙОН Айгерим-1"
			}, {
				"ename": "МИКРОРАЙОН Айгерим-2"
			}, {
				"ename": "МИКРОРАЙОН Айгерим микрорайон"
			}, {
				"ename": "МИКРОРАЙОН Акбулак"
			}, {
				"ename": "МИКРОРАЙОН Аккент"
			}, {
				"ename": "МИКРОРАЙОН Акмаржан"
			}, {
				"ename": "УЛИЦА Акмолинская"
			}, {
				"ename": "УЛИЦА Аксайская"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО АКХ Ленинский"
			}, {
				"ename": "МИКРОРАЙОН Алгабас"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Алтын Алма"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Алтын Алма"
			}, {
				"ename": "УЛИЦА Альпийская"
			}, {
				"ename": "УЛИЦА Ахременко 2"
			}, {
				"ename": "УЛИЦА Ахрименко"
			}, {
				"ename": "УЛИЦА Ачинская"
			}, {
				"ename": "МИКРОРАЙОН Байбесик"
			}, {
				"ename": "УЛИЦА Бартогайская"
			}, {
				"ename": "УЛИЦА Беломорская"
			}, {
				"ename": "УЛИЦА Благовещенская"
			}, {
				"ename": "ПЕРЕУЛОК Благовещенский"
			}, {
				"ename": "УЛИЦА Бобруйская"
			}, {
				"ename": "УЛИЦА Бокеева"
			}, {
				"ename": "МИКРОРАЙОН Болашақ"
			}, {
				"ename": "МИКРОРАЙОН Боралдай"
			}, {
				"ename": "МИКРОРАЙОН Ботакоз"
			}, {
				"ename": "УЛИЦА Братская"
			}, {
				"ename": "УЛИЦА Водника"
			}, {
				"ename": "УЛИЦА Войкова"
			}, {
				"ename": "МИКРОРАЙОН Гажайып"
			}, {
				"ename": "УЛИЦА Горняцкая"
			}, {
				"ename": "МИКРОРАЙОН Дарабоз"
			}, {
				"ename": "МИКРОРАЙОН Дархан"
			}, {
				"ename": "МИКРОРАЙОН Дархан /мкр.Ужет/"
			}, {
				"ename": "УЛИЦА Дельвига"
			}, {
				"ename": "УЛИЦА Джалиля"
			}, {
				"ename": "УЛИЦА Джезказганская"
			}, {
				"ename": "УЛИЦА Докучаева"
			}, {
				"ename": "УЛИЦА Долгорукова Ю."
			}, {
				"ename": "УЛИЦА Дубосековская"
			}, {
				"ename": "УЛИЦА Душанбинская"
			}, {
				"ename": "УЛИЦА Емцова"
			}, {
				"ename": "УЛИЦА Есебулатова"
			}, {
				"ename": "УЛИЦА Есенина С."
			}, {
				"ename": "УЛИЦА Загоскина"
			}, {
				"ename": "МИКРОРАЙОН Зердели"
			}, {
				"ename": "УЛИЦА Калининградская"
			}, {
				"ename": "МИКРОРАЙОН Карасу"
			}, {
				"ename": "УЛИЦА Карпатская"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Карпатский"
			}, {
				"ename": "УЛИЦА Каскеленская"
			}, {
				"ename": "УЛИЦА Качалова"
			}, {
				"ename": "ПЕРЕУЛОК Качалова"
			}, {
				"ename": "УЛИЦА Кисловодская"
			}, {
				"ename": "МИКРОРАЙОН Коккайнар"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Кок-Озек"
			}, {
				"ename": "УЛИЦА Коунрадская"
			}, {
				"ename": "УЛИЦА Красильская"
			}, {
				"ename": "УЛИЦА Кудерина"
			}, {
				"ename": "УЛИЦА Куприна а."
			}, {
				"ename": "УЛИЦА Курская"
			}, {
				"ename": "УЛИЦА Курчатова И."
			}, {
				"ename": "УЛИЦА Левского"
			}, {
				"ename": "УЛИЦА Ленгерская"
			}, {
				"ename": "УЛИЦА Листа"
			}, {
				"ename": "УЛИЦА Магаданская"
			}, {
				"ename": "ПЕРЕУЛОК Магаданский"
			}, {
				"ename": "МИКРОРАЙОН Мадениет"
			}, {
				"ename": "УЛИЦА Мажорова"
			}, {
				"ename": "УЛИЦА Майкопская"
			}, {
				"ename": "УЛИЦА Мартехова В."
			}, {
				"ename": "УЛИЦА Метростроевская"
			}, {
				"ename": "УЛИЦА Моцарта"
			}, {
				"ename": "УЛИЦА Нальчикская"
			}, {
				"ename": "УЛИЦА Нарвская"
			}, {
				"ename": "УЛИЦА Немировича-Данченко"
			}, {
				"ename": "МИКРОРАЙОН Нуркент"
			}, {
				"ename": "УЛИЦА Нурпеисова"
			}, {
				"ename": "МИКРОРАЙОН Ожет"
			}, {
				"ename": "УЛИЦА Остроухова"
			}, {
				"ename": "УЛИЦА Отрарская"
			}, {
				"ename": "УЛИЦА Памирская"
			}, {
				"ename": "УЛИЦА Петрова"
			}, {
				"ename": "УЛИЦА Петровского"
			}, {
				"ename": "УЛИЦА Петропавловская"
			}, {
				"ename": "ПЕРЕУЛОК Пика"
			}, {
				"ename": "УЛИЦА Пика В."
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДЧЕСКИХ ТОВАРИЩЕСТВ Птицевод"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Радуга"
			}, {
				"ename": "ПРОСПЕКТ Райымбек"
			}, {
				"ename": "МИКРОРАЙОН Рахат"
			}, {
				"ename": "УЛИЦА Родникова"
			}, {
				"ename": "УЛИЦА Рудная"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Алгинский, ОБЛАСТЬ Актюбинская",
			"addressName": [{
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 10, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 11, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 12, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 13, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 14, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 15, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 16, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 17, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 18, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 19, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ЖИЛОЙ МАССИВ 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 20, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 21, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 22, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 23, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 23А, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 24, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 25, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 26, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 27, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 28, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 31, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 32, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 33, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 43, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 7, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 8, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ 9, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Абубакира, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Ақбұлақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Атаниязова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Ауезова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Байтақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Байтурсынова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Балдырған, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ПЕРЕУЛОК Б.Мухамбетова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Г.Муратбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Дос, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Елекская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Есета батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Жағалау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ПЕРЕУЛОК Жамбыла, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Жангельдина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Жәдігер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Желтоксан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Жеңіс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "МАССИВ Животноводческий Комплекс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Жібек жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА И.Мамбетова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Иманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ДОРОГА Қазақстан Темір Жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Казахская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЧАСТОК Карьер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Кемер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Көкжар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Көкпекті, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Комсомольская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Ленина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ПЕРЕУЛОК Мерует Алиева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Наурыз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Пацаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Подхоз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ ПШ-2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Р.Айымбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Рахметолла Агниязов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Сарыжайлау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Сейфуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ПЕРЕУЛОК Серпін, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Серуен (1), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ШОССЕ Тамдинский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Территория промзоны, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Трудовая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Тұлпар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Уалиханова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Фрунзе, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Химик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Чапаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Шамшырақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Шаңырақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Шиелі, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}, {
				"ename": "УЛИЦА Ықылас, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алга"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Алмалинский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Алматы",
			"addressName": [{
				"ename": "УЛИЦА 2 Кастекская"
			}, {
				"ename": "ПРОСПЕКТ Абая"
			}, {
				"ename": "ПРОСПЕКТ Абылай хана"
			}, {
				"ename": "УЛИЦА Айвазовского"
			}, {
				"ename": "УЛИЦА Айманова"
			}, {
				"ename": "УЛИЦА Айтеке би"
			}, {
				"ename": "УЛИЦА Айтиева"
			}, {
				"ename": "УЛИЦА Алексеева"
			}, {
				"ename": "УЛИЦА Алимжанова"
			}, {
				"ename": "УЛИЦА Амангельды"
			}, {
				"ename": "УЛИЦА Аносова"
			}, {
				"ename": "УЛИЦА Аренского"
			}, {
				"ename": "УЛИЦА Артема"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Архитектор"
			}, {
				"ename": "УЛИЦА Ауэзова"
			}, {
				"ename": "УЛИЦА Байганина"
			}, {
				"ename": "УЛИЦА Байзакова"
			}, {
				"ename": "УЛИЦА Байсеитовой"
			}, {
				"ename": "УЛИЦА Байтурсынулы"
			}, {
				"ename": "УЛИЦА Бекетова"
			}, {
				"ename": "УЛИЦА Богенбай батыра"
			}, {
				"ename": "УЛИЦА Бородина"
			}, {
				"ename": "УЛИЦА Бруно"
			}, {
				"ename": "УЛИЦА Брусиловского"
			}, {
				"ename": "УЛИЦА Брюллова"
			}, {
				"ename": "УЛИЦА Бутлерова"
			}, {
				"ename": "УЛИЦА Варламова"
			}, {
				"ename": "УЛИЦА Васнецова"
			}, {
				"ename": "УЛИЦА Верещагина"
			}, {
				"ename": "ПЕРЕУЛОК Верещагина"
			}, {
				"ename": "УЛИЦА Волховская"
			}, {
				"ename": "ПРОСПЕКТ Гагарина"
			}, {
				"ename": "УЛИЦА Гоголя"
			}, {
				"ename": "УЛИЦА Грановского"
			}, {
				"ename": "УЛИЦА Гринева"
			}, {
				"ename": "УЛИЦА Джандарбекова"
			}, {
				"ename": "УЛИЦА Джумалиева К"
			}, {
				"ename": "УЛИЦА Досмухамедова"
			}, {
				"ename": "УЛИЦА Дуйсенова"
			}, {
				"ename": "УЛИЦА Есенжанова Х"
			}, {
				"ename": "УЛИЦА Есентайская"
			}, {
				"ename": "УЛИЦА Жамбыла"
			}, {
				"ename": "УЛИЦА Жарокова"
			}, {
				"ename": "УЛИЦА Желтоксан"
			}, {
				"ename": "УЛИЦА Жемчужная"
			}, {
				"ename": "ПРОСПЕКТ Жибек жолы"
			}, {
				"ename": "УЛИЦА Индустриальная"
			}, {
				"ename": "УЛИЦА Исаева"
			}, {
				"ename": "УЛИЦА Ислам Каримов"
			}, {
				"ename": "УЛИЦА Кабанбай батыра"
			}, {
				"ename": "УЛИЦА Кавказская"
			}, {
				"ename": "УЛИЦА Казыбек би"
			}, {
				"ename": "УЛИЦА Караоткел"
			}, {
				"ename": "УЛИЦА Карасай батыра"
			}, {
				"ename": "УЛИЦА Карасу"
			}, {
				"ename": "УЛИЦА Катаева"
			}, {
				"ename": "УЛИЦА Кашгарская"
			}, {
				"ename": "УЛИЦА Клочкова"
			}, {
				"ename": "УЛИЦА Кожамкулова"
			}, {
				"ename": "УЛИЦА Кулымбетова"
			}, {
				"ename": "УЛИЦА Курильская"
			}, {
				"ename": "УЛИЦА Курмангазы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Лада"
			}, {
				"ename": "УЛИЦА литейная"
			}, {
				"ename": "УЛИЦА лихачева"
			}, {
				"ename": "УЛИЦА Макатаева"
			}, {
				"ename": "УЛИЦА Маметовой"
			}, {
				"ename": "УЛИЦА Манаса"
			}, {
				"ename": "УЛИЦА Маршака"
			}, {
				"ename": "УЛИЦА Масанчи"
			}, {
				"ename": "УЛИЦА Мауленова"
			}, {
				"ename": "УЛИЦА Механическая"
			}, {
				"ename": "ПЕРЕУЛОК Мирзояна"
			}, {
				"ename": "УЛИЦА Молдагуловой"
			}, {
				"ename": "УЛИЦА Монгольская"
			}, {
				"ename": "УЛИЦА Муканова"
			}, {
				"ename": "УЛИЦА Муратбаева"
			}, {
				"ename": "УЛИЦА Наурызбай батыра"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Научный работник"
			}, {
				"ename": "УЛИЦА Нұрлы Жол"
			}, {
				"ename": "УЛИЦА Нурмакова"
			}, {
				"ename": "ПРОСПЕКТ Нұрсұлтан Назарбаев"
			}, {
				"ename": "УЛИЦА Панфилова"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ ПОДЗЕМНЫЕ ГАРАЖИ"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО ПОДЗЕМНЫЕ ГАРАЖИ"
			}, {
				"ename": "УЛИЦА Потемкина"
			}, {
				"ename": "УЛИЦА Прокофьева"
			}, {
				"ename": "УЛИЦА Радостовца"
			}, {
				"ename": "ПРОСПЕКТ Райымбека"
			}, {
				"ename": "УЛИЦА Рахманинова"
			}, {
				"ename": "УЛИЦА Розыбакиева"
			}, {
				"ename": "ПРОСПЕКТ Сейфуллина"
			}, {
				"ename": "МАССИВ Сооружение Энергетики"
			}, {
				"ename": "МИКРОРАЙОН Тастак-1"
			}, {
				"ename": "МИКРОРАЙОН Тастак-2"
			}, {
				"ename": "УЛИЦА Текстильная"
			}, {
				"ename": "УЛИЦА Тлендиева"
			}, {
				"ename": "УЛИЦА Толе би"
			}, {
				"ename": "УЛИЦА Торекулова"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Тулпар"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Алматы, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Астана",
			"addressName": [{
				"ename": "УЛИЦА 101"
			}, {
				"ename": "УЛИЦА 189"
			}, {
				"ename": "УЛИЦА 196"
			}, {
				"ename": "УЛИЦА 197"
			}, {
				"ename": "УЛИЦА 23-16"
			}, {
				"ename": "УЛИЦА 23-2"
			}, {
				"ename": "УЛИЦА 92"
			}, {
				"ename": "МАССИВ VIP-Городок"
			}, {
				"ename": "УЛИЦА А 1"
			}, {
				"ename": "УЛИЦА А 102"
			}, {
				"ename": "УЛИЦА А 103"
			}, {
				"ename": "УЛИЦА А 105"
			}, {
				"ename": "УЛИЦА А 108"
			}, {
				"ename": "УЛИЦА А 123"
			}, {
				"ename": "УЛИЦА А 128"
			}, {
				"ename": "УЛИЦА А 129"
			}, {
				"ename": "УЛИЦА А 130"
			}, {
				"ename": "УЛИЦА А 139"
			}, {
				"ename": "УЛИЦА А 184"
			}, {
				"ename": "УЛИЦА А 185"
			}, {
				"ename": "УЛИЦА А 187"
			}, {
				"ename": "УЛИЦА А 188"
			}, {
				"ename": "УЛИЦА А 189"
			}, {
				"ename": "УЛИЦА А 190"
			}, {
				"ename": "УЛИЦА А 191"
			}, {
				"ename": "УЛИЦА А 194"
			}, {
				"ename": "УЛИЦА А 195"
			}, {
				"ename": "УЛИЦА А 2"
			}, {
				"ename": "УЛИЦА А 205"
			}, {
				"ename": "УЛИЦА А 206"
			}, {
				"ename": "УЛИЦА А 207"
			}, {
				"ename": "УЛИЦА А 218"
			}, {
				"ename": "УЛИЦА А 219"
			}, {
				"ename": "УЛИЦА А 220"
			}, {
				"ename": "УЛИЦА А 221"
			}, {
				"ename": "УЛИЦА А 227"
			}, {
				"ename": "УЛИЦА А 27"
			}, {
				"ename": "УЛИЦА А 273"
			}, {
				"ename": "УЛИЦА А 28"
			}, {
				"ename": "УЛИЦА А 29"
			}, {
				"ename": "УЛИЦА А 292"
			}, {
				"ename": "УЛИЦА А 30"
			}, {
				"ename": "УЛИЦА А 31"
			}, {
				"ename": "УЛИЦА А 32"
			}, {
				"ename": "УЛИЦА А 333"
			}, {
				"ename": "УЛИЦА А 334"
			}, {
				"ename": "УЛИЦА А 348"
			}, {
				"ename": "УЛИЦА А 35"
			}, {
				"ename": "УЛИЦА А 351"
			}, {
				"ename": "УЛИЦА А 353"
			}, {
				"ename": "УЛИЦА А 354"
			}, {
				"ename": "УЛИЦА А 355"
			}, {
				"ename": "УЛИЦА А 356"
			}, {
				"ename": "УЛИЦА А 357"
			}, {
				"ename": "УЛИЦА А 358"
			}, {
				"ename": "УЛИЦА А 359"
			}, {
				"ename": "УЛИЦА А 360"
			}, {
				"ename": "УЛИЦА А 361"
			}, {
				"ename": "УЛИЦА А 362"
			}, {
				"ename": "УЛИЦА А 363"
			}, {
				"ename": "УЛИЦА А 364"
			}, {
				"ename": "УЛИЦА А 37"
			}, {
				"ename": "УЛИЦА А 372"
			}, {
				"ename": "УЛИЦА А 373"
			}, {
				"ename": "УЛИЦА А 375"
			}, {
				"ename": "УЛИЦА А 376"
			}, {
				"ename": "УЛИЦА А 377"
			}, {
				"ename": "УЛИЦА А 378"
			}, {
				"ename": "УЛИЦА А 379"
			}, {
				"ename": "УЛИЦА А 38"
			}, {
				"ename": "УЛИЦА А 381"
			}, {
				"ename": "УЛИЦА А 382"
			}, {
				"ename": "УЛИЦА А 383"
			}, {
				"ename": "УЛИЦА А 384"
			}, {
				"ename": "УЛИЦА А 385"
			}, {
				"ename": "УЛИЦА А 386"
			}, {
				"ename": "УЛИЦА А 387"
			}, {
				"ename": "УЛИЦА А 388"
			}, {
				"ename": "УЛИЦА А 389"
			}, {
				"ename": "УЛИЦА А 39"
			}, {
				"ename": "УЛИЦА А 390"
			}, {
				"ename": "УЛИЦА А 391"
			}, {
				"ename": "УЛИЦА А 392"
			}, {
				"ename": "УЛИЦА А 393"
			}, {
				"ename": "УЛИЦА А 394"
			}, {
				"ename": "УЛИЦА А 395"
			}, {
				"ename": "УЛИЦА А 396"
			}, {
				"ename": "УЛИЦА А 397"
			}, {
				"ename": "УЛИЦА А 398"
			}, {
				"ename": "УЛИЦА А 399"
			}, {
				"ename": "УЛИЦА А 40"
			}, {
				"ename": "УЛИЦА А 400"
			}, {
				"ename": "УЛИЦА А 401"
			}, {
				"ename": "УЛИЦА А 402"
			}, {
				"ename": "УЛИЦА А 403"
			}, {
				"ename": "УЛИЦА А 404"
			}, {
				"ename": "УЛИЦА А 405"
			}, {
				"ename": "УЛИЦА А 406"
			}, {
				"ename": "УЛИЦА А 407"
			}, {
				"ename": "УЛИЦА А 408"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Алтай, ОБЛАСТЬ Восточно-Казахстанская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, ПОСЕЛОК Зубовск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-002, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-033, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-033, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-044, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-045, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-048, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-051, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-052, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-053, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-053, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-053, ПОСЕЛОК Прибрежный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-059, ПОСЕЛОК Прибрежный"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-060, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-061, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-070-062, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-082-010, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 05-084-006, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "КВАРТАЛ 1, ПОСЕЛОК Прибрежный"
			}, {
				"ename": "МАССИВ 1, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МИКРОРАЙОН №1, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА 10-летия Астаны, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "КВАРТАЛ 2, ПОСЕЛОК Прибрежный"
			}, {
				"ename": "МАССИВ 2, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МИКРОРАЙОН №2, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МАССИВ 3, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "КВАРТАЛ 3, ПОСЕЛОК Прибрежный"
			}, {
				"ename": "МИКРОРАЙОН №3, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МАССИВ 4, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МИКРОРАЙОН №4, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "ПЕРЕУЛОК 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "МИКРОРАЙОН №5, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МИКРОРАЙОН №6, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МИКРОРАЙОН №7, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "МИКРОРАЙОН №8, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА 8 Марта, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "ВОИНСКАЯ ЧАСТЬ 97638, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "БАЗА ОТДЫХА Автоматика, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Автомобилист, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "УЛИЦА А.Иманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "БАЗА ОТДЫХА Айна, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "БАЗА ОТДЫХА Айна-2, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Акционерная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Александра Несмиянова (Стахановская), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Алтайская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "БАЗА ОТДЫХА Алтайская бухта, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДОВ Анастасия, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДОВ Анастасия, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Анатолия Косого, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "ПЕРЕУЛОК Арман (3), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Арыктая Каюпова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Астана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА А.Толстого, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Ауэзова, ПОСЕЛОК Зубовск"
			}, {
				"ename": "УЛИЦА Бажова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "ПЕРЕУЛОК Базарный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "ПЕРЕУЛОК Балдәурен (1), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Бастау, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Бастау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "УЛИЦА Баумана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Белорусская, ПОСЕЛОК Прибрежный"
			}, {
				"ename": "УЛИЦА Береговая, ПОСЕЛОК Зубовск"
			}, {
				"ename": "УЛИЦА Береговая, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЛИЦА Береговая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "ПЕРЕУЛОК Береговой, ПОСЕЛОК Зубовск"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Березка, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "БАЗА ОТДЫХА Березка, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Березовская, ПОСЕЛОК Зубовск"
			}, {
				"ename": "ПЕРЕУЛОК Березовский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "ПЕРЕУЛОК Болотный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Больничная, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЛИЦА Больничная, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УРОЧИЩЕ Борок, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "БАЗА ОТДЫХА Борок, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Бостандық, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЛИЦА Бочарникова, ПОСЕЛОК Зубовск"
			}, {
				"ename": "УЛИЦА Бочарникова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Брилина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "ПЕРЕУЛОК Бульварный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "БУЛЬВАР Бурнашова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "БАЗА ОТДЫХА Бухта Лазурная, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "ПРОСТОЕ САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Бухтарма (ПРОСТОЕ САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО \"БУХТАРМА\"), ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "БАЗА ОТДЫХА Бухтарма, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Бухтарминская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Бухтарминская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "УЛИЦА Бухтарминская, ПОСЕЛОК Октябрьский"
			}, {
				"ename": "УЛИЦА Бухтарминская, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Бухтарминское, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Бухтарминское садовое общество, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "БАЗА ОТДЫХА Бухта Солнечная, ПОСЕЛОК Новая Бухтарма"
			}, {
				"ename": "УЛИЦА Вавилова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Ватутина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Алтай"
			}, {
				"ename": "УЛИЦА Веденеева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Серебрянск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Алтынсаринский, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "ПЕРЕУЛОК 1 Мая, СЕЛО Новоалексеевка"
			}, {
				"ename": "ПЕРЕУЛОК 8 Марта, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Железнодорожная, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Зелёная, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Ивановская, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Кавказская, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Казахская, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Молодёжная, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Свердловка"
			}, {
				"ename": "ПЕРЕУЛОК Октябрьский, СЕЛО Новоалексеевка"
			}, {
				"ename": "БАЗА ОТДЫХА Орленок, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Парковая, СЕЛО Красный Кордон"
			}, {
				"ename": "ПЕРЕУЛОК Рабочий, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Романенко, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Садовая, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Свердлова, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Советская, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Советская, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Степная, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Строительная, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Строительная, СЕЛО Свердловка"
			}, {
				"ename": "ТЕРРИТОРИЯ товарищество с ограниченной ответственностью \\\\\\\"Беляевка\\\\\\\" (товарищество с ограниченной ответственностью \"Олжа Беляевка\"), СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Украинская, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Центральная, СЕЛО Красный Кордон"
			}, {
				"ename": "БАЗА ОТДЫХА Чайка, СЕЛО Красный Кордон"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Новоалексеевка"
			}, {
				"ename": "УЛИЦА Энергетиков, СЕЛО Свердловка"
			}, {
				"ename": "УЛИЦА 19 съезда ВЛКСМ, СЕЛО Силантьевка, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА 20 лет Целины, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА 30 лет Победы, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА 30 лет Целины, СЕЛО Приозерное, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Приозерное, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА 50 лет ВЛКСМ, СЕЛО Первомайское, СЕЛЬСКИЙ ОКРУГ имени Омара Шипина"
			}, {
				"ename": "ТРАССА 54 км автодороги Костанай - Карасу, СЕЛО Убаганское, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "ТРАССА 589 км трассы Екатеринбург-Алматы, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА 60 лет СССР, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА 60 лет СССР, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА 60 лет СССР, СЕЛО Силантьевка, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА 70 лет Октября, СЕЛО Убаганское, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Первомайское, СЕЛЬСКИЙ ОКРУГ имени Омара Шипина"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Большая Чураковка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Воробьевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Докучаевка, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Имени Ильяса Омарова, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Александр Ребро, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Алимов Серик Касымбекович, СЕЛО Первомайское, СЕЛЬСКИЙ ОКРУГ имени Омара Шипина"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Басбек, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Сатай, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Воробьевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Докучаевка, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО А.Шокай, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Большая Чураковка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Арыстанкольская, СЕЛО Темир Казык, СЕЛЬСКИЙ ОКРУГ имени Омара Шипина"
			}, {
				"ename": "УЛИЦА Атамекен, СЕЛО Большая Чураковка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Большая Чураковка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Банный Переулок, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА Басбекская, СЕЛО Басбек, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Темир Казык, СЕЛЬСКИЙ ОКРУГ имени Омара Шипина"
			}, {
				"ename": "УЛИЦА Б.Ержанова, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Малая Чураковка, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "ТЕРРИТОРИЯ бывшего пионерского лагеря \\\"Солнечный\\\", СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "ТЕРРИТОРИЯ бывшего пионерского лагеря \\\"Юный геолог\\\", СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "ТЕРРИТОРИЯ Бывшей базы отдыха \\\"Арман\\\", СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Бирюковка, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Большая Чураковка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "ТЕРРИТОРИЯ в районе 27 квартала Аракарагайского ГУ, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО А.Шокай, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Детсадовская, СЕЛО Докучаевка, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Детская, СЕЛО Танабаевское, СЕЛЬСКИЙ ОКРУГ Димитровский"
			}, {
				"ename": "БАЗА ОТДЫХА Джайляу КЗ, СЕЛО Щербаково, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Силантьевка, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Осиповка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Докучаевка, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Дощанова, СЕЛО Коскудук, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Сатай, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Докучаевка, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Дружбы Народов, СЕЛО Убаганское, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА Жанасу, СЕЛО Жанасу, СЕЛЬСКИЙ ОКРУГ Имени Ильяса Омарова"
			}, {
				"ename": "УЛИЦА Заводская, СЕЛО Большая Чураковка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Зелёная, СЕЛО Кубековка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Зелёная, СЕЛО Новониколаевка, СЕЛЬСКИЙ ОКРУГ Большечураковский"
			}, {
				"ename": "УЛИЦА Зелёная, СЕЛО Зуевка, СЕЛЬСКИЙ ОКРУГ Убаганский"
			}, {
				"ename": "УЛИЦА Ильяс Омарова, СЕЛО Басбек, СЕЛЬСКИЙ ОКРУГ имени Мариям Хәкімжанова"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Аль-Фарабийский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Шымкент",
			"addressName": [{
				"ename": "КВАРТАЛ 001"
			}, {
				"ename": "КВАРТАЛ 002"
			}, {
				"ename": "КВАРТАЛ 003"
			}, {
				"ename": "КВАРТАЛ 004"
			}, {
				"ename": "КВАРТАЛ 005"
			}, {
				"ename": "КВАРТАЛ 006"
			}, {
				"ename": "КВАРТАЛ 007"
			}, {
				"ename": "КВАРТАЛ 008"
			}, {
				"ename": "КВАРТАЛ 009"
			}, {
				"ename": "КВАРТАЛ 010"
			}, {
				"ename": "КВАРТАЛ 011"
			}, {
				"ename": "КВАРТАЛ 012"
			}, {
				"ename": "КВАРТАЛ 013"
			}, {
				"ename": "КВАРТАЛ 014"
			}, {
				"ename": "КВАРТАЛ 015"
			}, {
				"ename": "КВАРТАЛ 016"
			}, {
				"ename": "КВАРТАЛ 017"
			}, {
				"ename": "КВАРТАЛ 018"
			}, {
				"ename": "КВАРТАЛ 019"
			}, {
				"ename": "КВАРТАЛ 020"
			}, {
				"ename": "КВАРТАЛ 021"
			}, {
				"ename": "КВАРТАЛ 022"
			}, {
				"ename": "КВАРТАЛ 032"
			}, {
				"ename": "КВАРТАЛ 035"
			}, {
				"ename": "КВАРТАЛ 073"
			}, {
				"ename": "КВАРТАЛ 078"
			}, {
				"ename": "КВАРТАЛ 079"
			}, {
				"ename": "КВАРТАЛ 080"
			}, {
				"ename": "КВАРТАЛ 081"
			}, {
				"ename": "КВАРТАЛ 083"
			}, {
				"ename": "КВАРТАЛ 092"
			}, {
				"ename": "КВАРТАЛ 094"
			}, {
				"ename": "КВАРТАЛ 095"
			}, {
				"ename": "КВАРТАЛ 109"
			}, {
				"ename": "КВАРТАЛ 117"
			}, {
				"ename": "КВАРТАЛ 119"
			}, {
				"ename": "КВАРТАЛ 122"
			}, {
				"ename": "МИКРОРАЙОН 15"
			}, {
				"ename": "КВАРТАЛ 157"
			}, {
				"ename": "МИКРОРАЙОН 16"
			}, {
				"ename": "КВАРТАЛ 161"
			}, {
				"ename": "КВАРТАЛ 162"
			}, {
				"ename": "МИКРОРАЙОН 17"
			}, {
				"ename": "МИКРОРАЙОН 18"
			}, {
				"ename": "КВАРТАЛ 195"
			}, {
				"ename": "ПЕРЕУЛОК 1-й А.Байтурсынова"
			}, {
				"ename": "ПЕРЕУЛОК 1-й Бостандык"
			}, {
				"ename": "ПЕРЕУЛОК 1-й Диирмен"
			}, {
				"ename": "ТУПИК 1-й Ерназаров"
			}, {
				"ename": "УЛИЦА 1-й Забадам"
			}, {
				"ename": "УЛИЦА 1-й Коксай"
			}, {
				"ename": "ТУПИК 1-й Конституции"
			}, {
				"ename": "УЛИЦА 1-й Кызыласкер"
			}, {
				"ename": "УЛИЦА 1-й Милицейский"
			}, {
				"ename": "ПЕРЕУЛОК 1 Узбек"
			}, {
				"ename": "КВАРТАЛ 203"
			}, {
				"ename": "КВАРТАЛ 270"
			}, {
				"ename": "КВАРТАЛ 271"
			}, {
				"ename": "КВАРТАЛ №272"
			}, {
				"ename": "КВАРТАЛ 273"
			}, {
				"ename": "КВАРТАЛ №274"
			}, {
				"ename": "КВАРТАЛ №275"
			}, {
				"ename": "КВАРТАЛ 276"
			}, {
				"ename": "КВАРТАЛ №297"
			}, {
				"ename": "УЛИЦА 2-ая Узбек"
			}, {
				"ename": "ТУПИК 2-й 8 марта"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Айтеке Би"
			}, {
				"ename": "ТУПИК 2-й Амангельды"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Амангельды"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Бостандык"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Турысова"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Узбек"
			}, {
				"ename": "УЛИЦА 2-ой Гульбах"
			}, {
				"ename": "ТУПИК 3-й Бостандык"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Бостандык"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Диирмен"
			}, {
				"ename": "ТУПИК 3-й Ерназарова"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Турысов"
			}, {
				"ename": "ПЕРЕУЛОК 4-й Диирмен"
			}, {
				"ename": "ПЕРЕУЛОК 4-й Турысова"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ 6А"
			}, {
				"ename": "ПЕРЕУЛОК 6-й Бостандык"
			}, {
				"ename": "ТУПИК 7-й Бостандык"
			}, {
				"ename": "УЛИЦА 8 Марта"
			}, {
				"ename": "КВАРТАЛ 94"
			}, {
				"ename": "ПЕРЕУЛОК 9-й Бостандык"
			}, {
				"ename": "ПРОЕЗД Абат"
			}, {
				"ename": "УЛИЦА Абат"
			}, {
				"ename": "УЛИЦА Абдуразакова"
			}, {
				"ename": "УЛИЦА Абжапар Жылкышиев"
			}, {
				"ename": "УЛИЦА Автозаводская"
			}, {
				"ename": "УЛИЦА А.Диваева"
			}, {
				"ename": "ПРОЕЗД Адила Сасбухаева"
			}, {
				"ename": "УЛИЦА Адила Сасбухаева"
			}, {
				"ename": "УЛИЦА Айтеке-би"
			}, {
				"ename": "УЛИЦА Акбастау"
			}, {
				"ename": "МИКРОРАЙОН Акжайык"
			}, {
				"ename": "ПРОЕЗД Акжауын"
			}, {
				"ename": "УЛИЦА Акжауын"
			}, {
				"ename": "ТУПИК Акжауын"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Амангельдинский, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "УЛИЦА Абая, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Жангельдина (Жанкельдина), СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Советская, СЕЛО Аксай"
			}, {
				"ename": "УЧАСТОК Таскора, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Аккиси, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Кумкешу, СЕЛЬСКИЙ ОКРУГ Кумкешуский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Есир, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Жетибай, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Кабырга, СЕЛЬСКИЙ ОКРУГ Кабыргинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Амантогай, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Косжан, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Каракудук, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Тасты, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Карашатобе, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Агаштыколь, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Жанатурмыс, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Карынсалды, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Жанатай, СЕЛЬСКИЙ ОКРУГ Кабыргинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Когалыколь, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Кемер, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Айтбай, СЕЛЬСКИЙ ОКРУГ Кумкешуский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Косжан, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Тасты, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Агаштыколь, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Кабырга, СЕЛЬСКИЙ ОКРУГ Кабыргинский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Каракудук, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Амантогай, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Есир, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Кемер, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №3, СЕЛО Есир, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА №3, СЕЛО Кабырга, СЕЛЬСКИЙ ОКРУГ Кабыргинский"
			}, {
				"ename": "УЛИЦА №3, СЕЛО Тасты, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА №4, СЕЛО Тасты, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА №4, СЕЛО Кабырга, СЕЛЬСКИЙ ОКРУГ Кабыргинский"
			}, {
				"ename": "УЛИЦА 50 лет Октября, СЕЛО Амантогай, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаева, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА А Байтурсынова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Степняк, СЕЛЬСКИЙ ОКРУГ Уштогайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Амантогай, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кумкешу, СЕЛЬСКИЙ ОКРУГ Кумкешуский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "ЗИМОВКА Абдир, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "ТРАССА автодорога Аркалык-Торгай, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "ЗИМОВКА Айткул, СЕЛО Кумкешу, СЕЛЬСКИЙ ОКРУГ Кумкешуский"
			}, {
				"ename": "ЗИМОВКА Айткул, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "ЗИМОВКА Аккора, СЕЛО Агайдар, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Акоткел, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Аксай, СЕЛО Им.Абу Сыздыкова, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "ЗИМОВКА Актабан, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "ЗИМОВКА Актобе, СЕЛО Есир, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Алиби Жанкельдина, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Алиби Жанкельдина, СЕЛО Горняк, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "ЗИМОВКА Алимбай, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "ЗИМОВКА Алтыбас, СЕЛО Жанатурмыс, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Уштогай, СЕЛЬСКИЙ ОКРУГ Уштогайский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Когалыколь, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Карынсалды, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Анеш Дуйсенбаева, СЕЛО Жалдама, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА А Нурманова, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА А Нурманова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "ЗИМОВКА Арал, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Ахмета Нарбая, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынова, СЕЛО Жалдама, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Ахметбекова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "ЗИМОВКА Байдаулет, СЕЛО Агаштыколь, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Байдилда Омарова, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "ЗИМОВКА Байдос, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА Байкадамова, СЕЛО Байгабыл, СЕЛЬСКИЙ ОКРУГ Байгабылский"
			}, {
				"ename": "УЛИЦА Байкадамова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Бакытжана Байкадамова, СЕЛО Жалдама, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "ЗИМОВКА Балгабай, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Б.Гордеева, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Горняк, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Жалдама, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Бейсенбек Абенов, СЕЛО Тасты, СЕЛЬСКИЙ ОКРУГ Тастинский"
			}, {
				"ename": "ЗИМОВКА Беспай, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЧАСТОК Бестобе, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧАСТОК Бирали, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Бирали Кожабаева, СЕЛО Урпек, СЕЛЬСКИЙ ОКРУГ Урпекский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Есенбаев, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Б.Майлина, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Божманова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Амантогай, СЕЛЬСКИЙ ОКРУГ Амантогайский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Степняк, СЕЛЬСКИЙ ОКРУГ Уштогайский"
			}, {
				"ename": "УЛИЦА Д.Ещанова, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Джангильдина, СЕЛО Уштогай, СЕЛЬСКИЙ ОКРУГ Уштогайский"
			}, {
				"ename": "УЛИЦА Досана Есполова, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Дуйсенбина, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аральский, ОБЛАСТЬ Кызылординская",
			"addressName": [{
				"ename": "МИКРОРАЙОН 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "МИКРОРАЙОН № 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "МИКРОРАЙОН 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА 60 жылдык Октябрь, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА 8 Марта, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Абдиказы Баймырзаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК Абдикали Жусупов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Абдикер Каюпов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Абдикер Темирбаев, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Абдильда Тажибаев, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Абдиразак Досмырзаев, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Абдисадык Ахметов, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА АБДРАМАН БАЙТАХАНОВ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Абдуали Нурпейсова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК Абдуали Шалманов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА АБДУЛ-ХАМИД МАРХАБАЕВ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Абжами Сарымсаков, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Абилкайыр Хан (Лев Толстой), ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Абилкайыр Хан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Абу Насыр Аль-Фараби, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК Айтеке би (Кумсай), ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Айтеке Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Айтеке Би, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УРОЧИЩЕ Акбулак, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УРОЧИЩЕ Акколь, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Акорда, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Аксакал Жумагулов, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Актан Батыр, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Актан Батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алданазар Шокпаров, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алданыш Халыкулов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алекеш Бисембаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Александр Павлович Мин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Александр Пушкин, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Али Бердалиев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алиби Жангельдин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алиби Жангельдин, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Алиби Жангельдин, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Алила Сатаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА АЛМАҒАНБЕТ МАХАНОВ (Дружба), ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Алматы, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Алматы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алпысбай Медетов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алсейит Жубаниязов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алтыбай Кумаров, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Алтыкудык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Альмурат Лепесов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Амангельди Иманов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Амангельди Иманов, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Амангос Есмурзаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Амиредин Аленов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Арал, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УРОЧИЩЕ Аралқұм, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Аралтуз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Арықбай Жиеналиев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Арыстан баб (30 жылдык Женис), ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Астана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Ауелбек Медетбаев, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Ауельбек Толегенулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Ауыл Жылы, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК Ахмет Байтурсынов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынов, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА АХМЕТЖАН БИЖАНОВ, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УРОЧИЩЕ Баба-2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Байгара батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Байжан Бижанов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Байконыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК БАЙТЕРЕК, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Байузак Кошалаев, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Бактыбай батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бакыт Рыскалов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК Балекеш Ермагамбетов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УРОЧИЩЕ Баскудык, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Баспак Баймуратов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, ПОСЕЛОК Жаксыкылыш"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "ТУПИК Бауыржан Момышұлы (Степная), ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Бегим ана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Беимбет Майлин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Беимбет Майлин, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Бекарыстан Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бекетай би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бекмырза хан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бекузак Танирбергенов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бержан Жайлыбаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бержан Торемуратов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА БИСЕНАЛЫ ХАЛЫКОВ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УЛИЦА Бодаш Уалиев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}, {
				"ename": "УРОЧИЩЕ Бокай, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА БҮКІРЕК БАТЫР (Мир), ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Булкайыр Айкынов, ПОСЕЛОК Саксаульск"
			}, {
				"ename": "УЛИЦА Валентина Терешкова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аральск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Аркалык, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "УЛИЦА 8 Марта"
			}, {
				"ename": "ПРОСПЕКТ Абая"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автокооператив №1"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автокооператив №3"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автокооператив №5"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автокооператив №6"
			}, {
				"ename": "УЛИЦА Автомобилистов"
			}, {
				"ename": "УЛИЦА Алтынсарина"
			}, {
				"ename": "УЛИЦА Амангельды"
			}, {
				"ename": "УЛИЦА Ауельбеков (Ауельбекова)"
			}, {
				"ename": "УЛИЦА Ауэзова"
			}, {
				"ename": "УЛИЦА Байкадамов (Байкадамова)"
			}, {
				"ename": "УЛИЦА Баймагамбетова (Баймаганбетова)"
			}, {
				"ename": "УЛИЦА Байтурсынова"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Виноградная"
			}, {
				"ename": "УЛИЦА Волкова"
			}, {
				"ename": "УЛИЦА Гагарина"
			}, {
				"ename": "УЛИЦА Гастелло"
			}, {
				"ename": "УЛИЦА Горбачева"
			}, {
				"ename": "УЛИЦА Горняков"
			}, {
				"ename": "УЛИЦА Демченко"
			}, {
				"ename": "УЛИЦА Джангельдина"
			}, {
				"ename": "УЛИЦА Дорожная"
			}, {
				"ename": "УЛИЦА Дубинина"
			}, {
				"ename": "УЛИЦА Дулатова"
			}, {
				"ename": "ПЕРЕУЛОК Жастар"
			}, {
				"ename": "УЛИЦА Жауке батыра"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Железнодорожная"
			}, {
				"ename": "УЛИЦА Заводская"
			}, {
				"ename": "УЛИЦА Загородная"
			}, {
				"ename": "МИКРОРАЙОН Западный"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Зеленая"
			}, {
				"ename": "УЛИЦА Каирбекова"
			}, {
				"ename": "ПЕРЕУЛОК Кайнар"
			}, {
				"ename": "УЛИЦА Кальменова"
			}, {
				"ename": "УЛИЦА Кейки Батыра"
			}, {
				"ename": "УЛИЦА Киевская"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Ковыльная"
			}, {
				"ename": "УЛИЦА Козыбаева"
			}, {
				"ename": "ПЕРЕУЛОК Коктем"
			}, {
				"ename": "УЛИЦА Кольцевая"
			}, {
				"ename": "УЛИЦА Комарова"
			}, {
				"ename": "УЛИЦА Кооперативная"
			}, {
				"ename": "УЛИЦА Космонавтов"
			}, {
				"ename": "УЛИЦА Красноармейская"
			}, {
				"ename": "УЛИЦА Крупской"
			}, {
				"ename": "УЛИЦА Кусаинов (Кусаинова)"
			}, {
				"ename": "УЛИЦА Ленинградская"
			}, {
				"ename": "УЛИЦА Лесная"
			}, {
				"ename": "УЛИЦА Летняя"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Магистральная"
			}, {
				"ename": "УЛИЦА Майкутова"
			}, {
				"ename": "УЛИЦА Малиновая"
			}, {
				"ename": "УЛИЦА Матросова"
			}, {
				"ename": "УЛИЦА Мауленова"
			}, {
				"ename": "УЛИЦА Маясовой (Маясовой)"
			}, {
				"ename": "УЛИЦА Молодежная"
			}, {
				"ename": "ПЕРЕУЛОК Молодежный (Молодежный, Молодежная)"
			}, {
				"ename": "МИКРОРАЙОН Молодежный (Молодежный, Молодежная)"
			}, {
				"ename": "УЛИЦА Московская"
			}, {
				"ename": "УЛИЦА Муканова"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Набережная"
			}, {
				"ename": "УЛИЦА Нагорная"
			}, {
				"ename": "МИКРОРАЙОН Новый"
			}, {
				"ename": "УЛИЦА Нургали и Назипы Кульжановых"
			}, {
				"ename": "УЛИЦА Огородная"
			}, {
				"ename": "УЛИЦА Озерная"
			}, {
				"ename": "УЛИЦА Октябрьская"
			}, {
				"ename": "УЛИЦА Павлова"
			}, {
				"ename": "УЛИЦА Партизанская"
			}, {
				"ename": "УЛИЦА Первомайская"
			}, {
				"ename": "УЛИЦА Пионерская"
			}, {
				"ename": "УЛИЦА Полевая"
			}, {
				"ename": "ПЕРЕУЛОК Полевой"
			}, {
				"ename": "УЛИЦА Приозерная"
			}, {
				"ename": "ПЕРЕУЛОК Приозерный"
			}, {
				"ename": "УЛИЦА Пролетарская"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона"
			}, {
				"ename": "УЛИЦА Промышленная"
			}, {
				"ename": "УЛИЦА Пятилетки"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Рабочая"
			}, {
				"ename": "УЛИЦА Рабочая"
			}, {
				"ename": "УЛИЦА Рудничная"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Садовая"
			}, {
				"ename": "УЛИЦА Садовая"
			}, {
				"ename": "УЛИЦА Садыкова"
			}, {
				"ename": "ПЕРЕУЛОК Сайран"
			}, {
				"ename": "УЛИЦА Сатпаева"
			}, {
				"ename": "УЛИЦА Светлая"
			}, {
				"ename": "ПЕРЕУЛОК Светлый"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Север"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Северная"
			}, {
				"ename": "УЛИЦА Северная"
			}, {
				"ename": "ПЕРЕУЛОК Северная (Северный)"
			}, {
				"ename": "УЛИЦА Советская"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Солнечная"
			}, {
				"ename": "УЛИЦА Степная"
			}, {
				"ename": "УЛИЦА Суворова"
			}, {
				"ename": "ЗОНА Технологическая"
			}, {
				"ename": "УЛИЦА Трофимова"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аршалынский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, ПОСЕЛОК Аршалы"
			}, {
				"ename": "КВАРТАЛ 044, СЕЛЬСКИЙ ОКРУГ Арнасай"
			}, {
				"ename": "МИКРОРАЙОН 1, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО №1, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 10, ПОСЕЛОК Аршалы"
			}, {
				"ename": "МИКРОРАЙОН 2, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО №2, ПОСЕЛОК Аршалы"
			}, {
				"ename": "МИКРОРАЙОН 3, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ПЕРЕУЛОК 3, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 3, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО №3, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 4, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 40 лет Целины, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 5, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 6, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА 7, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА №8, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Алаш, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Алейникова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Алтын Астык, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Алтын Гасыр, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Астана, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Атаконыс, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Баркытбел, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Бейбитшилик, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Бирлик, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Болашак, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Бытовик, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Волкова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Восточная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Гранит, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Гранитная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Дзержинского, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Добровольского, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Достык, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Дружба, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ТРАССА Екатеринбург-Алматы, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Есил, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жалгызтал, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ПЕРЕУЛОК Жамбыла, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жанажол, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жастар, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Железнодорожная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Женис, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жолдаспаева, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ПЕРЕУЛОК Жолдаспаева, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жумабека Ташенова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Жұмбақтас, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Заводская, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Заречная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Зеленая, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Казахстан, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Казахстан, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Карьер, ПОСЕЛОК Аршалы"
			}, {
				"ename": "КВАРТАЛ Квартал Новый, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Коммунальная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Конституция, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Линейная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Луговая, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Мадениет, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Макаренко, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Маншук Маметовой, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Матросова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Митченко, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Мойылды, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Молодежный, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Ново-Автобазовская, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Объездная дорога №229, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Озерная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Отан, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Парасат, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Пацаева, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Писарева, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ДАЧНЫЙ МАССИВ Природа, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Промышленная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА ПТЛ-14, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Республика, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Речная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Родниковская, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Садовод, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Сазонова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "ПЕРЕУЛОК Сарыарка, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Северная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Спортивная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Станционная, ПОСЕЛОК Аршалы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Строитель, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Тауелсиздик, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Т.Бегельдинова, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Темиржолшылар, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Тналина, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Труда, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Улица 1, ПОСЕЛОК Аршалы"
			}, {
				"ename": "УЛИЦА Улица №9, ПОСЕЛОК Аршалы"
			}, {
				"ename": "КВАРТАЛ УЧЕТНЫЙ КВАРТАЛ 001, ПОСЕЛОК Аршалы"
			}, {
				"ename": "КВАРТАЛ УЧЕТНЫЙ КВАРТАЛ 003, ПОСЕЛОК Аршалы"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Арыс, ОБЛАСТЬ Туркестанская",
			"addressName": [{
				"ename": "КВАРТАЛ 001"
			}, {
				"ename": "КВАРТАЛ 002"
			}, {
				"ename": "КВАРТАЛ 003"
			}, {
				"ename": "КВАРТАЛ 004"
			}, {
				"ename": "КВАРТАЛ 005"
			}, {
				"ename": "КВАРТАЛ 006"
			}, {
				"ename": "КВАРТАЛ 007"
			}, {
				"ename": "КВАРТАЛ 008"
			}, {
				"ename": "КВАРТАЛ 009"
			}, {
				"ename": "КВАРТАЛ 010"
			}, {
				"ename": "КВАРТАЛ 011"
			}, {
				"ename": "КВАРТАЛ 012"
			}, {
				"ename": "КВАРТАЛ 013"
			}, {
				"ename": "КВАРТАЛ 014"
			}, {
				"ename": "КВАРТАЛ 015"
			}, {
				"ename": "КВАРТАЛ 016"
			}, {
				"ename": "КВАРТАЛ 019"
			}, {
				"ename": "КВАРТАЛ 027"
			}, {
				"ename": "КВАРТАЛ 028"
			}, {
				"ename": "КВАРТАЛ 029"
			}, {
				"ename": "КВАРТАЛ 030"
			}, {
				"ename": "КВАРТАЛ 031"
			}, {
				"ename": "КВАРТАЛ 032"
			}, {
				"ename": "КВАРТАЛ 033"
			}, {
				"ename": "КВАРТАЛ 034"
			}, {
				"ename": "КВАРТАЛ 035"
			}, {
				"ename": "КВАРТАЛ 036"
			}, {
				"ename": "КВАРТАЛ 037"
			}, {
				"ename": "КВАРТАЛ 038"
			}, {
				"ename": "КВАРТАЛ 039"
			}, {
				"ename": "КВАРТАЛ 040"
			}, {
				"ename": "КВАРТАЛ 041"
			}, {
				"ename": "КВАРТАЛ 042"
			}, {
				"ename": "КВАРТАЛ 043"
			}, {
				"ename": "КВАРТАЛ 044"
			}, {
				"ename": "КВАРТАЛ 045"
			}, {
				"ename": "КВАРТАЛ 046"
			}, {
				"ename": "КВАРТАЛ 047"
			}, {
				"ename": "КВАРТАЛ 048"
			}, {
				"ename": "КВАРТАЛ 050"
			}, {
				"ename": "КВАРТАЛ 055"
			}, {
				"ename": "КВАРТАЛ 057"
			}, {
				"ename": "КВАРТАЛ 064"
			}, {
				"ename": "КВАРТАЛ 068"
			}, {
				"ename": "КВАРТАЛ 072"
			}, {
				"ename": "КВАРТАЛ 075"
			}, {
				"ename": "КВАРТАЛ 077"
			}, {
				"ename": "УЛИЦА А.Акмурзаева"
			}, {
				"ename": "УЛИЦА Абаи Кунанбаева"
			}, {
				"ename": "УЛИЦА А.Балгынбекова"
			}, {
				"ename": "УЛИЦА Абат"
			}, {
				"ename": "УЛИЦА Абдолла Жумагалиева"
			}, {
				"ename": "УЛИЦА Абдулла Жармухамбетова"
			}, {
				"ename": "УЛИЦА Абылаи Тилеубердин"
			}, {
				"ename": "ПЛОЩАДЬ Абылайхан"
			}, {
				"ename": "УЛИЦА Адалхан Тулепова"
			}, {
				"ename": "УЛИЦА Адилбек би"
			}, {
				"ename": "УЛИЦА Азизаева Усербаи"
			}, {
				"ename": "УЛИЦА Аибын"
			}, {
				"ename": "УЛИЦА Аитеке би"
			}, {
				"ename": "УЛИЦА Акалтин"
			}, {
				"ename": "УЛИЦА Ақарыс"
			}, {
				"ename": "УЛИЦА Акдала"
			}, {
				"ename": "УЛИЦА Акжайлау"
			}, {
				"ename": "УЛИЦА Акжар"
			}, {
				"ename": "УЛИЦА Акжелкен"
			}, {
				"ename": "УЛИЦА Акжол"
			}, {
				"ename": "УЛИЦА Акжусан"
			}, {
				"ename": "УЛИЦА Акикат"
			}, {
				"ename": "УЛИЦА Акиык"
			}, {
				"ename": "УЛИЦА Аккузова Абуталип"
			}, {
				"ename": "УЛИЦА Акниет"
			}, {
				"ename": "УЛИЦА Акозек"
			}, {
				"ename": "УЛИЦА Акшуак"
			}, {
				"ename": "УЛИЦА Аламан"
			}, {
				"ename": "МИКРОРАЙОН Алатау Батыр"
			}, {
				"ename": "УЛИЦА Алаш"
			}, {
				"ename": "УЛИЦА Алип Мадалиева"
			}, {
				"ename": "УЛИЦА Алмалы"
			}, {
				"ename": "УЛИЦА Алма Оразбаевой"
			}, {
				"ename": "УЛИЦА Алматы"
			}, {
				"ename": "УЛИЦА Алтинбек Ешназарова"
			}, {
				"ename": "УЛИЦА Алтын Бесік"
			}, {
				"ename": "УЛИЦА Алтындала"
			}, {
				"ename": "ПЛОЩАДЬ Аль-Фараби"
			}, {
				"ename": "УЛИЦА Аль-Фараби"
			}, {
				"ename": "УЛИЦА Аманат"
			}, {
				"ename": "УЛИЦА Амангелди"
			}, {
				"ename": "УЛИЦА Ансар"
			}, {
				"ename": "УЛИЦА Арай"
			}, {
				"ename": "УЛИЦА Арайлы"
			}, {
				"ename": "УЛИЦА Арасан"
			}, {
				"ename": "УЛИЦА Аргымак"
			}, {
				"ename": "УЛИЦА Ардагер"
			}, {
				"ename": "УЛИЦА А.Салыкбаева"
			}, {
				"ename": "УЛИЦА Асанова Кожан"
			}, {
				"ename": "УЛИЦА Асар"
			}, {
				"ename": "УЛИЦА Асилбек Борикбаева"
			}, {
				"ename": "УЛИЦА Асилбекова Жумат"
			}, {
				"ename": "УЛИЦА Аскар Токмаганбетова"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Астраханский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "ПЕРЕУЛОК №1, СЕЛО Камышенка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "ПЕРЕУЛОК №2, СЕЛО Камышенка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА 24 Марта, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Есильский"
			}, {
				"ename": "ПЕРЕУЛОК 8 Марта, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "ПЕРЕУЛОК Абай (Некрасова), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Жана-турмыс, СЕЛЬСКИЙ ОКРУГ Кызылжарский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Николаевский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Николаевский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Абылай хан (Ленина), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Колутонский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Узунколь, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Жана-турмыс, СЕЛЬСКИЙ ОКРУГ Кызылжарский"
			}, {
				"ename": "УЛИЦА Акана Серы, СЕЛО Жана-турмыс, СЕЛЬСКИЙ ОКРУГ Кызылжарский"
			}, {
				"ename": "УЛИЦА Акан сери, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Ак жол, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Алиби Жангельдина, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Аль Фараби, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Аль-Фараби, СЕЛО Караколь, СЕЛЬСКИЙ ОКРУГ Острогорский"
			}, {
				"ename": "УЛИЦА Аль-Фараби, СЕЛО Новый Колутон, СЕЛЬСКИЙ ОКРУГ Острогорский"
			}, {
				"ename": "УЛИЦА Аль-Фараби, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Аманат (Автотранспортная), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Амангелді Құрманалин (2 Линейная), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Аманжола Шалтаева, СЕЛО Ковыленка, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Андрея Коваленко, СЕЛО Степное, СЕЛЬСКИЙ ОКРУГ Есильский"
			}, {
				"ename": "УЛИЦА Атамекен, СЕЛО Каменка, СЕЛЬСКИЙ ОКРУГ Каменский"
			}, {
				"ename": "УЛИЦА Ахмета Байтурсынова, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Ахмет Байтұрсынұлы (Октябрьская), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Бақ (Садовая), СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Балуана Шолака, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Батыс (Западная), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Батыс, СЕЛО Первомайка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Бауржана Момышулы, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Бауржана Момышулы, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Бауыржана Момышулы, СЕЛО Жарсуат, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы (Буденного), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Шиликти, СЕЛЬСКИЙ ОКРУГ Есильский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Каменка, СЕЛЬСКИЙ ОКРУГ Каменский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Николаевский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Приишимка, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Мира), СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Мира), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "ПЕРЕУЛОК Береке (Книжный), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Береке, СЕЛО Первомайка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Первомайка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Бірлік (Жбк), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "ПЕРЕУЛОК Бірлік (Школьный), СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Богенбай Батыра, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Богенбая Батыра, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Болашақ (Новый Маслозавод), СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Бостандык, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Бостандык, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Вокзальная, СЕЛО Колутон, СЕЛЬСКИЙ ОКРУГ Колутонский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Есильский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Даулеткерея, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Динмухамеда Кунаева, СЕЛО Новый Колутон, СЕЛЬСКИЙ ОКРУГ Острогорский"
			}, {
				"ename": "УЛИЦА Динмухамеда Кунаева, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Дінмұхамед Қонаев (Северная), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Новый Колутон, СЕЛЬСКИЙ ОКРУГ Острогорский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Николаевский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Ягодное, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Первомайка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Каменка, СЕЛЬСКИЙ ОКРУГ Каменский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Оксановка, СЕЛЬСКИЙ ОКРУГ Кызылжарский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Енбек, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Достық (Комсомольская), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "ШОССЕ Екатеринбург-Алматы, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "ШОССЕ Екатеринбург-Алматы, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "ШОССЕ Екатеринбург-Алматы, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "ШОССЕ Екатеринбург-Алматы, СЕЛО Косколь, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова (Тельмана), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "ДАЧНЫЙ МАССИВ Енбек, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Енбек, СЕЛО Первомайка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Еңбек (Трудовая), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Есильская, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Жағалау (Набережная), СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Жапархана Асаинова, СЕЛО Астраханка, СЕЛЬСКИЙ ОКРУГ Астраханский"
			}, {
				"ename": "УЛИЦА Жапархана Асаинова, СЕЛО Косколь, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Жапархан Асаинов (Советская), СЕЛО Жалтыр, СЕЛЬСКИЙ ОКРУГ Жалтырский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Каменка, СЕЛЬСКИЙ ОКРУГ Каменский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Первомайка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Новочеркасское, СЕЛЬСКИЙ ОКРУГ Новочеркасский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Николаевский"
			}, {
				"ename": "УЛИЦА Железнодорожная, СЕЛО Колутон, СЕЛЬСКИЙ ОКРУГ Колутонский"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Каменка, СЕЛЬСКИЙ ОКРУГ Каменский"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Старый Колутон, СЕЛЬСКИЙ ОКРУГ Староколутонский"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Каменка, СЕЛЬСКИЙ ОКРУГ Каменский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Атбасарский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "МИКРОРАЙОН №1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА 8 Марта, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ 9, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Абылайхана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Автомобилистов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист ПАТП, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Агыбай батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Акбулак, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Александра Затаевича, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "МИКРОРАЙОН Армандастар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Атбасарская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Ахмета Байтурсынова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Байтерек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Борисовка"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Бирлик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Буденного, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Бытовик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Виденеева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Вокзальная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Восточная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Гвардейская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Достык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Борисовка"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Дружба, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "ТРАССА Екатеринбург-Алматы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Әлімхан Ермеков (Ирченко), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Жайлау, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Жакыпбека Жангозина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Жамбула, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Железнодорожная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Желтоксан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Женис, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Жибек жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Заготовитель, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Заправочная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Заречная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Ибаррури, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Ибрая Алтынсарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Ильяса Есенберлина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Имени Акана Курманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Имени Бауыржана Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Имени Ивана Дьяченко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Имени Рахимжана Кошкарбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Инкубаторная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Источная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Қажымұқан (Матросова), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Казахстанская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Қайрат Рысқұлбеков (Островского), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Каменный Карьер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА К.Амировой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Канай би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Кенесары, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Керамзит, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Клименко Cемён, СЕЛО Борисовка"
			}, {
				"ename": "УЛИЦА К.Мукушева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Коктем, СЕЛО Новосельское"
			}, {
				"ename": "ТРАССА Кокшетау-Атбасар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Комсомольская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Красноармейская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Краснознаменная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Куйбышева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Курмангазы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Линейная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Логовая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Локомотив, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Лука Белаш, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Мадениет, СЕЛО Новосельское"
			}, {
				"ename": "УЛИЦА Майкутова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Макарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА М.Ауэзова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА М.Аюханова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Маяковского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА М.Горького, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Мельничная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Мира, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Мищенко Иван, СЕЛО Борисовка"
			}, {
				"ename": "УЛИЦА Міржақып Дулатұлы (Урицкого), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА М.Маметовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Молодежная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Мұстафа Шоқай (Интернациональная), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Набережная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Никиты Карацупа, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Н.Нурсеитова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Озерная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА О.Куанышева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Ондирис, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА О.Шмидта, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Панфилова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}, {
				"ename": "УЛИЦА Перевалочная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Атбасар"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Атырау, ОБЛАСТЬ Атырауская",
			"addressName": [{
				"ename": "ГАРАЖНЫЙ МАССИВ №12 Мектеп"
			}, {
				"ename": "РЯД № 2"
			}, {
				"ename": "РАЗЪЕЗД 496"
			}, {
				"ename": "РЯД № 6"
			}, {
				"ename": "МАССИВ 8 Наурыз"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Абай алаңы"
			}, {
				"ename": "УЛИЦА Абая"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Авангард"
			}, {
				"ename": "МИКРОРАЙОН Авангард -2"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Авангард -2"
			}, {
				"ename": "МИКРОРАЙОН Авангард-3"
			}, {
				"ename": "МИКРОРАЙОН Авангард-4"
			}, {
				"ename": "ПРОЕЗД Авиатор"
			}, {
				"ename": "ПРОЕЗД Автобаза"
			}, {
				"ename": "ПРОЕЗД Автомобилист"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Автопарк"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Автотэп"
			}, {
				"ename": "ПРОЕЗД Ағатай Батыр"
			}, {
				"ename": "УЛИЦА Адмирал Лев Владимирский"
			}, {
				"ename": "ПРОЕЗД Адырыс"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Азаттық"
			}, {
				"ename": "ПРОСПЕКТ Азаттық"
			}, {
				"ename": "УЛИЦА Айша Бибі"
			}, {
				"ename": "УЛИЦА Академик Бинеш Жарбосынов"
			}, {
				"ename": "УЛИЦА Акжайык"
			}, {
				"ename": "МИКРОРАЙОН Ақжайық"
			}, {
				"ename": "ПЕРЕУЛОК Ақжал"
			}, {
				"ename": "ПРОЕЗД Ақжол"
			}, {
				"ename": "ПРОЕЗД Аққыстау"
			}, {
				"ename": "УЛИЦА Ақсұңқар"
			}, {
				"ename": "ПРОЕЗД Ақтамберді Жырау"
			}, {
				"ename": "УЛИЦА Ақтау"
			}, {
				"ename": "МИКРОРАЙОН Ақ Шағала"
			}, {
				"ename": "ПРОЕЗД Ақшағыл"
			}, {
				"ename": "ПРОЕЗД Ақын Сара"
			}, {
				"ename": "ПРОЕЗД Ақын Шернияз"
			}, {
				"ename": "УЛИЦА Алатау"
			}, {
				"ename": "УЛИЦА Алатау (Сырдария)"
			}, {
				"ename": "УЛИЦА Алаш"
			}, {
				"ename": "ПРОЕЗД Алғабас"
			}, {
				"ename": "УЛИЦА Александр Афанасьев"
			}, {
				"ename": "УЛИЦА Александр Грибоедов"
			}, {
				"ename": "ПРОЕЗД Александр Затаевич"
			}, {
				"ename": "УЛИЦА Александр Пушкин"
			}, {
				"ename": "УЛИЦА Александр Стаханов"
			}, {
				"ename": "УЛИЦА Алиева- Курмангазы"
			}, {
				"ename": "МИКРОРАЙОН Алмагүл"
			}, {
				"ename": "МАССИВ Алмалы"
			}, {
				"ename": "ПРОЕЗД Алмалы"
			}, {
				"ename": "ПРОЕЗД Алпамыс Батыр"
			}, {
				"ename": "УЛИЦА Алтай"
			}, {
				"ename": "УЛИЦА Алтынкөл"
			}, {
				"ename": "УЛИЦА Альпияр Жұмағазиев"
			}, {
				"ename": "УЛИЦА Амангелді"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Амөз Аумағындағы Өндіріс аймағы"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Анпз"
			}, {
				"ename": "ПРОЕЗД Антон Чехов"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО АНУ-2"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Арал"
			}, {
				"ename": "ПРОЕЗД Арал"
			}, {
				"ename": "МИКРОРАЙОН Ардагер"
			}, {
				"ename": "УЛИЦА Ардагер"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Арзамасская"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Арын"
			}, {
				"ename": "УЛИЦА Асау Барақ"
			}, {
				"ename": "УЛИЦА Аскар Бисекенов"
			}, {
				"ename": "УЛИЦА Астана"
			}, {
				"ename": "ТРАССА Астрахань"
			}, {
				"ename": "УЛИЦА Астрахань"
			}, {
				"ename": "МИКРОРАЙОН Атамұра (Алиев Курмангазы)"
			}, {
				"ename": "МИКРОРАЙОН Атырау"
			}, {
				"ename": "МИКРОРАЙОН Атырау-2"
			}, {
				"ename": "ТРАССА Атырау-Доссор"
			}, {
				"ename": "ТРАССА Атырау-Уральск"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынов"
			}, {
				"ename": "УЛИЦА Ахмет Жұбанов"
			}, {
				"ename": "ПРОЕЗД Ащысай"
			}, {
				"ename": "ПРОЕЗД Байкент"
			}, {
				"ename": "ПРОЕЗД Байланысшылар"
			}, {
				"ename": "МИКРОРАЙОН Байтақ (Водников)"
			}, {
				"ename": "ПРОЕЗД Бақсай"
			}, {
				"ename": "УЛИЦА Бақтыгерей Құлманов"
			}, {
				"ename": "УЛИЦА Балқаш"
			}, {
				"ename": "МИКРОРАЙОН Балықшы"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы"
			}, {
				"ename": "ПЕРЕУЛОК Баянауыл (Улкенкульская)"
			}, {
				"ename": "УЛИЦА Баянды (Қаршыға Ахмедьяров)"
			}, {
				"ename": "ПРОСПЕКТ Бейбарыс"
			}, {
				"ename": "ПРОЕЗД Бәйдібек (Ахмет Байтұрсынов)"
			}, {
				"ename": "УЛИЦА Бейімбет Майлин"
			}, {
				"ename": "УЛИЦА Бекбай Бимағанов"
			}, {
				"ename": "ПРОЕЗД Бердібек Соқпақбаев (Талғат Бигельдинов)"
			}, {
				"ename": "МИКРОРАЙОН Береке"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Береке"
			}, {
				"ename": "УЛИЦА Береке"
			}, {
				"ename": "УЛИЦА Берқайыр Аманшин"
			}, {
				"ename": "УЛИЦА Бестоғай (Блочная)"
			}, {
				"ename": "МИКРОРАЙОН Бірлік"
			}, {
				"ename": "УЛИЦА Бөгенбай Батыр"
			}, {
				"ename": "УЛИЦА Боран Нысанбаев"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аулиекольский, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "УЛИЦА №1, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА №1, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Первомайское"
			}, {
				"ename": "ТРАССА 108, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА 10 пятилетка, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА №2, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА 20 лет Целины, СЕЛО Первомайское"
			}, {
				"ename": "УЛИЦА №3, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА №4, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА 40 лет Казахстана, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА №5, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА 50 лет ВЛКСМ, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА №6, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА №7, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА №8, СЕЛО Коктал"
			}, {
				"ename": "УЛИЦА 9 пятилетка, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Аулиеколь"
			}, {
				"ename": "ТРАССА Аулиеколь - Амангельды 105 км, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Баймагамбетова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Баймагамбетова, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Байтурсынова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Бәйтерек, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Березовая, СЕЛО Аулиеколь"
			}, {
				"ename": "МИКРОРАЙОН Бірлік, СЕЛО Аулиеколь"
			}, {
				"ename": "ПЕРЕУЛОК Больничный, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Буденного, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Вагонная, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Валиханова, СЕЛО Первомайское"
			}, {
				"ename": "УЛИЦА Валиханова, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Валиханова, СЕЛО Аулиеколь"
			}, {
				"ename": "ПЕРЕУЛОК Военный Городок, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Первомайское"
			}, {
				"ename": "УЛИЦА Гастелло, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Гоголя, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Горького, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Деповская, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Первомайское"
			}, {
				"ename": "УЛИЦА Джамбула, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Джангельдина (Джангильдина), СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Дзержинского, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Дорожников, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Есенина, СЕЛО Аулиеколь"
			}, {
				"ename": "ПЕРЕУЛОК Железнодорожный (Железнодорожная), ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Жильгильдина, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА Жильгильдина, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Заводская, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Закарьерная, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Затобольская, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Зеленая, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА имени  Байқұлақ батыра, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА имени Ерика Асанбаева, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА имени Мұқаш Тойқожаұлы, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА имени Саржетім Қарабалуан батыра, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА имени Султана Еркимбаева, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА имени Шақшақ Жәнібек батыра, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Индустриальная, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Кавкетаева, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Калинина, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Караганская, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "ПЕРЕУЛОК Кирова, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Кирова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА К.Маркса, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Комарова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Комсомольская, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Первомайское"
			}, {
				"ename": "УЛИЦА Космонавтов, СЕЛО Аулиеколь"
			}, {
				"ename": "ТРАССА Костанай-Сурган 103 км, СЕЛО Аулиеколь"
			}, {
				"ename": "ТРАССА Костанай-Сурган 105 км, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Кравцова, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА Куаныша Шамшиева, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Кустанайская, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА Кустанайская, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Кутузова, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Ленина, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Лермонтова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Лесная, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Лесная, СЕЛО Тимофеевка"
			}, {
				"ename": "ЛЕСХОЗ Лесничество, СЕЛО Тимофеевка"
			}, {
				"ename": "УЛИЦА Луговая, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Мамедова, СЕЛО Аулиеколь"
			}, {
				"ename": "ПЕРЕУЛОК Матросов, ПОСЕЛОК Кушмурун"
			}, {
				"ename": "УЛИЦА Медета Досымханова, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Аулиеколь"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Первомайское"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Ауэзовский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Алматы",
			"addressName": [{
				"ename": "МИКРОРАЙОН 1"
			}, {
				"ename": "МИКРОРАЙОН 10"
			}, {
				"ename": "МИКРОРАЙОН 10а"
			}, {
				"ename": "МИКРОРАЙОН 11"
			}, {
				"ename": "МИКРОРАЙОН 12"
			}, {
				"ename": "МИКРОРАЙОН 2"
			}, {
				"ename": "УЛИЦА 2 Вишневского"
			}, {
				"ename": "МИКРОРАЙОН 3"
			}, {
				"ename": "МИКРОРАЙОН 4"
			}, {
				"ename": "МИКРОРАЙОН 5"
			}, {
				"ename": "МИКРОРАЙОН 6"
			}, {
				"ename": "МИКРОРАЙОН 7"
			}, {
				"ename": "МИКРОРАЙОН 8"
			}, {
				"ename": "МИКРОРАЙОН 9"
			}, {
				"ename": "ПРОСПЕКТ Абая"
			}, {
				"ename": "МИКРОРАЙОН Аксай-1"
			}, {
				"ename": "МИКРОРАЙОН Аксай-1а"
			}, {
				"ename": "МИКРОРАЙОН Аксай-2"
			}, {
				"ename": "МИКРОРАЙОН Аксай-3"
			}, {
				"ename": "МИКРОРАЙОН Аксай-3а"
			}, {
				"ename": "МИКРОРАЙОН Аксай-3б"
			}, {
				"ename": "МИКРОРАЙОН Аксай-4"
			}, {
				"ename": "МИКРОРАЙОН Аксай-5"
			}, {
				"ename": "УЛИЦА Актюбинская"
			}, {
				"ename": "ПЕРЕУЛОК Актюбинский"
			}, {
				"ename": "УЛИЦА Алданская"
			}, {
				"ename": "МИКРОРАЙОН Алмас"
			}, {
				"ename": "МИКРОРАЙОН Алтын бесик"
			}, {
				"ename": "ПРОСПЕКТ Алтынсарина"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Арман"
			}, {
				"ename": "УЛИЦА Аскарова"
			}, {
				"ename": "МИКРОРАЙОН Астана"
			}, {
				"ename": "МИКРОРАЙОН Атамекен"
			}, {
				"ename": "МИКРОРАЙОН Баян-аул"
			}, {
				"ename": "МИКРОРАЙОН Баянаул-2"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Ветеран"
			}, {
				"ename": "УЛИЦА Вилюйская"
			}, {
				"ename": "ПЕРЕУЛОК Вишневского"
			}, {
				"ename": "УЛИЦА Восточная"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Восход"
			}, {
				"ename": "УЛИЦА Губкина"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Дархан"
			}, {
				"ename": "МИКРОРАЙОН Достык"
			}, {
				"ename": "УЛИЦА Дружба"
			}, {
				"ename": "МИКРОРАЙОН Дубок-2 /Таугуль/"
			}, {
				"ename": "УЛИЦА Есенина"
			}, {
				"ename": "МИКРОРАЙОН Жазира"
			}, {
				"ename": "УЛИЦА Жазылбека"
			}, {
				"ename": "УЛИЦА Жандосова"
			}, {
				"ename": "МИКРОРАЙОН Жетысу-1"
			}, {
				"ename": "МИКРОРАЙОН Жетысу-2"
			}, {
				"ename": "МИКРОРАЙОН Жетысу-3"
			}, {
				"ename": "МИКРОРАЙОН Жетысу-4"
			}, {
				"ename": "УЛИЦА Жубанова"
			}, {
				"ename": "УЛИЦА Запотоцкого"
			}, {
				"ename": "ПЕРЕУЛОК Заречный"
			}, {
				"ename": "УЛИЦА Златоустовская"
			}, {
				"ename": "УЛИЦА Кабдолова"
			}, {
				"ename": "УЛИЦА Каргалинка дом отдыха"
			}, {
				"ename": "УЛИЦА Карпинского"
			}, {
				"ename": "УЛИЦА Карская"
			}, {
				"ename": "УЛИЦА касаткина"
			}, {
				"ename": "МИКРОРАЙОН Куаныш"
			}, {
				"ename": "УЛИЦА Ладыгина"
			}, {
				"ename": "УЛИЦА Лазарева"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Ласточка"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Лиана"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Луч"
			}, {
				"ename": "МИКРОРАЙОН Мамыр"
			}, {
				"ename": "МИКРОРАЙОН Мамыр-1"
			}, {
				"ename": "МИКРОРАЙОН Мамыр-2"
			}, {
				"ename": "МИКРОРАЙОН Мамыр-3"
			}, {
				"ename": "МИКРОРАЙОН Мамыр-4"
			}, {
				"ename": "МИКРОРАЙОН Мамыр-7"
			}, {
				"ename": "УЛИЦА Мамыр пос."
			}, {
				"ename": "УЛИЦА Мануильского"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Медео-1"
			}, {
				"ename": "УЛИЦА Навои"
			}, {
				"ename": "УЛИЦА подвойского"
			}, {
				"ename": "УЛИЦА Пришвина"
			}, {
				"ename": "УЛИЦА Пятницкого"
			}, {
				"ename": "ПРОСПЕКТ Райымбек"
			}, {
				"ename": "УЛИЦА Рыскулбекова"
			}, {
				"ename": "УЛИЦА Садовникова"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Садовод"
			}, {
				"ename": "УЛИЦА Саина"
			}, {
				"ename": "МИКРОРАЙОН Сайран"
			}, {
				"ename": "УЛИЦА Сатпаева"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Селевик"
			}, {
				"ename": "УЛИЦА Семятовой"
			}, {
				"ename": "УЛИЦА Симферопольская"
			}, {
				"ename": "УЛИЦА Смирнова"
			}, {
				"ename": "УЛИЦА Солнечная"
			}, {
				"ename": "МАССИВ Сооружение Энергетики"
			}, {
				"ename": "УЛИЦА Сулейменова"
			}, {
				"ename": "УЛИЦА Сурикова"
			}, {
				"ename": "УЛИЦА Талдыкурганская"
			}, {
				"ename": "МИКРОРАЙОН Тастак-1"
			}, {
				"ename": "МИКРОРАЙОН Таугуль"
			}, {
				"ename": "МИКРОРАЙОН Таугуль-1"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Аягозский, ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "УЧАСТОК 10 км автотрассы Аягоз-Баршатас, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 14 Линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 15 Линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДАЧНЫЙ МАССИВ 16 км трассы Аягоз-Баршатас, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 17 Линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК 18 км авторассы Аягоз-Усть-Каменогорск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "РАЗЪЕЗД № 19 Алтын Колат, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО 1 Линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "РАЗЪЕЗД № 21 Разъезд, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "РАЗЪЕЗД № 22 Разъезд, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "РАЗЪЕЗД № 24 Разъезд, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "РАЗЪЕЗД № 27 Разъезд, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА 3 Км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК 5 очередь, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА 6 Пункт, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "СТАНЦИЯ 781 км автотрассы Алматы-Усть-Каменогорск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК 813 км трассасы Алматы-Усть-Каменогорск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Байтурсынова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "БУЛЬВАР Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Болатова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Автодорога Алматы-Усть-Каменогорск 780 км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Ағайынды Махмут Садық Байсалбаевтар (Водосточная), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Дауытбергенова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "РАЗЪЕЗД Айгыржал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Аканаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА Аканаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Аканаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Аккожа Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Аккожа Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Кошкимбаевой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА А.Кошкинбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА Актамберды, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ТРАССА Актамберды, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Актамберды, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Актамберды № 30, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Актамберды 6/1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Актамберды осиеты, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Актанберды № 26, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Актанберды № 28, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Актанберды № 30, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ТРАССА Алматы-Усть-Каменогорск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ШОССЕ Алматы-Усть-Каменогорск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Алматы-Усть-Каменогорск 776Б, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ШОССЕ Алматы-Усть-Каменогорск шоссе 778 км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Алтынсарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Алтынсарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Алтынсарина № 17, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Алтынсарина № 44, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Маженова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Мамбетова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Амангелды, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Матросова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Найманбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Нугманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ АО Казахтелеком, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Арип, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Аталыкова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Танирбергенова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ А.Танирбергенова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Таурбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Терликбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Турганбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Ауезова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Ауезова № 30, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Ауезова № 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Шакенова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Шантемисова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Аягоз-Вет, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ТЕРРИТОРИЯ Аягозский аэропорт \\\"Казаэронавигация\\\", ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Аягузская районная эксплуатационная часть, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА А.Янушкевича, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Баймурат Батыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Байтерек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЗИМОВКА Балжан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Балжан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Барак Батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Без названия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Береке, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Береке-Бірлік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Берик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Бериккали Тугелбаев (Пролетарская), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Бирлик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Б.Искакова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Б.Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА Б.Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Б.Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА Богенбай батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Богенбай батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Богенбай Батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Болашак, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Боранбай Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЛИЦА Б.Тайкиманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Бульвар Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ДОРОГА Бульвар Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Бульвар Абая   21 ТП-139, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Бульвар Абая № 23, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "ЛИНИЯ Бульвар Абая 25, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК вдоль трассы Алматы-Усть-Каменогорск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}, {
				"ename": "УЧАСТОК Вдоль трассы Аягоз-Баршатас, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аягоз"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Байганинский, ОБЛАСТЬ Актюбинская",
			"addressName": [{
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Арыстанбая, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "РАЗЪЕЗД 142, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "РАЗЪЕЗД №174, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА 1 МАй, СЕЛО Ебейти, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА 1 Май Туйыгы, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА 1 Мамыр, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "РАЗЪЕЗД 202, СЕЛО Ногайты, СЕЛЬСКИЙ ОКРУГ Ащынский"
			}, {
				"ename": "РАЗЪЕЗД 236, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "РАЗЪЕЗД № 239, СЕЛО Айрык, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА 8 Март, СЕЛО Ебейти, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА Абай Туйыгы, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Агзон, СЕЛО Коптогай, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Айрык, СЕЛО Айрык, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА Айрык, СЕЛО Айрык, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Айсейит, СЕЛО Каражар, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "УЛИЦА Акбулак, СЕЛО Кокбулак, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Ак Булак, СЕЛО Ногайты, СЕЛЬСКИЙ ОКРУГ Ащынский"
			}, {
				"ename": "УЛИЦА Акжар, СЕЛО Бесбай, СЕЛЬСКИЙ ОКРУГ Миялинский"
			}, {
				"ename": "ЗИМОВКА Акжар, СЕЛО Булактыколь, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "УЛИЦА Акжар, СЕЛО Актам, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Аккуб, СЕЛО Айрык, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Кокбулак, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Булактыколь, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Актам, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Аккудык 1, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "ЗИМОВКА Аккудык 2, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "ЗИМОВКА Акмола, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Аксуат, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялинский"
			}, {
				"ename": "УЛИЦА Актан, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Актемис, СЕЛО Каражар, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Актогай, СЕЛО Жаркамыс, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Акшагала, СЕЛО Косарал, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Акшагала, СЕЛО Казахстан, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Акшат, СЕЛО Казахстан, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Акши 1, СЕЛО Актам, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Акши 2, СЕЛО Каражар, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "УЛИЦА Ален Макыбаев, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Алия Молдагуловой, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Алпана, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Алшын, СЕЛО Каражар, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "УЛИЦА Ардагерлер, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Артезиан, СЕЛО Дияр, СЕЛЬСКИЙ ОКРУГ Миялинский"
			}, {
				"ename": "ЗИМОВКА Арыстанбая, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Арыстанбая, СЕЛО Кораши, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Асау Батыра, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "ЗИМОВКА Асылкора, СЕЛО Жынгылдытогай, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "ЗИМОВКА Асылкора, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Атамекен, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "ЗИМОВКА Аша, СЕЛО Жаркамыс, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Аша, СЕЛО Алтай Батыр, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА Ашим Толенова, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Ащы, СЕЛО Алтай Батыр, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА Ащы, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялинский"
			}, {
				"ename": "ЗИМОВКА Ащылытогай, СЕЛО Актам, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "УЛИЦА Аэропорт, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Байге Тобе, СЕЛО Жаркамыс, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Байтау, СЕЛО Каражар, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "ЗИМОВКА Байтилеу, СЕЛО Копа, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА Барак Батыра, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Баргана, СЕЛО Жаркамыс, СЕЛЬСКИЙ ОКРУГ Жаркамысский"
			}, {
				"ename": "УЛИЦА Бармак Батыра, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Баршакум, СЕЛО Казахстан, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Баспаккора, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Ебейти, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Ногайты, СЕЛЬСКИЙ ОКРУГ Ащынский"
			}, {
				"ename": "УЛИЦА Бесбай, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялинский"
			}, {
				"ename": "УЛИЦА Билим, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Кемерши, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Кораши, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Ногайты, СЕЛЬСКИЙ ОКРУГ Ащынский"
			}, {
				"ename": "УЛИЦА Бирлик-1, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Бирлик-2, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Бирлик-3, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Бирсагыр, СЕЛО Кораши, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "ЗИМОВКА Бисек, СЕЛО Баршакум, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "УЛИЦА Болат Жолы, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Болашак, СЕЛО Косарал, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Болашак., СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Бостандык, СЕЛО Ебейти, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Бузаукора, СЕЛО Ебейти, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "УЛИЦА Булак, СЕЛО Булактыколь, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "УЛИЦА Булак, СЕЛО Алтай Батыр, СЕЛЬСКИЙ ОКРУГ Сарытогайский"
			}, {
				"ename": "ЗИМОВКА Булак, СЕЛО Булактыколь, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "УЛИЦА Дауит Батыра, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "ЗИМОВКА Дауыл, СЕЛО Кокбулак, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Динмуханбет Конаева, СЕЛО Карауылкелды, СЕЛЬСКИЙ ОКРУГ Карауылкелдинский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Оймауыт, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Кемерши, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Кораши, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Ногайты, СЕЛЬСКИЙ ОКРУГ Ащынский"
			}, {
				"ename": "УЛИЦА Дукентубек, СЕЛО Кемерши, СЕЛЬСКИЙ ОКРУГ Кызылбулакский"
			}, {
				"ename": "ЗИМОВКА Ебейти, СЕЛО Ебейти, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Егиндисай, СЕЛО Айрык, СЕЛЬСКИЙ ОКРУГ Копинский"
			}, {
				"ename": "ЗИМОВКА Елибай, СЕЛО Жарлы, СЕЛЬСКИЙ ОКРУГ Кольтабанский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Байдибекский, ОБЛАСТЬ Туркестанская",
			"addressName": [{
				"ename": "КВАРТАЛ 010 Квартал, СЕЛО Танатар, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "КВАРТАЛ 022 Квартал, СЕЛО Мынбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "КВАРТАЛ 036 Квартал, СЕЛО Кенестобе, СЕЛЬСКИЙ ОКРУГ Коктерекский"
			}, {
				"ename": "КВАРТАЛ 043 Квартал, СЕЛО Агыбет, СЕЛЬСКИЙ ОКРУГ Агыбетский"
			}, {
				"ename": "КВАРТАЛ 049 Квартал, СЕЛО Акбастау, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "КВАРТАЛ 057 Квартал, СЕЛО Боралдай, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "КВАРТАЛ 063 Квартал, СЕЛО Сарыбулак, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "КВАРТАЛ 070 Квартал, СЕЛО Екпинди, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "КВАРТАЛ 074 Квартал, СЕЛО Жиенкум, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "КВАРТАЛ 079 Квартал, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "КВАРТАЛ 093 Квартал, СЕЛО Жолгабас, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЛИЦА 10-Улица, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА 13-Улица, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА 1 Мамыр, СЕЛО Мынбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА №1 улица, СЕЛО Байжансай, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА №2, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА №2 улица, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА №2 улица, СЕЛО Жузимдик, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА №3, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА 3 А, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА №4 улица, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА 5 А УЛИЦА, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА №5 коше, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА №6 коше, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА №7 коше, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА 8 Наурыз, СЕЛО Кайнарбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА А.Айнакожаулы, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА А.Айтуаров, СЕЛО Кенес, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Мынбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА А.Байетов, СЕЛО Шукыршак, СЕЛЬСКИЙ ОКРУГ Борлысайский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА А.Байнеулы, СЕЛО Шалдар, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Абдирашид Жансейтов, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Абу Абдраймов, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА А.Дауылбаев, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Адилай Ташимбетов, СЕЛО Кенсай, СЕЛЬСКИЙ ОКРУГ Борлысайский"
			}, {
				"ename": "УЛИЦА А.Ералиев, СЕЛО Мынбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА А.Жумадиллаулы, СЕЛО Боралдай, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА А.Жылкышиев, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Азаттык, СЕЛО Акбастау, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЛИЦА Айдарлы (№1 улица), СЕЛО Усиктас, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА Айнабулак, СЕЛО Кенестобе, СЕЛЬСКИЙ ОКРУГ Коктерекский"
			}, {
				"ename": "УЛИЦА Айналма, СЕЛО Саркырама, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Айналма Жол, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Айтеке Би, СЕЛО Жогаргы Боралдай, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА А.Камбашулы, СЕЛО Шалдар, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА А.Касимбеков, СЕЛО Шалдар, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Аката, СЕЛО Кайнарбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Акбидай, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Акжол, СЕЛО Туракты, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЛИЦА А.Кидирбаев, СЕЛО Жарыкбас, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Аккуыс, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА А.Кокишулы, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Ак откел, СЕЛО Ынтымак, СЕЛЬСКИЙ ОКРУГ Коктерекский"
			}, {
				"ename": "УЛИЦА Аксай, СЕЛО Жарыкбас, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Аксакал би, СЕЛО Боралдай, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА Актас, СЕЛО Кайнарбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Актау, СЕЛО Байдибек, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Актобе, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Коктерекский"
			}, {
				"ename": "УЛИЦА Актобе, СЕЛО Акбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Акшокы, СЕЛО Теректи, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА Акынбекулы Мыктыбек, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА Алмалы, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Алтын Дан, СЕЛО Акбастау, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЛИЦА Амангелди, СЕЛО Мынбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Амирбек Менликулов, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Агыбет, СЕЛЬСКИЙ ОКРУГ Агыбетский"
			}, {
				"ename": "УЛИЦА А.Накыпбеков, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА А.Нысанов, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Коктерекский"
			}, {
				"ename": "УЛИЦА А.Нысанов, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА А.Отемалиулы, СЕЛО Мынбулак, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Арнасай, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Асар, СЕЛО Hура, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Асилбек Бектибаев, СЕЛО Кошкарата, СЕЛЬСКИЙ ОКРУГ Борлысайский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО О. Тайманов, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА Атабек Тойшыулы, СЕЛО Актас, СЕЛЬСКИЙ ОКРУГ Борлысайский"
			}, {
				"ename": "УЛИЦА Атакул Жунисалиулы, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА Атамура, СЕЛО Hура, СЕЛЬСКИЙ ОКРУГ Мынбулакский"
			}, {
				"ename": "УЛИЦА Ауезов, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Ауелбек Тажиев, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Аулие тас, СЕЛО Жарыкбас, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Байдибек би, СЕЛО Амансай, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА Байдибек Карашаулы, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Баймурза Ержанов, СЕЛО Шакпак, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Казата, СЕЛЬСКИЙ ОКРУГ Алгабасский"
			}, {
				"ename": "УЛИЦА Балауса, СЕЛО Екпинди, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Балгынсай, СЕЛО Байдибек, СЕЛЬСКИЙ ОКРУГ Алмалинский"
			}, {
				"ename": "УЛИЦА Балтай ата, СЕЛО Боралдай, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА Б.Аширбеков, СЕЛО Шыбыт, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Б.Бактияров, СЕЛО Шалдар, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Б.Бимишулы, СЕЛО Шалдар, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Б.Егизбекулы, СЕЛО Шалдар, СЕЛЬСКИЙ ОКРУГ Бугунский"
			}, {
				"ename": "УЛИЦА Бегман Болатбеков, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Акбастау, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Боралдайский"
			}, {
				"ename": "УЛИЦА Бейсе Беласаров, СЕЛО Кошкарата, СЕЛЬСКИЙ ОКРУГ Борлысайский"
			}, {
				"ename": "УЛИЦА Бекасыл Аширбеков, СЕЛО Шаян, СЕЛЬСКИЙ ОКРУГ Шаянский"
			}, {
				"ename": "УЛИЦА Бекжигитулы Тайжигит, СЕЛО Кенестобе, СЕЛЬСКИЙ ОКРУГ Коктерекский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Байзакский, ОБЛАСТЬ Жамбылская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Бурыл, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 049 Квартал, СЕЛО Дихан, СЕЛЬСКИЙ ОКРУГ Диханский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 107, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 109, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "ПЕРЕУЛОК 1 Талас, СЕЛО Байзак, СЕЛЬСКИЙ ОКРУГ Ботамойнакский"
			}, {
				"ename": "ПЕРЕУЛОК 3 Талас, СЕЛО Байзак, СЕЛЬСКИЙ ОКРУГ Ботамойнакский"
			}, {
				"ename": "УЛИЦА 50 лет Победы, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "ПЕРЕУЛОК 9 Май, СЕЛО Дихан, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА 9-мая, СЕЛО Бурыл, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Дихан, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Сазтерекский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Мырзатай, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Кенес, СЕЛЬСКИЙ ОКРУГ Коптерекский"
			}, {
				"ename": "ПЕРЕУЛОК Абай, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Базарбай, СЕЛЬСКИЙ ОКРУГ Байтерек"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кумжота, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "УЛИЦА Абдикаримов Зада Койайдарулы, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Абдуакас Аликулов, СЕЛО Дихан, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА Абилекова Смагула Беспаевича, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА А.Бөгенбаев, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "ПЕРЕУЛОК Агадил Суханбаева, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "ПЕРЕУЛОК А.Дукенбайкызы, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "УЛИЦА А.Дукенбайкызы, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "ПЕРЕУЛОК А.Дукенбайкызы 1, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "УЛИЦА А.Еденов, СЕЛО Жетыбай, СЕЛЬСКИЙ ОКРУГ Жалгызтобинский"
			}, {
				"ename": "УЛИЦА А.Жумадилов, СЕЛО Жетыбай, СЕЛЬСКИЙ ОКРУГ Жалгызтобинский"
			}, {
				"ename": "УЛИЦА А.Жуматаев, СЕЛО Кокбастау, СЕЛЬСКИЙ ОКРУГ Жанатурмысский"
			}, {
				"ename": "УЛИЦА Азимбек Жанкулиев, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Айжигитовы, СЕЛО Кокбастау, СЕЛЬСКИЙ ОКРУГ Жанатурмысский"
			}, {
				"ename": "УЛИЦА Акбаев Елемес, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Акберди, СЕЛО Аккия, СЕЛЬСКИЙ ОКРУГ Жалгызтобинский"
			}, {
				"ename": "УЛИЦА Акбулак, СЕЛО Байзак, СЕЛЬСКИЙ ОКРУГ Ботамойнакский"
			}, {
				"ename": "УЛИЦА Акбулым, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Ақдала, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Аққұдық, СЕЛО Мырзатай, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА А.Колдасов, СЕЛО Мадимар, СЕЛЬСКИЙ ОКРУГ Ынтымакский"
			}, {
				"ename": "УЛИЦА Ақсарай (Матимкул), СЕЛО Шахан, СЕЛЬСКИЙ ОКРУГ Темирбекский"
			}, {
				"ename": "УЛИЦА Актерек, СЕЛО Жанасаз, СЕЛЬСКИЙ ОКРУГ Сазтерекский"
			}, {
				"ename": "УЛИЦА А.Кузембай, СЕЛО Дихан, СЕЛЬСКИЙ ОКРУГ Диханский"
			}, {
				"ename": "УЛИЦА Акыл ата, СЕЛО Жетыбай, СЕЛЬСКИЙ ОКРУГ Жалгызтобинский"
			}, {
				"ename": "УЛИЦА А.Кылышбеков, СЕЛО Мадимар, СЕЛЬСКИЙ ОКРУГ Ынтымакский"
			}, {
				"ename": "УЛИЦА Ақыртас, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Косак, СЕЛЬСКИЙ ОКРУГ Байтерек"
			}, {
				"ename": "ПЕРЕУЛОК Алатау 1, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "ПЕРЕУЛОК Алатау 2, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЛИЦА Алаш (Бошай би), СЕЛО Тегистик, СЕЛЬСКИЙ ОКРУГ Темирбекский"
			}, {
				"ename": "УЛИЦА Алаш, СЕЛО Женис, СЕЛЬСКИЙ ОКРУГ Диханский"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, СЕЛО Базарбай, СЕЛЬСКИЙ ОКРУГ Байтерек"
			}, {
				"ename": "УЛИЦА А.Л.Нахманович, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Альмурза, СЕЛО Кумжота, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "ПЕРЕУЛОК Амангелди, СЕЛО Байзак, СЕЛЬСКИЙ ОКРУГ Ботамойнакский"
			}, {
				"ename": "УЛИЦА Амангелды, СЕЛО Бурыл, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "УЛИЦА Амангелды, СЕЛО Байзак, СЕЛЬСКИЙ ОКРУГ Ботамойнакский"
			}, {
				"ename": "УЛИЦА Амангелды, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Аманкелди, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "ПЕРЕУЛОК Аманкелди 1, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "ПЕРЕУЛОК Аманкелди 2, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЛИЦА А.Мин, СЕЛО Коктал, СЕЛЬСКИЙ ОКРУГ Кокталский"
			}, {
				"ename": "УЛИЦА Амиркулулы Жамансары, СЕЛО Мырзатай, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Коктал, СЕЛЬСКИЙ ОКРУГ Кокталский"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Талас, СЕЛЬСКИЙ ОКРУГ Костобинский"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Тегистик, СЕЛЬСКИЙ ОКРУГ Темирбекский"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Аккия, СЕЛЬСКИЙ ОКРУГ Жалгызтобинский"
			}, {
				"ename": "УЛИЦА А.Нахманович, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "ПЕРЕУЛОК А.Нахманович, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "УЛИЦА Анкет Молдашбаев, СЕЛО Дихан, СЕЛЬСКИЙ ОКРУГ Диханский"
			}, {
				"ename": "МАССИВ Арай, СЕЛО Бурыл, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "УЛИЦА Арбатас, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Арык, СТАНЦИЯ Талас, СЕЛЬСКИЙ ОКРУГ Костобинский"
			}, {
				"ename": "УЛИЦА А.Сейдалиев, СЕЛО Мадимар, СЕЛЬСКИЙ ОКРУГ Ынтымакский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Косак, СЕЛЬСКИЙ ОКРУГ Байтерек"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Сарыбарак, СЕЛЬСКИЙ ОКРУГ Темирбекский"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Жакаш, СЕЛЬСКИЙ ОКРУГ Суханбаевский"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Кенес, СЕЛЬСКИЙ ОКРУГ Коптерекский"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Аккия, СЕЛЬСКИЙ ОКРУГ Жалгызтобинский"
			}, {
				"ename": "УЛИЦА А.Суханбаев, СЕЛО Кызыл жулдыз, СЕЛЬСКИЙ ОКРУГ Кызылжулдызский"
			}, {
				"ename": "УЛИЦА А.Суханбаев 2, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА А.Торгаев, СЕЛО Коктал, СЕЛЬСКИЙ ОКРУГ Кокталский"
			}, {
				"ename": "УЛИЦА Аубакир Кушербаев, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Ауданбай Жамалов, СЕЛО Байзак, СЕЛЬСКИЙ ОКРУГ Ботамойнакский"
			}, {
				"ename": "ПЕРЕУЛОК Аулие Ата, СЕЛО Костобе, СЕЛЬСКИЙ ОКРУГ Костобинский"
			}, {
				"ename": "УЛИЦА Аулие-Ата, СЕЛО Костобе, СЕЛЬСКИЙ ОКРУГ Костобинский"
			}, {
				"ename": "УЛИЦА А.Хамдиев, СЕЛО Бурыл, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}, {
				"ename": "УЛИЦА Ахан Инкаров, СЕЛО Мырзатай, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "УЛИЦА Базарбай Жуасбай, СЕЛО Аймантобе, СЕЛЬСКИЙ ОКРУГ Диханский"
			}, {
				"ename": "УЛИЦА Байдаулетулы Ашимбай, СЕЛО Мырзатай, СЕЛЬСКИЙ ОКРУГ Мырзатайский"
			}, {
				"ename": "ПЕРЕУЛОК Байдибек Баба, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Байдибек Баба, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "ПЕРЕУЛОК Байдибек Баба 1, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Байдилда Карбозов, СЕЛО Кенес, СЕЛЬСКИЙ ОКРУГ Коптерекский"
			}, {
				"ename": "ПЕРЕУЛОК Байзак батыр, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "УЛИЦА Байзак батыр, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Байзак батыр, СЕЛО Туймекент, СЕЛЬСКИЙ ОКРУГ Туймекентский"
			}, {
				"ename": "ПЕРЕУЛОК Байзак батыр, СЕЛО Сарыкемер, СЕЛЬСКИЙ ОКРУГ Сарыкемерский"
			}, {
				"ename": "УЛИЦА Байзак Датка, СЕЛО Бурыл, СЕЛЬСКИЙ ОКРУГ Бурылский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Байконыр, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Астана",
			"addressName": [{
				"ename": "УЛИЦА 101"
			}, {
				"ename": "УЛИЦА 126"
			}, {
				"ename": "УЛИЦА 191"
			}, {
				"ename": "УЛИЦА 215"
			}, {
				"ename": "ПРОЕЗД 34"
			}, {
				"ename": "ПЕРЕУЛОК 3-ий Радищева (Радищева 3-й)"
			}, {
				"ename": "ПРОЕЗД 41"
			}, {
				"ename": "ПРОЕЗД 68"
			}, {
				"ename": "ПРОЕЗД 69"
			}, {
				"ename": "ПРОЕЗД 70"
			}, {
				"ename": "УЛИЦА 85"
			}, {
				"ename": "ПРОЕЗД 93"
			}, {
				"ename": "УЛИЦА А 197"
			}, {
				"ename": "УЛИЦА А 304"
			}, {
				"ename": "УЛИЦА А 350"
			}, {
				"ename": "УЛИЦА А 357"
			}, {
				"ename": "УЛИЦА А 365"
			}, {
				"ename": "УЛИЦА А 366"
			}, {
				"ename": "УЛИЦА А 367"
			}, {
				"ename": "УЛИЦА А 368"
			}, {
				"ename": "УЛИЦА А 369"
			}, {
				"ename": "УЛИЦА А 370"
			}, {
				"ename": "УЛИЦА А 371"
			}, {
				"ename": "УЛИЦА А 380"
			}, {
				"ename": "УЛИЦА А 449"
			}, {
				"ename": "УЛИЦА А 450"
			}, {
				"ename": "УЛИЦА А 451"
			}, {
				"ename": "УЛИЦА А 452"
			}, {
				"ename": "УЛИЦА А 453"
			}, {
				"ename": "УЛИЦА А 454"
			}, {
				"ename": "УЛИЦА А 455"
			}, {
				"ename": "УЛИЦА А 456"
			}, {
				"ename": "УЛИЦА А 457"
			}, {
				"ename": "УЛИЦА А 458"
			}, {
				"ename": "УЛИЦА А 459"
			}, {
				"ename": "УЛИЦА А 460"
			}, {
				"ename": "УЛИЦА А 461"
			}, {
				"ename": "УЛИЦА А 462"
			}, {
				"ename": "УЛИЦА А 463"
			}, {
				"ename": "УЛИЦА А 464"
			}, {
				"ename": "УЛИЦА А 465"
			}, {
				"ename": "УЛИЦА А 466"
			}, {
				"ename": "УЛИЦА А 467"
			}, {
				"ename": "УЛИЦА А 468"
			}, {
				"ename": "УЛИЦА А 470"
			}, {
				"ename": "УЛИЦА А 471"
			}, {
				"ename": "УЛИЦА А 472"
			}, {
				"ename": "УЛИЦА А 473"
			}, {
				"ename": "УЛИЦА А 474"
			}, {
				"ename": "УЛИЦА А 475"
			}, {
				"ename": "УЛИЦА А 476"
			}, {
				"ename": "УЛИЦА А 477"
			}, {
				"ename": "УЛИЦА А 478"
			}, {
				"ename": "УЛИЦА А 479"
			}, {
				"ename": "УЛИЦА А 480"
			}, {
				"ename": "УЛИЦА А 481"
			}, {
				"ename": "УЛИЦА А 482"
			}, {
				"ename": "УЛИЦА А 483"
			}, {
				"ename": "УЛИЦА А 484"
			}, {
				"ename": "УЛИЦА А 493"
			}, {
				"ename": "УЛИЦА А 521"
			}, {
				"ename": "УЛИЦА А 522"
			}, {
				"ename": "УЛИЦА А 523"
			}, {
				"ename": "УЛИЦА А 524"
			}, {
				"ename": "УЛИЦА А 525"
			}, {
				"ename": "УЛИЦА А 526"
			}, {
				"ename": "УЛИЦА А 527"
			}, {
				"ename": "УЛИЦА А 528"
			}, {
				"ename": "УЛИЦА А 530"
			}, {
				"ename": "УЛИЦА А 531"
			}, {
				"ename": "УЛИЦА А 559"
			}, {
				"ename": "ПРОСПЕКТ Абай"
			}, {
				"ename": "ПЕРЕУЛОК Абыралы"
			}, {
				"ename": "УЛИЦА Ағыбай батыр"
			}, {
				"ename": "УЛИЦА Адольфа Янушкевича"
			}, {
				"ename": "ПЕРЕУЛОК Ақкент"
			}, {
				"ename": "ПЕРЕУЛОК Аккульский"
			}, {
				"ename": "УЛИЦА Ақсеңгір"
			}, {
				"ename": "УЛИЦА Ақсу-Жабағылы"
			}, {
				"ename": "ПЕРЕУЛОК Ақсүмбе"
			}, {
				"ename": "МИКРОРАЙОН Алатау"
			}, {
				"ename": "ШОССЕ Алаш"
			}, {
				"ename": "УЛИЦА Александра Кравцова"
			}, {
				"ename": "УЛИЦА Александра Пушкина"
			}, {
				"ename": "УЛИЦА Александр Бараев"
			}, {
				"ename": "УЛИЦА Алтынқұм"
			}, {
				"ename": "УЛИЦА Альмухана Сембинова"
			}, {
				"ename": "УЛИЦА Амангелді Иманов"
			}, {
				"ename": "ПЕРЕУЛОК Амангелді Иманов"
			}, {
				"ename": "УЛИЦА Анарская"
			}, {
				"ename": "УЛИЦА Ануара Алимжанова"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ АО Акмоламелиорация"
			}, {
				"ename": "УЛИЦА Арқарлы"
			}, {
				"ename": "УЛИЦА Асан Қайғы"
			}, {
				"ename": "ПЕРЕУЛОК Астраханский"
			}, {
				"ename": "УЛИЦА Ахмета Жубанова"
			}, {
				"ename": "УЛИЦА Ашхабадская"
			}, {
				"ename": "УЛИЦА Байқадам"
			}, {
				"ename": "УЛИЦА Байырқұм"
			}, {
				"ename": "УЛИЦА Бактыораз Бейсекбаев"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Байконыр, ОБЛАСТЬ Кызылординская",
			"addressName": [{
				"ename": "ПЛОЩАДКА 1"
			}, {
				"ename": "ПЛОЩАДКА 10"
			}, {
				"ename": "ПЛОЩАДКА 103"
			}, {
				"ename": "ПЛОЩАДКА 106"
			}, {
				"ename": "ПЛОЩАДКА 110"
			}, {
				"ename": "ПЛОЩАДКА 110А"
			}, {
				"ename": "ПЛОЩАДКА 111-1"
			}, {
				"ename": "ПЛОЩАДКА 111-2"
			}, {
				"ename": "ПЛОЩАДКА 112"
			}, {
				"ename": "ПЛОЩАДКА 112А"
			}, {
				"ename": "ПЛОЩАДКА 112Д"
			}, {
				"ename": "ПЛОЩАДКА 113"
			}, {
				"ename": "ПЛОЩАДКА 113Г"
			}, {
				"ename": "ПЛОЩАДКА 114А"
			}, {
				"ename": "ПЛОЩАДКА 114Б"
			}, {
				"ename": "ПЛОЩАДКА 115Б"
			}, {
				"ename": "ПЛОЩАДКА 116"
			}, {
				"ename": "ПЛОЩАДКА 118"
			}, {
				"ename": "ПЛОЩАДКА 13"
			}, {
				"ename": "ПЛОЩАДКА 132"
			}, {
				"ename": "ПЛОЩАДКА 15А"
			}, {
				"ename": "ПЛОЩАДКА 15Г"
			}, {
				"ename": "ПЛОЩАДКА 17"
			}, {
				"ename": "ПЛОЩАДКА 175"
			}, {
				"ename": "ПЛОЩАДКА 17К"
			}, {
				"ename": "ПЛОЩАДКА 17-К"
			}, {
				"ename": "ПЛОЩАДКА 17МЖГ"
			}, {
				"ename": "ПЛОЩАДКА 17П"
			}, {
				"ename": "ПЛОЩАДКА 18"
			}, {
				"ename": "ПЛОЩАДКА 19А"
			}, {
				"ename": "ПЛОЩАДКА 2"
			}, {
				"ename": "ПЛОЩАДКА 20"
			}, {
				"ename": "ПЛОЩАДКА 200"
			}, {
				"ename": "ПЛОЩАДКА 201"
			}, {
				"ename": "ПЛОЩАДКА 202"
			}, {
				"ename": "ПЛОЩАДКА 21"
			}, {
				"ename": "ПЛОЩАДКА 21А"
			}, {
				"ename": "ПЛОЩАДКА 21Б"
			}, {
				"ename": "ПЛОЩАДКА 21В"
			}, {
				"ename": "ПЛОЩАДКА 21Г"
			}, {
				"ename": "ПЛОЩАДКА 22"
			}, {
				"ename": "ПЛОЩАДКА 23"
			}, {
				"ename": "ПЛОЩАДКА 250"
			}, {
				"ename": "ПЛОЩАДКА 250А"
			}, {
				"ename": "ПЛОЩАДКА 251"
			}, {
				"ename": "ПЛОЩАДКА 254"
			}, {
				"ename": "ПЛОЩАДКА 255"
			}, {
				"ename": "ПЛОЩАДКА 255-254,110А"
			}, {
				"ename": "ПЛОЩАДКА 257"
			}, {
				"ename": "ПЛОЩАДКА 257А"
			}, {
				"ename": "ПЛОЩАДКА 257Б"
			}, {
				"ename": "ПЛОЩАДКА 2А"
			}, {
				"ename": "ПЛОЩАДКА 2Б"
			}, {
				"ename": "ПЛОЩАДКА 2Ж"
			}, {
				"ename": "ПЛОЩАДКА 2т"
			}, {
				"ename": "ПЛОЩАДКА 3"
			}, {
				"ename": "СТАНЦИЯ 3"
			}, {
				"ename": "ПЛОЩАДКА 31"
			}, {
				"ename": "ПЛОЩАДКА 32"
			}, {
				"ename": "ПЛОЩАДКА 37"
			}, {
				"ename": "ПЛОЩАДКА 3А"
			}, {
				"ename": "ПЛОЩАДКА 3Б"
			}, {
				"ename": "ПЛОЩАДКА 3Ж"
			}, {
				"ename": "ПЛОЩАДКА 3Р"
			}, {
				"ename": "ПЛОЩАДКА 4"
			}, {
				"ename": "ПЛОЩАДКА 42"
			}, {
				"ename": "ПЛОЩАДКА 43"
			}, {
				"ename": "ПЛОЩАДКА 44"
			}, {
				"ename": "ПЛОЩАДКА 45"
			}, {
				"ename": "ПЛОЩАДКА 5"
			}, {
				"ename": "СТАНЦИЯ 5"
			}, {
				"ename": "МИКРОРАЙОН 5"
			}, {
				"ename": "ПЛОЩАДКА 504-3К"
			}, {
				"ename": "МИКРОРАЙОН 5 А"
			}, {
				"ename": "МИКРОРАЙОН 6"
			}, {
				"ename": "ПЛОЩАДКА 6"
			}, {
				"ename": "МИКРОРАЙОН 6А"
			}, {
				"ename": "МИКРОРАЙОН 7"
			}, {
				"ename": "ПЛОЩАДКА 71"
			}, {
				"ename": "ПЛОЩАДКА 72"
			}, {
				"ename": "ПЛОЩАДКА 75"
			}, {
				"ename": "МИКРОРАЙОН 7А"
			}, {
				"ename": "ПЛОЩАДКА 81"
			}, {
				"ename": "ПЛОЩАДКА 82"
			}, {
				"ename": "ПЛОЩАДКА 84"
			}, {
				"ename": "УЛИЦА 8 Марта"
			}, {
				"ename": "ПЛОЩАДКА 9"
			}, {
				"ename": "ПЛОЩАДКА 90"
			}, {
				"ename": "ПЛОЩАДКА 9/1"
			}, {
				"ename": "ПЛОЩАДКА 91А"
			}, {
				"ename": "ПЛОЩАДКА 92"
			}, {
				"ename": "ПЛОЩАДКА 92А"
			}, {
				"ename": "ПЛОЩАДКА 95"
			}, {
				"ename": "ПЛОЩАДКА 97"
			}, {
				"ename": "ПЛОЩАДКА 9 Бт"
			}, {
				"ename": "ПЛОЩАДКА 9Т"
			}, {
				"ename": "ПЛОЩАДКА 9ТЗБ"
			}, {
				"ename": "УЛИЦА Абая"
			}, {
				"ename": "УЛИЦА Авиационная"
			}, {
				"ename": "УЛИЦА А.Максимова"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Балхаш, ОБЛАСТЬ Карагандинская",
			"addressName": [{
				"ename": "КВАРТАЛ 1"
			}, {
				"ename": "ЛИНИЯ 1"
			}, {
				"ename": "МИКРОРАЙОН 10"
			}, {
				"ename": "КВАРТАЛ 10"
			}, {
				"ename": "КВАРТАЛ 11"
			}, {
				"ename": "МИКРОРАЙОН 11"
			}, {
				"ename": "МИКРОРАЙОН 12"
			}, {
				"ename": "КВАРТАЛ 12"
			}, {
				"ename": "КВАРТАЛ 12А"
			}, {
				"ename": "КВАРТАЛ 13"
			}, {
				"ename": "МИКРОРАЙОН № 13"
			}, {
				"ename": "КВАРТАЛ 14"
			}, {
				"ename": "КВАРТАЛ 14А"
			}, {
				"ename": "КВАРТАЛ 15"
			}, {
				"ename": "КВАРТАЛ 15А"
			}, {
				"ename": "КВАРТАЛ 16"
			}, {
				"ename": "КВАРТАЛ 16А"
			}, {
				"ename": "КВАРТАЛ 17"
			}, {
				"ename": "КВАРТАЛ 17А"
			}, {
				"ename": "КВАРТАЛ 17Б"
			}, {
				"ename": "КВАРТАЛ 18"
			}, {
				"ename": "КВАРТАЛ 19"
			}, {
				"ename": "ЛИНИЯ 2"
			}, {
				"ename": "КВАРТАЛ 2"
			}, {
				"ename": "КВАРТАЛ 20"
			}, {
				"ename": "КВАРТАЛ 21"
			}, {
				"ename": "КВАРТАЛ 26"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2 Карьерная"
			}, {
				"ename": "КВАРТАЛ 3"
			}, {
				"ename": "ЛИНИЯ 3"
			}, {
				"ename": "ЛИНИЯ 4"
			}, {
				"ename": "КВАРТАЛ 4"
			}, {
				"ename": "ЛИНИЯ 5"
			}, {
				"ename": "ЛИНИЯ 6"
			}, {
				"ename": "МИКРОРАЙОН 6"
			}, {
				"ename": "КВАРТАЛ 6"
			}, {
				"ename": "КВАРТАЛ 60"
			}, {
				"ename": "КВАРТАЛ 62"
			}, {
				"ename": "КВАРТАЛ 64"
			}, {
				"ename": "КВАРТАЛ 7"
			}, {
				"ename": "МИКРОРАЙОН 7"
			}, {
				"ename": "ЛИНИЯ 7"
			}, {
				"ename": "ЛИНИЯ 8"
			}, {
				"ename": "КВАРТАЛ 8"
			}, {
				"ename": "УЛИЦА 8 Наурыз (8 Марта)"
			}, {
				"ename": "МИКРОРАЙОН 9"
			}, {
				"ename": "КВАРТАЛ 9"
			}, {
				"ename": "КВАРТАЛ 90"
			}, {
				"ename": "КВАРТАЛ 96"
			}, {
				"ename": "КВАРТАЛ 97"
			}, {
				"ename": "УЛИЦА Абай (Ленина)"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Автомобилист"
			}, {
				"ename": "УЛИЦА Агыбай батыра"
			}, {
				"ename": "КВАРТАЛ Ақшағыл (Рембаза)"
			}, {
				"ename": "КВАРТАЛ Ақшоқы (Ботанический сад)"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой"
			}, {
				"ename": "УЛИЦА Алихана Бокейханова"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 454 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 631км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 632 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 633 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 634 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 635 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 636 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 637 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 638 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 639 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 640 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 641 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 642 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 643 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 644 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 645 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 646 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 647 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 648 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 649 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 650 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 651 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 652 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 653 км"
			}, {
				"ename": "ШОССЕ Алматы-Екатеринбург 705км"
			}, {
				"ename": "УЛИЦА Алтынсарина"
			}, {
				"ename": "УЛИЦА Аманат (Центральная)"
			}, {
				"ename": "УЛИЦА Амангельды"
			}, {
				"ename": "КВАРТАЛ Ардагерлер (Ветеранов)"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Арман"
			}, {
				"ename": "УЛИЦА Аубакира Алимжанова"
			}, {
				"ename": "ПЕРЕУЛОК Ахметжана Сармантайулы"
			}, {
				"ename": "СТАНЦИЯ Ащыозек"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Аэропорт"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Аэропорт-Новый"
			}, {
				"ename": "СТАНЦИЯ Балхаш-1"
			}, {
				"ename": "СТАНЦИЯ Балхаш-4"
			}, {
				"ename": "УЛИЦА Балхашская"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Бгмк"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО БГМК-1"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО БГМК-2"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Белый камень"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Белый камень-1"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Балхашский, ОБЛАСТЬ Алматинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Бакбакты, СЕЛЬСКИЙ ОКРУГ Бакбактынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 012, СЕЛО Бакбакты, СЕЛЬСКИЙ ОКРУГ Бакбактынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, СЕЛО Бакбакты, СЕЛЬСКИЙ ОКРУГ Бакбактынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛО Береке, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Береке, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Береке, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, СЕЛО Коктал, СЕЛЬСКИЙ ОКРУГ Коктальский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, СЕЛО Жидели, СЕЛЬСКИЙ ОКРУГ Жиделинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 042, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 043, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Береке, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 053, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 054, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 058, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Акжарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 059, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Акжарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 059, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 063, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 065, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 065, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 065, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Акжарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 066, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 067, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 067, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 071, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 071, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 072, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 077, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 077, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 078, СЕЛО Куйган, СЕЛЬСКИЙ ОКРУГ Куйганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 080, СЕЛО Куйган, СЕЛЬСКИЙ ОКРУГ Куйганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 081, СЕЛО Куйган, СЕЛЬСКИЙ ОКРУГ Куйганский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 081, СЕЛО Жидели, СЕЛЬСКИЙ ОКРУГ Жиделинский"
			}, {
				"ename": "УЛИЦА 1, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА 2, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА 3, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА 4, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА 8, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА А Аманқұлов, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЛИЦА А Ахметова, СЕЛО Караой, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Бакбакты, СЕЛЬСКИЙ ОКРУГ Бакбактынский"
			}, {
				"ename": "УЛИЦА А Байғозиев, СЕЛО Кокжиде, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЛИЦА А Байтұрсынов, СЕЛО Береке, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЛИЦА А Достемесұлы, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЛИЦА А Жұбанов, СЕЛО Бура, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЛИЦА А Иманов, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЛИЦА А Иманов, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЛИЦА А.Иманов, СЕЛО Акдала, СЕЛЬСКИЙ ОКРУГ Акдалинский"
			}, {
				"ename": "УЛИЦА А Қасымбеков, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЛИЦА Ақбайлау, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЛИЦА Акдала, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Акжарский"
			}, {
				"ename": "УЛИЦА А Койшыбеков, СЕЛО Акколь, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЛИЦА Алтынсарин, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЛИЦА А Өсербаев, СЕЛО Кокжиде, СЕЛЬСКИЙ ОКРУГ Аккольский"
			}, {
				"ename": "УЛИЦА А Оспанов, СЕЛО Бакбакты, СЕЛЬСКИЙ ОКРУГ Бакбактынский"
			}, {
				"ename": "УЛИЦА Аралқұм, СЕЛО Аралкум, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЛИЦА Ардагер, СЕЛО Миялы, СЕЛЬСКИЙ ОКРУГ Миялынский"
			}, {
				"ename": "УЛИЦА Ардагер, СЕЛО Береке, СЕЛЬСКИЙ ОКРУГ Берекенский"
			}, {
				"ename": "УЛИЦА Аркар, СЕЛО Аркар, СЕЛЬСКИЙ ОКРУГ Караойский"
			}, {
				"ename": "УЛИЦА Атан, СЕЛО Жидели, СЕЛЬСКИЙ ОКРУГ Жиделинский"
			}, {
				"ename": "УЛИЦА Аэродром, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЛИЦА Базарқұл, СЕЛО Коктал, СЕЛЬСКИЙ ОКРУГ Коктальский"
			}, {
				"ename": "УЛИЦА Балпық Би, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА Балтағұл, СЕЛО Желторангы, СЕЛЬСКИЙ ОКРУГ Желторангынский"
			}, {
				"ename": "УЛИЦА Бап Омирзаков, СЕЛО Баканас, СЕЛЬСКИЙ ОКРУГ Баканаский"
			}, {
				"ename": "УЛИЦА Батыс, СЕЛО Балатопар, СЕЛЬСКИЙ ОКРУГ Балатопарский"
			}, {
				"ename": "УЛИЦА Б Бейсекбаев, СЕЛО Жидели, СЕЛЬСКИЙ ОКРУГ Жиделинский"
			}, {
				"ename": "УЛИЦА Б Бейсекбаев, СЕЛО Аралтобе, СЕЛЬСКИЙ ОКРУГ Акжарский"
			}, {
				"ename": "УЛИЦА Б Бекқұлов, СЕЛО Топар, СЕЛЬСКИЙ ОКРУГ Топарский"
			}, {
				"ename": "УЛИЦА Б Дәуренбеков, СЕЛО Акжар, СЕЛЬСКИЙ ОКРУГ Акжарский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Баянаульский, ОБЛАСТЬ Павлодарская",
			"addressName": [{
				"ename": "УЛИЦА 40 лет Казахстана, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА 60 лет Казахстана, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА А. Абдыкалыкова, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Алтын дала, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Амангельды, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Астана, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Аубакир Кабылбеков, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Байтерек, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Бакыт Хайдарова, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ЗИМОВКА Бауыржан, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Богенбай Батыра, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Василий Христенко, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Гагарина, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ГАРАЖЕЙ Гагарина, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Геологическая, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Гоголя, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Джамбула, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Достық, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Естая, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Жаяу Мұса, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Жумат Шанин, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ЗИМОВКА Жыркудык, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ЗИМОВКА Каракудык, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Кенжебаева, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Кенши, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Лермонтова, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Маншук Маметова, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА М.Горького, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Мухтар Ауезов, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ЗИМОВКА Нурлан, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Орджоникидзе, ПОСЕЛОК Майкаин"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Пионерская, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Пушкина, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Сатпаева, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Торайгырова, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЛИЦА Шәкен Айманов, ПОСЕЛОК Майкаин"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "КВАРТАЛ 033, СЕЛО Мәшһүр Жүсіп, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, СЕЛО Торайгырова, СЕЛЬСКИЙ ОКРУГ Торайгыровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, СЕЛО Қаныш Сәтбаев, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, СЕЛО Торайгырова, СЕЛЬСКИЙ ОКРУГ Торайгыровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 075, СЕЛО Кундыколь, СЕЛЬСКИЙ ОКРУГ Кундыкольский"
			}, {
				"ename": "КВАРТАЛ 076, СЕЛО Кундыколь, СЕЛЬСКИЙ ОКРУГ Кундыкольский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 080, СЕЛО Баянаул, СЕЛЬСКИЙ ОКРУГ Баянаульский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 084, СЕЛО Қаныш Сәтбаев, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 088, СЕЛО Қаныш Сәтбаев, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "КВАРТАЛ 103, СЕЛО Узунбулак, СЕЛЬСКИЙ ОКРУГ Узунбулакский"
			}, {
				"ename": "УЧАСТОК 104, СЕЛО Узунбулак, СЕЛЬСКИЙ ОКРУГ Узунбулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 112, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 114, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 116, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 117, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 118, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 119, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 120, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 122, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 124, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 126, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 129, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 135, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 136, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 137, СЕЛО Жұмат Шанин, СЕЛЬСКИЙ ОКРУГ Куркелинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 142, СЕЛО Жұмат Шанин, СЕЛЬСКИЙ ОКРУГ Куркелинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 147, СЕЛО Жұмат Шанин, СЕЛЬСКИЙ ОКРУГ Куркелинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 148, СЕЛО Жұмат Шанин, СЕЛЬСКИЙ ОКРУГ Куркелинский"
			}, {
				"ename": "КВАРТАЛ 150, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 153, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 158, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 160, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "ЗИМОВКА 19 База, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "КВАРТАЛ 21, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 41, СЕЛО Шонай, СЕЛЬСКИЙ ОКРУГ Баянаульский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 68, СЕЛО Шонай, СЕЛЬСКИЙ ОКРУГ Баянаульский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Каратомар, СЕЛЬСКИЙ ОКРУГ Каратомарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Баянаул, СЕЛЬСКИЙ ОКРУГ Баянаульский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Узунбулак, СЕЛЬСКИЙ ОКРУГ Узунбулакский"
			}, {
				"ename": "ЗИМОВКА Абен, СЕЛО Акмектеп, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЛИЦА Абикена Бектурова, СЕЛО Баянаул, СЕЛЬСКИЙ ОКРУГ Баянаульский"
			}, {
				"ename": "ЗИМОВКА Абильда, СЕЛО Шоманколь, СЕЛЬСКИЙ ОКРУГ Куркелинский"
			}, {
				"ename": "ЗИМОВКА Азат, СЕЛО Аксан, СЕЛЬСКИЙ ОКРУГ Аксанский"
			}, {
				"ename": "ЗИМОВКА Азатбек, СЕЛО Мурынтал, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "ЗИМОВКА Айдарлы, СЕЛО Кызылшилик, СЕЛЬСКИЙ ОКРУГ Торайгыровский"
			}, {
				"ename": "ЗИМОВКА Айдос, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "ЗИМОВКА Айкен, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЛИЦА Айман Алданова, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "УЛИЦА Айманова, СЕЛО Карашокы, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "ЗИМОВКА Айнабулак, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "ЗИМОВКА Айрык, СЕЛО Мұса Шорман, СЕЛЬСКИЙ ОКРУГ Сатпаевский"
			}, {
				"ename": "УЛИЦА Айтпахина, СЕЛО Мәшһүр Жүсіп, СЕЛЬСКИЙ ОКРУГ Жанажольский"
			}, {
				"ename": "ЗИМОВКА Айыртас, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "УЛИЦА Акажан Тумарбекова, СЕЛО Жанатлек, СЕЛЬСКИЙ ОКРУГ Жанатлекский"
			}, {
				"ename": "ЗИМОВКА Аканкадыр, СЕЛО Шоманколь, СЕЛЬСКИЙ ОКРУГ Куркелинский"
			}, {
				"ename": "ЗИМОВКА Акбаз, СЕЛО Жусупбека Аймауытова, СЕЛЬСКИЙ ОКРУГ Кызылтауский"
			}, {
				"ename": "ЗИМОВКА Акбаз, СЕЛО Кызылшилик, СЕЛЬСКИЙ ОКРУГ Торайгыровский"
			}, {
				"ename": "ЗИМОВКА Акбаз, СЕЛО Акмектеп, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Беимбета Майлина, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "УЛИЦА Бакыт, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Бейбітшілік, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Бірлік, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Болашақ, ПОСЕЛОК Тобол"
			}, {
				"ename": "ПЕРЕУЛОК Больничный, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Викторовская, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Водрем-303, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Восточная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Гагарина, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Дорожная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Достық, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА ДЭУ-23, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Женіс, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Западная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Каменный Карьер, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Карьерная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Комсомольская, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Ксмк, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Кустанайская, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Молодежная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Нефтебазовская, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Новая, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Панфилова, ПОСЕЛОК Тобол"
			}, {
				"ename": "БАЗА ОТДЫХА Параллель, СЕЛЬСКИЙ ОКРУГ Набережный"
			}, {
				"ename": "УЛИЦА Путейская, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Рабочая, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Самал, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Северная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Станционная, ПОСЕЛОК Тобол"
			}, {
				"ename": "ПЕРЕУЛОК Станционный, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Степная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Строительная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Тарана, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Тәуелсіздік, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Титова, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Тобольская, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Целинная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Школьный Тупик, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Элеваторная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Юбилейная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Южная, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА 50 лет Октября, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА 50 лет Октября, СЕЛО Елизаветинка, СЕЛЬСКИЙ ОКРУГ Набережный"
			}, {
				"ename": "УЛИЦА 60 лет Октября, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА 60 лет СССР, СЕЛО Приозерное, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Кайындыколь, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Максут, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кайындыколь, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Береговое, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Смайловка, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Автобазовская, СЕЛО Апановка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "УЛИЦА Аятская, СЕЛО Асенкритовка, СЕЛЬСКИЙ ОКРУГ Асенкритовский"
			}, {
				"ename": "УЛИЦА Баймагамбетова, СЕЛО Елизаветинка, СЕЛЬСКИЙ ОКРУГ Набережный"
			}, {
				"ename": "УЛИЦА Белинская, СЕЛО Кайындыколь, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Б. Майлина, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Болашақ, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "ПЕРЕУЛОК Больничный, СЕЛО Павловка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Варваринка, СЕЛЬСКИЙ ОКРУГ Асенкритовский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Павловка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Майлин, СЕЛЬСКИЙ ОКРУГ Асенкритовский"
			}, {
				"ename": "УЛИЦА Вокзальная, СЕЛО Апановка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Оренбургское, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Николаевка, СЕЛЬСКИЙ ОКРУГ Асенкритовский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Красносельское, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Приозерное, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Максут, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Геологов, СЕЛО Кайындыколь, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Береговое, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Дзержинского, СЕЛО Приозерное, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Береговое, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Дощанова, СЕЛО Нагорное, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "БАЗА ОТДЫХА Дружба, СЕЛО Юбилейное, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Юбилейное, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Егорова, СЕЛО Приозерное, ПОСЕЛОК Тобол"
			}, {
				"ename": "УЛИЦА Е.Омаров, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Е.Омирзаков, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Жабағы-Батыра, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Жангаскина, СЕЛО Набережное, СЕЛЬСКИЙ ОКРУГ Набережный"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Майлин, СЕЛЬСКИЙ ОКРУГ Асенкритовский"
			}, {
				"ename": "УЛИЦА Железнодорожная, СЕЛО Баталы, СЕЛЬСКИЙ ОКРУГ Асенкритовский"
			}, {
				"ename": "УЛИЦА Жукова, СЕЛО Береговое, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Заводская, СЕЛО Новоильиновка, СЕЛЬСКИЙ ОКРУГ Новоильиновский"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Юбилейное, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Оренбургское, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Әйет, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Зеленая, СЕЛО Красносельское, СЕЛЬСКИЙ ОКРУГ Әйет"
			}, {
				"ename": "УЛИЦА Зеленая, СЕЛО Кайындыколь, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЛИЦА Зеленый Клин, СЕЛО Максут, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "БАЗА ОТДЫХА Золотая Рыбка, СЕЛО Елизаветинка, СЕЛЬСКИЙ ОКРУГ Набережный"
			}, {
				"ename": "ПЕРЕУЛОК Имени Абая, СЕЛО Павловка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "ПЕРЕУЛОК Имени Вачасова, СЕЛО Павловка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "ПЕРЕУЛОК Имени Гагарина, СЕЛО Павловка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "УЛИЦА Индустриальная, СЕЛО Майское, СЕЛЬСКИЙ ОКРУГ Майский"
			}, {
				"ename": "УЛИЦА Интернациональная, СЕЛО Юбилейное, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Казахская, СЕЛО Кайындыколь, СЕЛЬСКИЙ ОКРУГ Белинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ Казахстан, СЕЛО Юбилейное, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Карла Маркса, СЕЛО Павловка, СЕЛЬСКИЙ ОКРУГ Павловский"
			}, {
				"ename": "УЛИЦА Карла Маркса, СЕЛО Смайловка, СЕЛЬСКИЙ ОКРУГ Белинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бейнеуский, ОБЛАСТЬ Мангистауская",
			"addressName": [{
				"ename": "ЗОНА №1, СЕЛО Турыш"
			}, {
				"ename": "ЗОНА №1, СЕЛО Сарга"
			}, {
				"ename": "ЗОНА №1, СЕЛО Толеп"
			}, {
				"ename": "ЗОНА №1, СЕЛО Есет"
			}, {
				"ename": "ЗОНА №1, СЕЛО Сынгырлау"
			}, {
				"ename": "ЗОНА №1, СЕЛО Тажен"
			}, {
				"ename": "ЗОНА №1, СЕЛО Акжигит"
			}, {
				"ename": "ЗОНА №1, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №1, СЕЛО Бейнеу"
			}, {
				"ename": "ЗОНА №10, СЕЛО Боранкул"
			}, {
				"ename": "УЛИЦА 1-Участок, СЕЛО Бейнеу"
			}, {
				"ename": "УЧАСТОК 2, СЕЛО Бейнеу"
			}, {
				"ename": "ЗОНА 2, СЕЛО Турыш"
			}, {
				"ename": "ЗОНА 2, СЕЛО Толеп"
			}, {
				"ename": "ЗОНА 2, СЕЛО Сынгырлау"
			}, {
				"ename": "ЗОНА №2, СЕЛО Есет"
			}, {
				"ename": "ЗОНА №2, СЕЛО Сарга"
			}, {
				"ename": "ЗОНА №2, СЕЛО Бейнеу"
			}, {
				"ename": "ЗОНА №2, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №2, СЕЛО Акжигит"
			}, {
				"ename": "ЗОНА №2, СЕЛО Тажен"
			}, {
				"ename": "ЗОНА №3, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №4, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №5, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №6, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №7, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №8, СЕЛО Боранкул"
			}, {
				"ename": "ЗОНА №9, СЕЛО Боранкул"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА А.Байтурсынов, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Абдибек Жаманбаев, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Абылай Хан, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Адил, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА А.Жангелдин, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА А.Жубанов, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Азан Балов, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Азаттык, СЕЛО Тажен"
			}, {
				"ename": "УЛИЦА Айназар Ата, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Айракты, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Акбобек, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Акшагыл, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Аманбай ата, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Аманжол шебер, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Амантурлы Батыр, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА А.Махутов, СЕЛО Толеп"
			}, {
				"ename": "УЛИЦА А.Молдагулова, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА А.Отеуов, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Асау Батыр, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Аспантай, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Атакозы Батыр, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА А.Тилеуулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ахтан Керейулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Байкул Кажы Каныбекулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Балкаш, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Балуанияз, СЕЛО Толеп"
			}, {
				"ename": "УЛИЦА Балуанияз, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Барак батыр, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Акжигит"
			}, {
				"ename": "УЛИЦА Бекес Дәрментайұлы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Белдеули, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Бердибай Сарбалаев, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Билеули, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Б.Калиев, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Б.Майлин, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Б.Момышулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Бопай Ханым, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Дагар, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Д.Нурпейисова, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Досан Тажиев, СЕЛО Сарга"
			}, {
				"ename": "УЛИЦА Досан Тажиулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Досат, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Е.Айшуаков, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Әбілхайыр Хан, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Е.Бокетбайулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Егемендик, СЕЛО Сынгырлау"
			}, {
				"ename": "УЛИЦА Егемендик, СЕЛО Тажен"
			}, {
				"ename": "УЛИЦА Егемендик, СЕЛО Акжигит"
			}, {
				"ename": "УЛИЦА Егемен ел, СЕЛО Сарга"
			}, {
				"ename": "УЛИЦА Әлихан Бөкейхан, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ер Бегей, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ер Кармыс, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ер Конай, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ерменбет Би, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ер Шабай, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Есбосынов Болысбай, СЕЛО Сарга"
			}, {
				"ename": "УЛИЦА Есекмерген Батыр, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Есенказак, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ж.Аймауытов, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жайык, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жайылган, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жалау Мынбаев, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жамбыл, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Ж.Байбозулы, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жезди, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Желтау, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жетысу, СЕЛО Бейнеу"
			}, {
				"ename": "УЛИЦА Жидели, СЕЛО Бейнеу"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бәйтерек, ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Шалгай, СЕЛЬСКИЙ ОКРУГ Шалғайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Тыңдала, СЕЛЬСКИЙ ОКРУГ Шалғайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Таловая, СЕЛЬСКИЙ ОКРУГ Шалғайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, СЕЛО Шалгай, СЕЛЬСКИЙ ОКРУГ Шалғайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, СЕЛО Қайнар, СЕЛЬСКИЙ ОКРУГ Атамекен"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Гремячее, СЕЛЬСКИЙ ОКРУГ Атамекен"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Гремячее, СЕЛЬСКИЙ ОКРУГ Атамекен"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010 Квартал, СЕЛО Қайнар, СЕЛЬСКИЙ ОКРУГ Атамекен"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Егиндибулак, СЕЛЬСКИЙ ОКРУГ Егиндибулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 012, СЕЛО Егиндибулак, СЕЛЬСКИЙ ОКРУГ Егиндибулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Егиндибулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Егиндибулак, СЕЛЬСКИЙ ОКРУГ Егиндибулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Зеленовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Зеленовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Зеленовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, СЕЛО Переметное, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Переметное, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Белес, СЕЛЬСКИЙ ОКРУГ Белес"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, СЕЛО Белес, СЕЛЬСКИЙ ОКРУГ Белес"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, СЕЛО Акжол, СЕЛЬСКИЙ ОКРУГ Белес"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Белес, СЕЛЬСКИЙ ОКРУГ Белес"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, СЕЛО Болашақ, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Забродино, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, СЕЛО Переметное, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, СЕЛО Переметное, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, СЕЛО Болашақ, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, СЕЛО Забродино, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, СЕЛО Щапово, СЕЛЬСКИЙ ОКРУГ Щаповский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, СЕЛО Щапово, СЕЛЬСКИЙ ОКРУГ Щаповский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Жанатан, СЕЛЬСКИЙ ОКРУГ Щаповский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 035, СЕЛО Большой Чаган, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 037, СЕЛО Кушум, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, СЕЛО Кушум, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Кушум, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Оркен, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Ақсу, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Большой Чаган, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Кушум, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 043, СЕЛО Оркен, СЕЛЬСКИЙ ОКРУГ Кушумский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, СЕЛО Янайкино, СЕЛЬСКИЙ ОКРУГ Янайкинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 046, СЕЛО Янайкино, СЕЛЬСКИЙ ОКРУГ Янайкинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Янайкино, СЕЛЬСКИЙ ОКРУГ Янайкинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Богатск, СЕЛЬСКИЙ ОКРУГ Янайкинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Янайкино, СЕЛЬСКИЙ ОКРУГ Янайкинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 049, СЕЛО Январцево, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 051, СЕЛО Петрово, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 053, СЕЛО Кирсаново, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 054, СЕЛО Январцево, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 054, СЕЛО Спартак, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 055, СЕЛО Красноармейское, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 056, СЕЛО Январцево, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 057, СЕЛО Январцево, СЕЛЬСКИЙ ОКРУГ Январцевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 061, СЕЛО Озерное, СЕЛЬСКИЙ ОКРУГ Дарьинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 061, СЕЛО Дарьинское, СЕЛЬСКИЙ ОКРУГ Дарьинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 062, СЕЛО Дарьинское, СЕЛЬСКИЙ ОКРУГ Дарьинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 064, СЕЛО Дарьинское, СЕЛЬСКИЙ ОКРУГ Дарьинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 065, СЕЛО Дарьинское, СЕЛЬСКИЙ ОКРУГ Дарьинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 066, СЕЛО Құрманғазы, СЕЛЬСКИЙ ОКРУГ Құрманғазы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 067, СЕЛО Аманат, СЕЛЬСКИЙ ОКРУГ Құрманғазы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 068, СЕЛО Құрманғазы, СЕЛЬСКИЙ ОКРУГ Құрманғазы"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 072, СЕЛО Рубежинское, СЕЛЬСКИЙ ОКРУГ Рубежинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 074, СЕЛО Рубежинское, СЕЛЬСКИЙ ОКРУГ Рубежинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 075, СЕЛО Макарово, СЕЛЬСКИЙ ОКРУГ Макаровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 077, СЕЛО Садовое, СЕЛЬСКИЙ ОКРУГ Макаровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 079, СЕЛО Садовое, СЕЛЬСКИЙ ОКРУГ Макаровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 079, СЕЛО Макарово, СЕЛЬСКИЙ ОКРУГ Макаровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 080, СЕЛО Чувашинское, СЕЛЬСКИЙ ОКРУГ Достық"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 082, СЕЛО Достык, СЕЛЬСКИЙ ОКРУГ Достық"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 083, СЕЛО Сұлу Көл, СЕЛЬСКИЙ ОКРУГ Сұлу Көл"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 085, СЕЛО Махамбет, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 086, СЕЛО Горбуново, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 087, СЕЛО Павлово, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 088, СЕЛО Махамбет, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 089, СЕЛО Махамбет, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 089, СЕЛО Горбуново, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 090, СЕЛО Бейбітшілік, СЕЛЬСКИЙ ОКРУГ Бейбітшілік"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 091, СЕЛО Астафьево, СЕЛЬСКИЙ ОКРУГ Бейбітшілік"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 092, СЕЛО Чапурино, СЕЛЬСКИЙ ОКРУГ Бейбітшілік"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 095, СЕЛО Бейбітшілік, СЕЛЬСКИЙ ОКРУГ Бейбітшілік"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 097, СЕЛО Мичуринское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "МИКРОРАЙОН 1, СЕЛО Калининское, СЕЛЬСКИЙ ОКРУГ Переметнинский"
			}, {
				"ename": "УЛИЦА 1, СЕЛО Асан, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЛИЦА 1, СЕЛО Садовое, СЕЛЬСКИЙ ОКРУГ Макаровский"
			}, {
				"ename": "УЛИЦА 1 (Тәуелсіздік), СЕЛО Махамбет, СЕЛЬСКИЙ ОКРУГ Махамбет"
			}, {
				"ename": "МИКРОРАЙОН №1, СЕЛО Асан, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЛИЦА №1, СЕЛО Белес, СЕЛЬСКИЙ ОКРУГ Белес"
			}, {
				"ename": "МИКРОРАЙОН №1, СЕЛО Мичуринское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЛИЦА №10, СЕЛО Асан, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЛИЦА №10, СЕЛО Белес, СЕЛЬСКИЙ ОКРУГ Белес"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 100, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 101, СЕЛО Октябрьское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 101, СЕЛО Макарово, СЕЛЬСКИЙ ОКРУГ Макаровский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 102, СЕЛО Асан, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 104, СЕЛО Мичуринское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ № 105, СЕЛО Мичуринское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 106, СЕЛО Мичуринское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 106, СЕЛО Зеленое, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 106, СЕЛО Октябрьское, СЕЛЬСКИЙ ОКРУГ Мичуринский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 107, СЕЛО Трекино, СЕЛЬСКИЙ ОКРУГ Трекинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 108, СЕЛО Жайык, СЕЛЬСКИЙ ОКРУГ Трекинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бескарагайский, ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "УЛИЦА 1 Квартал, СЕЛО Лесной, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Малая Владимировка, СЕЛЬСКИЙ ОКРУГ МалоВладимировский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Карагайлы, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА 25 лет Октября, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА 2 Квартал, СЕЛО Лесной, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА 3 Квартал, СЕЛО Лесной, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА 50 лет ВЛКСМ, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА 50 летия СССР, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА 50 лет Октября, СЕЛО Мостик, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Башкуль, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жыланды, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бегень, СЕЛЬСКИЙ ОКРУГ Бегенский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Коянбай, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Карабас, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Канонерка, СЕЛЬСКИЙ ОКРУГ Канонерский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жетижар, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Грачи, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Карамырза, СЕЛЬСКИЙ ОКРУГ Канонерский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бозтал, СЕЛЬСКИЙ ОКРУГ МалоВладимировский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Коянбай, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Автомобилистов, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Адам Баймұхамбетов (Чернышевского, Адам Баймұхамбетов), СЕЛО Карабас, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА А.Иманова, СЕЛО Жетижар, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Айткожа Калигожаулы, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА А.Кашаубаева, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Ақниет (Свердлова), СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА ак.Павлова, СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Алаш, СЕЛО Карагайлы, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Ауезова, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Карагайлы, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Бағым, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Баймуратова, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Бастау (Целинная), СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы, СЕЛО Карагайлы, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы (1 Мая), СЕЛО Бегень, СЕЛЬСКИЙ ОКРУГ Бегенский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Башкуль, СЕЛО Башкуль, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Бегень, СЕЛЬСКИЙ ОКРУГ Бегенский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Белокаменка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Черемушка, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Мостик, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Кривинка, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Грачи, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Жетижар, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Береке (Октябрьская), СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Болашақ (Советская), СЕЛО Жыланды, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Болашақ, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Болотная, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Карабас, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Боровая, СЕЛО Карамырза, СЕЛЬСКИЙ ОКРУГ Канонерский"
			}, {
				"ename": "УЛИЦА Боровая, СЕЛО Мостик, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Боровая, ЛЕСХОЗ Морозовский, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Боровая, СЕЛО Букебай, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Боровая, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Ворошилова, СЕЛО Карабас, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Канонерка, СЕЛЬСКИЙ ОКРУГ Канонерский"
			}, {
				"ename": "УЛИЦА Габбасова, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Малая Владимировка, СЕЛЬСКИЙ ОКРУГ МалоВладимировский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Карабас, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Грачи, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Кривинка, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Карагайлы, СЕЛЬСКИЙ ОКРУГ Баскольский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Белокаменка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Жыланды, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Канонерка, СЕЛЬСКИЙ ОКРУГ Канонерский"
			}, {
				"ename": "ЛЕСНИЧЕСТВО ГЛПР Семей орманы, СЕЛО Малая Владимировка, СЕЛЬСКИЙ ОКРУГ МалоВладимировский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Малая Владимировка, СЕЛЬСКИЙ ОКРУГ МалоВладимировский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Канонерка, СЕЛЬСКИЙ ОКРУГ Канонерский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Малая Владимировка, СЕЛЬСКИЙ ОКРУГ МалоВладимировский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Жетижар, СЕЛЬСКИЙ ОКРУГ Жетижарский"
			}, {
				"ename": "СТАНЦИЯ Дегелен, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Коянбай, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Бодене, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Глуховка, СЕЛЬСКИЙ ОКРУГ Глуховский"
			}, {
				"ename": "УЛИЦА Дикопольского, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "УЛИЦА Динмухамед Кунаева, СЕЛО Бегень, СЕЛЬСКИЙ ОКРУГ Бегенский"
			}, {
				"ename": "УЛИЦА Диц, СЕЛО Долонь, СЕЛЬСКИЙ ОКРУГ Долонский"
			}, {
				"ename": "КАРДОН Донгелек, СЕЛО Ондирис, СЕЛЬСКИЙ ОКРУГ Карабасский"
			}, {
				"ename": "ПЕРЕУЛОК Дорожный, СЕЛО Бескарагай, СЕЛЬСКИЙ ОКРУГ Бескарагайский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Биржан сал, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Мамай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Мамай"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Абсалям кажы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Абулхаира Досова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Абылай хана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Мамай"
			}, {
				"ename": "УЛИЦА Акана Серэ, СЕЛО Кенащи"
			}, {
				"ename": "УЛИЦА Алпысбай Жакупова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Амангельдинская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Ахата Атнашева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Биржан Сал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Биржан Сала, СЕЛО Мамай"
			}, {
				"ename": "УЛИЦА Биржан Сала, СЕЛО Кенащи"
			}, {
				"ename": "УЛИЦА Богембай батыра, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Василия Чапаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Енбек, СЕЛО Краснофлот"
			}, {
				"ename": "УЛИЦА Еркеша Ибрагима, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Есмаганбета Исмаилова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Жакана Сыздыкова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Жангельдинская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Заводская, СЕЛО Заозерный"
			}, {
				"ename": "УЛИЦА Кабдолла Кошербаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Касыма Антаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Кенесары Касымова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Магжана Жумабаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Маншук Маметовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА М.Ауезова, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Мектеп, СЕЛО Краснофлот"
			}, {
				"ename": "УЛИЦА Микрорайон, СЕЛО Заозерный"
			}, {
				"ename": "УЛИЦА Михаила Буденного, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Наурызбай батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Николая Дрыгача, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Николая Моисеенко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Николая Некрасова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Омигова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Орталык, СЕЛО Краснофлот"
			}, {
				"ename": "УЛИЦА Первомайская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Рамазана Елебаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Сакена Сейфуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Сатана Нурмаганова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Сейтбаттала Мустафина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Симов Гирея, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Тауелсиздик, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Турара Рыскулова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Шаймердена Косшыгулова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЛИЦА Шахтерская, СЕЛО Заозерный"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Заозерный"
			}, {
				"ename": "УЛИЦА Шокана Уалиханова, СЕЛО Мамай"
			}, {
				"ename": "УЛИЦА Шокана Уалиханова, СЕЛО Аксу"
			}, {
				"ename": "УЛИЦА Шокана Уалиханова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Степняк"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Сауле, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Бирсуат, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, СЕЛО Бирсуат, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Шошкалы, СЕЛЬСКИЙ ОКРУГ Баймырзинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Баймырзинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Яблоновка, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Заураловка, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Кудукагаш, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ульгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Кызылуюм, СЕЛЬСКИЙ ОКРУГ Ульгинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019 кв (018), СЕЛО Заураловка, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Андыкожа батыра, СЕЛЬСКИЙ ОКРУГ Донской"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, СЕЛО Макинка, СЕЛЬСКИЙ ОКРУГ Макинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 036, СЕЛО Шокан Уалиханов, СЕЛЬСКИЙ ОКРУГ Валихановский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Актас, СЕЛЬСКИЙ ОКРУГ Енбекшильдерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Енбекшильдерское, СЕЛЬСКИЙ ОКРУГ Енбекшильдерский"
			}, {
				"ename": "ПОЛЕВОЙ СТАН 1, СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Баймырзинский"
			}, {
				"ename": "УЛИЦА 1-я Комбинатовская, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ульгинский"
			}, {
				"ename": "УЛИЦА 2-я Комбинатовская, СЕЛО Ульги, СЕЛЬСКИЙ ОКРУГ Ульгинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шокан Уалиханов, СЕЛЬСКИЙ ОКРУГ Валихановский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Енбекшильдерское, СЕЛЬСКИЙ ОКРУГ Енбекшильдерский"
			}, {
				"ename": "УЛИЦА Абулхаира Досова, СЕЛО Шокан Уалиханов, СЕЛЬСКИЙ ОКРУГ Валихановский"
			}, {
				"ename": "УЛИЦА Абулхаира Досова, СЕЛО Буланды, СЕЛЬСКИЙ ОКРУГ Макинский"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Алга, СЕЛЬСКИЙ ОКРУГ Валихановский"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Бирсуат, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЛИЦА Абылай-Хана, СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Баймырзинский"
			}, {
				"ename": "УЛИЦА Айтима Амирова, СЕЛО Сауле, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЛИЦА Акана Серэ, СЕЛО Бирсуат, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЛИЦА Акана Серэ, СЕЛО Сауле, СЕЛЬСКИЙ ОКРУГ Бирсуатский"
			}, {
				"ename": "УЛИЦА Акана Серэ, СЕЛО Когам, СЕЛЬСКИЙ ОКРУГ Макинский"
			}, {
				"ename": "УЛИЦА Ак Кайын, СЕЛО Ангал батыра, СЕЛЬСКИЙ ОКРУГ Ангалбатырский"
			}, {
				"ename": "УЛИЦА Аксу, СЕЛО Ангал батыра, СЕЛЬСКИЙ ОКРУГ Ангалбатырский"
			}, {
				"ename": "УЛИЦА Алга, СЕЛО Кудукагаш, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЛИЦА Алшынбай, СЕЛО Енбекшильдерское, СЕЛЬСКИЙ ОКРУГ Енбекшильдерский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Ангал батыра, СЕЛЬСКИЙ ОКРУГ Ангалбатырский"
			}, {
				"ename": "УЛИЦА Ангал батыра, СЕЛО Ангал батыра, СЕЛЬСКИЙ ОКРУГ Ангалбатырский"
			}, {
				"ename": "УЛИЦА Аталык, СЕЛО Яблоновка, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЛИЦА Базарбек, СЕЛО Уюмшил, СЕЛЬСКИЙ ОКРУГ Ульгинский"
			}, {
				"ename": "УЛИЦА Баймырза, СЕЛО Баймырза, СЕЛЬСКИЙ ОКРУГ Баймырзинский"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Заураловка, СЕЛЬСКИЙ ОКРУГ Заураловский"
			}, {
				"ename": "УЛИЦА Бауыржана Момышулы, СЕЛО Буланды, СЕЛЬСКИЙ ОКРУГ Макинский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Макпал, СЕЛЬСКИЙ ОКРУГ Макинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бокейординский, ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "ЗИМОВКА 10 Точка, СЕЛО Макар, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Ажен, СЕЛЬСКИЙ ОКРУГ Муратсайский"
			}, {
				"ename": "УЛИЦА 1У, СЕЛО Жетибай, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Шонгай, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Коктерек, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Мамбет, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Уштерек, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Теренкудук, СЕЛЬСКИЙ ОКРУГ Имени Темира Масина"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Тайгара, СЕЛЬСКИЙ ОКРУГ Муратсайский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Hауша, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 1 У, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА №26 Точка, СЕЛО Тайгара, СЕЛЬСКИЙ ОКРУГ Муратсайский"
			}, {
				"ename": "ЗИМОВКА 2-ая Точка, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 2у, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 2у, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "УЛИЦА 2У, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 2У, СЕЛО Бесколь, СЕЛЬСКИЙ ОКРУГ Саралжинский"
			}, {
				"ename": "УЛИЦА 2 У, СЕЛО Жетибай, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "УЛИЦА 2 У, СЕЛО Жиеккум, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "УЛИЦА 2 У, СЕЛО Шонгай, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА 2 Улица, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "РАЗЪЕЗД 340, СЕЛО Мамбет, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 365, СЕЛО Шонгай, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "РАЗЪЕЗД №372, СЕЛО Шонгай, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 390, СЕЛО Шонгай, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 3 Точка, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 3У, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 3-ши Бригада, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 41-ая Точка, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА 4-ая Точка, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 5У, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА 6-Точка, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА 6У, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА №9 Точка, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шонгай, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Муратсай, СЕЛЬСКИЙ ОКРУГ Муратсайский"
			}, {
				"ename": "УЛИЦА Абдигалиева Н, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Абдол, СЕЛО Уштерек, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА Абухан Сисенгалиев, СЕЛО Бурли, СЕЛЬСКИЙ ОКРУГ Имени Темира Масина"
			}, {
				"ename": "ЗИМОВКА Абылай, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА А.Герасимов, СЕЛО Хан Ордасы, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Адык, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Азамат, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Азербаева, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Айбас-1, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Айбас-2, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Айбас-3, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Айдарлы, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Аймекен, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Айтали, СЕЛО Макар, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА Айтжан Сундетов, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Айшим, СЕЛО Уштерек, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Айшим, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Акай, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Аканкол, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Акбулак, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Аккемпир, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Акколмек, СЕЛО Коктерек, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Аққыстау, СЕЛО Уштерек, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Акмектеп-1, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Акмектеп-2, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Акмолда, СЕЛО Сейткали, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Ак Ой, СЕЛО Бесколь, СЕЛЬСКИЙ ОКРУГ Саралжинский"
			}, {
				"ename": "ЗИМОВКА Аксай, СЕЛО Уштерек, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Аксай, СЕЛО Мамбет, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Аксарай, СЕЛО Бурли, СЕЛЬСКИЙ ОКРУГ Имени Темира Масина"
			}, {
				"ename": "ЗИМОВКА Аксор, СЕЛО Уштерек, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Аксор, СЕЛО Бисен, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "УЛИЦА Алаш Орда, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Алиби Жангелдина, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Алина, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, СЕЛО Саралжын, СЕЛЬСКИЙ ОКРУГ Саралжинский"
			}, {
				"ename": "УЛИЦА Алмы Оразбаевой, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА А.Маметова, СЕЛО Хан Ордасы, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "ЗИМОВКА Амангали, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА А.Мендыбаев, СЕЛО Саралжын, СЕЛЬСКИЙ ОКРУГ Саралжинский"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, СЕЛО Хан Ордасы, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Ангиык, СЕЛО Жарменке, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "ЗИМОВКА Андаш, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Апакай, СЕЛО Жиеккум, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Апет, СЕЛО Ажен, СЕЛЬСКИЙ ОКРУГ Муратсайский"
			}, {
				"ename": "ЗИМОВКА Арал, СЕЛО Кеной, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Арон, СЕЛО Жиеккум, СЕЛЬСКИЙ ОКРУГ Бисенский"
			}, {
				"ename": "ЗИМОВКА Арыстан, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Аскар, СЕЛО Бурли, СЕЛЬСКИЙ ОКРУГ Имени Темира Масина"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Аубакирова Т, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "УЛИЦА Аубакирова Т, СЕЛО Муратсай, СЕЛЬСКИЙ ОКРУГ Муратсайский"
			}, {
				"ename": "УЛИЦА А.Уразбаевой, СЕЛО Хан Ордасы, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА А.Уразбаевой, СЕЛО Бурли, СЕЛЬСКИЙ ОКРУГ Имени Темира Масина"
			}, {
				"ename": "УЛИЦА Ахмедияр Кусайнов, СЕЛО Хан Ордасы, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}, {
				"ename": "УЛИЦА Ахмедияр Кусайнов, СЕЛО Сайхин, СЕЛЬСКИЙ ОКРУГ Сайхинский"
			}, {
				"ename": "УЛИЦА Ахмедиярова К, СЕЛО Уялы, СЕЛЬСКИЙ ОКРУГ Уялинский"
			}, {
				"ename": "ЗИМОВКА Ахмет, СЕЛО Карасу, СЕЛЬСКИЙ ОКРУГ Урдинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бородулихинский, ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "УЛИЦА 60 лет КССР, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Аягузная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Б/у, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Вишневая, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Гаражная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Горняков, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Дачная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Дружбы, ПОСЕЛОК Жезкент"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Жезкент ГУ, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Индивидуальная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Комсомольская, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Конечная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Малиновая, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Молодежная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Новая, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Общежитие, ПОСЕЛОК Жезкент"
			}, {
				"ename": "ПРОСПЕКТ Октября, ПОСЕЛОК Жезкент"
			}, {
				"ename": "ПЕРЕУЛОК Парковый, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА ПЛОЩАДЬ АВТОСТАНЦИИ, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Промышленная Зона Гока, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА РАЙОН ТАМОЖЕННОГО ПОСТА, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Розовая, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Садовая, ПОСЕЛОК Жезкент"
			}, {
				"ename": "ПЕРЕУЛОК Садовый, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Сатпаева, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Сахарова, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Северная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА СЕЛЬСКИЙ ОКРУГ, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Советская, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Строительная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Тохтарова, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Фруктовая, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Школьная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Юбилейная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Южная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Яблочная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА Ягодная, ПОСЕЛОК Жезкент"
			}, {
				"ename": "УЛИЦА 14 км автодороги Семей-Барнаул Бор-го р-на ВКО, СЕЛО Коростели, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА 1йпереулок, СЕЛО Зубаир, СЕЛЬСКИЙ ОКРУГ Зубаирский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Ивановка, СЕЛЬСКИЙ ОКРУГ Новодворовский"
			}, {
				"ename": "ПЕРЕУЛОК 1 Мая, СЕЛО Дмитриевка, СЕЛЬСКИЙ ОКРУГ Дмитриевский"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Переменовка, СЕЛЬСКИЙ ОКРУГ Переменовский"
			}, {
				"ename": "УЛИЦА 1МАЯ, СТАНЦИЯ Аул, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА 30 лет Целины, СЕЛО Коростели, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Новая Шульба, СЕЛЬСКИЙ ОКРУГ Новошульбинский"
			}, {
				"ename": "ПЕРЕУЛОК 8 Марта, СЕЛО Дмитриевка, СЕЛЬСКИЙ ОКРУГ Дмитриевский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Коростели, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Уба-Форпост, СЕЛЬСКИЙ ОКРУГ Красноярский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ақши, СЕЛЬСКИЙ ОКРУГ Новошульбинский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Бородулиха, СЕЛЬСКИЙ ОКРУГ Бородулихинский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Михайличенково, СЕЛЬСКИЙ ОКРУГ Андреевский"
			}, {
				"ename": "УЛИЦА Абеулова, СЕЛО Новая Шульба, СЕЛЬСКИЙ ОКРУГ Новошульбинский"
			}, {
				"ename": "УЛИЦА Абеулова, СЕЛО Речное, СЕЛЬСКИЙ ОКРУГ Красноярский"
			}, {
				"ename": "УЛИЦА Ақжол, СЕЛО Ақши, СЕЛЬСКИЙ ОКРУГ Новошульбинский"
			}, {
				"ename": "УЛИЦА Ақ Жол, СЕЛО Зубаир, СЕЛЬСКИЙ ОКРУГ Зубаирский"
			}, {
				"ename": "УЛИЦА Алаш, СЕЛО Зенковка, СЕЛЬСКИЙ ОКРУГ Бель-агачский"
			}, {
				"ename": "УЛИЦА Алтай (Сто), СЕЛО Бородулиха, СЕЛЬСКИЙ ОКРУГ Бородулихинский"
			}, {
				"ename": "УЛИЦА Алтайская, СЕЛО Бель-Агач, СЕЛЬСКИЙ ОКРУГ Бель-агачский"
			}, {
				"ename": "УЛИЦА Аманова, СЕЛО Ивановка, СЕЛЬСКИЙ ОКРУГ Новодворовский"
			}, {
				"ename": "УЛИЦА Аманова, СЕЛО Новопокровка, СЕЛЬСКИЙ ОКРУГ Новопокровский"
			}, {
				"ename": "УЛИЦА Аубакирова, СЕЛО Сарногай, СЕЛЬСКИЙ ОКРУГ Новопокровский"
			}, {
				"ename": "УЛИЦА АУЛЬСКОЕ ЛЕСНИЧЕСТВО, СТАНЦИЯ Аул, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Михайличенково, СЕЛЬСКИЙ ОКРУГ Андреевский"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Бородулиха, СЕЛЬСКИЙ ОКРУГ Бородулихинский"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Успенка, СЕЛЬСКИЙ ОКРУГ Бородулихинский"
			}, {
				"ename": "УЛИЦА Бакинская, СЕЛО Коростели, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА Баркова Петра Николаевича, СЕЛО Бородулиха, СЕЛЬСКИЙ ОКРУГ Бородулихинский"
			}, {
				"ename": "УЛИЦА Бастау, СЕЛО Бель-Агач, СЕЛЬСКИЙ ОКРУГ Бель-агачский"
			}, {
				"ename": "УЛИЦА Батпаевское Лесничество, СЕЛО Новопокровка, СЕЛЬСКИЙ ОКРУГ Новопокровский"
			}, {
				"ename": "ЛЕСНИЧЕСТВО Батпаевское Лесничество, СЕЛО Камышенка, СЕЛЬСКИЙ ОКРУГ Подборный"
			}, {
				"ename": "УЛИЦА Без Улиц, ПОДХОЗ Березовка, СЕЛЬСКИЙ ОКРУГ Новодворовский"
			}, {
				"ename": "УЛИЦА Без Улицы, СЕЛО Уба-Форпост, СЕЛЬСКИЙ ОКРУГ Красноярский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Жарбулак, СЕЛЬСКИЙ ОКРУГ Кунарлинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Буркотово, СЕЛЬСКИЙ ОКРУГ Таврический"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Новая Шульба, СЕЛЬСКИЙ ОКРУГ Новошульбинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Новопокровка, СЕЛЬСКИЙ ОКРУГ Новопокровский"
			}, {
				"ename": "УЛИЦА Береке, СЕЛО Камышенка, СЕЛЬСКИЙ ОКРУГ Подборный"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Михайличенково, СЕЛЬСКИЙ ОКРУГ Андреевский"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Бородулиха, СЕЛЬСКИЙ ОКРУГ Бородулихинский"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Дмитриевка, СЕЛЬСКИЙ ОКРУГ Дмитриевский"
			}, {
				"ename": "УЛИЦА Бірлік, СТАНЦИЯ Аул, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА Богомоловская, СЕЛО Буркотово, СЕЛЬСКИЙ ОКРУГ Таврический"
			}, {
				"ename": "УЛИЦА Болата Агиманова, СЕЛО Петропавловка, СЕЛЬСКИЙ ОКРУГ Петропавловский"
			}, {
				"ename": "УЛИЦА Болашақ, СЕЛО Переменовка, СЕЛЬСКИЙ ОКРУГ Переменовский"
			}, {
				"ename": "УЛИЦА Болашақ, СЕЛО Шелехово, СЕЛЬСКИЙ ОКРУГ Степной"
			}, {
				"ename": "УЛИЦА Болашақ, СЕЛО Михайличенково, СЕЛЬСКИЙ ОКРУГ Андреевский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Уба-Форпост, СЕЛЬСКИЙ ОКРУГ Красноярский"
			}, {
				"ename": "УЛИЦА Борцов Революции, СЕЛО Красный Яр, СЕЛЬСКИЙ ОКРУГ Красноярский"
			}, {
				"ename": "ПЕРЕУЛОК Бригадный, СЕЛО Песчанка, СЕЛЬСКИЙ ОКРУГ Кунарлинский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Красный Яр, СЕЛЬСКИЙ ОКРУГ Красноярский"
			}, {
				"ename": "УЛИЦА Б/у, СТАНЦИЯ Аул, СЕЛЬСКИЙ ОКРУГ Бакинский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Петропавловка, СЕЛЬСКИЙ ОКРУГ Петропавловский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Буркотово, СЕЛЬСКИЙ ОКРУГ Таврический"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Камышенка, СЕЛЬСКИЙ ОКРУГ Подборный"
			}, {
				"ename": "УЛИЦА Б/у, САНАТОРИЙ Березовка, СЕЛЬСКИЙ ОКРУГ Новодворовский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Жарбулак, СЕЛЬСКИЙ ОКРУГ Кунарлинский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Песчанка, СЕЛЬСКИЙ ОКРУГ Кунарлинский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Ивановка, СЕЛЬСКИЙ ОКРУГ Новодворовский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Байтанат, СЕЛЬСКИЙ ОКРУГ Зубаирский"
			}, {
				"ename": "УЛИЦА Б/у, СЕЛО Пол Лог, СЕЛЬСКИЙ ОКРУГ Жерновский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Бостандыкский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Алматы",
			"addressName": [{
				"ename": "ПЕРЕУЛОК 13 переулок"
			}, {
				"ename": "ПЕРЕУЛОК 14 переулок"
			}, {
				"ename": "ПЕРЕУЛОК 15 переулок"
			}, {
				"ename": "УЛИЦА 1 кирпичнозаводская"
			}, {
				"ename": "УЛИЦА 1 Лисянского"
			}, {
				"ename": "УЛИЦА 1 Нестерова"
			}, {
				"ename": "УЛИЦА 20 линия"
			}, {
				"ename": "ПЕРЕУЛОК 20 линия"
			}, {
				"ename": "УЛИЦА 22 Линия"
			}, {
				"ename": "УЛИЦА 24 июня"
			}, {
				"ename": "УЛИЦА 26"
			}, {
				"ename": "УЛИЦА 28"
			}, {
				"ename": "УЛИЦА 2 кирпичнозаводская"
			}, {
				"ename": "УЛИЦА 3 вишневского"
			}, {
				"ename": "УЛИЦА 3 кирпичнозаводская"
			}, {
				"ename": "УЛИЦА 5 кирпичнозаводская"
			}, {
				"ename": "УЛИЦА 6 кирпичнозаводская"
			}, {
				"ename": "ПРОСПЕКТ Абая"
			}, {
				"ename": "УЛИЦА Абиш Кекилбайулы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Автомобилист"
			}, {
				"ename": "УЛИЦА Айвазовского"
			}, {
				"ename": "УЛИЦА Айманова"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Айнабулак"
			}, {
				"ename": "УЛИЦА Айтиева"
			}, {
				"ename": "УЛИЦА Аксакова"
			}, {
				"ename": "МИКРОРАЙОН Актобе"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Алатау"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Алатау-2"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Алатау Байқоңыр"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Алма"
			}, {
				"ename": "МИКРОРАЙОН Алма Арасан"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ОБЩЕСТВО Алма Баганашыл"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Алмагуль"
			}, {
				"ename": "МИКРОРАЙОН Алмагуль"
			}, {
				"ename": "УЛИЦА Алматинская"
			}, {
				"ename": "ПРОСПЕКТ Аль-Фараби"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ САДОВОДЧЕСКИХ ТОВАРИЩЕСТВ Арасан"
			}, {
				"ename": "МИКРОРАЙОН Архат"
			}, {
				"ename": "УЛИЦА Асанбая Аскарова"
			}, {
				"ename": "МИКРОРАЙОН Аскартау"
			}, {
				"ename": "УЛИЦА Ауэзова"
			}, {
				"ename": "УЛИЦА Бабаева"
			}, {
				"ename": "МИКРОРАЙОН Баганашыл"
			}, {
				"ename": "УЛИЦА Байзакова"
			}, {
				"ename": "УЛИЦА Байкадамова"
			}, {
				"ename": "УЛИЦА Байсеитовой"
			}, {
				"ename": "УЛИЦА Байтурсынулы"
			}, {
				"ename": "УЛИЦА Байшешек"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Бак Алма"
			}, {
				"ename": "УЛИЦА Бальзака"
			}, {
				"ename": "УЛИЦА Басенова"
			}, {
				"ename": "УЛИЦА Баталпашинская"
			}, {
				"ename": "ПЕРЕУЛОК Баха"
			}, {
				"ename": "УЛИЦА Баха"
			}, {
				"ename": "УЛИЦА Березовая"
			}, {
				"ename": "УЛИЦА Березовского"
			}, {
				"ename": "УЛИЦА Биокомбинат"
			}, {
				"ename": "УЛИЦА Бокина"
			}, {
				"ename": "МИКРОРАЙОН Ботанический сад"
			}, {
				"ename": "УЛИЦА Брауна"
			}, {
				"ename": "УЛИЦА Брусиловского"
			}, {
				"ename": "УЛИЦА Бультриковой"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Буран"
			}, {
				"ename": "УЛИЦА Бутлерова"
			}, {
				"ename": "БУЛЬВАР Бухар жырау"
			}, {
				"ename": "УЛИЦА Вахтангова"
			}, {
				"ename": "ПЕРЕУЛОК Вахтангова"
			}, {
				"ename": "УЛИЦА Витебская"
			}, {
				"ename": "УЛИЦА Володарского"
			}, {
				"ename": "УЛИЦА Вяземская"
			}, {
				"ename": "УЛИЦА Габдуллина"
			}, {
				"ename": "ПРОСПЕКТ Гагарина"
			}, {
				"ename": "МИКРОРАЙОН Галамат"
			}, {
				"ename": "УЛИЦА Гидрометслужбы"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Горный"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Горный Гигант"
			}, {
				"ename": "МИКРОРАЙОН Дарын"
			}, {
				"ename": "МИКРОРАЙОН Дарын-1"
			}, {
				"ename": "УЛИЦА Декарта"
			}, {
				"ename": "УЛИЦА Джандарбекова"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Достык"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Дружба"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Дружба-2000"
			}, {
				"ename": "УЛИЦА Дружбы"
			}, {
				"ename": "ПЕРЕУЛОК Дружбы"
			}, {
				"ename": "УЛИЦА Дунаевского"
			}, {
				"ename": "УЛИЦА Егизбаева"
			}, {
				"ename": "УЛИЦА Еділ Ерғожин"
			}, {
				"ename": "УЛИЦА Ербола Сыпатаева"
			}, {
				"ename": "МИКРОРАЙОН Ерменсай"
			}, {
				"ename": "МИКРОРАЙОН Ерменсай 2"
			}, {
				"ename": "УЛИЦА Ескараева С"
			}, {
				"ename": "МИКРОРАЙОН Жайлау"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Жаңару"
			}, {
				"ename": "УЛИЦА Жандосова"
			}, {
				"ename": "УЛИЦА Жарокова"
			}, {
				"ename": "УЛИЦА Желтоксан"
			}, {
				"ename": "УЛИЦА Жубановой Г"
			}, {
				"ename": "УЛИЦА Журавлева"
			}, {
				"ename": "УЛИЦА Заилийская"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Буландынский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛЬСКИЙ ОКРУГ Караозекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛЬСКИЙ ОКРУГ Карамышевский"
			}, {
				"ename": "ПЕРЕУЛОК 1 Балуан Шолака, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Дорстроя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Ивана Скуридина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Кенесары, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Крупской, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА 1 Мая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Некрасова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Новосёлов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Садовый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Станционный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Суворова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Урицкого, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Шевченко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 1 Шокана Уалиханова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "РАЗЪЕЗД 26, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА 2-ая Садовая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА 2-ая Станционная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Дорстроя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Некрасова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Новосёлов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Садовый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Станционный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Суворова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 2 Шевченко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 3 Дорстроя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 3 Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 3 Садовый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 3 Шокана Уалиханова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 4 Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 4 Садовый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 5 Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПЕРЕУЛОК 5 Садовый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА 9 Мая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Автомобильная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Алтын Абишевой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ШОССЕ Астана-Петропавловск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Бауыржана Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Богенбай Батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "МИКРОРАЙОН Болашак, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Восточная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Гагарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Гастелло, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Геологическая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Герцена, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Гоголя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Горького, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Гранит, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Гранитная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Громовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Дзержинского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Достоевского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Достык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Елены Мейтиной, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ШОССЕ Жалтыр-Макинск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Заводская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Западная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Зои Космодемьянской, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Ивана Омигова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Ивана Остроконя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Ивана Скуридина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА имени Айыма Серикбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА имени Балуан Шолака, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Имени Шамши Калдаякова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Интернациональная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Кайыржана Ескендирова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Калинина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Каменная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Каменный Карьер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Каныша Сатпаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Карьерная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Кенесары, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Кирова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Клубная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Кольцо, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Кооперативная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Куйбышева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Лермонтова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Лесная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Лихачёва, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Ломоносова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Луговая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ШОССЕ Макинск-Жалтыр, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Маншук Маметовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Матросова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Маяковского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Меридиан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Микрорайон, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Микрорайон, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Минерал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}, {
				"ename": "УЛИЦА Мира, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Макинск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бурабайский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЛИЦА 2-ая Фабричная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА 2-я Звездная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА 2-я Пушкина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Абая (Советская), ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Абылай хана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Айнакол, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Акан Сери, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Акбидай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Акбулак, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Акжол, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Аккайын, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Аккайын, ПОСЕЛОК Бурабай"
			}, {
				"ename": "МИКРОРАЙОН Ак-Кайын, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Аксай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Аксу, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Алатау, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Алаш, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Алимусиных, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Алтын Дан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Алтын Күз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Андыкожа батыра, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Арай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Арасан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Ардагерлер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Арлан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Арман, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Аскартау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ДОРОГА Астана-Кокшетау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ДОРОГА Астана-Петропавловск, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Атамекен, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Ахмета Байтурсынулы (Ахмет Байтурсынов), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Байтерек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Балауса, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бармашино, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бармашино 1 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бармашино 2 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бармашино 3 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бармашино 4 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бармашино 5 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Батыс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УРОЧИЩЕ Баянбай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Бейбитшилик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "БАЗА ОТДЫХА Берег озера Щучье, восточная часть, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ТЕРРИТОРИЯ Берег озера Щучье, юго-восточная часть, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ТЕРРИТОРИЯ Берег озера Щучье, юго-западная часть, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Береке, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Берен, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Биржан Сал, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Бирлик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Богембай батыра, ПОСЕЛОК Бурабай"
			}, {
				"ename": "МИКРОРАЙОН Болашак, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ДОРОГА Боровое-Птицефабрика, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Боровская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Ботаническая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Бсхт, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Бурабай Автолюбитель, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Верхняя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Ветбаклаборатория, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Войкова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Восток, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Восточная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Гагарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Галея Ахмадеева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Галыма Елемесова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Геологическая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Гоголя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УРОЧИЩЕ Голубой залив, ПОСЕЛОК Бурабай"
			}, {
				"ename": "МИКРОРАЙОН Горный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Горького, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Джамбула Жабаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Дидар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Динмухамеда Кунаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Дом отдыха Кокшетау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Дорожкиных, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Дорожная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Достык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА ДСУ-46, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Думан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Дщтсл, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Едомского, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Енбек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Еркиндик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Жагалау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Жайлау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Жас Улан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Железнодорожник, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Жигер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "УЛИЦА Жібек Жолы, ПОСЕЛОК Бурабай"
			}, {
				"ename": "УЛИЦА Западная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 10 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 1 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 2 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 3 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 4 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 5 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 6 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}, {
				"ename": "МИКРОРАЙОН Заречный 7 линия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Щучинск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бурлинский, ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "МИКРОРАЙОН 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 10, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 11, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 12, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 13, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ЖИЛОЙ РАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 5, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 5 А, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 7, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 7 А, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА 8 Наурыз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН 9, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ПРОСПЕКТ Абай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Абай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ПЕРЕУЛОК Автороторский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Ақбұлақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Ақсу, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Алексеева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Амангелді, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Арыстанова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Байжиен, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Балдырған, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Батыс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Бейбітшілік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Бекзат Саттарханов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Береке, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Бірлік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Болашақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Борлi, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ТРАССА Борли-Аксай-Жымпиты, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Буденный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Буровик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Вахтовый городок, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Газовик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Деповская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Джамбульская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Достык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Дружба, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Дружба народов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Әл-Фараби, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Еңбекші, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жайлау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жайық, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жаңаталап, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жастар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Железнодорожная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Желтоқсан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жерұйық, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жібек жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Жұбан Молдағалиев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Зерде, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Иван Ващук, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "СТАНЦИЯ Казахстан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Казахстан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Казбургаз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Қайыр Шакенов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Қарашығанақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Көкжиек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Көкмайса, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "МИКРОРАЙОН Коктем, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Курлыс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Локомотив, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Луговая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Луговая 7 II, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Луговая 7 III, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Маметова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Месторождения, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Мостовая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Мустахим Иксанов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Мұхтар Әуезов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "БУЛЬВАР Наурыз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Оңтүстік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Орал, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Өркен, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Орталық, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ПЛОЩАДЬ Победа, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Промышленная Зона, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Совхоз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Солтүстік, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ПЕРЕУЛОК Степной, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Степной переулок II, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Степной переулок III, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Строитель, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Строитель, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Строитель2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Строительная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Строительная 10, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Строительная 6, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Строительная 9, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Сырым Датулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Талғат Бигелдинов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Тихоненко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Торговая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Транспортная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Хиуаз Доспанова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}, {
				"ename": "УЛИЦА Цвилинга, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Аксай"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Бухар-Жырауский, ОБЛАСТЬ Карагандинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Акоре"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Акоре"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, СЕЛО Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, СЕЛО Каракудук"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, СЕЛО Каракудук"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 035, СЕЛО Каракудук"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 036, СЕЛО Суыксу"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 037, СЕЛО Суыксу"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 066, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 068, СЕЛО Каракудук"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 069, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 070, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 070, СЕЛО Жанаталап"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 070, СЕЛО Акоре"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 083, СЕЛО Жанаталап"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 084, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ботакара"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Абылайхана, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Айдильда Кыздарбекова, СЕЛО Каракудук"
			}, {
				"ename": "УЛИЦА Айтеке Би, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Амангельды, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Аубакирова, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Ауэзова, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Акоре"
			}, {
				"ename": "УЛИЦА Бәйтерек (Молодежная), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Болашак, СЕЛО Жанаталап"
			}, {
				"ename": "СТАНЦИЯ Ботакара, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Бухар-Жырау, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Габидена Мустафина, СЕЛО Каракудук"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Суыксу"
			}, {
				"ename": "УЛИЦА Г. Мустафина, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Доскея, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Акоре"
			}, {
				"ename": "УЛИЦА Достық (Юбилейная), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Әлихан Бөкейхан (Энергетиков), ПОСЕЛОК Ботакара"
			}, {
				"ename": "ОТДЕЛЕНИЕ Жалгызкудук, СЕЛО Каракудук"
			}, {
				"ename": "УЛИЦА Жамбыла, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Ботакара"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Ботакара"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Акоре"
			}, {
				"ename": "УЛИЦА Жеңіс (К.Черняева), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Жумабека Ташенова, СЕЛО Каракудук"
			}, {
				"ename": "УЛИЦА Жұмабек Тәшенов (40 лет Казахстана), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Жуматаева, СЕЛО Каракудук"
			}, {
				"ename": "УЛИЦА Казахстан, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Казыбек Би, ПОСЕЛОК Ботакара"
			}, {
				"ename": "ТРАССА Караганда Каркаралинск, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА К.Байсеитова, ПОСЕЛОК Ботакара"
			}, {
				"ename": "ЗИМОВКА Косшокы, СЕЛО Акоре"
			}, {
				"ename": "УЛИЦА Кумыскудук, СЕЛО Каракудук"
			}, {
				"ename": "УЛИЦА Курмангазы, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Курылысшылар, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Суыксу"
			}, {
				"ename": "УЛИЦА Мәншүк Мәметова (Механизаторская), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Мәшһүр Жүсіп (Березюкова), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Мустафина, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Мухтара Ауэзова, СЕЛО Ботакара"
			}, {
				"ename": "УЛИЦА Н.Абдирова, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Нуринская, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Огородная, СЕЛО Жанаталап"
			}, {
				"ename": "ПЕРЕУЛОК Октябрьский, СЕЛО Суыксу"
			}, {
				"ename": "УЛИЦА Орынбека Карабасова, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Сарыарка, СЕЛО Жанаталап"
			}, {
				"ename": "УЛИЦА Сарыарқа (Подгорная), ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Сатпаева, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Сейфуллина, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Строительная, СЕЛО Суыксу"
			}, {
				"ename": "УЛИЦА Таттимбета, СЕЛО Ботакара"
			}, {
				"ename": "УЛИЦА Толе би, СЕЛО Ботакара"
			}, {
				"ename": "УЛИЦА Толе би, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Т.Торегожина, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Акоре"
			}, {
				"ename": "УЛИЦА Центральная, СЕЛО Акоре"
			}, {
				"ename": "ЗИМОВКА Шатан, СЕЛО Акоре"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Суыксу"
			}, {
				"ename": "УЛИЦА Шопанай, ПОСЕЛОК Ботакара"
			}, {
				"ename": "УЛИЦА Энгельса, СЕЛО Суыксу"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Алабас, СЕЛЬСКИЙ ОКРУГ Акбелский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Акбел, СЕЛЬСКИЙ ОКРУГ Акбелский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001 (004), СЕЛО Умуткер, СЕЛЬСКИЙ ОКРУГ Умуткерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002 (003), СЕЛО Умуткер, СЕЛЬСКИЙ ОКРУГ Умуткерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, СЕЛО Акбел, СЕЛЬСКИЙ ОКРУГ Акбелский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003 (001), СЕЛО Акбел, СЕЛЬСКИЙ ОКРУГ Акбелский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Ульга, СЕЛЬСКИЙ ОКРУГ Умуткерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Умуткер, СЕЛЬСКИЙ ОКРУГ Умуткерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003 (006), СЕЛО Керней, СЕЛЬСКИЙ ОКРУГ Керней"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004 (005), СЕЛО Керней, СЕЛЬСКИЙ ОКРУГ Керней"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004 (002), СЕЛО Акбел, СЕЛЬСКИЙ ОКРУГ Акбелский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Тортколь, СЕЛЬСКИЙ ОКРУГ Умуткерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Умуткер, СЕЛЬСКИЙ ОКРУГ Умуткерский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Глубоковский, ОБЛАСТЬ Восточно-Казахстанская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, ПОСЕЛОК Алтайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, ПОСЕЛОК Алтайский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 052, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 063, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 068, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 069, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 070, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 071, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 156, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 161, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "РАЗЪЕЗД 195 Км, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 1й Береговой, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 1й Заводской, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 1й Калининский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 1й Кирпичный, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 2 Заводской, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 2й Береговой, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 2й Калининский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 2й Кирпичный, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 3 Заводской, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 3й Кирпичный, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 3 Калининский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "МИКРОРАЙОН 4й, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 4й Калининский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 4й Кирпичный, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 5й Калининский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК 5 й Кирпичный, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "МИКРОРАЙОН Абая, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автомотолюбитель, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Алейская, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Алтайская, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Алтайская, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Амангельды, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Амбулаторная, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Базарная, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Без Кооператива, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК Белоусовский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Береговая, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК Березовский, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Берестова, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Бн, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Бн, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Бн, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Больничная, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Больничная, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Больничная, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Большая, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Буденного, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Буденного, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Буровая, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Ватутина, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Верхняя, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Верхняя, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Водопроводная, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Вокзальная, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Ворошилова, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Восход, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Гвардейская, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Герцена, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Гоголя, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Гоголя, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Горная, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Горноспасательная, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Горняк, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Горняцкая, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Джамбула, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Джамбула, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Достоевского, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Еремкина, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Железно Дорожный Переезд, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Жібек жолы (Ленина), ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Жукова, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Заводская, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Заводская, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Заглубочанка, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА За Линией, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Заречная, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "ПЕРЕУЛОК Зеленый, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "СТАНЦИЯ Иртышский завод, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Искра, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Казахстанская, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК Казахстанский, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "ПЕРЕУЛОК Казахстанский, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Казаченко, ПОСЕЛОК Глубокое"
			}, {
				"ename": "ПЕРЕУЛОК Казаченко, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Калинина, ПОСЕЛОК Верхнеберезовский"
			}, {
				"ename": "УЛИЦА Калинина, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Калинина, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Калинина, ПОСЕЛОК Алтайский"
			}, {
				"ename": "УЛИЦА Канонерка, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Карла Маркса, ПОСЕЛОК Белоусовка"
			}, {
				"ename": "УЛИЦА Киргородок, ПОСЕЛОК Глубокое"
			}, {
				"ename": "УЛИЦА Кирова, ПОСЕЛОК Глубокое"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Денисовский, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "УЛИЦА Большая, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Лесная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Малая, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Новостройка, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Парижская, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Парковая, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-1, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-1, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-10, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-10, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-11, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-11, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-12, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-13, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-14, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-2, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-2, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-3, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-4, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-4, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-5, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-5, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-6, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-6, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-6, СЕЛЬСКИЙ ОКРУГ Красноармейский"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-7, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-7, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-8, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-8, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-9, СЕЛО Глебовка"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Промзона-9, СЕЛО Перелески"
			}, {
				"ename": "ТРАССА Республиканская автодорога \\\\\\\"Костанай-Карабутак\\\\\\\" 151 км, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Садовая, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Северная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Средняя, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Станция, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Строительная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Центральная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Центральная, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Шанхайская, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Глебовка"
			}, {
				"ename": "УЛИЦА Юбилейная, СЕЛО Перелески"
			}, {
				"ename": "УЛИЦА Южная, СЕЛО Перелески"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 15, СЕЛО Аятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Георгиевка, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА 20 лет Целины, СЕЛО Жалтырколь, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА 25 лет Целины, СЕЛО Свердловка, СЕЛЬСКИЙ ОКРУГ Свердловский"
			}, {
				"ename": "УЛИЦА 40 лет Казахстана, СЕЛО Аятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА 50 лет Казахстана, СЕЛО Аятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА 50 лет Октября, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Комаровка, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Алчановка, СЕЛЬСКИЙ ОКРУГ Тельманский"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Базарная, СЕЛО Георгиевка, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА Базарная, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Набережное, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Антоновка, СЕЛЬСКИЙ ОКРУГ Тельманский"
			}, {
				"ename": "УЛИЦА Березовая, СЕЛО Досовка, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Фрунзенское, СЕЛЬСКИЙ ОКРУГ Красноармейский"
			}, {
				"ename": "УЛИЦА Вихляева, СЕЛО Приреченка, СЕЛЬСКИЙ ОКРУГ Приреченский"
			}, {
				"ename": "УЛИЦА Воронежская, СЕЛО Окраинка, СЕЛЬСКИЙ ОКРУГ Приреченский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Приреченка, СЕЛЬСКИЙ ОКРУГ Приреченский"
			}, {
				"ename": "ПЕРЕУЛОК Восточный, СЕЛО Зааятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА Въездная, СЕЛО Жалтырколь, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Алчановка, СЕЛЬСКИЙ ОКРУГ Тельманский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Фрунзенское, СЕЛЬСКИЙ ОКРУГ Красноармейский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Зааятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Зааятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Гришенка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Комаровка, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА ДЭУ-239, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Железнодорожная, СЕЛО Зааятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА Животноводческая, СЕЛО Аятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Георгиевка, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА Заречная, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Зеленая, СЕЛО Подгорное, СЕЛЬСКИЙ ОКРУГ Свердловский"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Имановка, СЕЛО Покровка, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Интернациональная, СЕЛО Крымское, СЕЛО Крымское"
			}, {
				"ename": "УЛИЦА Кавказская, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Казахская, СЕЛО Комаровка, СЕЛЬСКИЙ ОКРУГ Аршалинский"
			}, {
				"ename": "УЛИЦА Казахская, СЕЛО Покровка, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Калинина, СЕЛО Денисовка, СЕЛЬСКИЙ ОКРУГ Денисовский"
			}, {
				"ename": "УЛИЦА Киевская, СЕЛО Зааятское, СЕЛЬСКИЙ ОКРУГ Аятское"
			}, {
				"ename": "УЛИЦА Киевская, СЕЛО Окраинка, СЕЛЬСКИЙ ОКРУГ Приреченский"
			}, {
				"ename": "УЛИЦА Киевская, СЕЛО Свердловка, СЕЛЬСКИЙ ОКРУГ Свердловский"
			}, {
				"ename": "УЛИЦА Клубная, СЕЛО Приреченка, СЕЛЬСКИЙ ОКРУГ Приреченский"
			}, {
				"ename": "УЛИЦА Клубная, СЕЛО Свердловка, СЕЛЬСКИЙ ОКРУГ Свердловский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Джангельдинский, ОБЛАСТЬ Костанайская",
			"addressName": [{
				"ename": "УЛИЦА Абая, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Абжан Турманов, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Айгожин Аяжан, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Айса Нурманова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Айтима Кожмуханбетова, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Аккора, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Акмырза, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Алақоңыз, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Алиби Жангелдина, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Амангелды, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Аңсаған Конкабаев, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Ардагерлер, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Сужарган"
			}, {
				"ename": "УЛИЦА Ахмет Байтұрсынов, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "УЛИЦА Ахмет Байтұрсынов, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Байтемір, СЕЛО Сужарган"
			}, {
				"ename": "ЗИМОВКА Байтемір, СЕЛО Сужарган"
			}, {
				"ename": "УЛИЦА Байту Салык, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Бакытжана Байкадамова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Бейбітшілік көшесі, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "УЛИЦА Болата Хамзина, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Босаға, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Гафу Кайырбекова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Дабена Бокишова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Дамолла Катен, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Дамолла Катена, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Еркеш Тауешкин, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Ермана Мусина, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Жайнақ, СЕЛО Сужарган"
			}, {
				"ename": "УЛИЦА Жакан Косабаев, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Жанайдар Батыр, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Желтоксан, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Желтоқсан, СЕЛО Сужарган"
			}, {
				"ename": "УЛИЦА Жеңіс, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Жеңіс көшесі, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "ЗИМОВКА Жынкылды, СЕЛО Шеген"
			}, {
				"ename": "ЗИМОВКА Қазыбай, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Кайнекей, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Кайырбек Алматова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА К.Алтынсары, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Канапия Кайдосова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Каражана Топаева, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Қарасор, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "УЛИЦА Қарасу, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "ЗИМОВКА Қаратоғай, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Каргалы, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Кейки Батыр, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Кенжеғали Сағадиев, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Кенжегали Сагадиева, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Кеншилик Мырзабекова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Когабай Сарсекеева, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Койшыгара Салгарина, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Қосбидайық, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Қошалақ, СЕЛО Сужарган"
			}, {
				"ename": "ЗИМОВКА Қуат, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Кулжановых, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Кумколь, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Кыпшак Сейткула, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Марат Нұрқалиев, СЕЛО Аралбай"
			}, {
				"ename": "ЗИМОВКА Маужан, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "ЗИМОВКА Мекебай, СЕЛО Сужарган"
			}, {
				"ename": "ЗИМОВКА Мешіт, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Миржакыпа Дулатова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Міржақып Дулатов, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "УЛИЦА Муханбетжана Дузенова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Мырзагалия Жангелова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Нарынбаевых, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Нурхана Акына, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Нурхан Ахметбеков, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Омара Тынымова, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Орсақ, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "ЗИМОВКА Өске Түбегі, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Сапабека Жунусова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Сейт Кенжеахметова, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Сызай, СЕЛО Акколь"
			}, {
				"ename": "УЛИЦА Сырбайа Мауленова, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Табай, СЕЛО Аралбай"
			}, {
				"ename": "ЗИМОВКА Табылды, СЕЛО Аралбай"
			}, {
				"ename": "ЗИМОВКА Талдыкөл, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Тәуелсіздік, СЕЛО Ахмет Байтұрсынұлы"
			}, {
				"ename": "УЛИЦА Тәуелсіздік, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Токтабаев, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Тосын, СЕЛО Шеген"
			}, {
				"ename": "УЛИЦА Хакимбека Токина, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Хамза Нарымбаев, СЕЛО Шеген"
			}, {
				"ename": "ЗИМОВКА Шөптікөл, СЕЛО Акколь"
			}, {
				"ename": "ЗИМОВКА Шуақбай, СЕЛО Аралбай"
			}, {
				"ename": "УЛИЦА Ыбырая Алтынсарина, СЕЛО Торгай"
			}, {
				"ename": "УЛИЦА Энергетика, СЕЛО Торгай"
			}, {
				"ename": "ЗИМОВКА Абылда, СЕЛО Тауыш, СЕЛЬСКИЙ ОКРУГ Жаркольский"
			}, {
				"ename": "УЛИЦА Айнаколь, СЕЛО Акшиганак, СЕЛЬСКИЙ ОКРУГ Акшиганакский"
			}, {
				"ename": "УЛИЦА Айсы Нурманова, СЕЛО Кокалат, СЕЛЬСКИЙ ОКРУГ Албарбогетский"
			}, {
				"ename": "ЗИМОВКА Айтуар, СЕЛО Сага, СЕЛЬСКИЙ ОКРУГ Кызбельский"
			}, {
				"ename": "ЗИМОВКА Айтуган, СЕЛО Акшиганак, СЕЛЬСКИЙ ОКРУГ Акшиганакский"
			}, {
				"ename": "УЛИЦА Акмырза, СЕЛО Калам-Карасу, СЕЛЬСКИЙ ОКРУГ Калам-Карасуский"
			}, {
				"ename": "ЗИМОВКА Аксуат, СЕЛО Кокалат, СЕЛЬСКИЙ ОКРУГ Албарбогетский"
			}, {
				"ename": "ЗИМОВКА Акши, СЕЛО Акшиганак, СЕЛЬСКИЙ ОКРУГ Акшиганакский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Егиндыкольский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "ПОЛЕВОЙ СТАН 1, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "ПОЛЕВОЙ СТАН 2, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "ПОЛЕВОЙ СТАН 3, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА 9 Пятилетки, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Тоганас, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Баумана, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Водопроводная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Полтавское, СЕЛЬСКИЙ ОКРУГ Алакольский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Грейдерная, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Дальняя, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Джакубаева, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Дихандар, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Егиндыкольская, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Жарлыколь, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Животноводческая, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Жолдыбая, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Полтавское, СЕЛЬСКИЙ ОКРУГ Алакольский"
			}, {
				"ename": "УЛИЦА Зеленая, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Зеленая, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Историческая, СЕЛО Полтавское, СЕЛЬСКИЙ ОКРУГ Алакольский"
			}, {
				"ename": "УЛИЦА Казахская, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Казахстанская, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА Калинина, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Калинина, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Карасу, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Кенесары, СЕЛО Тоганас, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Кирова, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Коркем, СЕЛО Коркем, СЕЛЬСКИЙ ОКРУГ Алакольский"
			}, {
				"ename": "УЛИЦА Косколь, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Космическая, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Крайняя, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Линейная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Мадениет, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Медиков, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Механическая, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА Микрорайон, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Полтавское, СЕЛЬСКИЙ ОКРУГ Алакольский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА М.Маметовой, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Наурыз, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Нефтебазовая, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Нефтебазовская, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Озерная, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Орталык, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Победы, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Победы, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Победы, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Приозерная, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}, {
				"ename": "УЛИЦА Приозерная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Приозерная, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Приозерная, СЕЛО Жалманкулак, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Приозерная, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Приозерная, СЕЛО Спиридоновка, СЕЛЬСКИЙ ОКРУГ Спиридоновка"
			}, {
				"ename": "УЛИЦА Пришкольная, СЕЛО Жулдыз, СЕЛЬСКИЙ ОКРУГ Жалманкулакский"
			}, {
				"ename": "УЛИЦА Пролетарская, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Пушкина, СЕЛО Буревестник, СЕЛЬСКИЙ ОКРУГ Буревестниковский"
			}, {
				"ename": "УЛИЦА Пушкина, СЕЛО Бауманское, СЕЛЬСКИЙ ОКРУГ Бауманский"
			}, {
				"ename": "УЛИЦА Пушкина, СЕЛО Коржинколь, СЕЛЬСКИЙ ОКРУГ Коржинкольский"
			}, {
				"ename": "УЛИЦА Пушкина, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Ружинского, СЕЛО Полтавское, СЕЛЬСКИЙ ОКРУГ Алакольский"
			}, {
				"ename": "УЛИЦА Северная, СЕЛО Егиндыколь, СЕЛЬСКИЙ ОКРУГ Егиндыкольский"
			}, {
				"ename": "УЛИЦА Соловьева, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Абайский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Енбекшиказахский, ОБЛАСТЬ Алматинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "МИКРОРАЙОН 1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "МИКРОРАЙОН 2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ 2 Микрорайон, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "МИКРОРАЙОН 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ №307, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "МИКРОРАЙОН 4, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК 8-Марта, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА 8-Марта, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Абай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Абай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК А.Гайдар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА А.Гайдар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Алматинская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Алматинский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Алма Уразбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Алтын Адам аллеясы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА А.Малкеев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК А.Малкеев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Амангелді, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Амангелді, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Амурская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА А.Пушкин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Ардагер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Арычная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Астана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА А.Чехов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Байкальская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Байкальская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "МИКРОРАЙОН Байтерек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Бейімбет Майлин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Болашақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Братский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Быковский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Вавилов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Васильев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Вишневый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Водопроводный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Волжский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Волжский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Гастелло, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Глубинный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Гоголя, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Горный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Гражданский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Грибоедов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Грушовая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Грушовый сад, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Г.Тохтабаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Дзержинский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Д.Кешубаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Достық, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Епэс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПРОСПЕКТ Жамбыл, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Жамбыла, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Жароков, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Желтоқсан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Заводской, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Заводской, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Зазулин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Западная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Западный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Заречный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ПЕРЕУЛОК Зеленый, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Иссыкская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Кавказский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Калинин, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Қали Нұрбаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Карагачев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Кардон, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Қарсақбайұлы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Қ.Жаманқараев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Киевская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Киров, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Колесникова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Колхозный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Коммунальный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Қ.Орымбетов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Космонавтов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Космонавтов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Кошевой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Крупская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Крылов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Крымская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Куйбышев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Лазо, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Лермонтов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Ломоносов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Мағжан Жұмабаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Малая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Малокрымская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА М.Аманбаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Марат Абошұлы Ысқақ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Матросов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Менделеев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Мәншүк Маметова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА М.Әуезов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}, {
				"ename": "УЛИЦА Мечников, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есик"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Енбекшинский, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Шымкент",
			"addressName": [{
				"ename": "КВАРТАЛ 001"
			}, {
				"ename": "КВАРТАЛ 019"
			}, {
				"ename": "КВАРТАЛ 024"
			}, {
				"ename": "КВАРТАЛ 025"
			}, {
				"ename": "КВАРТАЛ 026"
			}, {
				"ename": "КВАРТАЛ 027"
			}, {
				"ename": "КВАРТАЛ 028"
			}, {
				"ename": "КВАРТАЛ 029"
			}, {
				"ename": "КВАРТАЛ 030"
			}, {
				"ename": "КВАРТАЛ 032"
			}, {
				"ename": "КВАРТАЛ 033"
			}, {
				"ename": "КВАРТАЛ 034"
			}, {
				"ename": "КВАРТАЛ 035"
			}, {
				"ename": "КВАРТАЛ 037"
			}, {
				"ename": "КВАРТАЛ 038"
			}, {
				"ename": "КВАРТАЛ 039"
			}, {
				"ename": "КВАРТАЛ 040"
			}, {
				"ename": "КВАРТАЛ 041"
			}, {
				"ename": "КВАРТАЛ 042"
			}, {
				"ename": "КВАРТАЛ 043"
			}, {
				"ename": "КВАРТАЛ 044"
			}, {
				"ename": "КВАРТАЛ 045"
			}, {
				"ename": "КВАРТАЛ 046"
			}, {
				"ename": "КВАРТАЛ 047"
			}, {
				"ename": "КВАРТАЛ 048"
			}, {
				"ename": "КВАРТАЛ 049"
			}, {
				"ename": "КВАРТАЛ 050"
			}, {
				"ename": "КВАРТАЛ 051"
			}, {
				"ename": "КВАРТАЛ 052"
			}, {
				"ename": "КВАРТАЛ 053"
			}, {
				"ename": "КВАРТАЛ 054"
			}, {
				"ename": "КВАРТАЛ 055"
			}, {
				"ename": "КВАРТАЛ 056"
			}, {
				"ename": "КВАРТАЛ 057"
			}, {
				"ename": "КВАРТАЛ 058"
			}, {
				"ename": "КВАРТАЛ 082"
			}, {
				"ename": "ДОРОГА №1"
			}, {
				"ename": "МИКРОРАЙОН 11"
			}, {
				"ename": "МИКРОРАЙОН 12"
			}, {
				"ename": "МИКРОРАЙОН 13"
			}, {
				"ename": "КВАРТАЛ 161"
			}, {
				"ename": "КВАРТАЛ 162"
			}, {
				"ename": "КВАРТАЛ 178"
			}, {
				"ename": "КВАРТАЛ 190"
			}, {
				"ename": "КВАРТАЛ 191"
			}, {
				"ename": "КВАРТАЛ 193"
			}, {
				"ename": "КВАРТАЛ 194"
			}, {
				"ename": "КВАРТАЛ 195"
			}, {
				"ename": "УЛИЦА 1-ая Арычная"
			}, {
				"ename": "ЖИЛОЙ МАССИВ 1 Бадам"
			}, {
				"ename": "ДОРОГА №1, в районе Цем завода"
			}, {
				"ename": "УЛИЦА 1-й Ташкент"
			}, {
				"ename": "ПЕРЕУЛОК 1-Новостройка"
			}, {
				"ename": "ДОРОГА №1 пр Тауке-хана"
			}, {
				"ename": "УЛИЦА 1 Тастак"
			}, {
				"ename": "УЛИЦА 20"
			}, {
				"ename": "КВАРТАЛ № 237"
			}, {
				"ename": "КВАРТАЛ 238"
			}, {
				"ename": "КВАРТАЛ 251"
			}, {
				"ename": "КВАРТАЛ 254"
			}, {
				"ename": "КВАРТАЛ 255"
			}, {
				"ename": "КВАРТАЛ № 256"
			}, {
				"ename": "КВАРТАЛ 257"
			}, {
				"ename": "КВАРТАЛ № 258"
			}, {
				"ename": "КВАРТАЛ № 259"
			}, {
				"ename": "УЛИЦА 26"
			}, {
				"ename": "КВАРТАЛ 260"
			}, {
				"ename": "КВАРТАЛ № 261"
			}, {
				"ename": "КВАРТАЛ № 262"
			}, {
				"ename": "КВАРТАЛ № 263"
			}, {
				"ename": "КВАРТАЛ № 264"
			}, {
				"ename": "КВАРТАЛ № 265"
			}, {
				"ename": "КВАРТАЛ № 266"
			}, {
				"ename": "КВАРТАЛ № 267"
			}, {
				"ename": "КВАРТАЛ 268"
			}, {
				"ename": "КВАРТАЛ № 269"
			}, {
				"ename": "КВАРТАЛ 270"
			}, {
				"ename": "КВАРТАЛ №297"
			}, {
				"ename": "УЛИЦА 2-ая Арычная"
			}, {
				"ename": "ПЕРЕУЛОК 2-й Жанакурылыс"
			}, {
				"ename": "УЛИЦА 2-й Коксай"
			}, {
				"ename": "УЛИЦА 2-й Тастак"
			}, {
				"ename": "ПЕРЕУЛОК 3-й Жанакурылыс"
			}, {
				"ename": "УЛИЦА 3-й Коксай"
			}, {
				"ename": "ПЕРЕУЛОК 4-й Жанакурылыс"
			}, {
				"ename": "УЛИЦА 5 км. Жастар"
			}, {
				"ename": "УЛИЦА 5 км Железнодорожный"
			}, {
				"ename": "ПРОЕЗД 5 км Железнодорожный"
			}, {
				"ename": "УЛИЦА А.Алимбетова"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Абдилабад"
			}, {
				"ename": "ПРОЕЗД Аварийный"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Автомобилист"
			}, {
				"ename": "УЛИЦА А.Жылкышиева"
			}, {
				"ename": "МИКРОРАЙОН Азат"
			}, {
				"ename": "УЛИЦА Айбатты"
			}, {
				"ename": "УЛИЦА Айкол"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Айнатас"
			}, {
				"ename": "УЛИЦА Акбидай"
			}, {
				"ename": "УЛИЦА Акжол"
			}, {
				"ename": "УЛИЦА Ак Жол"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Ерейментауский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Бозтал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Бозтал"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 030, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Новомарковка"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 042, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, СЕЛО Селетинское"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 060, СЕЛО Бозтал"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Абылайхана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Автомобилистов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "ЗИМОВКА Айгыржал, СЕЛО Бозтал"
			}, {
				"ename": "ЗИМОВКА Актобе, СЕЛО Бозтал"
			}, {
				"ename": "УЛИЦА Александра Пушкина, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Алексея Камышного, СЕЛО Новомарковка"
			}, {
				"ename": "УЛИЦА Алихан Барлыбаев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Аль-Фараби, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Аманжола Альжанова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Аманжола Каликова, СЕЛО Новомарковка"
			}, {
				"ename": "УЛИЦА Ардагер, СЕЛО Новомарковка"
			}, {
				"ename": "УЛИЦА Ардагерлер, СЕЛО Бозтал"
			}, {
				"ename": "ТРАССА Астана-Шидерты, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Атан Батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, СЕЛО Бозтал"
			}, {
				"ename": "ЗИМОВКА Баянды, СЕЛО Бозтал"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Бекболат Акына, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Богенбая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Богенбая, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Болата Бектемирова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Валерия Чкалова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Галымжана Мукатова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Горнолесная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Деповская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Джамбула Жабаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Новомарковка"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Бозтал"
			}, {
				"ename": "ЗИМОВКА Жаман-Кара, СЕЛО Бозтал"
			}, {
				"ename": "УЛИЦА Жанайдара Ыбыраева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Жантай Батыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Новомарковка"
			}, {
				"ename": "УЛИЦА Железнодорожная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Желтоксана, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Женис, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Заводская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Западная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Заречная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Зеленый Хутор, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Имени Абая Кунанбаева, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Алии Молдагуловой, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Аль-Фараби, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Ахмета Байтурсынова, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Кабанбай Батыра, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Каныш Сатпаева, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Молдажана Жадайулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Имени Сакена Сейфуллина, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Имени Умбетей Жырау, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Имени Ыбырая Алтынсарина, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Интернациональная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Казахская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Каменный Карьер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "ЗИМОВКА Карадыр, СЕЛО Бозтал"
			}, {
				"ename": "ЗИМОВКА Карасенгир, СЕЛО Бозтал"
			}, {
				"ename": "УЛИЦА Карасу, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Кенесары Касымова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Кеноткел, СЕЛО Новомарковка"
			}, {
				"ename": "УЛИЦА Кожа Ахмета Яссауи, СЕЛО Селетинское"
			}, {
				"ename": "ЗИМОВКА Койтас, СЕЛО Бозтал"
			}, {
				"ename": "УЛИЦА Линейная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Малика Габдуллина, СЕЛО Селетинское"
			}, {
				"ename": "УЛИЦА Мира, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Мухтара Ауезова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "ПЕРЕУЛОК Октябрьский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "ПЕРЕУЛОК Первомайский, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}, {
				"ename": "УЛИЦА Приречная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Ерейментау"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН В ГОРОДЕ Есиль, ГОРОД РЕСПУБЛИКАНСКОГО ЗНАЧЕНИЯ Астана",
			"addressName": [{
				"ename": "ПРОЕЗД 20"
			}, {
				"ename": "ПЕРЕУЛОК 217"
			}, {
				"ename": "ПЕРЕУЛОК 218"
			}, {
				"ename": "ПЕРЕУЛОК 219"
			}, {
				"ename": "ПЕРЕУЛОК 220"
			}, {
				"ename": "ПЕРЕУЛОК 221"
			}, {
				"ename": "ПЕРЕУЛОК 222"
			}, {
				"ename": "ПЕРЕУЛОК 223"
			}, {
				"ename": "ПЕРЕУЛОК 224"
			}, {
				"ename": "ПЕРЕУЛОК 225"
			}, {
				"ename": "УЛИЦА 25"
			}, {
				"ename": "УЛИЦА 3"
			}, {
				"ename": "УЛИЦА 39"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО №51 ПМК Союзцелингаз"
			}, {
				"ename": "ПРОЕЗД 77"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ИНДИВИДУАЛЬНЫХ ГАРАЖЕЙ  Авиатор"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Авиатор"
			}, {
				"ename": "УЛИЦА Ақмешіт"
			}, {
				"ename": "УЛИЦА Александр Сызғанов (Е 357)"
			}, {
				"ename": "УЛИЦА Алматы"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ АТП-4 Автомобилист-1"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ АТЭП - 4"
			}, {
				"ename": "УЛИЦА Барлыбек Сырттанұлы (Е 889)"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Березка"
			}, {
				"ename": "УЛИЦА Будапешт"
			}, {
				"ename": "УЛИЦА Букар жырау"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Весна"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Ветераны Войны"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ САДОВЫХ, ДАЧНЫХ УЧАСТКОВ Вишенка"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ ВРЗ-3"
			}, {
				"ename": "УЛИЦА Ғабдолла Тоқай"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Гвоздика"
			}, {
				"ename": "УЛИЦА Гейдар Әлиев"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ СОБСТВЕННИКОВ ДАЧНЫХ УЧАСТКОВ Гидростроитель"
			}, {
				"ename": "УЛИЦА Дінмұхамед Қонаев"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Дорожник"
			}, {
				"ename": "ГАРАЖНОЕ ОБЩЕСТВО Дорожник-2"
			}, {
				"ename": "САДОВОДЧЕСКОЕ ТОВАРИЩЕСТВО Дорожник упрдор-44"
			}, {
				"ename": "УЛИЦА Достық"
			}, {
				"ename": "САДОВОЕ ОБЩЕСТВО Дружба"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Дск"
			}, {
				"ename": "УЛИЦА Дүкенбай Досжан (Е 324)"
			}, {
				"ename": "УЛИЦА Е 114"
			}, {
				"ename": "УЛИЦА Е 116"
			}, {
				"ename": "УЛИЦА Е 117"
			}, {
				"ename": "УЛИЦА Е 118"
			}, {
				"ename": "УЛИЦА Е 129"
			}, {
				"ename": "УЛИЦА Е 150"
			}, {
				"ename": "УЛИЦА Е 152"
			}, {
				"ename": "УЛИЦА Е 178"
			}, {
				"ename": "УЛИЦА Е 179"
			}, {
				"ename": "УЛИЦА Е 184"
			}, {
				"ename": "ПЕРЕУЛОК Е 217"
			}, {
				"ename": "ПЕРЕУЛОК Е227"
			}, {
				"ename": "ПЕРЕУЛОК Е228"
			}, {
				"ename": "ПЕРЕУЛОК Е229"
			}, {
				"ename": "ПЕРЕУЛОК Е230"
			}, {
				"ename": "ПЕРЕУЛОК Е231"
			}, {
				"ename": "УЛИЦА Е232"
			}, {
				"ename": "УЛИЦА Е233"
			}, {
				"ename": "УЛИЦА Е235"
			}, {
				"ename": "УЛИЦА Е236"
			}, {
				"ename": "УЛИЦА Е237"
			}, {
				"ename": "УЛИЦА Е238"
			}, {
				"ename": "УЛИЦА Е239"
			}, {
				"ename": "УЛИЦА Е 24"
			}, {
				"ename": "УЛИЦА Е240"
			}, {
				"ename": "УЛИЦА Е241"
			}, {
				"ename": "УЛИЦА Е 314"
			}, {
				"ename": "УЛИЦА Е 319"
			}, {
				"ename": "УЛИЦА Е 321"
			}, {
				"ename": "УЛИЦА Е 332"
			}, {
				"ename": "УЛИЦА Е 344"
			}, {
				"ename": "УЛИЦА Е 346"
			}, {
				"ename": "УЛИЦА Е 349"
			}, {
				"ename": "УЛИЦА Е 351"
			}, {
				"ename": "УЛИЦА Е 354"
			}, {
				"ename": "УЛИЦА Е 445"
			}, {
				"ename": "УЛИЦА Е 446"
			}, {
				"ename": "УЛИЦА Е 447"
			}, {
				"ename": "УЛИЦА Е 448"
			}, {
				"ename": "УЛИЦА Е 449"
			}, {
				"ename": "УЛИЦА Е 450"
			}, {
				"ename": "УЛИЦА Е 452"
			}, {
				"ename": "УЛИЦА Е 453"
			}, {
				"ename": "УЛИЦА Е 458"
			}, {
				"ename": "УЛИЦА Е 460"
			}, {
				"ename": "УЛИЦА Е 472"
			}, {
				"ename": "УЛИЦА Е 473"
			}, {
				"ename": "УЛИЦА Е 474"
			}, {
				"ename": "УЛИЦА Е 475"
			}, {
				"ename": "УЛИЦА Е 476"
			}, {
				"ename": "УЛИЦА Е 477"
			}, {
				"ename": "УЛИЦА Е 478"
			}, {
				"ename": "УЛИЦА Е 479"
			}, {
				"ename": "УЛИЦА Е 480"
			}, {
				"ename": "УЛИЦА Е 481"
			}, {
				"ename": "УЛИЦА Е 482"
			}, {
				"ename": "УЛИЦА Е 483"
			}, {
				"ename": "УЛИЦА Е 486"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Есильский, ОБЛАСТЬ Северо-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 40 лет Победы, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА А-атинская, СЕЛО Покровка, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА А-атинская, СЕЛО Двинск, СЕЛЬСКИЙ ОКРУГ Тарангульский"
			}, {
				"ename": "УЛИЦА Абай (Комсомольская), СЕЛО Амангельдинское, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Абай (Ленина), СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Оседлое, СЕЛЬСКИЙ ОКРУГ Петровский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Караагаш, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Каратал, СЕЛЬСКИЙ ОКРУГ Hиколаевский"
			}, {
				"ename": "УЛИЦА Абая (Коммунистическая), СЕЛО Лузинка, СЕЛЬСКИЙ ОКРУГ Волошинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бескудук, СЕЛЬСКИЙ ОКРУГ Бескудукский"
			}, {
				"ename": "УЛИЦА Абылай Рамазанов (Роща), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Абылай Хан (К.Маркса), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Караагаш, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Алка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Автобаза, СЕЛО Николаевка, СЕЛЬСКИЙ ОКРУГ Hиколаевский"
			}, {
				"ename": "УЛИЦА А.Иманова, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Аккайын, СЕЛО Карагай, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Ак Кийк, СЕЛО Орталык, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Аккудук, СЕЛО Булак, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Алексея Мухина (Советская), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Алтайская, СЕЛО Тарангул, СЕЛЬСКИЙ ОКРУГ Тарангульский"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Алка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Амангельдинское, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА А.М. Ершова (Крупская), СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Астыкты, СЕЛО Актас, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Ауезова, СЕЛО Чириковка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Ауэзова, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Ахмета Байтурсунова, СЕЛО Караагаш, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Ахмет Байтұрсынұлы (Щорса), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Батырхан Шүкенов (Первомайская), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Баумана, СЕЛО Новоузенка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы (Буденного), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Жаналык, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Булак, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Пролетарская), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Мальцево, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Енбек, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Покровка, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Амангельдинское, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Николаевка, СЕЛЬСКИЙ ОКРУГ Hиколаевский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Карагай, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Чириковка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Мектеп, СЕЛЬСКИЙ ОКРУГ Алматинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Заградовка, СЕЛЬСКИЙ ОКРУГ Заградовский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Актас, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Амангельды, СЕЛЬСКИЙ ОКРУГ Ильинский"
			}, {
				"ename": "УЛИЦА Бобрицкого, СЕЛО Бескудук, СЕЛЬСКИЙ ОКРУГ Бескудукский"
			}, {
				"ename": "УЛИЦА Бокейхана, СЕЛО Караагаш, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Борамбая Абишева, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Братьев Ткач, СЕЛО Спасовка, СЕЛЬСКИЙ ОКРУГ Спасовский"
			}, {
				"ename": "УЛИЦА Букетная, СЕЛО Чириковка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Булак, СЕЛО Булак, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Валиханова, СЕЛО Чириковка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Валиханова, СЕЛО Тамамбай, СЕЛЬСКИЙ ОКРУГ Бескудукский"
			}, {
				"ename": "УЛИЦА Ветеранов, СЕЛО Поляковка, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Водников, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Ворошилова, СЕЛО Советское, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Амангельдинское, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Черуновка, СЕЛЬСКИЙ ОКРУГ Бескудукский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Советское, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "ПРОСПЕКТ Гагарина, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Гвардейская, СЕЛО Заградовка, СЕЛЬСКИЙ ОКРУГ Заградовский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Советское, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Дальняя, СЕЛО Александровка, СЕЛЬСКИЙ ОКРУГ Ильинский"
			}, {
				"ename": "УЛИЦА Дачная, СЕЛО Есильское, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Горное, СЕЛЬСКИЙ ОКРУГ Заградовский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Дінмұхамед Қонаев (Фурманова), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Добрынина, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Петровский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Покровка, СЕЛЬСКИЙ ОКРУГ Покровский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Орнек, СЕЛЬСКИЙ ОКРУГ Алматинский"
			}, {
				"ename": "УЛИЦА Достық (Ленина), СЕЛО Волошинка, СЕЛЬСКИЙ ОКРУГ Волошинский"
			}, {
				"ename": "ПЕРЕУЛОК Достық (Первомайский), СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Чириковка, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова (Комсомольская), СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Әлия Молдағұлова (Фрунзе), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Әл-Фараби (Урицкого), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Ершова, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Ершова, СЕЛО Заградовка, СЕЛЬСКИЙ ОКРУГ Заградовский"
			}, {
				"ename": "УЛИЦА Есим Шайкина, СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Есіл (С Разина), СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Жабаева, СЕЛО Караагаш, СЕЛЬСКИЙ ОКРУГ Заречный"
			}, {
				"ename": "УЛИЦА Жалела Кизатова, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Жамбула, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Заградовский"
			}, {
				"ename": "УЛИЦА Жамбыл (Советская), СЕЛО Амангельдинское, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Жана, СЕЛО Тауагаш, СЕЛЬСКИЙ ОКРУГ Спасовский"
			}, {
				"ename": "УЛИЦА Жаркова, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Петровский"
			}, {
				"ename": "УЛИЦА Жастар, СЕЛО Орнек, СЕЛЬСКИЙ ОКРУГ Алматинский"
			}, {
				"ename": "ДОРОГА Жезказган-Петропавловск, СЕЛО Явленка, СЕЛЬСКИЙ ОКРУГ Явленский"
			}, {
				"ename": "УЛИЦА Жекеколь, СЕЛО Жекеколь, СЕЛЬСКИЙ ОКРУГ Петровский"
			}, {
				"ename": "УЛИЦА Жәлел Қизатов (Пер Советский), СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Актас, СЕЛЬСКИЙ ОКРУГ Булакский"
			}, {
				"ename": "УЛИЦА Жеңіс (Партизанская), СЕЛО Лузинка, СЕЛЬСКИЙ ОКРУГ Волошинский"
			}, {
				"ename": "УЛИЦА Жеңіс (Пионерская), СЕЛО Амангельдинское, СЕЛЬСКИЙ ОКРУГ Амангельдинский"
			}, {
				"ename": "УЛИЦА Жеңіс (Фурманова), СЕЛО Корнеевка, СЕЛЬСКИЙ ОКРУГ Корнеевский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Есильский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "БАЗА ОТДЫХА 1, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА 1 Мая, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА 1Разъезд, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА 3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА 429 Км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА 432 Км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА 5 Км, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Абая Кунанбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Абылай Хан, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Айтеке Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Акан Сери, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Акжол, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Акжол, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Александра Пушкина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Алихан Бокейханов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Алматы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Амангельды Иманов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Атк, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО АТК-УМС, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "МИКРОРАЙОН Батыс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Баубек Булкышев, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "МИКРОРАЙОН Бейбитшилик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Бирлик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Больница-2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Бригадная, СЕЛО Знаменка"
			}, {
				"ename": "УЛИЦА Ватутина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Московское"
			}, {
				"ename": "УЛИЦА Гагарина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Гарышкерлер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Горкомхоз, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Знаменка"
			}, {
				"ename": "БАЗА ОТДЫХА Гульдер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Депо-1, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Депо-2, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Депо-3, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Динмухаммеда Конаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Дорожник, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Достык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Енбекшилер, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Есиль, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ТРАССА Жаксы-Есиль-Бузулук, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Жамбыла Жабаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ТРАССА Жана жол, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "МИКРОРАЙОН Жастар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Женис, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Жибек жолы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Животноводческая, СЕЛО Аксай"
			}, {
				"ename": "НАБЕРЕЖНАЯ Ишим, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Ишхан Сарибекян, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Кажимукана Мунайтпасова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Казыбек Би, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Кайым Мухамедханов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Калинина, СЕЛО Знаменка"
			}, {
				"ename": "БАЗА ОТДЫХА Карлыгаш, СЕЛО Аксай"
			}, {
				"ename": "БАЗА ОТДЫХА Карлыгаш, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Каукен Кенжетаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО КБИ, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "ДАЧНОЕ ОБЩЕСТВО Керамзит, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Коммунистическая, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Знаменка"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Московское"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Аксай"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Космонавтов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Курылысшылар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Ленина, ПОСЕЛОК Красногорский"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Леонова, СЕЛО Знаменка"
			}, {
				"ename": "УЛИЦА Лесная, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Макаренко, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Маншук Маметова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Мира, ПОСЕЛОК Красногорский"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Московское"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Знаменка"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Мичурина, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Московское"
			}, {
				"ename": "УЛИЦА Московская, СЕЛО Знаменка"
			}, {
				"ename": "УЛИЦА Мухтара Ауэзова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Знаменка"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Московское"
			}, {
				"ename": "УЛИЦА Набережная, ПОСЕЛОК Красногорский"
			}, {
				"ename": "УЛИЦА Нестеренко, СЕЛО Знаменка"
			}, {
				"ename": "МИКРОРАЙОН Николая Самохвалова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Новая-2, СЕЛО Аксай"
			}, {
				"ename": "УЛИЦА Нуркена Абдирова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Озерная, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Орловка"
			}, {
				"ename": "УЛИЦА Октябрьская, ПОСЕЛОК Красногорский"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Знаменка"
			}, {
				"ename": "ПРОСПЕКТ Ондирис, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}, {
				"ename": "УЛИЦА Онтустик, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Есиль"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Ескельдинский, ОБЛАСТЬ Жетісу",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА 1-ШІ, СЕЛО Шымыр, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА 2-ШІ, СЕЛО Шымыр, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "ТЕРРИТОРИЯ №4 Бригада, СЕЛО Ешкиольмес, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА 8 Март, СЕЛО Актума, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА 8 Март, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА 8 Март, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Коныр, СЕЛЬСКИЙ ОКРУГ Конырский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Кокжазык, СЕЛЬСКИЙ ОКРУГ Кокжазыкский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Коктобе, СЕЛЬСКИЙ ОКРУГ Конырский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Сырымбет, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Ельтай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Акын Сара, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Жетысу, СЕЛЬСКИЙ ОКРУГ Толенгитский"
			}, {
				"ename": "УЛИЦА А.Байтұрсынов, СЕЛО Тамбала, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шымыр, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Айдаболов, СЕЛО Жетысу, СЕЛЬСКИЙ ОКРУГ Толенгитский"
			}, {
				"ename": "УЛИЦА Айдар Би, СЕЛО Каратал, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Ақан Сері, СЕЛО Кокжазык, СЕЛЬСКИЙ ОКРУГ Кокжазыкский"
			}, {
				"ename": "УЛИЦА Акименко, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Аққайың (К.Цеткин), СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Аққайың, СЕЛО Коржымбай, СЕЛЬСКИЙ ОКРУГ Кайнарлинский"
			}, {
				"ename": "УЛИЦА Ақық Нұрманбетов, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Ақылбеков Бауыржан, СЕЛО Ельтай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Сырымбет, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Алатау (Нахимова), СЕЛО Ешкиольмес, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Алдабергенов Нұрмолда, СЕЛО Алдабергенов, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Алипов, СЕЛО Жалгызагаш, СЕЛЬСКИЙ ОКРУГ Жалгызагашский"
			}, {
				"ename": "УЛИЦА Алмабала Жетписбайқызы, СЕЛО Каратал, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Алмалы, СЕЛО Актасты, СЕЛЬСКИЙ ОКРУГ Кайнарлинский"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Алмалы, СЕЛО Алмалы, СЕЛЬСКИЙ ОКРУГ Конырский"
			}, {
				"ename": "УЛИЦА Алтынсарин, СЕЛО Актума, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА Алтынсарина, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "НАБЕРЕЖНАЯ Амангелді, СЕЛО Алдабергенов, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Амангелді, СЕЛО Отенай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Амангелді, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Амангелді, СЕЛО Ельтай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Амангелді, СЕЛО Матай Байысов, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Амангелді, СЕЛО Боктерли, СЕЛЬСКИЙ ОКРУГ Кокжазыкский"
			}, {
				"ename": "УЛИЦА Амангелді, СЕЛО Коныр, СЕЛЬСКИЙ ОКРУГ Конырский"
			}, {
				"ename": "УЛИЦА Асанбаев Базарбай, СЕЛО Жаналык, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Асанова, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Асылбеков, СЕЛО Алдабергенов, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Аубакирова, СЕЛО Шымыр, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Базарбай Асанов, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Байкал, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Байысов Матай, СЕЛО Алдабергенов, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Бақтыбай, СЕЛО Ельтай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Бақтыбай, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бақтыбай, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бақтыбай, СЕЛО Матай Байысов, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бақтыбай, СЕЛО Жалгызагаш, СЕЛЬСКИЙ ОКРУГ Жалгызагашский"
			}, {
				"ename": "УЛИЦА Бақтыбай Жолбарысұлы, СЕЛО Алдабергенов, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Бақтыбай Жолбарысұлы, СЕЛО Екпинди, СЕЛЬСКИЙ ОКРУГ Толенгитский"
			}, {
				"ename": "УЛИЦА Бақты Ниязбеков, СЕЛО Жастар, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Балқаш (Балхаш), СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Балпық Би, СЕЛО Сырымбет, СЕЛЬСКИЙ ОКРУГ Сырымбетский"
			}, {
				"ename": "УЛИЦА Балпық Би, СЕЛО Алдабергенов, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Балпық Би, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Балтабай Абдрахманов, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Бауржан Момышұлы, СЕЛО Жетысу, СЕЛЬСКИЙ ОКРУГ Толенгитский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Абай, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Коктобе, СЕЛЬСКИЙ ОКРУГ Конырский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Матай Байысов, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Жалгызагаш, СЕЛЬСКИЙ ОКРУГ Жалгызагашский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Теректы, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Бейсен Ысқақов, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Бердібек Соқпақбаев, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Береке (Свердлова), СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бикен Римова, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Біржан Сал, СЕЛО Акын Сара, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Шымыр, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Бірлік, СЕЛО Матай Байысов, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бірлік, СЕЛО Коржымбай, СЕЛЬСКИЙ ОКРУГ Кайнарлинский"
			}, {
				"ename": "УЛИЦА Б.Момышұлы, СЕЛО Акын Сара, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА Б.Момышұлы, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Б.Нұрманбетов, СЕЛО Кайнарлы, СЕЛЬСКИЙ ОКРУГ Кайнарлинский"
			}, {
				"ename": "УЛИЦА Бөгенбай Батыр, СЕЛО Акын Сара, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЛИЦА Болашақ, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Бопау Батыр, СЕЛО Теректы, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Боранбаев Еділ, СЕЛО Жастар, СЕЛЬСКИЙ ОКРУГ Алдабергеновский"
			}, {
				"ename": "УЛИЦА Бұқар жырау, СЕЛО Акешки, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "УЧАСТОК Водозабор, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "ТЕРРИТОРИЯ Водохранилище, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Вторая, СЕЛО Бактыбай, СЕЛЬСКИЙ ОКРУГ Бактыбайский"
			}, {
				"ename": "УЛИЦА Габбаса Укеева, СЕЛО Кайнарлы, СЕЛЬСКИЙ ОКРУГ Кайнарлинский"
			}, {
				"ename": "УЛИЦА Ғабиден, СЕЛО Коныр, СЕЛЬСКИЙ ОКРУГ Конырский"
			}, {
				"ename": "УЛИЦА Гагарин, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Ғали Орманов, СЕЛО Жалгызагаш, СЕЛЬСКИЙ ОКРУГ Жалгызагашский"
			}, {
				"ename": "УЛИЦА Гарышкер, СЕЛО Шымыр, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Ғарышкер, СЕЛО Теректы, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Герцена, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Ғ.Жұбанова, СЕЛО Кайнарлы, СЕЛЬСКИЙ ОКРУГ Кайнарлинский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}, {
				"ename": "УЛИЦА Ғ.Орманов, СЕЛО Акешки, СЕЛЬСКИЙ ОКРУГ Акын Сара"
			}, {
				"ename": "СТАНЦИЯ Гэс, СЕЛО Каратал, СЕЛЬСКИЙ ОКРУГ Каратальский"
			}, {
				"ename": "УЛИЦА Даиров, СЕЛО Карабулак, СЕЛЬСКИЙ ОКРУГ Карабулакский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жаксынский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "САДОВОДЧЕСКИЙ КОМПЛЕКС 003 кв, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Абай (Комсомольская), СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Абай (Ленина), СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА А.Иманова, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Аубакирова, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Ауезова, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Байтерек, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы (Комсомольская), СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Береке, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Бирлик, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Чапаевское"
			}, {
				"ename": "УЛИЦА Дзержинского, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Жаксы"
			}, {
				"ename": "ПЕРЕУЛОК Дорожный, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Жаксы"
			}, {
				"ename": "ТРАССА Екатеринбург-Алматы, СЕЛО Жаксы"
			}, {
				"ename": "ДОРОГА Жаксы-Есиль-Бузулук, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Жамбула, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Жангельдина, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Жансугурова, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Жибек жолы, СЕЛО Чапаевское"
			}, {
				"ename": "УЛИЦА Западная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Иманова, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Кали Еспенбетулы, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Кенесары (Советская), СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Кенжеша Туктубаева, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Кирова, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Коктем, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Магжан Жумабаев (К.Маркса), СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Майкутова, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Майлина, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Мереке, СЕЛО Жаксы"
			}, {
				"ename": "МИКРОРАЙОН Микрорайон, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА М.Маметовой, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Московская, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Набережная, СЕЛО Чапаевское"
			}, {
				"ename": "УЛИЦА Новая, СЕЛО Чапаевское"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Октябрьская, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Орталык, СЕЛО Чапаевское"
			}, {
				"ename": "УЛИЦА Парковая, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Пионерская, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Рагузова, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Сарыарка, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Сарыарка, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Северная, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Сейтжана Жакупова, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Сейфуллина, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Советская, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Сортоучасток, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Степная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Строительная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Тауелсиздик, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Транспортная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Фрунзе, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Киевское"
			}, {
				"ename": "УЛИЦА Целинная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Белагаш"
			}, {
				"ename": "УЛИЦА Школьная, СЕЛО Подгорное"
			}, {
				"ename": "УЛИЦА Элеваторная, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА Энергетиков, СЕЛО Жаксы"
			}, {
				"ename": "УЛИЦА 22 Партсъезда, СЕЛО Кайракты, СЕЛЬСКИЙ ОКРУГ Беловодский"
			}, {
				"ename": "УЛИЦА 25 лет Целины, СЕЛО Тарасовка, СЕЛЬСКИЙ ОКРУГ Тарасовский"
			}, {
				"ename": "УЛИЦА 30 лет Победы, СЕЛО Кайракты, СЕЛЬСКИЙ ОКРУГ Беловодский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Ишимское, СЕЛЬСКИЙ ОКРУГ Ишимский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Моховое, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Перекатное, СЕЛЬСКИЙ ОКРУГ Беловодский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Алгабас, СЕЛЬСКИЙ ОКРУГ Жанакийминский"
			}, {
				"ename": "ПЕРЕУЛОК Агрономический, СЕЛО Новокиенка, СЕЛО Новокиенский"
			}, {
				"ename": "УЛИЦА Акан Сери, СЕЛО Кировское, СЕЛЬСКИЙ ОКРУГ Кызылсайский"
			}, {
				"ename": "УЛИЦА Ал-Фараби (Октябрьская), СЕЛО Моховое, СЕЛЬСКИЙ ОКРУГ Калининский"
			}, {
				"ename": "УЛИЦА Аркаринская, СЕЛО Лозовое, СЕЛЬСКИЙ ОКРУГ Запорожский"
			}, {
				"ename": "УЛИЦА Атамекен (Целинная), СЕЛО Кировское, СЕЛЬСКИЙ ОКРУГ Кызылсайский"
			}, {
				"ename": "УЛИЦА Бабичева, СЕЛО Кийма, СЕЛЬСКИЙ ОКРУГ Жанакийминский"
			}, {
				"ename": "УЛИЦА Баубек батыр, СЕЛО Ишимское, СЕЛЬСКИЙ ОКРУГ Ишимский"
			}, {
				"ename": "УЛИЦА БАУБЕК-БАТЫРА, СЕЛО Жана Кийма, СЕЛЬСКИЙ ОКРУГ Жанакийминский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жалагашский, ОБЛАСТЬ Кызылординская",
			"addressName": [{
				"ename": "УЛИЦА Абай, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА А Байсопаков, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Абдулла Нургалиев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Абшекена Абжаппарова, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА А Изтелеуова, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Айтбай Казыбеков, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Айтбай Кузенбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Айтеке Би, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА АҚНАЗАР БЕКТАСОВ (9 Улица), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "ПЕРЕУЛОК АҚПАН БАТЫР (Ибрай Алтынсарин), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЧАСТОК Актерек, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Алдаберген Бисенов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Амангельди Иманов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Амандык Бектибаева, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "ПЕРЕУЛОК АХМЕТ ТІЛЕУЛИЕВ (Абай), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Аяган Боханов (1 коше), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Болат Алтынбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Б Соппеков, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Бухарбай Естекбайулы, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Гани Муратбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Дауимбай, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА ДАУЫЛБАЙ БАЙНИЯЗОВ, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА ДОСБОЛ ҚУАНБАЕВ, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Дэу, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА ЕРДӘУЛЕТ ҚҰРМАНБАЕВ (Строительная), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Жамбыл Жабаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Жана, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Желтоксан, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Зияда Ижанова, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "ПЕРЕУЛОК ЗОРДАН САЛЫҚБАЕВ (Толеген Кистаубаев), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Ибрай Алтынсарин, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Ильяс Кабылов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Ильяс Нуркенов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Казыбек Би, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Кали Мусилимулы Нурпеисов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Каныш Сатпаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Келменбет батыра, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЧАСТОК Кисыкарык, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Конституция, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА К Рахимов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Мадибай Байтореев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Маншук Маметова, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА МАХМЕТХАН ӘБІШЕВ (2 коше), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Морали Шаменов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Мубарак Тайтиков, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Мысык би, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Назтай Сермахановой, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Н Алмаганбетов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Несипбай Апрезов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Нефтебаза, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Ныгмет Мырзалиев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Нысанбай жырау, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Омирбай Шешен, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Омирзак Тунгишбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Орынбай Сарманов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Панфилов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА ПІРМАН ЖЫЛКЕЛДИЕВ, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА ПМК-9, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЧАСТОК Полигон, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Сакен Сейфуллин, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Сакыбай Калыбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Сарке Батыр, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА САУДА ОРМАНОВ, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "ПЕРЕУЛОК СЕЙТНӘБИ МҰҚАШЕВ (Ныгмет Мырзалиев), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Сырмагамбет Отарбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Темирбек Жургенов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Тилек Абжалиев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Тоганас Батыр, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Толе би, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Толеген Кистаубаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Т Уркимбаев, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "ПЕРЕУЛОК ҰЛМЕКЕН ТӨЛЕГЕНОВА (Октябрь), ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Улы Женистин 50 жылдыгы, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Шокан Уалиханов, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Шонбай Акын, ПОСЕЛОК Жалагаш"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Жанадария, СЕЛЬСКИЙ ОКРУГ Жанадарьинский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Аккум, СЕЛЬСКИЙ ОКРУГ Аккумский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Мадениет, СЕЛЬСКИЙ ОКРУГ Мадениетский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Каракеткен, СЕЛЬСКИЙ ОКРУГ Каракеткенский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Тан, СЕЛЬСКИЙ ОКРУГ Танский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО М.Шаменова, СЕЛЬСКИЙ ОКРУГ имени М.Шаменова"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Бухарбай Батыра, СЕЛЬСКИЙ ОКРУГ имени Бухарбай Батыра"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Аккошкар, СЕЛЬСКИЙ ОКРУГ Енбекский"
			}, {
				"ename": "УЛИЦА Абдилда Жургенбаев, СЕЛО Мырзабай Ахун, СЕЛЬСКИЙ ОКРУГ Мырзабай Ахуна"
			}, {
				"ename": "УЛИЦА Абдихалык Куттыбаева, СЕЛО Темирбек Жургенов, СЕЛЬСКИЙ ОКРУГ Макпалкольский"
			}, {
				"ename": "УЛИЦА Абдрахман Ташимбетов, СЕЛО М.Шаменова, СЕЛЬСКИЙ ОКРУГ имени М.Шаменова"
			}, {
				"ename": "УЛИЦА Абдрашид Бердаулетов, СЕЛО Бухарбай Батыра, СЕЛЬСКИЙ ОКРУГ имени Бухарбай Батыра"
			}, {
				"ename": "УЛИЦА Абжалел Кожабаев, СЕЛО Жанаталап, СЕЛЬСКИЙ ОКРУГ Жанаталапский"
			}, {
				"ename": "УЛИЦА Абылайхан, СЕЛО М.Шаменова, СЕЛЬСКИЙ ОКРУГ имени М.Шаменова"
			}, {
				"ename": "УЛИЦА Адиса  Ахетулы, СЕЛО Аккыр, СЕЛЬСКИЙ ОКРУГ Аккырский"
			}, {
				"ename": "УЛИЦА Аимкуль Изтлеуова, СЕЛО Бухарбай Батыра, СЕЛЬСКИЙ ОКРУГ имени Бухарбай Батыра"
			}, {
				"ename": "УЛИЦА АЙНАШ БАЛҒАБАЕВА, СЕЛО Мадениет, СЕЛЬСКИЙ ОКРУГ Мадениетский"
			}, {
				"ename": "УЛИЦА Акарык, СЕЛО Аксу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЛИЦА Акарык, СЕЛО Есет Батыр, СЕЛЬСКИЙ ОКРУГ Аламесекский"
			}, {
				"ename": "УЛИЦА Акбогет, СЕЛО Аксу, СЕЛЬСКИЙ ОКРУГ Аксуский"
			}, {
				"ename": "УЛИЦА Акжарма, СЕЛО Есет Батыр, СЕЛЬСКИЙ ОКРУГ Аламесекский"
			}, {
				"ename": "УЛИЦА Акколка, СЕЛО Сатбай, СЕЛЬСКИЙ ОКРУГ Жанадарьинский"
			}, {
				"ename": "УЧАСТОК Аккум, СЕЛО Аккум, СЕЛЬСКИЙ ОКРУГ Аккумский"
			}, {
				"ename": "УЛИЦА Аккум, СЕЛО Аккум, СЕЛЬСКИЙ ОКРУГ Аккумский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жамбылский, ОБЛАСТЬ Жамбылская",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, СЕЛО Орнек, СЕЛЬСКИЙ ОКРУГ Орнекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, СЕЛО Орнек, СЕЛЬСКИЙ ОКРУГ Орнекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, СЕЛО Кумсуат, СЕЛЬСКИЙ ОКРУГ Тогызтарауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, СЕЛО Ерназар, СЕЛЬСКИЙ ОКРУГ Ерназарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 005, СЕЛО Орнек, СЕЛЬСКИЙ ОКРУГ Орнекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 008, СЕЛО Сулутор, СЕЛЬСКИЙ ОКРУГ Каройский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Ащыбулак, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Шайдана, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Ащыбулак, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Ащыбулак, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Гродеково, СЕЛЬСКИЙ ОКРУГ Гродековский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 012, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Тогызтарау, СЕЛЬСКИЙ ОКРУГ Тогызтарауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 014, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 015, СЕЛО Рахат, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 016, СЕЛО Шокай, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, СЕЛО Кумтиын, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 017, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Жалпактобе, СЕЛЬСКИЙ ОКРУГ Полаткосшынский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Ащыбулак, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Бирлесу-Енбек, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Гродеково, СЕЛЬСКИЙ ОКРУГ Гродековский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 018, СЕЛО Шокай, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Бирлесу-Енбек, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Акбулым, СЕЛЬСКИЙ ОКРУГ Акбулымский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Бирлесу-Енбек, СЕЛЬСКИЙ ОКРУГ Акбастауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 020, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Енбек, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, РАЗЪЕЗД 27, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 022, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Жамбыла, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 024, СЕЛО Костобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Енбек, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Аса, СЕЛЬСКИЙ ОКРУГ Асинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Костобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, СЕЛО Орнек, СЕЛЬСКИЙ ОКРУГ Орнекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СТАНЦИЯ Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 028, СЕЛО Коныртобе, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, СЕЛО Шакен Ниязбеков, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, СЕЛО Тастобе, СЕЛЬСКИЙ ОКРУГ Колкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, СЕЛО Капал, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 032, СЕЛО Шакен Ниязбеков, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Коныртобе, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СТАНЦИЯ Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Шайдана, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, СЕЛО Шайдана, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 034, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 037, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 037, СЕЛО Каратау, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 039, СЕЛО Шайкорык, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 040, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 041, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 042, СЕЛО Акбулым, СЕЛЬСКИЙ ОКРУГ Акбулымский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 043, СЕЛО Акбулым, СЕЛЬСКИЙ ОКРУГ Акбулымский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 044, СЕЛО Акбулым, СЕЛЬСКИЙ ОКРУГ Акбулымский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, СЕЛО Акбулым, СЕЛЬСКИЙ ОКРУГ Акбулымский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 045, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 046, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 046, СЕЛО Бектобе, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Кызылшарык, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 047, СЕЛО Бектобе, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Бектобе, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 048, СЕЛО Байтерек, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, СЕЛО Каракемер, СЕЛЬСКИЙ ОКРУГ Каракемерский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 050, СЕЛО Бектобе, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 057, СЕЛО Кызылкайнар, СЕЛЬСКИЙ ОКРУГ Кызылкайнарский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 058, СЕЛО Бектобе, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 058, СЕЛО Кызылшарык, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 058, СЕЛО Байтерек, СЕЛЬСКИЙ ОКРУГ Каратобинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 059, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 060, СЕЛО Аулиеколь, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 060, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 061, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 065, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 066, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 067, СЕЛО Айшабиби, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 067, СЕЛО Аулиеколь, СЕЛЬСКИЙ ОКРУГ Айшабибинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жамбылский, ОБЛАСТЬ Алматинская",
			"addressName": [{
				"ename": "МИКРОРАЙОН №1, СЕЛО Улкен, СЕЛЬСКИЙ ОКРУГ Улькенский"
			}, {
				"ename": "МИКРОРАЙОН 1 Микрорайон, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "МИКРОРАЙОН 2 Микрорайон, СЕЛО Улкен, СЕЛЬСКИЙ ОКРУГ Улькенский"
			}, {
				"ename": "МИКРОРАЙОН №5, СЕЛО Улкен, СЕЛЬСКИЙ ОКРУГ Улькенский"
			}, {
				"ename": "МИКРОРАЙОН №6, СЕЛО Улкен, СЕЛЬСКИЙ ОКРУГ Улькенский"
			}, {
				"ename": "УЛИЦА 6 Хатка, СЕЛО Танбалытас, СЕЛЬСКИЙ ОКРУГ Матыбулакский"
			}, {
				"ename": "УЛИЦА А. Ақшалов, СЕЛО Аккайнар, СЕЛЬСКИЙ ОКРУГ Аккайнарский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Ынтымак, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Айдарлы, СЕЛЬСКИЙ ОКРУГ Айдарлынский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Бериктас, СЕЛЬСКИЙ ОКРУГ Бериктасский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Шилибастау, СЕЛЬСКИЙ ОКРУГ Матыбулакский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Абай, СТАНЦИЯ Казыбек бек, СЕЛЬСКИЙ ОКРУГ Темиржолский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Матыбулак, СЕЛЬСКИЙ ОКРУГ Матыбулакский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Балгабек Кыдырбекулы, СЕЛЬСКИЙ ОКРУГ Таранский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Каракыстак, СЕЛЬСКИЙ ОКРУГ Каракыстакский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Дегерес, СЕЛЬСКИЙ ОКРУГ Дегересский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Бозой, СЕЛЬСКИЙ ОКРУГ Бозойский"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, СЕЛО Мынбаев, СЕЛЬСКИЙ ОКРУГ Мынбаевский"
			}, {
				"ename": "УЛИЦА А Байтұрсынов, СЕЛО Матыбулак, СЕЛЬСКИЙ ОКРУГ Матыбулакский"
			}, {
				"ename": "УЛИЦА Абдразака Мами, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Абылайхан, СТАНЦИЯ Казыбек бек, СЕЛЬСКИЙ ОКРУГ Темиржолский"
			}, {
				"ename": "УЛИЦА Абылай Хан, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Абылай Хан, СЕЛО Бериктас, СЕЛЬСКИЙ ОКРУГ Бериктасский"
			}, {
				"ename": "УРОЧИЩЕ Адыр, СТАНЦИЯ Казыбек бек, СЕЛЬСКИЙ ОКРУГ Темиржолский"
			}, {
				"ename": "УЛИЦА Ажибая Жанкойлыкова, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Айдарлы, СЕЛО Сарыбай би, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Айдарлы, СЕЛО Карасай, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Айдарлы, СЕЛО Айдарлы, СЕЛЬСКИЙ ОКРУГ Айдарлынский"
			}, {
				"ename": "УЛИЦА Айдос, СЕЛО Аркарлы, СЕЛЬСКИЙ ОКРУГ Актерекский"
			}, {
				"ename": "УЛИЦА Айтжан Кушербаев, СТАНЦИЯ Казыбек бек, СЕЛЬСКИЙ ОКРУГ Темиржолский"
			}, {
				"ename": "УЛИЦА Айтқұловтар, СЕЛО Бесмойнак, СЕЛЬСКИЙ ОКРУГ Дегересский"
			}, {
				"ename": "УЛИЦА Айтұмар, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Айтұмар, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Айтұмар, СЕЛО Жанакурылыс, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақбарыс, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақ Бата, СЕЛО Касымбек, СЕЛЬСКИЙ ОКРУГ Шолаккаргалинский"
			}, {
				"ename": "УЛИЦА Ақбосаға, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақ Босаға, СЕЛО Жанакурылыс, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақбұлақ, СЕЛО Шиен, СЕЛЬСКИЙ ОКРУГ Шиенский"
			}, {
				"ename": "УЛИЦА Ақбұлақ, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақдала, СЕЛО Кайназар, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Ақ Дала, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақжайық, СЕЛО Сарыбастау, СЕЛЬСКИЙ ОКРУГ Унгиртасский"
			}, {
				"ename": "УЛИЦА Ақжайық, СЕЛО Сарыбай би, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Ақжайық, СЕЛО Мынбаев, СЕЛЬСКИЙ ОКРУГ Мынбаевский"
			}, {
				"ename": "УЛИЦА Ақ Жайық, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақ Жайық, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Акжар, СЕЛО Жанакурылыс, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Жайсан, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Карасай, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Сарыбай би, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Ақжар, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақжол, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Аккайнар, СЕЛО Касымбек, СЕЛЬСКИЙ ОКРУГ Шолаккаргалинский"
			}, {
				"ename": "УЛИЦА Аққайнар, СЕЛО Карасай, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Аққайнар, СЕЛО Сарыбай би, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Аққайнар, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақ Қайнар, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақкесік, СЕЛО Жайсан, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақкесік, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Акорда, СТАНЦИЯ Казыбек бек, СЕЛЬСКИЙ ОКРУГ Темиржолский"
			}, {
				"ename": "УЛИЦА Ақорда, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақорда, СЕЛО Жайсан, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақорда, СЕЛО Жанакурылыс, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақорда, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақ Орда, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "КРЕСТЬЯНСКОЕ ХОЗЯЙСТВО Ақсеңгір, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақсу, СЕЛО Мынбаев, СЕЛЬСКИЙ ОКРУГ Мынбаевский"
			}, {
				"ename": "УЛИЦА Ақсуат, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақтайлақ, СЕЛО Кайназар, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Ақтам, СЕЛО Жайсан, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақтам, СЕЛО Аксенгир, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Ақтам, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақтасты, СЕЛО Карасай, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Ақтасты, СЕЛО Кайназар, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Акуа Аралбайулы, СЕЛО Жамбыл, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА А Құнанбаев, СЕЛО Ульгили, СЕЛЬСКИЙ ОКРУГ Ульгилинский"
			}, {
				"ename": "УЛИЦА Ақшалов, СЕЛО Коккайнар, СЕЛЬСКИЙ ОКРУГ Унгиртасский"
			}, {
				"ename": "УЛИЦА Ақшатыр, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Ақ Шатыр, СЕЛО Жанакурылыс, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Ақши, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Алатас, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Кокдала, СЕЛЬСКИЙ ОКРУГ Аксенгирский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Жанакурылыс, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Шиен, СЕЛЬСКИЙ ОКРУГ Шиенский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Касымбек, СЕЛЬСКИЙ ОКРУГ Шолаккаргалинский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Сарыбай би, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Мынбаев, СЕЛЬСКИЙ ОКРУГ Мынбаевский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Самсы, СЕЛЬСКИЙ ОКРУГ Самсынский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Узынагаш, СЕЛЬСКИЙ ОКРУГ Узынагашский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Балгабек Кыдырбекулы, СЕЛЬСКИЙ ОКРУГ Таранский"
			}, {
				"ename": "УЛИЦА Алатау, СЕЛО Карасай, СЕЛЬСКИЙ ОКРУГ Карасуский"
			}, {
				"ename": "УЛИЦА Алатау 2, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}, {
				"ename": "УЛИЦА Алау, СЕЛО Каргалы, СЕЛЬСКИЙ ОКРУГ Каргалинский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жамбылский, ОБЛАСТЬ Северо-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 8 Марта, СЕЛО Мирное, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА 9 Мая, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Светлое, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Казанка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Озерное, СЕЛЬСКИЙ ОКРУГ Озерный"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Рождественка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Богдановка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Hовое, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Айымжан, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "ПЕРЕУЛОК Абая, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "ПЕРЕУЛОК Абая, СЕЛО Майбалык, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА АБУ ФАЙЗУЛИНА, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Абылай хана, СЕЛО Каракамыс, СЕЛЬСКИЙ ОКРУГ Озерный"
			}, {
				"ename": "УЛИЦА Аккусак, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Майбалыкский"
			}, {
				"ename": "УЛИЦА Алматинская, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Амангельды, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Амреша Дарменова, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Амреша Дарменова, СЕЛО Озерное, СЕЛЬСКИЙ ОКРУГ Озерный"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Орталык, СЕЛЬСКИЙ ОКРУГ Троицкий"
			}, {
				"ename": "УЛИЦА Астаны, СЕЛО Есперли, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Балта, СЕЛО Баян, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА Батыра, СЕЛО Сабит, СЕЛЬСКИЙ ОКРУГ Майбалыкский"
			}, {
				"ename": "УЛИЦА Батырева, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Баян, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Озерное, СЕЛЬСКИЙ ОКРУГ Озерный"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Чапаевка, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Буденное, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Украинское, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Симаки, СЕЛЬСКИЙ ОКРУГ Кладбинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Кабань, СЕЛЬСКИЙ ОКРУГ Первомайский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Hовое, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Богдановка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Святодуховка, СЕЛЬСКИЙ ОКРУГ Майбалыкский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Лапушки, СЕЛЬСКИЙ ОКРУГ Железенский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Кайранколь, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Hоворыбинка, СЕЛЬСКИЙ ОКРУГ Кладбинский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Казанка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Екатериновка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Макарьевка, СЕЛЬСКИЙ ОКРУГ Пресноредутский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Пресноредуть, СЕЛЬСКИЙ ОКРУГ Пресноредутский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Ястребинка, СЕЛЬСКИЙ ОКРУГ Пресноредутский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Железное, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "ПЕРЕУЛОК Береговая, СЕЛО Железное, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Береговая, СЕЛО Архангелка, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА Березовка, СЕЛО Троицкое, СЕЛЬСКИЙ ОКРУГ Троицкий"
			}, {
				"ename": "УЛИЦА Больничная, СЕЛО Пресноредуть, СЕЛЬСКИЙ ОКРУГ Пресноредутский"
			}, {
				"ename": "ПЕРЕУЛОК Больничный, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Бостандыкская, СЕЛО Суатколь, СЕЛЬСКИЙ ОКРУГ Жамбылский"
			}, {
				"ename": "УЛИЦА Бригадная, СЕЛО Кладбинка, СЕЛЬСКИЙ ОКРУГ Кладбинский"
			}, {
				"ename": "ПЕРЕУЛОК Валиханова, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Верхняя, СЕЛО Сенжарка, СЕЛЬСКИЙ ОКРУГ Кладбинский"
			}, {
				"ename": "УЛИЦА Виктора Довженко, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Водопроводная, СЕЛО Муромское, СЕЛЬСКИЙ ОКРУГ Баянаульский"
			}, {
				"ename": "ПЕРЕУЛОК Водопроводный, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Воропаева, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Воропаева, СЕЛО Пресноредуть, СЕЛЬСКИЙ ОКРУГ Пресноредутский"
			}, {
				"ename": "УЛИЦА Восточная, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "ПЕРЕУЛОК Габита Мусрепова, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Украинское, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Кайранколь, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Казанка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Габита Мусрепова, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Майбалыкский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Екатериновка, СЕЛЬСКИЙ ОКРУГ Казанский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Рождественка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Кайранколь, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Украинское, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Архангелка, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "ПЕРЕУЛОК Гайдара, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Гоголя, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "ПЕРЕУЛОК Горького, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Горького, СЕЛО Мирное, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Громовой, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Дальняя, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Дачная, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Джамбула, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "ПЕРЕУЛОК Дзержинского, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "УЛИЦА Дорожная, СЕЛО Благовещенка, СЕЛЬСКИЙ ОКРУГ Благовещенский"
			}, {
				"ename": "ПЕРЕУЛОК Дорожный, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Баян, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Айтуар, СЕЛЬСКИЙ ОКРУГ Архангельский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Пресновка, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Железное, СЕЛЬСКИЙ ОКРУГ Пресновский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Лапушки, СЕЛЬСКИЙ ОКРУГ Железенский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Узынколь, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Рождественка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "ПЕРЕУЛОК Дружбы, СЕЛО Украинское, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Баумана, СЕЛЬСКИЙ ОКРУГ Озерный"
			}, {
				"ename": "УЛИЦА Дружбы, СЕЛО Петровка, СЕЛЬСКИЙ ОКРУГ Мирный"
			}, {
				"ename": "УЛИЦА Дружная, СЕЛО Кайранколь, СЕЛЬСКИЙ ОКРУГ Кайранкольский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жанааркинский, ОБЛАСТЬ Ұлытау",
			"addressName": [{
				"ename": "УЧЕТНЫЙ КВАРТАЛ 001, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 002, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 003, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 004, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 006, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 007, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "ИМУЩЕСТВЕННЫЙ КОМПЛЕКС 1, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "КВАРТАЛ 1-ый Иртышский, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН 4, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН 6, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН 7, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Абила Байбосынова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА А.Даулетбеков, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Ақселеу Сланұлы Сейдімбеков, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА А.Оспановой, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Аралбай батыра, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Атасуйская, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Ахметжанова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Байгозы батыра, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Байдалы би, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Б.Аймуханова, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Бала баксы, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "ПЕРЕУЛОК Бейбітшілік, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Бейбітшілік (Мира), ПОСЕЛОК Кызылжар"
			}, {
				"ename": "ГАРАЖНЫЙ МАССИВ Бекет, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Бірлік, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Б. Кужекенова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Б.Майлина, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Боранбая Бекбосынова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Б.Сагинтаев, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Даму, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Даулетбекова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Достық, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Ералиева, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Жамбыла, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "КВАРТАЛ Жананур (006), ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "ДАЧНЫЙ МАССИВ Жасыл Желек, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "КВАРТАЛ Жолкен Дуйсенов, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Ж.Садвакасова, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Ж.Садыкбекова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА К.Абжанова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН Қанат Байшолақов (3), ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Караагаш, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА К.Байдаулетов, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Қоңырбай Асанов, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН Күшікбай батыр (1), ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "ТРАССА Қызылорда Павлодар, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "ТРАССА Қызылорда Павлодар, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Мұса Амзе, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Н.Абдирова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Нияз батыра, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН Нұрбай батыр (5), ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Орманбаева, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА П.Мухамеджана, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Пушкина, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Садвакасова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "КВАРТАЛ Сарыарқа, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "ЖИЛОЙ МАССИВ Сарыарқа, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Сарысуйская, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Сары тока, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Саябақ, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "ПРОСПЕКТ С.Сейфуллина, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Тәуелсіздік (40 лет Победы), ПОСЕЛОК Кызылжар"
			}, {
				"ename": "ПРОСПЕКТ Тәуелсіздік, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Т.Игликова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Трутько, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Туребай Смаилов, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА У.Абжанова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ УЧЕТНЫЙ КВАРТАЛ 005, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ УЧЕТНЫЙ КВАРТАЛ 033, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Шамши Усенов, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Ш.Ералиев, ПОСЕЛОК Кызылжар"
			}, {
				"ename": "УЛИЦА Шоң Телғозыұлы, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЛИЦА Ш.Уалиханова, ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "МИКРОРАЙОН Ыдырыс Жұмабеков (2), ПОСЕЛОК Жаңаарқа"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 009, СЕЛО Айнабулак, СЕЛЬСКИЙ ОКРУГ Айнабулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 010, СЕЛО Айнабулак, СЕЛЬСКИЙ ОКРУГ Айнабулакский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Талдыбулак, СЕЛЬСКИЙ ОКРУГ Талдыбулак"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 011, СЕЛО Тугускен, СЕЛЬСКИЙ ОКРУГ Тугускенский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 013, СЕЛО Бидайык, СЕЛЬСКИЙ ОКРУГ Бидайыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО Байгул, СЕЛЬСКИЙ ОКРУГ Мукажана Жумажанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 019, СЕЛО М.Жумажанова, СЕЛЬСКИЙ ОКРУГ Мукажана Жумажанова"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 021, СЕЛО Орынбай, СЕЛЬСКИЙ ОКРУГ Орынбай"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Атасу, СЕЛЬСКИЙ ОКРУГ Байдалы Бийский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 023, СЕЛО Талдыбулак, СЕЛЬСКИЙ ОКРУГ Талдыбулак"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 025, СЕЛО Актау, СЕЛЬСКИЙ ОКРУГ Актауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 026, СЕЛО Актау, СЕЛЬСКИЙ ОКРУГ Актауский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СТАНЦИЯ Мынадыр, СЕЛЬСКИЙ ОКРУГ Актубекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Уркендеу, СЕЛЬСКИЙ ОКРУГ Актубекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СТАНЦИЯ Атасу, СЕЛЬСКИЙ ОКРУГ Актубекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 027, СЕЛО Актубек, СЕЛЬСКИЙ ОКРУГ Актубекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 029, СЕЛО Интымак, СЕЛЬСКИЙ ОКРУГ С.Сейфуллинский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 031, СЕЛО Ералиев, СЕЛЬСКИЙ ОКРУГ Ералиевский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СТАНЦИЯ Атасу, СЕЛЬСКИЙ ОКРУГ Актубекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Актубек, СЕЛЬСКИЙ ОКРУГ Актубекский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 033, СЕЛО Бидайык, СЕЛЬСКИЙ ОКРУГ Бидайыкский"
			}, {
				"ename": "УЧЕТНЫЙ КВАРТАЛ 038 кв, СЕЛО М.Жумажанова, СЕЛЬСКИЙ ОКРУГ Мукажана Жумажанова"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жанакорганский, ОБЛАСТЬ Кызылординская",
			"addressName": [{
				"ename": "РАЗЪЕЗД № 25, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Абай Кунанбаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Абдикадыр Хайникеев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Абдиманап Абылахов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Абдисултан Ержигитов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Абдулла Алтый Сулеймен, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА АБИШ ШОКЫБАЕВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Абылайхан, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА Айдархан Ержанов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Айтмаганбет Накыпов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Акмешит, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алаш Жаппасов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алгашбек Шаухаманов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алдамжар Мухаммеджанов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алдан Аюпов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Александр Романов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алиаскар Султанов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Али Еламанов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Али Исаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алимколь, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Али Токсанбаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Алшекей Бектибаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Аль-Фараби, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА Аманбай Шонабаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "ТУПИК Амангельди, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "ПРОСПЕКТ Амангельди Иманов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА АМАНТАЙ САТБЕКОВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Аметжан Байниязов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Амир Мажитов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Анарбек Асанов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ануар Абуталипов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Арасат Файзуллаулы, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Асилбек Кошкаров, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА Ахмедия Пахырдинов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ахметжан Жанпеисов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА АХМЕТ ШЫНТАЕВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Байдуйсен Досымулы, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Батырхан Сейтов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Бегайдар Аралбаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Беимбет Майлин, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА БЕКМАХАН ДҮЙСЕНБАЕВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Бексултан Байкенжеев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Бидаш Искаков, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Болашак, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "ПЕРЕУЛОК Бостандык, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Гафур Мухамеджанов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Даумен кажы Шоманулы, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "ПЕРЕУЛОК Достык, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА ДҮКЕНБАЙ ДОСЖАН, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА ӘБІЛАСАН ӘШІРБЕКОВ (МАИ бекети 4), ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА ӘЛІМ МҰХАМЕДЖАНОВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ералы Белсенбаева, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ергеш Сабырханов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ерман Айтбембетов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ерман Байзаков, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Есиркеп Конкабаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Жакат Абдиреймов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Жамал Кулымбетов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Желкилдек батыр Болтекулы, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Женис, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Жибек жолы, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА ЗАМАНХАН МЫРЗАЛИЕВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Зулпыхар Байзаков, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Зулпыхар Мусаханов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Зулпыхар Мусаханов, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА Ибрай Алтынсарин, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Иван Цой, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром 20, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром 21, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром-25, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром-26, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром-26-1, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром-26-2, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром-27, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Ипподром 9, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Иргебай Сейтенов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА ИСА МҰСАЕВ (Ипподром 22), ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Исмайыл Искаков, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА ИСМАЙЫЛ САРБАСОВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Кадыр Тагаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Калдарбек Аширов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Калкоз Сейтпенбетов, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА КАНЫШ САТБАЕВ, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА Каржаубек Жаркымбекулы, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Кеншилер, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА ҚОЖАХМЕТ АУАНОВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "ПЕРЕУЛОК Корган, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Коргантогай, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Кудабай Наурызбаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Кудас Жунисбеков, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Кулан Алдабергенулы, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Кулсин Бакирова, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Курмангазы Сагырбаев, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Курылысшылар, ПОСЕЛОК Шалкия"
			}, {
				"ename": "УЛИЦА Кылышбай Омаров, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА КЫРАШБАЙ ЖАКЫПОВ, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Маи бекети-10 киылыс, ПОСЕЛОК Жанакорган"
			}, {
				"ename": "УЛИЦА Маи бекети-11 киылыс, ПОСЕЛОК Жанакорган"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жанаозен, ОБЛАСТЬ Мангистауская",
			"addressName": [{
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 5"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 6"
			}, {
				"ename": "МИКРОРАЙОН Акбулак"
			}, {
				"ename": "МИКРОРАЙОН Арай"
			}, {
				"ename": "МИКРОРАЙОН Астана"
			}, {
				"ename": "МИКРОРАЙОН Байтерек"
			}, {
				"ename": "ПРОСПЕКТ Бокайулы Канатбай"
			}, {
				"ename": "МИКРОРАЙОН Бостандык"
			}, {
				"ename": "ПРОСПЕКТ Е Уразаков"
			}, {
				"ename": "МИКРОРАЙОН Жалын"
			}, {
				"ename": "УЛИЦА Кашаган"
			}, {
				"ename": "МИКРОРАЙОН Коктем"
			}, {
				"ename": "УЛИЦА Коскулаков"
			}, {
				"ename": "МИКРОРАЙОН Мамыр"
			}, {
				"ename": "ПРОСПЕКТ Мангистауская"
			}, {
				"ename": "УЛИЦА Мира"
			}, {
				"ename": "МИКРОРАЙОН Мунайлы"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Нефтянников"
			}, {
				"ename": "МИКРОРАЙОН Оркен"
			}, {
				"ename": "ПРОСПЕКТ Отеп Балгымбаев"
			}, {
				"ename": "ПЛОЩАДЬ Промзона"
			}, {
				"ename": "МИКРОРАЙОН Рауан"
			}, {
				"ename": "МИКРОРАЙОН Самал"
			}, {
				"ename": "УЛИЦА Сатпаев"
			}, {
				"ename": "УЛИЦА Северная промзона"
			}, {
				"ename": "СТАНЦИЯ Станция Вокзал"
			}, {
				"ename": "ГАРАЖНЫЙ КООПЕРАТИВ Тюльпан"
			}, {
				"ename": "МИКРОРАЙОН Шанырак"
			}, {
				"ename": "УЛИЦА Шанырак Курбанов"
			}, {
				"ename": "МИКРОРАЙОН Шугыла"
			}, {
				"ename": "УЛИЦА Юго восточная промзона"
			}, {
				"ename": "ЛИНИЯ 1, ПРОМЫШЛЕННАЯ ЗОНА 1"
			}, {
				"ename": "ЛИНИЯ 1, МИКРОРАЙОН Шанырак"
			}, {
				"ename": "УЛИЦА 16, МИКРОРАЙОН Арай"
			}, {
				"ename": "УЛИЦА 17, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА 22, МИКРОРАЙОН Акбулак"
			}, {
				"ename": "УЛИЦА 44, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Абай, МИКРОРАЙОН Шанырак"
			}, {
				"ename": "УЛИЦА Абиш Кожа, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Абыз Тилеген, МИКРОРАЙОН Мамыр"
			}, {
				"ename": "УЛИЦА Абыл Отембетулы, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Адил Отегулулы, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Азаттык, МИКРОРАЙОН Акбулак"
			}, {
				"ename": "УЛИЦА Айтеке Би, МИКРОРАЙОН Байтерек"
			}, {
				"ename": "УЛИЦА Айткулулы Атакозы, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "УЛИЦА Акбобек, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Акпан Батыр, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "МИКРОРАЙОН Аксу, СЕЛО Рахат"
			}, {
				"ename": "УЛИЦА Актан Керейулы, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Актау, МИКРОРАЙОН Астана"
			}, {
				"ename": "УЛИЦА Алиби Жангельдин, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Алия Молдагулова, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "УЛИЦА Алуаш Дуйсенбаев, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Амангерей Орынбаев, МИКРОРАЙОН Байтерек"
			}, {
				"ename": "УЛИЦА Анес Айтниязов, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Анес Буркитбаев, МИКРОРАЙОН Астана"
			}, {
				"ename": "УЛИЦА Арай, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Аралбай Онгарбекулы, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Асау Барак, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "УЛИЦА Ахмет Байтурсынов, МИКРОРАЙОН Астана"
			}, {
				"ename": "УЛИЦА Ахмет Жубанов, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Байдеш Нурбаев, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "УЛИЦА Байимбет Койлыбаев, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Бактыбай Борсанов, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Бакытжан Бисенгалиев, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Балабакша, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Балуанияз, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Бегениш Абылханов, МИКРОРАЙОН Мунайлы"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Бейнеубай Кулшарулы, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Билал Калиев, МИКРОРАЙОН Арай"
			}, {
				"ename": "УЛИЦА Бисалы Бабаханов, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Битим Кыдырбаев, МИКРОРАЙОН Мунайлы"
			}, {
				"ename": "УЛИЦА Бозашы, МИКРОРАЙОН Акбулак"
			}, {
				"ename": "УЛИЦА Ботакоз, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Бургышы, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Бухар Жырау, МИКРОРАЙОН Байтерек"
			}, {
				"ename": "УЛИЦА Гани Муратбаев, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Гани Муратбаев, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Гариполла Кайсагалиев, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "УЛИЦА Гарифолла Курмангалиев, МИКРОРАЙОН Арай"
			}, {
				"ename": "УЛИЦА Губайдулла Айдаров, МИКРОРАЙОН Арай"
			}, {
				"ename": "УЛИЦА Губкина, МИКРОРАЙОН Шанырак"
			}, {
				"ename": "УЛИЦА Диас Жумашев, МИКРОРАЙОН Арай"
			}, {
				"ename": "УЛИЦА Дильмаганбетов Амандык, МИКРОРАЙОН Бостандык"
			}, {
				"ename": "УЛИЦА Дина Нурпеисова, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Дмитрий Клинчев, МИКРОРАЙОН Мунайлы"
			}, {
				"ename": "УЛИЦА Досан Тажиев, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Досат Мустафаулы, СЕЛО Кызылсай"
			}, {
				"ename": "УЛИЦА Достык Дангылы, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Дружба, МИКРОРАЙОН Шанырак"
			}, {
				"ename": "УЛИЦА Дуйсенбай Бисекенов, МИКРОРАЙОН Мунайлы"
			}, {
				"ename": "УЛИЦА Ер Кармыс, СЕЛО Тенге"
			}, {
				"ename": "УЛИЦА Ер Толеп, МИКРОРАЙОН Мамыр"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жангалинский, ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 10, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 10 Лет Независимости, СЕЛО Пятимар, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "УЛИЦА 12, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 15, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 17, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 18, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 1-Мая, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 20, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 21, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 22, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 23, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 25, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 30 лет Победы, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 31, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 33, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 36, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 5, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 57, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 6, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 62, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 69, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 70 лет Пятимару, СЕЛО Пятимар, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "УЛИЦА 8 Марта, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА 9, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Пятимар, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Кызылоба, СЕЛЬСКИЙ ОКРУГ Кызылобинский"
			}, {
				"ename": "УЛИЦА Абдилхамит Нарымбетов, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА А.Бектасова, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Абил, СЕЛО Жуалыой, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "УЛИЦА Абиш Кекилбайулы, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА Автодор, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "ЗИМОВКА Ажибай, СЕЛО Мастексай, СЕЛЬСКИЙ ОКРУГ Маштексайский"
			}, {
				"ename": "УЛИЦА Азаттык, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЛИЦА Азс, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА А.Иманова, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айгожа-1, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айгожа-1, СЕЛО Саралжын, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айгожа-2, СЕЛО Саралжын, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айгожа 3, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айгожа-6, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айғожа 8, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "УЛИЦА Айдархан, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Айжарык, СЕЛО Мукыр, СЕЛЬСКИЙ ОКРУГ Маштексайский"
			}, {
				"ename": "ЗИМОВКА Айкожа, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айпара, СЕЛО Салтанат, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Айсары, СЕЛО Ушкемпир, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "ЗИМОВКА Айтжан, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "УЛИЦА Айтпай, СЕЛО Айтпай, СЕЛЬСКИЙ ОКРУГ Кызылобинский"
			}, {
				"ename": "УЛИЦА Айыпсай, СЕЛО Айыпсай, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Айыпсай, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Акбай, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА Акбалшык, СЕЛО Акбалшык, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "ЗИМОВКА Акешка, СЕЛО Сарыкол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Аккол, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Аккудык, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Аккус, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "УЛИЦА Аккус, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Аккус-2, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Аккутир, СЕЛО Айтпай, СЕЛЬСКИЙ ОКРУГ Кызылобинский"
			}, {
				"ename": "ЗИМОВКА Аккыстау, СЕЛО Жуалыой, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Акмамбет, СЕЛО Кыркопа, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "ЗИМОВКА Акмола, СЕЛО Сарыкол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Ақой, СЕЛО Киши Айдархан, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Ақсай, СЕЛО Еңбек, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "ЗИМОВКА Аксай 1, СЕЛО Кыркопа, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "ЗИМОВКА Аксай 2, СЕЛО Кыркопа, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "ЗИМОВКА Аксерке, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Аксуат, СЕЛО Сарыкол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Актамыс, СЕЛО Пятимар, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Актан, СЕЛО Акбалшык, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "ЗИМОВКА Актау, СЕЛО Балдырган, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Ак Уй, СЕЛО Кыркопа, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "ЗИМОВКА Акшагыл, СЕЛО Жанажол, СЕЛЬСКИЙ ОКРУГ Жанажолский"
			}, {
				"ename": "ЗИМОВКА Ак Шагыл, СЕЛО Мукыр, СЕЛЬСКИЙ ОКРУГ Маштексайский"
			}, {
				"ename": "ЗИМОВКА Алаша, СЕЛО Копжасар, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "ЗИМОВКА Али, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Алимбек, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Алимбек-1, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Алкакол, СЕЛО Жуалыой, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Амиржан, СЕЛО Мастексай, СЕЛЬСКИЙ ОКРУГ Маштексайский"
			}, {
				"ename": "УЛИЦА А.Молдагуловой, СЕЛО Кыркопа, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "УЛИЦА А.Оразбаевой, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "ЗИМОВКА Арыстанбек, СЕЛО Кызылоба, СЕЛЬСКИЙ ОКРУГ Кызылобинский"
			}, {
				"ename": "ЗИМОВКА Асабай, СЕЛО Жуалыой, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Пятимар, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА Атаконыс, СЕЛО Бирлик, СЕЛЬСКИЙ ОКРУГ Бирликский"
			}, {
				"ename": "ЗИМОВКА Атау, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Атаукудык, СЕЛО Аккус, СЕЛЬСКИЙ ОКРУГ Пятимарский"
			}, {
				"ename": "ЗИМОВКА Атим, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "УЛИЦА Атп, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "ЗИМОВКА Аукетай, СЕЛО Салтанат, СЕЛЬСКИЙ ОКРУГ Копжасарский"
			}, {
				"ename": "УЛИЦА Ахмет Дауылбаев, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА Ахмет Жұбанов, СЕЛО Жангала, СЕЛЬСКИЙ ОКРУГ Жангалинский"
			}, {
				"ename": "УЛИЦА Ахметова, СЕЛО Жанаказан, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}, {
				"ename": "ЗИМОВКА Ашыкудук, СЕЛО Мастексай, СЕЛЬСКИЙ ОКРУГ Маштексайский"
			}, {
				"ename": "ЗИМОВКА Ашыкудук, СЕЛО Кыркопа, СЕЛЬСКИЙ ОКРУГ С.Мендешевский"
			}, {
				"ename": "ЗИМОВКА Ащыкудык, СЕЛО Жуалыой, СЕЛЬСКИЙ ОКРУГ Жанаказанский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жанибекский, ОБЛАСТЬ Западно-Казахстанская",
			"addressName": [{
				"ename": "УЛИЦА 15, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 19, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 20, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 21, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 22, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 24, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 26, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 27, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 28, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 30, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 41, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА 5, СЕЛО Тегисшил, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "УЛИЦА Абай, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Борсы, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "ЗИМОВКА Абдогай, СЕЛО Онеге, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "УЛИЦА Абдрахманова, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА Абдрахманова, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Абдулла, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Абдуллина, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "УЛИЦА Абдуллина, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "ЗИМОВКА Абен, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "УЛИЦА Абылай Хан, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "УЛИЦА Абылайхана, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "ЗИМОВКА Азамат, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Айдарлы, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "ЗИМОВКА Акадыр, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "ЗИМОВКА Аккул, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Алип, СЕЛО Онеге, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Алпауыз, СЕЛО Борсы, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "ЗИМОВКА Алтыкашар, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Алты Кашар, СЕЛО Жаскайрат, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Аманат, СЕЛО Таловка, СЕЛЬСКИЙ ОКРУГ Таловский"
			}, {
				"ename": "ЗИМОВКА Амантай, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Апакаш, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Арашайым, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Арашайым, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "УЛИЦА Ардагер, СЕЛО Жаскайрат, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Арман, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "ЗИМОВКА Арык, СЕЛО Онеге, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Арыстангали, СЕЛО Онеге, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "УЛИЦА Астана, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "УЛИЦА Аубекерова Т, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "УЛИЦА Аубекерова Т, СЕЛО Борсы, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "УЛИЦА Ауезов, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Баймурат, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Байтурсынова, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА Бакиза Сыдыкова, СЕЛО Курсай, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Бари, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "ЗИМОВКА Басеке, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "ЗИМОВКА Бассейн, СЕЛО Колтабан, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Батыс, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Бахтыгерей, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "УЛИЦА Бейбітшілік, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Беркали, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Бес Кашар, СЕЛО Курсай, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Бирали, СЕЛО Онеге, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Биринши, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Богет, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "ЗИМОВКА Богет, СЕЛО Борсы, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "ЗИМОВКА Бондюков, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "ЗИМОВКА Бондюков, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Бояулы, СЕЛО Борсы, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "ЗИМОВКА Бруцеллез, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "ЗИМОВКА Бурцулез, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Бухар, СЕЛО Колтабан, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "УЛИЦА Водстрой, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "ЗИМОВКА Вышка, СЕЛО Борсы, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "УЛИЦА Гагарина, СЕЛО Таловка, СЕЛЬСКИЙ ОКРУГ Таловский"
			}, {
				"ename": "УЛИЦА Гайсина, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Гиззат, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "ЗИМОВКА Гиляж, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "УЛИЦА Г.Караш, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА Ғұмар Қараш, СЕЛО Тегисшил, СЕЛЬСКИЙ ОКРУГ Борсынский"
			}, {
				"ename": "УЛИЦА Гэс, СЕЛО Жаскайрат, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Гэс, СЕЛО Жаскайрат, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "ЗИМОВКА Даулет, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "ЗИМОВКА Даулет, СЕЛО Онеге, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}, {
				"ename": "УЛИЦА Даулеткерея, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "УЛИЦА Д.Нурпейсова, СЕЛО Жанибек, СЕЛЬСКИЙ ОКРУГ Жанибекский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Майтубек, СЕЛЬСКИЙ ОКРУГ Таловский"
			}, {
				"ename": "УЛИЦА Достык, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Достық, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "ЗИМОВКА Дружба, СЕЛО Акоба, СЕЛЬСКИЙ ОКРУГ Акобинский"
			}, {
				"ename": "УЛИЦА Енбекши, СЕЛО Енбекши, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Енсеуова, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "ЗИМОВКА Ергазы, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "УЛИЦА Ерденбека Ниеткалиева, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "ЗИМОВКА Ертаргын, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "УЛИЦА Есимова, СЕЛО Тау, СЕЛЬСКИЙ ОКРУГ Тауский"
			}, {
				"ename": "ЗИМОВКА Ески Май, СЕЛО Камысты, СЕЛЬСКИЙ ОКРУГ Камыстинский"
			}, {
				"ename": "ЗИМОВКА Ески Откорм, СЕЛО Узункол, СЕЛЬСКИЙ ОКРУГ Узункольский"
			}, {
				"ename": "УЛИЦА Жагалау, СЕЛО Акадыр, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "УЛИЦА Жагалау, СЕЛО Жаксыбай, СЕЛЬСКИЙ ОКРУГ Жаксыбайский"
			}, {
				"ename": "УЛИЦА Жагалау, СЕЛО Жаскайрат, СЕЛЬСКИЙ ОКРУГ Куйгенкольский"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жаркаинский, ОБЛАСТЬ Акмолинская",
			"addressName": [{
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 1, СЕЛО Ушкарасу"
			}, {
				"ename": "ПОЛЕВОЙ СТАН 1, СЕЛО Бирсуат"
			}, {
				"ename": "ФЕРМА №1, СЕЛО Кумсуат"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 2, СЕЛО Ушкарасу"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 3, СЕЛО Ушкарасу"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА 4, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА 50 лет СССР, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Далабай"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Гастелло"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Тасоткель"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Тассуат"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Шойындыколь"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Абая, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Абылай Хан (Целинная), СЕЛО Пригородное"
			}, {
				"ename": "ОТДЕЛЕНИЕ Ак Каин, СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Акпана Укубаева, СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Акпана Укубаева, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА Акпана Укубаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "ОТДЕЛЕНИЕ Актобе, СЕЛО Далабай"
			}, {
				"ename": "УЛИЦА Алиби Джангильдина, СЕЛО Тассуат"
			}, {
				"ename": "УЛИЦА Алии Молдагуловой, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Алихана Бокейханова, СЕЛО Тассуат"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Тассуат"
			}, {
				"ename": "УЛИЦА Амангельды Иманова, СЕЛО Ушкарасу"
			}, {
				"ename": "ПЕРЕУЛОК Ардагерлер (Почтовый), СЕЛО Кумсуат"
			}, {
				"ename": "ОТДЕЛЕНИЕ Балталы, СЕЛО Пригородное"
			}, {
				"ename": "ОТДЕЛЕНИЕ Балуанколь, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Банная, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Баубек батыр, СЕЛО Тасоткель"
			}, {
				"ename": "УЛИЦА Безымянная, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Бейбитшилик, СЕЛО Тасоткель"
			}, {
				"ename": "УЛИЦА Бондаренко, СЕЛО Гастелло"
			}, {
				"ename": "ОТДЕЛЕНИЕ Бригада №2, СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Валентины Терешковой, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Вокзальная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Восточная, СЕЛО Кумсуат"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Восточная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Восточная, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Ғабит Мүсірепов (Озерная), СЕЛО Шойындыколь"
			}, {
				"ename": "ОТДЕЛЕНИЕ Гагаринский, СЕЛО Шойындыколь"
			}, {
				"ename": "ОТДЕЛЕНИЕ ДАЛАЛЫК КОС №1, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Джамбула Джабаева, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Джамбула Джабаева, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА Динмухаммеда Конаева, СЕЛО Ушкарасу"
			}, {
				"ename": "ПРОСПЕКТ Әл-Фараби (Рабочих), СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Жамбыл (Почтовая), СЕЛО Шойындыколь"
			}, {
				"ename": "ОТДЕЛЕНИЕ Жарколь, СЕЛО Шойындыколь"
			}, {
				"ename": "УЧАСТОК Жарколь 1, СЕЛО Шойындыколь"
			}, {
				"ename": "УЧАСТОК Жарколь 2, СЕЛО Шойындыколь"
			}, {
				"ename": "УЧАСТОК Жарколь 3, СЕЛО Шойындыколь"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА Женис, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Животноводов, СЕЛО Львовское"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Западная, СЕЛО Кумсуат"
			}, {
				"ename": "ПРОМЫШЛЕННАЯ ЗОНА Западная, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "ОТДЕЛЕНИЕ Западное, СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Захарова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Зерноскладская, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Ибрая Алтынсарина, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Ибрая Алтынсарина, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА Ишимская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Ишимская, СЕЛО Тассуат"
			}, {
				"ename": "УЛИЦА Ілияс Есенберлин (Школьная), СЕЛО Шойындыколь"
			}, {
				"ename": "УЛИЦА Каныша Сатпаева, СЕЛО Ушкарасу"
			}, {
				"ename": "УЧАСТОК Каскаколь, СЕЛО Шойындыколь"
			}, {
				"ename": "УЛИЦА Касыма Давлеталина, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Кирова, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Клубная, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Коммунистическая, СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Комсомольская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Комсомольская, СЕЛО Кумсуат"
			}, {
				"ename": "УЛИЦА Кооперативная, СЕЛО Кумсуат"
			}, {
				"ename": "ПЕРЕУЛОК Құлагер (Национальный), СЕЛО Кумсуат"
			}, {
				"ename": "УЛИЦА Ленина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Пригородное"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Ленина, СЕЛО Далабай"
			}, {
				"ename": "УЛИЦА Ленинского Комсомола, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Майкутова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Малика Габдуллина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Малика Габдуллина, СЕЛО Ушкарасу"
			}, {
				"ename": "УЛИЦА Малика Габдуллина, СЕЛО Тасоткель"
			}, {
				"ename": "ЗОНА Мал шаруашылыгы, СЕЛО Бирсуат"
			}, {
				"ename": "ЗОНА Мал шаруашылыгы, СЕЛО Гастелло"
			}, {
				"ename": "ЗОНА Мал шаруашылыгы, СЕЛО Пятигорское"
			}, {
				"ename": "УЛИЦА Мәншүк Мәметова (Больничная), СЕЛО Шойындыколь"
			}, {
				"ename": "УЛИЦА Механизаторская, СЕЛО Кумсуат"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Гастелло"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Бирсуат"
			}, {
				"ename": "УЛИЦА Мира, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Львовское"
			}, {
				"ename": "УЛИЦА Мира, СЕЛО Кумсуат"
			}, {
				"ename": "УЛИЦА Молодежная, СЕЛО Пригородное"
			}, {
				"ename": "МИКРОРАЙОН Молодежный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}, {
				"ename": "ПЕРЕУЛОК Молодежный, СЕЛО Кумсуат"
			}, {
				"ename": "УЛИЦА Московская, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Державинск"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "РАЙОН Жарминский, ОБЛАСТЬ Абай",
			"addressName": [{
				"ename": "КВАРТАЛ 1, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 1, ПОСЕЛОК Жарма"
			}, {
				"ename": "РАЗЪЕЗД 10, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 10, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 10 Квартал, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "РАЗЪЕЗД 15КМ, ПОСЕЛОК Жарма"
			}, {
				"ename": "РАЗЪЕЗД 16, ПОСЕЛОК Жарма"
			}, {
				"ename": "КВАРТАЛ 2, ПОСЕЛОК Жарма"
			}, {
				"ename": "КВАРТАЛ 2, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "РАЗЪЕЗД 3, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "КВАРТАЛ 3, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 3, ПОСЕЛОК Жарма"
			}, {
				"ename": "КВАРТАЛ 4, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "РАЗЪЕЗД 4, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "КВАРТАЛ 4, ПОСЕЛОК Жарма"
			}, {
				"ename": "УЧАСТОК 4 км северо-восточнее города Шар, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "КВАРТАЛ 5, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 5, ПОСЕЛОК Жарма"
			}, {
				"ename": "КВАРТАЛ 6, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 6, ПОСЕЛОК Жарма"
			}, {
				"ename": "КВАРТАЛ 7, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ 8, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "ДОРОГА 828 км. вдоль Автодороги Омск-Майкапшагай, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "ДОРОГА 858 км. вдоль Автодороги Омск-Майкапшагай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "КВАРТАЛ 9, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "РАЗЪЕЗД 9км, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "КВАРТАЛ А, ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Абая, ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Абая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Абылай хан (Береговая), ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "ТРАССА автодорога Алматы-Усть-Каменогорск 934 км, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "ДОРОГА автодорога Омск-Майкапчагай 860 км, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Ак Козы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Ак Кудык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Алибасова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Алтынтау (Фабричная), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "ЗИМОВКА Алшынбай, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "УЛИЦА Амангельди, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Ардагер (Спортивная), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "ЗИМОВКА Атанбай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА А.Темирханов, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Атыгай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Аубакирова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Аубакирулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Ауганбай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Ауезова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Ауеке, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Аяк Жыра, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "КВАРТАЛ Б, ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Байсеитовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Бауыржан Момышулы (Заводская), ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "ЗИМОВКА Баянбай, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "УЛИЦА Без названия, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "УЛИЦА Без названия, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЛИЦА Без названия, ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Без названия, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Бекишева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Береговая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Бигозыулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Буркитова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЧАСТОК Бывший совхоз \\\"Луговой\\\", ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Варепа, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Варепа (Первомайская), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Гагарина, ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Герцена, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "СТАНЦИЯ Дельбегетей, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЛИЦА Динмухамед Конаев (Ворошилова), ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЛИЦА Достык (Центральная), ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЛИЦА Достык (Дружбы), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Е.Боранбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Еділбай, ПОСЕЛОК Жангиз-тобе"
			}, {
				"ename": "УЛИЦА Әзілхан Нұршайықов, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЧАСТОК Еспе, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Жамбас (бывший совхоз \"Кезенсуйский\"), ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Жамбыла, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Жамбыла, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "ЗИМОВКА Жасулан, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЛИЦА Женис (Коммунистическая), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Жибек жолы (Социалистическая), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА Ж.Орынбаева, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "МИКРОРАЙОН Западный, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Кабанбая, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЧАСТОК Калымкан (Дастан), ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "ЗИМОВКА Кара Куыс, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Карауыл, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Караш, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Карелина, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Кенесары хан (Мира), ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "УЛИЦА Кеншилер (Горная), ПОСЕЛОК Ауэзов"
			}, {
				"ename": "УЛИЦА К.Калиулы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Кобдыкова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Комсомол, ПОСЕЛОК Суыкбулак"
			}, {
				"ename": "ЗИМОВКА Конек Калга, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Куандык, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЧАСТОК Қызыл жетек, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Кызыл Шокы, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Лекерова, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "УЛИЦА Маметовой, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Маятас, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}, {
				"ename": "ЗИМОВКА Муздыбай, ГОРОД РАЙОННОГО ЗНАЧЕНИЯ Шар"
			}]
		}]
	}, {
		"addressName": [{
			"ename": "ГОРОД ОБЛАСТНОГО ЗНАЧЕНИЯ Жезказган, ОБЛАСТЬ Ұлытау",
			"addressName": [{
				"ename": "МИКРОРАЙОН 1"
			}, {
				"ename": "КВАРТАЛ 10"
			}, {
				"ename": "КВАРТАЛ 15"
			}, {
				"ename": "КВАРТАЛ 19"
			}, {
				"ename": "ПЕРЕУЛОК 1-я Инженерная"
			}, {
				"ename": "МИКРОРАЙОН 2"
			}, {
				"ename": "КВАРТАЛ 21"
			}, {
				"ename": "КВАРТАЛ 23"
			}, {
				"ename": "КВАРТАЛ 27"
			}, {
				"ename": "КВАРТАЛ 28"
			}, {
				"ename": "КВАРТАЛ 29"
			}, {
				"ename": "ПЕРЕУЛОК 2-я Инженерная"
			}, {
				"ename": "МИКРОРАЙОН 3"
			}, {
				"ename": "КВАРТАЛ 32"
			}, {
				"ename": "РАЗЪЕЗД 323"
			}, {
				"ename": "РАЗЪЕЗД 359 Км"
			}, {
				"ename": "РАЗЪЕЗД 366 Км"
			}, {
				"ename": "УЧАСТОК №368"
			}, {
				"ename": "РАЗЪЕЗД 370 Км"
			}, {
				"ename": "РАЗЪЕЗД 385 Км"
			}, {
				"ename": "МИКРОРАЙОН 4"
			}, {
				"ename": "РАЗЪЕЗД 411"
			}, {
				"ename": "МИКРОРАЙОН 5"
			}, {
				"ename": "КВАРТАЛ 5-й"
			}, {
				"ename": "МИКРОРАЙОН 6"
			}, {
				"ename": "КВАРТАЛ 61"
			}, {
				"ename": "КВАРТАЛ 62"
			}, {
				"ename": "КВАРТАЛ 63"
			}, {
				"ename": "КВАРТАЛ 64"
			}, {
				"ename": "КВАРТАЛ 65"
			}, {
				"ename": "КВАРТАЛ 66"
			}, {
				"ename": "РАЗЪЕЗД 66"
			}, {
				"ename": "КВАРТАЛ 67"
			}, {
				"ename": "КВАРТАЛ 68"
			}, {
				"ename": "КВАРТАЛ 69"
			}, {
				"ename": "КВАРТАЛ 7"
			}, {
				"ename": "МИКРОРАЙОН 7"
			}, {
				"ename": "КВАРТАЛ 71"
			}, {
				"ename": "КВАРТАЛ 74"
			}, {
				"ename": "КВАРТАЛ 79"
			}, {
				"ename": "КВАРТАЛ 8"
			}, {
				"ename": "МИКРОРАЙОН 8"
			}, {
				"ename": "КВАРТАЛ 81"
			}, {
				"ename": "КВАРТАЛ 84"
			}, {
				"ename": "УЛИЦА 8 Марта"
			}, {
				"ename": "КВАРТАЛ 9"
			}, {
				"ename": "КВАРТАЛ 91"
			}, {
				"ename": "КВАРТАЛ 92"
			}, {
				"ename": "КВАРТАЛ 93"
			}, {
				"ename": "КВАРТАЛ 94"
			}, {
				"ename": "КВАРТАЛ 95"
			}, {
				"ename": "КВАРТАЛ 99"
			}, {
				"ename": "УЛИЦА Абая"
			}, {
				"ename": "УЛИЦА А.Бокейханова"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Авиатор"
			}, {
				"ename": "ДОРОГА Автодорога Жезказган-Кызыл-орда"
			}, {
				"ename": "ПОТРЕБИТЕЛЬСКИЙ КООПЕРАТИВ Автомобилист"
			}, {
				"ename": "УЛИЦА А. Ермекова"
			}, {
				"ename": "УЛИЦА А. Жубанова"
			}, {
				"ename": "УЛИЦА А. Иманова"
			}, {
				"ename": "УЛИЦА А. Казакбаева"
			}, {
				"ename": "УЛИЦА Ақдала"
			}, {
				"ename": "УЛИЦА Аккойши Тусупбекова"
			}, {
				"ename": "УЛИЦА А. Кусаинова"
			}, {
				"ename": "УЛИЦА Акына Болмана"
			}, {
				"ename": "УЛИЦА Акына Иманжана"
			}, {
				"ename": "УЛИЦА Акына Кожабая"
			}, {
				"ename": "УЛИЦА Акына Шашубая"
			}, {
				"ename": "ПЛОЩАДЬ Алаша"
			}, {
				"ename": "ПРОСПЕКТ Алашахана"
			}, {
				"ename": "УЛИЦА А. Майкутова"
			}, {
				"ename": "УЛИЦА А.Мамажанова (А. Мамажанова)"
			}, {
				"ename": "УЛИЦА Аманбай Батыра"
			}, {
				"ename": "УЛИЦА А.Маргулана (А. Маргулана)"
			}, {
				"ename": "УЛИЦА А. Молдагуловой"
			}, {
				"ename": "УЛИЦА Ауезова"
			}, {
				"ename": "УЛИЦА А. Шинтуринова"
			}, {
				"ename": "ТЕРРИТОРИЯ Аэропорт"
			}, {
				"ename": "УЛИЦА Бабыр би"
			}, {
				"ename": "УЛИЦА Базарная"
			}, {
				"ename": "УЛИЦА Б.Айбасова"
			}, {
				"ename": "УЛИЦА Балбырауын"
			}, {
				"ename": "УЛИЦА Балочная"
			}, {
				"ename": "УЛИЦА Батыра Агыбая"
			}, {
				"ename": "УЛИЦА Бауыржан Момышұлы"
			}, {
				"ename": "УЛИЦА Б. Булкышева"
			}, {
				"ename": "УЛИЦА Бебеля"
			}, {
				"ename": "УЛИЦА Белинского"
			}, {
				"ename": "ПЕРЕУЛОК Бірлік"
			}, {
				"ename": "ПЕРЕУЛОК Б.Майлина"
			}, {
				"ename": "УЛИЦА Б. Майлина"
			}, {
				"ename": "УЛИЦА Букуров Сутемген"
			}, {
				"ename": "ДАЧНЫЙ КООПЕРАТИВ Водник"
			}, {
				"ename": "ДОРОГА Восточно-объездная дорога"
			}, {
				"ename": "УЧАСТОК В районе Локона"
			}, {
				"ename": "УЧАСТОК В районе средней школы №3"
			}, {
				"ename": "УЛИЦА В. Тарадая"
			}, {
				"ename": "УЛИЦА Газиза Омарова"
			}, {
				"ename": "БУЛЬВАР Ғарышкерлер"
			}, {
				"ename": "МИКРОРАЙОН Геологический"
			}]
		}]
	}]
export default locations



// WEBPACK FOOTER //
// ./src/utils/location.js